
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Al71", function(module, exports) {

$parcel$export(module.exports, "HeadProvider", function () { return $585c45a76c7b8e3f$export$b6e9256a1f1b97ae; });
$parcel$export(module.exports, "Title", function () { return $585c45a76c7b8e3f$export$f99233281efd08a0; });
$parcel$export(module.exports, "Link", function () { return $585c45a76c7b8e3f$export$a6c7ac8248d6e38a; });

var $dzwm9 = parcelRequire("dzwm9");

var $6uMv9 = parcelRequire("6uMv9");

var $10zIL = parcelRequire("10zIL");

var $cqPcK = parcelRequire("cqPcK");

var $2vndP = parcelRequire("2vndP");

var $dpwOt = parcelRequire("dpwOt");
var $585c45a76c7b8e3f$var$_React$createContext = /*#__PURE__*/ (0, $6uMv9.createContext)(null), $585c45a76c7b8e3f$var$Consumer = $585c45a76c7b8e3f$var$_React$createContext.Consumer, $585c45a76c7b8e3f$var$Provider = $585c45a76c7b8e3f$var$_React$createContext.Provider;
var $585c45a76c7b8e3f$var$HeadTag = /*#__PURE__*/ function(_React$Component) {
    (0, $cqPcK.default)(HeadTag, _React$Component);
    function HeadTag() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            canUseDOM: false
        };
        _this.headTags = null;
        _this.index = -1;
        return _this;
    }
    var _proto = HeadTag.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this$props = this.props, tag = _this$props.tag, name = _this$props.name, property = _this$props.property;
        this.setState({
            canUseDOM: true
        });
        this.index = this.headTags.addClientTag(tag, name || property);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var tag = this.props.tag;
        this.headTags.removeClientTag(tag, this.index);
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props2 = this.props, Tag = _this$props2.tag, rest = (0, $10zIL.default)(_this$props2, [
            "tag"
        ]);
        var canUseDOM = this.state.canUseDOM;
        return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$Consumer, null, function(headTags) {
            if (headTags == null) throw Error("<HeadProvider /> should be in the tree");
            _this2.headTags = headTags;
            if (canUseDOM) {
                if (!headTags.shouldRenderTag(Tag, _this2.index)) return null;
                var ClientComp = /*#__PURE__*/ (0, $6uMv9.createElement)(Tag, rest);
                return /*#__PURE__*/ (0, $2vndP.createPortal)(ClientComp, document.head);
            }
            var ServerComp = /*#__PURE__*/ (0, $6uMv9.createElement)(Tag, (0, $dzwm9.default)({
                "data-rh": ""
            }, rest));
            headTags.addServerTag(ServerComp);
            return null;
        });
    };
    return HeadTag;
}((0, $6uMv9.Component));
var $585c45a76c7b8e3f$var$cascadingTags = [
    "title",
    "meta"
];
var $585c45a76c7b8e3f$export$b6e9256a1f1b97ae = /*#__PURE__*/ function(_React$Component) {
    (0, $cqPcK.default)(HeadProvider, _React$Component);
    function HeadProvider() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.indices = new Map();
        _this.state = {
            addClientTag: function addClientTag(tag, name) {
                // consider only cascading tags
                if ($585c45a76c7b8e3f$var$cascadingTags.indexOf(tag) !== -1) {
                    _this.setState(function(state) {
                        var _ref;
                        var names = state[tag] || [];
                        return _ref = {}, _ref[tag] = [].concat(names, [
                            name
                        ]), _ref;
                    }); // track indices synchronously
                    var _assertThisInitialize = (0, $dpwOt.default)(_this), indices = _assertThisInitialize.indices;
                    var index = indices.has(tag) ? indices.get(tag) + 1 : 0;
                    indices.set(tag, index);
                    return index;
                }
                return -1;
            },
            shouldRenderTag: function shouldRenderTag(tag, index) {
                if ($585c45a76c7b8e3f$var$cascadingTags.indexOf(tag) !== -1) {
                    var names = _this.state[tag]; // eslint-disable-line react/destructuring-assignment
                    // check if the tag is the last one of similar
                    return names && names.lastIndexOf(names[index]) === index;
                }
                return true;
            },
            removeClientTag: function removeClientTag(tag, index) {
                _this.setState(function(state) {
                    var names = state[tag];
                    if (names) {
                        var _ref2;
                        names[index] = null;
                        return _ref2 = {}, _ref2[tag] = names, _ref2;
                    }
                    return null;
                });
            },
            addServerTag: function addServerTag(tagNode) {
                var _this$props$headTags = _this.props.headTags, headTags = _this$props$headTags === void 0 ? [] : _this$props$headTags; // tweak only cascading tags
                if ($585c45a76c7b8e3f$var$cascadingTags.indexOf(tagNode.type) !== -1) {
                    var index = headTags.findIndex(function(prev) {
                        var prevName = prev.props.name || prev.props.property;
                        var nextName = tagNode.props.name || tagNode.props.property;
                        return prev.type === tagNode.type && prevName === nextName;
                    });
                    if (index !== -1) headTags.splice(index, 1);
                }
                headTags.push(tagNode);
            }
        };
        return _this;
    }
    var _proto = HeadProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var ssrTags = document.head.querySelectorAll('[data-rh=""]'); // `forEach` on `NodeList` is not supported in Googlebot, so use a workaround
        Array.prototype.forEach.call(ssrTags, function(ssrTag) {
            return ssrTag.parentNode.removeChild(ssrTag);
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, headTags = _this$props.headTags, children = _this$props.children;
        if (typeof window === "undefined" && Array.isArray(headTags) === false) throw Error("headTags array should be passed to <HeadProvider /> in node");
        return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$Provider, {
            value: this.state
        }, children);
    };
    return HeadProvider;
}((0, $6uMv9.Component));
var $585c45a76c7b8e3f$export$f99233281efd08a0 = function Title(props) {
    return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$HeadTag, (0, $dzwm9.default)({
        tag: "title"
    }, props));
};
var $585c45a76c7b8e3f$export$d9e45bc13d335801 = function Style(props) {
    return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$HeadTag, (0, $dzwm9.default)({
        tag: "style"
    }, props));
};
var $585c45a76c7b8e3f$export$b08a9033b36413fb = function Meta(props) {
    return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$HeadTag, (0, $dzwm9.default)({
        tag: "meta"
    }, props));
};
var $585c45a76c7b8e3f$export$a6c7ac8248d6e38a = function Link(props) {
    return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$HeadTag, (0, $dzwm9.default)({
        tag: "link"
    }, props));
};
var $585c45a76c7b8e3f$export$ef88aa0d34c34520 = function Base(props) {
    return /*#__PURE__*/ (0, $6uMv9.createElement)($585c45a76c7b8e3f$var$HeadTag, (0, $dzwm9.default)({
        tag: "base"
    }, props));
};

});

parcelRegister("6Sp0E", function(module, exports) {
$parcel$export(module.exports, "ChargePointDetailsPage", function () { return (parcelRequire("hkxnL")).ChargePointDetailsPage; });
parcelRequire("hkxnL");

});
parcelRegister("hkxnL", function(module, exports) {

$parcel$export(module.exports, "ChargePointDetailsPage", function () { return $be64b683aa394c63$export$dfdb4e8d44bad2a8; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $84v65 = parcelRequire("84v65");

var $k2Irz = parcelRequire("k2Irz");

var $fVJEu = parcelRequire("fVJEu");

var $1xw2Y = parcelRequire("1xw2Y");

var $4HY83 = parcelRequire("4HY83");

var $fvmYM = parcelRequire("fvmYM");

var $9kprt = parcelRequire("9kprt");
const $be64b683aa394c63$var$SExternalChargerMessageWrapper = (0, $akcQ4.default).div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
`;
const $be64b683aa394c63$var$SExternalChargerMessage = (0, $akcQ4.default).div`
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
    text-align: center;
    width: 310px;
`;
const $be64b683aa394c63$var$SContainer = (0, $akcQ4.default).div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;

    @media (min-width: 990px) {
        width: 970px;
    }

    @media (min-width: 1200px) {
        width: 90vw;
        max-width: 1400px;
    }
`;
function $be64b683aa394c63$export$dfdb4e8d44bad2a8() {
    const chargePointId = (0, $84v65.useParams)().chargePointId;
    const { data: chargePoint, isLoading: isLoading } = (0, $fvmYM.useChargePointGetQuery)({
        chargePointId: chargePointId,
        expand: "additionalInfo,scheduleInfo"
    }, {
        skip: !chargePointId,
        refetchOnFocus: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($be64b683aa394c63$var$SContainer, null, chargePoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4HY83.ChargePointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9kprt.ChargePointPageControls), {
        chargePoint: chargePoint
    }), chargePoint?.ocppServerMode === "None" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k2Irz.ChargePointCapiPage), {
        chargePoint: chargePoint,
        isLoading: isLoading
    }), chargePoint?.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fVJEu.ChargePointOcppPage), {
        chargePoint: chargePoint,
        isLoading: isLoading
    }), chargePoint?.ocppServerMode === "External" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($be64b683aa394c63$var$SExternalChargerMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($be64b683aa394c63$var$SExternalChargerMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgChargerIsDeployedToExternalPart",
        values: {
            chargePointId: chargePoint.id
        }
    })))))) : null);
}

});


parcelRegister("lVzQC", function(module, exports) {

$parcel$export(module.exports, "ReportsPage", function () { return (parcelRequire("63vVm")).ReportsPage; });

var $63vVm = parcelRequire("63vVm");

});
parcelRegister("63vVm", function(module, exports) {

$parcel$export(module.exports, "ReportsPage", function () { return $a28d55099d30f61a$export$b8a443164510a1b4; });

var $6uMv9 = parcelRequire("6uMv9");

var $52Dbq = parcelRequire("52Dbq");

var $8LupL = parcelRequire("8LupL");

var $3L9y2 = parcelRequire("3L9y2");

var $io716 = parcelRequire("io716");
const $a28d55099d30f61a$export$b8a443164510a1b4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3L9y2.ReportsGeneratorWidget), null), (0, $8LupL.isAdminDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $io716.AutomaticReportDeliveriesTable), null));
};

});
parcelRegister("3L9y2", function(module, exports) {

$parcel$export(module.exports, "ReportsGeneratorWidget", function () { return $7769f84bf243f542$export$1278b746cbafc746; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $4vH3e = parcelRequire("4vH3e");

var $2SOry = parcelRequire("2SOry");
var $6dpmc = parcelRequire("6dpmc");
var $9406q = parcelRequire("9406q");
var $1kNlJ = parcelRequire("1kNlJ");

var $feY3H = parcelRequire("feY3H");

var $f7UZA = parcelRequire("f7UZA");

var $8ugaX = parcelRequire("8ugaX");

var $l8slY = parcelRequire("l8slY");

var $iIdvQ = parcelRequire("iIdvQ");

var $fvmYM = parcelRequire("fvmYM");

var $2q5Lx = parcelRequire("2q5Lx");

var $1xw2Y = parcelRequire("1xw2Y");

var $3YfCm = parcelRequire("3YfCm");

var $238Qp = parcelRequire("238Qp");

var $2460e = parcelRequire("2460e");

var $8LupL = parcelRequire("8LupL");

var $4V32m = parcelRequire("4V32m");

var $86MrK = parcelRequire("86MrK");

var $7jCZT = parcelRequire("7jCZT");

var $aL1Vp = parcelRequire("aL1Vp");

var $bM0Pb = parcelRequire("bM0Pb");
const $7769f84bf243f542$var$dateFormat = "yyyy-MM-dd";
const $7769f84bf243f542$export$1278b746cbafc746 = ()=>{
    const text = (0, $aL1Vp.default)();
    const { selectedCompanyId: selectedCompanyId, partnerId: partnerId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const screenSize = (0, $4V32m.default)();
    const [intervalSelected, setIntervalSelected] = (0, $6uMv9.useState)("CurrentWeek");
    const [isGeneratingReport, setIsGeneratingReport] = (0, $6uMv9.useState)(false);
    const [showHelpModal, setShowHelpModal] = (0, $6uMv9.useState)(false);
    const periodOptions = (0, $6uMv9.useMemo)(()=>[
            {
                label: text("btnCurrentWeek"),
                value: "CurrentWeek"
            },
            {
                label: text("btnPreviousWeek"),
                value: "PreviousWeek"
            },
            {
                label: text("btnCurrentMonth"),
                value: "CurrentMonth"
            },
            {
                label: text("btnPreviousMonth"),
                value: "PreviousMonth"
            },
            {
                label: text("btnCurrentYear"),
                value: "CurrentYear"
            },
            {
                label: text("btnPreviousYear"),
                value: "PreviousYear"
            }
        ], [
        text
    ]);
    const { control: control, handleSubmit: handleSubmit, watch: watch, setValue: setValue, formState: { isValid: isValid } } = (0, $cbVaW.useForm)({
        defaultValues: {
            reportId: undefined,
            fromDate: (0, $1kNlJ.default)(new Date(), {
                weekStartsOn: 1
            }),
            toDate: (0, $6dpmc.default)(new Date(), {
                weekStartsOn: 1
            })
        }
    });
    const { data: adminReports } = (0, $fvmYM.useReportGetReportsForAdminQuery)({
        selectedCompanyId: selectedCompanyId
    }, {
        skip: !(0, $8LupL.isAdminDomain)
    });
    const { data: partnerReports } = (0, $fvmYM.useReportGetReportsForPartnerQuery)({
        partnerId: partnerId
    }, {
        skip: !(0, $8LupL.isPartnerDomain)
    });
    const reportsOptions = (0, $6uMv9.useMemo)(()=>{
        let reports;
        if ((0, $8LupL.isAdminDomain) && adminReports) reports = adminReports;
        else if ((0, $8LupL.isPartnerDomain) && partnerReports) reports = partnerReports;
        else return;
        return reports?.map((nextReport)=>({
                value: nextReport.id,
                label: nextReport.name
            }));
    }, [
        adminReports,
        partnerReports
    ]);
    const [getReports] = (0, $fvmYM.useLazyReportGetReportDataQuery)();
    const generateReportCompany = async ({ reportId: reportId, fromDate: fromDate, toDate: toDate })=>{
        try {
            setIsGeneratingReport(true);
            const from = (0, $9406q.default)(fromDate, $7769f84bf243f542$var$dateFormat);
            const to = (0, $9406q.default)((0, $2SOry.default)(toDate, 1), $7769f84bf243f542$var$dateFormat);
            (0, $2460e.notifySuccess)(text("lblGeneratingReport"));
            const tz = (0, (/*@__PURE__*/$parcel$interopDefault($feY3H))).determine();
            const reportData = await getReports({
                reportId: reportId,
                companyId: selectedCompanyId,
                fromInLocalTime: from,
                toInLocalTime: to,
                timeZone: tz.name()
            }).unwrap();
            (0, $bM0Pb.generateReports)(reportData, from, to);
            (0, $2460e.notifySuccess)(text("lblReportGenerateSuccess"));
        } catch (error) {
            (0, $2460e.notifyError)(text("Failed to generate report"));
        } finally{
            setIsGeneratingReport(false);
        }
    };
    const generateReportPartner = async ({ reportId: reportId, fromDate: fromDate, toDate: toDate })=>{
        try {
            setIsGeneratingReport(true);
            const from = (0, $9406q.default)(fromDate, $7769f84bf243f542$var$dateFormat);
            const to = (0, $9406q.default)((0, $2SOry.default)(toDate, 1), $7769f84bf243f542$var$dateFormat);
            (0, $2460e.notifySuccess)(text("lblGeneratingReport"));
            const tz = (0, (/*@__PURE__*/$parcel$interopDefault($feY3H))).determine();
            const reportData = await getReports({
                reportId: reportId,
                partnerId: partnerId,
                fromInLocalTime: from,
                toInLocalTime: to,
                timeZone: tz.name()
            }).unwrap();
            (0, $bM0Pb.generateReports)(reportData, from, to);
            (0, $2460e.notifySuccess)(text("lblReportGenerateSuccess"));
        } catch (error) {
            (0, $2460e.notifyError)(text("Failed to generate report"));
        } finally{
            setIsGeneratingReport(false);
        }
    };
    const getReportDescription = ()=>{
        const reports = (0, $8LupL.isAdminDomain) ? adminReports : partnerReports;
        return reports?.find((report)=>report.id === reportId)?.description;
    };
    const reportId = watch("reportId");
    const fromDate = watch("fromDate");
    const toDate = watch("toDate");
    const setDateBasedOnInterval = (interval)=>{
        const dateInterval = (0, $bM0Pb.getDatesForInterval)(interval);
        if (!dateInterval) return;
        if (dateInterval.fromDate) setValue("fromDate", dateInterval.fromDate);
        if (dateInterval.toDate) setValue("toDate", dateInterval.toDate);
        setIntervalSelected(interval);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblReportGenerator"),
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2q5Lx.TooltipIcon), null),
            onClick: ()=>setShowHelpModal(true),
            className: "ghost"
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            onClick: (0, $8LupL.isAdminDomain) ? handleSubmit(generateReportCompany) : handleSubmit(generateReportPartner),
            size: "sm",
            disabled: !isValid,
            loading: isGeneratingReport,
            "data-testid": "generate-btn"
        }, text("btnGenerate"))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-wrap md:flex-nowrap gap-4 field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field w-full w-12 md:w-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "reportId",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iIdvQ.Combobox), {
                id: "selecter-report",
                "data-testid": "select-report-dropdown",
                options: reportsOptions,
                value: value,
                onChange: (option)=>onChange(option.value),
                labelText: text("lblReport")
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 md:w-6 flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "fromDate",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8ugaX.default), {
                id: "fromDate",
                "data-testid": "fromDate-input",
                wrapperClassName: "w-6",
                labelText: text("lblFromField"),
                max: (0, $9406q.default)(toDate, $7769f84bf243f542$var$dateFormat),
                value: (0, $9406q.default)(value, $7769f84bf243f542$var$dateFormat),
                onChange: (event)=>{
                    onChange(event.target.valueAsDate);
                    setIntervalSelected(undefined);
                }
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "toDate",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8ugaX.default), {
                id: "toDate",
                "data-testid": "toDate-input",
                wrapperClassName: "w-6",
                labelText: text("lblToField"),
                min: (0, $9406q.default)(fromDate, $7769f84bf243f542$var$dateFormat),
                value: (0, $9406q.default)(value, $7769f84bf243f542$var$dateFormat),
                onChange: (event)=>{
                    onChange(event.target.valueAsDate);
                    setIntervalSelected(undefined);
                }
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex justify-content-between mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $238Qp.SLabelText), {
        className: "label-indent",
        "data-testid": "earthingSystem-label"
    }, text("lblPreDefinedIntervals"))), screenSize === (0, $86MrK.ScreenDeviceType).Tablet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iIdvQ.Combobox), {
        enableDefaultOption: false,
        id: "interval",
        "data-testid": "interval-dropdown",
        options: periodOptions,
        value: intervalSelected,
        onChange: (option)=>setDateBasedOnInterval(option.value)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $l8slY.default), {
        options: periodOptions,
        onChange: (value)=>setDateBasedOnInterval(value),
        value: intervalSelected
    })), reportId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field mt-2 mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex justify-content-between mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $238Qp.SLabelText), {
        className: "label-indent",
        "data-testid": "earthingSystem-label"
    }, text("lblSelectedReportDescription"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("i", null, getReportDescription())))), showHelpModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7jCZT.default), {
        title: text("lblHelpModal"),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "msgImportingReports"
        }),
        close: ()=>setShowHelpModal(false),
        dismiss: ()=>setShowHelpModal(false),
        okButtonText: text("btnClose")
    }));
};

});
parcelRegister("bM0Pb", function(module, exports) {

$parcel$export(module.exports, "getDatesForInterval", function () { return $df3d588ef8403c66$export$6d61308487428d58; });
$parcel$export(module.exports, "generateReports", function () { return $df3d588ef8403c66$export$50c60a6cc98727b6; });

var $ikmRQ = parcelRequire("ikmRQ");
var $6dpmc = parcelRequire("6dpmc");
var $jUatP = parcelRequire("jUatP");
var $hR689 = parcelRequire("hR689");
var $1kNlJ = parcelRequire("1kNlJ");
var $fYcsu = parcelRequire("fYcsu");
var $hTRiE = parcelRequire("hTRiE");
var $ipGTb = parcelRequire("ipGTb");
var $7Aqef = parcelRequire("7Aqef");

var $gS62Y = parcelRequire("gS62Y");

var $ioQ6U = parcelRequire("ioQ6U");
const $df3d588ef8403c66$export$6d61308487428d58 = (interval)=>{
    let intervalStart;
    let fromDate;
    let toDate;
    switch(interval){
        case "CurrentWeek":
            fromDate = (0, $1kNlJ.default)(new Date());
            toDate = (0, $6dpmc.default)(new Date());
            break;
        case "PreviousWeek":
            intervalStart = (0, $ipGTb.default)(new Date(), 1);
            fromDate = (0, $1kNlJ.default)(intervalStart);
            toDate = (0, $6dpmc.default)(intervalStart);
            break;
        case "CurrentMonth":
            fromDate = (0, $hR689.default)(new Date());
            toDate = (0, $ikmRQ.default)(new Date());
            break;
        case "PreviousMonth":
            intervalStart = (0, $hTRiE.default)(new Date(), 1);
            fromDate = (0, $hR689.default)(intervalStart);
            toDate = (0, $ikmRQ.default)(intervalStart);
            break;
        case "CurrentYear":
            fromDate = (0, $fYcsu.default)(new Date());
            toDate = (0, $jUatP.default)(new Date());
            break;
        case "PreviousYear":
            intervalStart = (0, $7Aqef.default)(new Date(), 1);
            fromDate = (0, $fYcsu.default)(intervalStart);
            toDate = (0, $jUatP.default)(intervalStart);
            break;
        default:
            return;
    }
    return {
        fromDate: fromDate,
        toDate: toDate
    };
};
const $df3d588ef8403c66$export$50c60a6cc98727b6 = (report, fromDate, toDate)=>{
    const reportName = (0, $gS62Y.default)(report, fromDate, toDate);
    let csvData = "\uFEFF" + report.formattedData;
    if (!report.formattedData || report.formattedData.length === 0) csvData += "N/A";
    (0, $ioQ6U.downloadFile)(reportName, "csv", csvData);
};

});
parcelRegister("hTRiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d080eaf0b46709de$export$2e2bcd8739ae039; });

var $6GWr2 = parcelRequire("6GWr2");

var $1To4m = parcelRequire("1To4m");

var $85z4K = parcelRequire("85z4K");
function $d080eaf0b46709de$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $85z4K.default)(2, arguments);
    var amount = (0, $6GWr2.default)(dirtyAmount);
    return (0, $1To4m.default)(dirtyDate, -amount);
}

});

parcelRegister("ipGTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67bd4b115fc0f68$export$2e2bcd8739ae039; });

var $6GWr2 = parcelRequire("6GWr2");

var $jp8I9 = parcelRequire("jp8I9");

var $85z4K = parcelRequire("85z4K");
function $d67bd4b115fc0f68$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $85z4K.default)(2, arguments);
    var amount = (0, $6GWr2.default)(dirtyAmount);
    return (0, $jp8I9.default)(dirtyDate, -amount);
}

});

parcelRegister("7Aqef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58603db132ee2868$export$2e2bcd8739ae039; });

var $6GWr2 = parcelRequire("6GWr2");

var $3rsxD = parcelRequire("3rsxD");

var $85z4K = parcelRequire("85z4K");
function $58603db132ee2868$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $85z4K.default)(2, arguments);
    var amount = (0, $6GWr2.default)(dirtyAmount);
    return (0, $3rsxD.default)(dirtyDate, -amount);
}

});

parcelRegister("gS62Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b884c2d1a308604e$export$2e2bcd8739ae039; });
const $b884c2d1a308604e$var$getReportName = (report, dateFrom, dateTo)=>`${report.name}_${dateFrom}--${dateTo}.${report.fileExtension}`;
var $b884c2d1a308604e$export$2e2bcd8739ae039 = $b884c2d1a308604e$var$getReportName;

});

parcelRegister("ioQ6U", function(module, exports) {

$parcel$export(module.exports, "downloadFile", function () { return $0287f4b3b478c63b$export$bb3b75778e3e272; });
const $0287f4b3b478c63b$var$blobType = {
    csv: "text/csv;charset=UTF-8",
    txt: "application/txt",
    pdf: "application/pdf",
    json: "application/json",
    xml: "application/xml"
};
const $0287f4b3b478c63b$export$bb3b75778e3e272 = (fileName, extension, data)=>{
    const file = new Blob([
        data
    ], {
        type: $0287f4b3b478c63b$var$blobType[extension]
    });
    const anchor = Object.assign(document.createElement("a"), {
        href: URL.createObjectURL(file),
        target: "_blank",
        download: `${fileName}`,
        style: "display: none"
    });
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
};

});



parcelRegister("io716", function(module, exports) {

$parcel$export(module.exports, "AutomaticReportDeliveriesTable", function () { return $707dd94eae27e7e0$export$7f0aebe95bb55606; });

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $f7UZA = parcelRequire("f7UZA");

var $8sl5H = parcelRequire("8sl5H");

var $2naDF = parcelRequire("2naDF");

var $dfOhE = parcelRequire("dfOhE");

var $cfXjW = parcelRequire("cfXjW");

var $7jCZT = parcelRequire("7jCZT");

var $2460e = parcelRequire("2460e");

var $fvmYM = parcelRequire("fvmYM");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $bAtcn = parcelRequire("bAtcn");

var $duQ8A = parcelRequire("duQ8A");

var $1dgSH = parcelRequire("1dgSH");

var $aL1Vp = parcelRequire("aL1Vp");
const $707dd94eae27e7e0$export$7f0aebe95bb55606 = ()=>{
    const text = (0, $aL1Vp.default)();
    const { selectedCompanyId: selectedCompanyId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const [addReportDeliveryModal, setAddReportDeliveryModal] = (0, $6uMv9.useState)({
        isOpen: false
    });
    const [confirmDeleteReportModal, setIsConfirmDeleteReportModalOpen] = (0, $6uMv9.useState)({
        isOpen: false
    });
    const { data: reports, isLoading: isLoading } = (0, $fvmYM.useReportGetReportsForAdminQuery)({
        selectedCompanyId: selectedCompanyId
    });
    const reportNames = (0, $6uMv9.useMemo)(()=>new Map(reports?.map((i)=>[
                i.id,
                i.name
            ])), [
        reports
    ]);
    const { data: reportDeliverySchedules } = (0, $fvmYM.useCompanyGetReportDeliverySchedulesQuery)({
        companyId: selectedCompanyId
    });
    const [deleteDeliveryScheduleRequest] = (0, $fvmYM.useCompanyDeleteReportDeliveryScheduleMutation)();
    const deleteDeliverySchedule = async (reportDeliveryScheduleId)=>{
        try {
            await deleteDeliveryScheduleRequest({
                companyId: selectedCompanyId,
                reportDeliveryScheduleId: reportDeliveryScheduleId
            }).unwrap();
            (0, $2460e.notifySuccess)("Report delivery schedule has been removed");
        } catch (_) {
            (0, $2460e.notifyError)("Failed to remove report delivery schedule");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblAutomaticReportDeliveriesField"),
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8sl5H.default), null),
            size: "sm",
            onClick: ()=>setAddReportDeliveryModal({
                    isOpen: true
                })
        }, text("lblAdd"))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblActiveStatus")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblReport")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblType")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblInterval")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblReceiverEmail")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblLastSent")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), {
        isLoading: isLoading,
        numberOfLoadingColumns: 6
    }, reportDeliverySchedules?.map((nextReportDeliverySchedule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: nextReportDeliverySchedule.id,
            className: "pointer",
            onClick: ()=>setAddReportDeliveryModal({
                    isOpen: true,
                    reportDeliverySchedule: nextReportDeliverySchedule
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "w-1rem"
        }, nextReportDeliverySchedule.active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            className: "flex justify-content-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cfXjW.CheckMarkIcon), {
            size: 18
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, nextReportDeliverySchedule.reportId && reportNames.get(nextReportDeliverySchedule.reportId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, nextReportDeliverySchedule.deliveryType), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, nextReportDeliverySchedule.deliveryInterval), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, nextReportDeliverySchedule.receiverEmail), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, (0, $dfOhE.default)(nextReportDeliverySchedule.lastSent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.default), {
            id: nextReportDeliverySchedule.reportId,
            "data-testid": "menu-toggle-report"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: (event)=>{
                event.stopPropagation();
                setIsConfirmDeleteReportModalOpen({
                    isOpen: true,
                    reportId: nextReportDeliverySchedule.id,
                    name: reportNames.get(nextReportDeliverySchedule.reportId)
                });
            },
            text: text("btnRemove"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1dgSH.default), {
                size: 14
            }),
            key: "btnRemoveReport",
            "data-testid": "btn-remove-report"
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $bAtcn.AddReportDeliveryModal), {
        visible: addReportDeliveryModal.isOpen,
        onHide: ()=>setAddReportDeliveryModal({
                isOpen: false,
                reportDeliverySchedule: undefined
            }),
        selectedReportDeliverySchedule: addReportDeliveryModal.reportDeliverySchedule
    }), confirmDeleteReportModal.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7jCZT.default), {
        title: text("lblRemoveReport"),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "msgConfirmReportRemoving",
            values: {
                reportName: confirmDeleteReportModal.name
            }
        }),
        showCancel: true,
        dismiss: ()=>setIsConfirmDeleteReportModalOpen({
                isOpen: false
            }),
        close: (result)=>{
            if (result && confirmDeleteReportModal.reportId) deleteDeliverySchedule(confirmDeleteReportModal.reportId);
            setIsConfirmDeleteReportModalOpen({
                isOpen: false
            });
        }
    }));
};

});
parcelRegister("8sl5H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f71b91d88fc312e5$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $3Bejm = parcelRequire("3Bejm");
const $f71b91d88fc312e5$var$AddIcon = ({ fill: fill = "currentColor", size: size = 14, title: title, id: id = "info-icon" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3Bejm.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("g", {
        clipPath: "url(#clip0_3971_11307)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M20 10H12V2H10V10H2V12H10V20H12V12H20V10Z",
        fill: fill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("clipPath", {
        id: "clip0_3971_11307"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("rect", {
        width: "18",
        height: "18",
        fill: fill,
        transform: "translate(2 2)"
    })))));
};
var $f71b91d88fc312e5$export$2e2bcd8739ae039 = $f71b91d88fc312e5$var$AddIcon;

});

parcelRegister("bAtcn", function(module, exports) {

$parcel$export(module.exports, "AddReportDeliveryModal", function () { return $677b990cd652cd02$export$c8c1b1755b871d63; });

var $6uMv9 = parcelRequire("6uMv9");

var $feY3H = parcelRequire("feY3H");

var $cbVaW = parcelRequire("cbVaW");

var $4vH3e = parcelRequire("4vH3e");

var $hJq0b = parcelRequire("hJq0b");

var $7Ilk7 = parcelRequire("7Ilk7");

var $05aLh = parcelRequire("05aLh");

var $aIcGc = parcelRequire("aIcGc");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $aHJk3 = parcelRequire("aHJk3");

var $l8slY = parcelRequire("l8slY");

var $aL1Vp = parcelRequire("aL1Vp");

var $1oBYI = parcelRequire("1oBYI");

var $iXXep = parcelRequire("iXXep");
const $677b990cd652cd02$var$defaultValues = {
    deliveryType: "Email"
};
const $677b990cd652cd02$export$c8c1b1755b871d63 = ({ visible: visible, onHide: onHide, selectedReportDeliverySchedule: selectedReportDeliverySchedule })=>{
    const text = (0, $aL1Vp.default)();
    const { selectedCompanyId: selectedCompanyId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const reportDeliveryIntervalsList = [
        {
            value: "Day",
            label: text("lblDayInterval")
        },
        {
            value: "Month",
            label: text("lblMonthInterval")
        },
        {
            value: "Year",
            label: text("lblYearInterval")
        },
        {
            value: "Quarter",
            label: text("lblQuarterInterval")
        }
    ];
    const reportDeliverySchema = $7Ilk7.object().shape({
        reportId: $7Ilk7.number().nullable().required(text("errReportRequired")),
        deliveryInterval: $7Ilk7.string().nullable().required(text("errDeliveryIntervalRequired")),
        deliveryType: $7Ilk7.string().nullable().required(text("errDeliveryTypeRequired")),
        receiverName: $7Ilk7.string().when("deliveryType", {
            is: "Email",
            then: $7Ilk7.string().required(text("errReceiverNameRequired")),
            otherwise: $7Ilk7.string().nullable().notRequired()
        }),
        receiverEmail: $7Ilk7.string().nullable().when("deliveryType", {
            is: "Email",
            then: $7Ilk7.string().email(text("errReceiverEmailInvalid")).required(text("errReceiverEmailRequired")),
            otherwise: $7Ilk7.string().nullable().notRequired()
        }),
        mailSubject: $7Ilk7.string().when("deliveryType", {
            is: "Email",
            then: $7Ilk7.string().required(text("errMailSubjectRequired")),
            otherwise: $7Ilk7.string().nullable().notRequired()
        }),
        ftpUrl: $7Ilk7.string().when("deliveryType", {
            is: "Ftp",
            then: $7Ilk7.string().url(text("errFtpUrlInvalid")).required(text("errFtpUrlRequired")),
            otherwise: $7Ilk7.string().nullable().notRequired()
        }),
        ftpUserName: $7Ilk7.string().when("deliveryType", {
            is: "Ftp",
            then: $7Ilk7.string().required(text("errFtpUserNameRequired")),
            otherwise: $7Ilk7.string().nullable().notRequired()
        }),
        ftpPassword: $7Ilk7.string().when("deliveryType", {
            is: "Ftp",
            then: $7Ilk7.string().required(text("errFtpPasswordRequired")),
            otherwise: $7Ilk7.string().nullable().notRequired()
        }),
        active: $7Ilk7.boolean().notRequired()
    });
    const { control: control, register: register, handleSubmit: handleSubmit, watch: watch, reset: reset, formState: { errors: errors, isValid: isValid, isSubmitting: isSubmitting } } = (0, $cbVaW.useForm)({
        defaultValues: {
            ...$677b990cd652cd02$var$defaultValues,
            ...selectedReportDeliverySchedule
        },
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: (0, $hJq0b.yupResolver)(reportDeliverySchema)
    });
    (0, $6uMv9.useEffect)(()=>{
        if (visible) reset({
            ...$677b990cd652cd02$var$defaultValues,
            ...selectedReportDeliverySchedule
        });
    }, [
        visible,
        selectedReportDeliverySchedule,
        reset
    ]);
    const deliveryType = watch("deliveryType");
    const [updateReport] = (0, $fvmYM.useCompanyUpdateReportDeliveryScheduleMutation)();
    const [createReport] = (0, $fvmYM.useCompanyCreateReportDeliveryScheduleMutation)();
    const saveReportDelivery = async (formValues)=>{
        try {
            const payload = {
                ...formValues,
                ftpUrl: deliveryType === "Ftp" ? formValues.ftpUrl : undefined,
                ftpUserName: deliveryType === "Ftp" ? formValues.ftpUserName : undefined,
                ftpPassword: deliveryType === "Ftp" ? formValues.ftpPassword : undefined,
                receiverName: deliveryType === "Email" ? formValues.receiverName : undefined,
                receiverEmail: deliveryType === "Email" ? formValues.receiverEmail : undefined,
                mailSubject: deliveryType === "Email" ? formValues.mailSubject : undefined,
                timeZone: (0, (/*@__PURE__*/$parcel$interopDefault($feY3H))).determine().name()
            };
            if (selectedReportDeliverySchedule) await updateReport({
                companyId: selectedCompanyId,
                reportDeliverySchedule: payload
            }).unwrap();
            else await createReport({
                companyId: selectedCompanyId,
                reportDeliverySchedule: payload
            }).unwrap();
            onHide();
            (0, $2460e.notifySuccess)(text("msgReportSaved"));
        } catch (_) {
            (0, $2460e.notifyError)(text("msgReportNotSaved"));
        }
    };
    const { data: reports } = (0, $fvmYM.useReportGetReportsForAdminQuery)({
        selectedCompanyId: selectedCompanyId
    }, {
        skip: !selectedCompanyId
    });
    const reportsOptions = (0, $6uMv9.useMemo)(()=>reports?.map((nextReport)=>({
                value: nextReport.id,
                label: nextReport.name
            })) || [], [
        reports
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $05aLh.Dialog), {
        header: text("lblReportAddingModal"),
        visible: visible,
        onHide: onHide,
        style: {
            width: "50vw"
        },
        breakpoints: {
            "960px": "75vw",
            "641px": "100vw"
        },
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
            label: text("btnCancel"),
            onClick: onHide,
            icon: "pi pi-times"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
            label: text("btnSave"),
            onClick: handleSubmit(saveReportDelivery),
            icon: "pi pi-check",
            disabled: !isValid || isSubmitting,
            loading: isSubmitting
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        className: "flex flex-column gap-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "reportId",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iXXep.Dropdown), {
                options: reportsOptions,
                id: "report-id-select",
                "data-testid": "report-id-select",
                label: text("lblReport"),
                value: field.value,
                onChange: (option)=>field.onChange(option.value),
                error: errors.reportId?.message
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "deliveryInterval",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iXXep.Dropdown), {
                options: reportDeliveryIntervalsList,
                label: text("lblDeliveryIntervalField"),
                id: "interval-select",
                "data-testid": "interval-select",
                value: field.value,
                onChange: (option)=>field.onChange(option.value),
                error: errors.deliveryInterval?.message
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "p-label",
        "data-testid": "report-delivery-label"
    }, text("lblDeliveryType")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "deliveryType",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $l8slY.default), {
                options: [
                    {
                        value: "Email",
                        label: "Email"
                    },
                    {
                        value: "Ftp",
                        label: "Ftp"
                    }
                ],
                onChange: (value)=>field.onChange(value),
                value: field.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "mb-2 text-xl text-color-secondary"
    }, text("lblReportDeliveryettings")), deliveryType === "Email" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-column gap-3",
        key: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "receiverName",
        label: "Receiver Name",
        maxLength: 50,
        error: errors.receiverName?.message,
        ...register("receiverName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "receiverEmail",
        label: "Receiver Email",
        type: "email",
        autoComplete: "off",
        maxLength: 100,
        error: errors.receiverEmail?.message,
        ...register("receiverEmail")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "receiverSubject",
        label: "Email Subject",
        autoComplete: "off",
        maxLength: 50,
        error: errors.mailSubject?.message,
        ...register("mailSubject")
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-column gap-3",
        key: "ftp"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "ftpURL",
        label: "FTP URL",
        type: "url",
        error: errors.ftpUrl?.message,
        ...register("ftpUrl")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "ftpUserName",
        label: "FTP Username",
        autoComplete: "new-password",
        error: errors.ftpUserName?.message,
        ...register("ftpUserName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "ftpPassword",
        label: "FTP Password",
        type: "password",
        autoComplete: "new-password",
        error: errors.ftpPassword?.message,
        ...register("ftpPassword")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "active",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aHJk3.default), {
                toggleText: "Active",
                isToggled: field.value ?? false,
                className: "justify-content-end",
                toggleFn: ()=>field.onChange(!field.value)
            })
    })));
};

});




parcelRegister("ckDUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b744a8951460a73f$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $lG0u6 = parcelRequire("lG0u6");

var $1xw2Y = parcelRequire("1xw2Y");

var $f7UZA = parcelRequire("f7UZA");

var $4AFFH = parcelRequire("4AFFH");

var $lSK2P = parcelRequire("lSK2P");

var $cfXjW = parcelRequire("cfXjW");

var $28pGp = parcelRequire("28pGp");
const $b744a8951460a73f$var$SDiv = (0, $akcQ4.default).div`
    position: fixed;
    bottom: 0px;
    width: 100%;
    z-index: 1000;
    padding: ${({ theme: theme })=>theme.sizing.padding.l};
    background-color: ${({ theme: theme })=>theme.whiteBackground};
    box-shadow: rgba(0, 0, 0, 0.1) 0px -10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
        text-decoration: underline;
    }

    @media (max-width: 767px) {
        flex-flow: column;
        gap: 20px;
    }
`;
const $b744a8951460a73f$var$SBtnGroup = (0, $akcQ4.default).div`
    display: flex;
    gap: ${({ theme: theme })=>theme.sizing.margin.m};

    @media (max-width: 767px) {
        margin-left: auto;
        flex-flow: column;
        width: 100%;

        button {
            width: 100%;
        }
    }
`;
const $b744a8951460a73f$var$cookieConsentName = "acceptCookieConsent";
const $b744a8951460a73f$var$clarityCookieName = "_clck";
const $b744a8951460a73f$var$CookieConsentBar = ()=>{
    const hasClarityCookie = ()=>document.cookie.split(";").findIndex((nextCookie)=>nextCookie.trimStart().startsWith($b744a8951460a73f$var$clarityCookieName)) > -1;
    const [cookieSelection, setCookieSelection] = (0, $6uMv9.useState)(()=>{
        if (hasClarityCookie()) return true;
        return (0, $lSK2P.default).getItem($b744a8951460a73f$var$cookieConsentName) === false;
    });
    const consentCookies = ()=>{
        if (!hasClarityCookie()) window.clarity("consent");
        (0, $28pGp.appInsights)?.getCookieMgr().setEnabled(true);
        (0, $lSK2P.default).setItem($b744a8951460a73f$var$cookieConsentName, true);
        setCookieSelection(true);
    };
    const closeCookies = ()=>{
        (0, $lSK2P.default).setItem($b744a8951460a73f$var$cookieConsentName, false);
        setCookieSelection(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, !cookieSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($b744a8951460a73f$var$SDiv, {
        "data-testid": "cookie-consent-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgCookiePolicyInformation",
        values: {
            link: {
                href: `https://www.chargeamps.com/cookie-policy/`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "blueLink"
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($b744a8951460a73f$var$SBtnGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        label: "Accept",
        size: "sm",
        onClick: ()=>consentCookies(),
        className: "consent-btn",
        "data-testid": "cookie-accept-btn",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cfXjW.CheckMarkIcon), {
            size: 20,
            color: (0, $lG0u6.theme).font.successColor
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        label: "Decline",
        size: "sm",
        onClick: ()=>closeCookies(),
        primary: false,
        className: "secondary",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4AFFH.CloseIcon), {
            size: 16
        }),
        "data-testid": "cookie-decline-btn"
    }))));
};
var $b744a8951460a73f$export$2e2bcd8739ae039 = $b744a8951460a73f$var$CookieConsentBar;

});
parcelRegister("28pGp", function(module, exports) {

$parcel$export(module.exports, "appInsights", function () { return $9ef5bb7a3cdc68bd$export$3615512b8c4a30de; });

var $bulXG = parcelRequire("bulXG");

var $afjBc = parcelRequire("afjBc");

var $gDDh0 = parcelRequire("gDDh0");
const { hostname: $9ef5bb7a3cdc68bd$var$hostname } = window.location;
const $9ef5bb7a3cdc68bd$var$shouldTrack = [
    ...(0, $bulXG.PRODUCTION_HOSTS),
    ...(0, $bulXG.STAGING_HOSTS),
    ...(0, $bulXG.DEV_HOSTS)
].includes($9ef5bb7a3cdc68bd$var$hostname);
const $9ef5bb7a3cdc68bd$var$shouldDisplay = [
    ...(0, $bulXG.DEV_HOSTS),
    (0, $bulXG.LOCAL_HOSTS)
].includes($9ef5bb7a3cdc68bd$var$hostname);
const $9ef5bb7a3cdc68bd$export$3615512b8c4a30de = $9ef5bb7a3cdc68bd$var$shouldTrack ? (0, $afjBc.default)("5b67ff0e-1cba-4c78-824d-c02d4a18c275") : null;
const $9ef5bb7a3cdc68bd$var$track = (eventName, props)=>{
    if ($9ef5bb7a3cdc68bd$var$shouldDisplay) (0, $gDDh0.default)("gtag", [
        eventName,
        props
    ]);
};
$9ef5bb7a3cdc68bd$var$track.pageView = (props)=>{
    $9ef5bb7a3cdc68bd$export$3615512b8c4a30de?.trackPageView({
        name: props.title || document.title,
        uri: props.location || window.location.href
    });
};
var $9ef5bb7a3cdc68bd$export$2e2bcd8739ae039 = $9ef5bb7a3cdc68bd$var$track;

});
parcelRegister("bulXG", function(module, exports) {

$parcel$export(module.exports, "PRODUCTION_HOSTS", function () { return $3f6dc7e18be2dac9$export$179d7ce44db1bb86; });
$parcel$export(module.exports, "STAGING_HOSTS", function () { return $3f6dc7e18be2dac9$export$6abbd97376ac33ee; });
$parcel$export(module.exports, "DEV_HOSTS", function () { return $3f6dc7e18be2dac9$export$441ffaf2f9e0a685; });
$parcel$export(module.exports, "LOCAL_HOSTS", function () { return $3f6dc7e18be2dac9$export$a7a99665d76eb3de; });
const $3f6dc7e18be2dac9$export$179d7ce44db1bb86 = [
    "ca-web-north-eu-webapp.azurewebsites.net",
    "chargeampsweb.azurewebsites.net",
    "my.charge.space",
    "fortum.charge.space"
];
const $3f6dc7e18be2dac9$export$6abbd97376ac33ee = [
    "ca-web-north-eu-webapp-staging.azurewebsites.net",
    "chargeampsweb-stage.azurewebsites.net",
    "mys.charge.space",
    "fortums.charge.space"
];
const $3f6dc7e18be2dac9$export$441ffaf2f9e0a685 = [
    "ca-web-webapp-dev.azurewebsites.net",
    "chargeampsweb-dev.azurewebsites.net",
    "myd.charge.space",
    "myz.charge.space"
];
const $3f6dc7e18be2dac9$export$97e33e37eeb5c5b7 = [
    "chargeampsweb-test.azurewebsites.net",
    "myt.charge.space"
];
const $3f6dc7e18be2dac9$export$a7a99665d76eb3de = [
    "localhost"
];

});

parcelRegister("afjBc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b721b7965ab9328$export$2e2bcd8739ae039; });

var $2pwX5 = parcelRequire("2pwX5");
const $3b721b7965ab9328$var$setupAppInsights = (trackingId)=>{
    const appInsights = new (0, $2pwX5.Initialization)({
        config: {
            instrumentationKey: trackingId,
            autoTrackPageVisitTime: true,
            enableAutoRouteTracking: true,
            disableCookiesUsage: true
        }
    });
    appInsights.loadAppInsights();
    return appInsights;
};
var $3b721b7965ab9328$export$2e2bcd8739ae039 = $3b721b7965ab9328$var$setupAppInsights;

});
parcelRegister("2pwX5", function(module, exports) {

$parcel$export(module.exports, "Initialization", function () { return $1c177a2a4b3f2253$export$d49a2f682d00cad8; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $31FNP = parcelRequire("31FNP");

var $zBQDZ = parcelRequire("zBQDZ");

var $HME9b = parcelRequire("HME9b");
var $hkZeA = parcelRequire("hkZeA");
var $cYGa2 = parcelRequire("cYGa2");
var $llS2C = parcelRequire("llS2C");
var $rOoAk = parcelRequire("rOoAk");
var $cWQSw = parcelRequire("cWQSw");
var $03HBY = parcelRequire("03HBY");
var $i2MiW = parcelRequire("i2MiW");
var $cVsUj = parcelRequire("cVsUj");
var $dU7nU = parcelRequire("dU7nU");
var $awDWn = parcelRequire("awDWn");
var $9rbbk = parcelRequire("9rbbk");
var $g5yzi = parcelRequire("g5yzi");
var $jMj33 = parcelRequire("jMj33");
var $czkZK = parcelRequire("czkZK");
var $cAmBy = parcelRequire("cAmBy");
var $cXuOT = parcelRequire("cXuOT");
var $ddqo3 = parcelRequire("ddqo3");
var $fIGMW = parcelRequire("fIGMW");
var $55exP = parcelRequire("55exP");
var $7iT8I = parcelRequire("7iT8I");

var $i86yL = parcelRequire("i86yL");
var $lhl6R = parcelRequire("lhl6R");
var $aOa6H = parcelRequire("aOa6H");
var $hGXAo = parcelRequire("hGXAo");
var $5GGqM = parcelRequire("5GGqM");
var $4LGgU = parcelRequire("4LGgU");
var $bU24K = parcelRequire("bU24K");

var $8S0st = parcelRequire("8S0st");

var $iri4r = parcelRequire("iri4r");

var $kzp4v = parcelRequire("kzp4v");

var $9gNlH = parcelRequire("9gNlH");
"use strict";
var $1c177a2a4b3f2253$var$_internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var $1c177a2a4b3f2253$var$_ignoreUpdateSnippetProperties = [
    (0, $kzp4v.STR_SNIPPET),
    "dependencies",
    "properties",
    "_snippetVersion",
    "appInsightsNew",
    "getSKUDefaults"
];
// Re-exposing the Common classes as Telemetry, the list was taken by reviewing the generated code for the build while using
// the previous configuration :-
// import * as Common from "@microsoft/applicationinsights-common"
// export const Telemetry = Common;
var $1c177a2a4b3f2253$var$fieldType = {
    Default: 0 /* FieldType.Default */ ,
    Required: 1 /* FieldType.Required */ ,
    Array: 2 /* FieldType.Array */ ,
    Hidden: 4 /* FieldType.Hidden */ 
};
var $1c177a2a4b3f2253$export$dce6f134b7ab7df7 = {
    __proto__: null,
    PropertiesPluginIdentifier: (0, $HME9b.PropertiesPluginIdentifier),
    BreezeChannelIdentifier: (0, $HME9b.BreezeChannelIdentifier),
    AnalyticsPluginIdentifier: (0, $HME9b.AnalyticsPluginIdentifier),
    Util: (0, $rOoAk.Util),
    CorrelationIdHelper: (0, $rOoAk.CorrelationIdHelper),
    UrlHelper: (0, $rOoAk.UrlHelper),
    DateTimeUtils: (0, $rOoAk.DateTimeUtils),
    ConnectionStringParser: (0, $cYGa2.ConnectionStringParser),
    FieldType: $1c177a2a4b3f2253$var$fieldType,
    RequestHeaders: (0, $ddqo3.RequestHeaders),
    DisabledPropertyName: (0, $cVsUj.DisabledPropertyName),
    ProcessLegacy: (0, $cVsUj.ProcessLegacy),
    SampleRate: (0, $cVsUj.SampleRate),
    HttpMethod: (0, $cVsUj.HttpMethod),
    DEFAULT_BREEZE_ENDPOINT: (0, $cVsUj.DEFAULT_BREEZE_ENDPOINT),
    Envelope: (0, $awDWn.Envelope),
    Event: (0, $9rbbk.Event),
    Exception: (0, $g5yzi.Exception),
    Metric: (0, $jMj33.Metric),
    PageView: (0, $czkZK.PageView),
    RemoteDependencyData: (0, $cXuOT.RemoteDependencyData),
    Trace: (0, $7iT8I.Trace),
    PageViewPerformance: (0, $cAmBy.PageViewPerformance),
    Data: (0, $03HBY.Data),
    SeverityLevel: (0, $fIGMW.SeverityLevel),
    ConfigurationManager: (0, $hkZeA.ConfigurationManager),
    ContextTagKeys: (0, $llS2C.ContextTagKeys),
    DataSanitizer: (0, $i2MiW.DataSanitizer),
    TelemetryItemCreator: (0, $55exP.TelemetryItemCreator),
    CtxTagKeys: (0, $cWQSw.CtxTagKeys),
    Extensions: (0, $cWQSw.Extensions),
    DistributedTracingModes: (0, $dU7nU.DistributedTracingModes)
};
/**
 * Application Insights API
 * @class Initialization
 * @implements {IApplicationInsights}
 */ var $1c177a2a4b3f2253$export$d49a2f682d00cad8 = /** @class */ function() {
    function Initialization(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        (0, $bO3cR.default)(Initialization, this, function(_self) {
            _initDefaults();
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[0, $9gNlH._DYN_VERSION /* @min:%2eversion */ ] || "");
            snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ] = snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ] || [];
            snippet[0, $9gNlH._DYN_VERSION /* @min:%2eversion */ ] = snippet[0, $9gNlH._DYN_VERSION /* @min:%2eversion */ ] || 2.0; // Default to new version
            var config = snippet[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ] || {};
            if (config[0, $9gNlH._DYN_CONNECTION_STRING /* @min:%2econnectionString */ ]) {
                var cs = (0, $cYGa2.parseConnectionString)(config[0, $9gNlH._DYN_CONNECTION_STRING /* @min:%2econnectionString */ ]);
                var ingest = cs.ingestionendpoint;
                config[0, $9gNlH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ] = ingest ? ingest + (0, $cVsUj.DEFAULT_BREEZE_PATH) : config[0, $9gNlH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]; // only add /v2/track when from connectionstring
                config[0, $9gNlH._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ] = cs.instrumentationkey || config[0, $9gNlH._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ];
            }
            _self[0, $9gNlH._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ] = new (0, $31FNP.AnalyticsPlugin)();
            properties = new (0, $iri4r.default)();
            dependencies = new (0, $8S0st.AjaxMonitor)();
            _sender = new (0, $zBQDZ.Sender)();
            _core = new (0, $aOa6H.AppInsightsCore)();
            _self.core = _core;
            var isErrMessageDisabled = (0, $hGXAo.isNullOrUndefined)(config[0, $9gNlH._DYN_DISABLE_IKEY_DEPRECA18 /* @min:%2edisableIkeyDeprecationMessage */ ]) ? true : config[0, $9gNlH._DYN_DISABLE_IKEY_DEPRECA18 /* @min:%2edisableIkeyDeprecationMessage */ ];
            if (!config[0, $9gNlH._DYN_CONNECTION_STRING /* @min:%2econnectionString */ ] && !isErrMessageDisabled) (0, $i86yL._throwInternal)(_core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ , "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
            _self[0, $kzp4v.STR_SNIPPET /* @min:%2esnippet */ ] = snippet;
            _self[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ] = config;
            _getSKUDefaults();
            _self[0, $kzp4v.STR_FLUSH /* @min:%2eflush */ ] = function(async) {
                if (async === void 0) async = true;
                (0, $4LGgU.doPerf)(_core, function() {
                    return "AISKU.flush";
                }, function() {
                    (0, $hGXAo.arrForEach)(_core[0, $9gNlH._DYN_GET_TRANSMISSION_CON19 /* @min:%2egetTransmissionControls */ ](), function(channels) {
                        (0, $hGXAo.arrForEach)(channels, function(channel) {
                            channel[0, $kzp4v.STR_FLUSH /* @min:%2eflush */ ](async);
                        });
                    });
                }, null, async);
            };
            _self[0, $9gNlH._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ] = function(async) {
                if (async === void 0) async = true;
                (0, $hGXAo.arrForEach)(_core[0, $9gNlH._DYN_GET_TRANSMISSION_CON19 /* @min:%2egetTransmissionControls */ ](), function(channels) {
                    (0, $hGXAo.arrForEach)(channels, function(channel) {
                        if (channel[0, $9gNlH._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ]) channel[0, $9gNlH._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ]();
                        else channel[0, $kzp4v.STR_FLUSH /* @min:%2eflush */ ](async);
                    });
                });
            };
            _self[0, $9gNlH._DYN_LOAD_APP_INSIGHTS /* @min:%2eloadAppInsights */ ] = function(legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) legacyMode = false;
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!(0, $hGXAo.isNullOrUndefined)(_snippetVersion)) snippetVer += _snippetVersion;
                        if (legacyMode) snippetVer += ".lg";
                        if (_self[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ] && _self[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ].internal) _self[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ].internal.snippetVer = snippetVer || "-";
                        // apply updated properties to the global instance (snippet)
                        (0, $hGXAo.objForEachKey)(_self, function(field, value) {
                            if ((0, $hGXAo.isString)(field) && !(0, $hGXAo.isFunction)(value) && field && field[0] !== "_" && // Don't copy "internal" values
                            (0, $hGXAo.arrIndexOf)($1c177a2a4b3f2253$var$_ignoreUpdateSnippetProperties, field) === -1) snippet[field] = value;
                        });
                    }
                }
                // dont allow additional channels/other extensions for legacy mode; legacy mode is only to allow users to switch with no code changes!
                if (legacyMode && _self[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ].extensions && _self[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ].extensions.length > 0) (0, $hGXAo.throwError)("Extensions not allowed in legacy mode");
                (0, $4LGgU.doPerf)(_self.core, function() {
                    return "AISKU.loadAppInsights";
                }, function() {
                    var extensions = [];
                    extensions[0, $9gNlH._DYN_PUSH /* @min:%2epush */ ](_sender);
                    extensions[0, $9gNlH._DYN_PUSH /* @min:%2epush */ ](properties);
                    extensions[0, $9gNlH._DYN_PUSH /* @min:%2epush */ ](dependencies);
                    extensions[0, $9gNlH._DYN_PUSH /* @min:%2epush */ ](_self[0, $9gNlH._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ]);
                    // initialize core
                    _core.initialize(_self[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ], extensions, logger, notificationManager);
                    _self[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ] = properties[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ];
                    if ($1c177a2a4b3f2253$var$_internalSdkSrc && _self[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ]) _self[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ].internal.sdkSrc = $1c177a2a4b3f2253$var$_internalSdkSrc;
                    _updateSnippetProperties(_self[0, $kzp4v.STR_SNIPPET /* @min:%2esnippet */ ]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[0, $kzp4v.STR_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */ ]();
                    _self[0, $9gNlH._DYN_ADD_HOUSEKEEPING_BEF20 /* @min:%2eaddHousekeepingBeforeUnload */ ](_self);
                });
                return _self;
            };
            _self[0, $9gNlH._DYN_UPDATE_SNIPPET_DEFIN0 /* @min:%2eupdateSnippetDefinitions */ ] = function(snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                (0, $hGXAo.proxyAssign)(snippet, _self, function(name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && (0, $hGXAo.arrIndexOf)($1c177a2a4b3f2253$var$_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function() {
                // call functions that were queued before the main script was loaded
                try {
                    if ((0, $hGXAo.isArray)(_self.snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ].length;
                        for(var i = 0; i < length_1; i++){
                            var call = _self.snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ][i];
                            call();
                        }
                        _self.snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ] = undefined;
                        delete _self.snippet[0, $9gNlH._DYN_QUEUE /* @min:%2equeue */ ];
                    }
                } catch (exception) {
                    var properties_1 = {};
                    if (exception && (0, $hGXAo.isFunction)(exception.toString)) properties_1.exception = exception.toString();
                // need from core
                // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                //     eLoggingSeverity.WARNING,
                //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                //     "Failed to send queued telemetry",
                //     properties);
                }
            };
            _self[0, $9gNlH._DYN_ADD_HOUSEKEEPING_BEF20 /* @min:%2eaddHousekeepingBeforeUnload */ ] = function(appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if ((0, $bU24K.hasWindow)() || (0, $bU24K.hasDocument)()) {
                    var performHousekeeping = function() {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[0, $9gNlH._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if ((0, $hGXAo.isFunction)(_this.core[0, $kzp4v.STR_GET_PLUGIN /* @min:%2egetPlugin */ ])) {
                            var loadedPlugin = _this.core[0, $kzp4v.STR_GET_PLUGIN /* @min:%2egetPlugin */ ]((0, $HME9b.PropertiesPluginIdentifier));
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ] && propertiesPlugin[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ]._sessionManager) propertiesPlugin[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ]._sessionManager.backup();
                            }
                        }
                    };
                    var added = false;
                    var excludePageUnloadEvents = appInsightsInstance.appInsights[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ].disablePageUnloadEvents;
                    if (!_houseKeepingNamespace) _houseKeepingNamespace = (0, $lhl6R.mergeEvtNamespace)(_evtNamespace, _core[0, $kzp4v.STR_EVT_NAMESPACE /* @min:%2eevtNamespace */ ] && _core[0, $kzp4v.STR_EVT_NAMESPACE /* @min:%2eevtNamespace */ ]());
                    if (!appInsightsInstance.appInsights.config[0, $9gNlH._DYN_DISABLE_FLUSH_ON_BEF11 /* @min:%2edisableFlushOnBeforeUnload */ ]) {
                        // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                        // As just hooking the window does not always fire (on chrome) for page navigation's.
                        if ((0, $lhl6R.addPageUnloadEventListener)(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) added = true;
                        // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                        if ((0, $lhl6R.addPageHideEventListener)(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) added = true;
                        // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                        // log the failure in this case
                        if (!added && !(0, $bU24K.isReactNative)()) (0, $i86yL._throwInternal)(appInsightsInstance[0, $9gNlH._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ].core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */ , "Could not add handler for beforeunload and pagehide");
                    }
                    if (!added && !appInsightsInstance.appInsights.config[0, $9gNlH._DYN_DISABLE_FLUSH_ON_UNL12 /* @min:%2edisableFlushOnUnload */ ]) // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                    (0, $lhl6R.addPageHideEventListener)(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace);
                }
            };
            _self.getSender = function() {
                return _sender;
            };
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                _self[0, $9gNlH._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ](isAsync);
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    (0, $lhl6R.removePageUnloadEventListener)(null, _houseKeepingNamespace);
                    (0, $lhl6R.removePageHideEventListener)(null, _houseKeepingNamespace);
                }
                _core.unload && _core.unload(isAsync, unloadComplete, cbTimeout);
            };
            (0, $hGXAo.proxyFunctions)(_self, _self[0, $9gNlH._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ], [
                (0, $kzp4v.STR_GET_COOKIE_MGR),
                (0, $kzp4v.STR_TRACK_EVENT),
                (0, $kzp4v.STR_TRACK_PAGE_VIEW),
                "trackPageViewPerformance",
                (0, $kzp4v.STR_TRACK_EXCEPTION),
                "_onerror",
                (0, $kzp4v.STR_TRACK_TRACE),
                (0, $kzp4v.STR_TRACK_METRIC),
                (0, $kzp4v.STR_START_TRACK_PAGE),
                (0, $kzp4v.STR_STOP_TRACK_PAGE),
                (0, $kzp4v.STR_START_TRACK_EVENT),
                (0, $kzp4v.STR_STOP_TRACK_EVENT)
            ]);
            (0, $hGXAo.proxyFunctions)(_self, _getCurrentDependencies, [
                (0, $kzp4v.STR_TRACK_DEPENDENCY_DATA),
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            (0, $hGXAo.proxyFunctions)(_self, _core, [
                (0, $kzp4v.STR_ADD_TELEMETRY_INITIALIZER),
                (0, $kzp4v.STR_POLL_INTERNAL_LOGS),
                "stopPollingInternalLogs",
                (0, $kzp4v.STR_GET_PLUGIN),
                "addPlugin",
                (0, $kzp4v.STR_EVT_NAMESPACE),
                "addUnloadCb",
                "getTraceCtx"
            ]);
            (0, $hGXAo.proxyFunctions)(_self, function() {
                var context = properties[0, $9gNlH._DYN_CONTEXT /* @min:%2econtext */ ];
                return context ? context.user : null;
            }, [
                (0, $kzp4v.STR_SET_AUTHENTICATED_USER_CONTEXT),
                (0, $kzp4v.STR_CLEAR_AUTHENTICATED_USER_CONTEXT)
            ]);
            function _getSKUDefaults() {
                _self.config[0, $9gNlH._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] = _self.config[0, $9gNlH._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] && _self[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ][0, $9gNlH._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] > 0 ? _self[0, $9gNlH._DYN_CONFIG /* @min:%2econfig */ ][0, $9gNlH._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] : 10000;
            }
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = (0, $5GGqM.createUniqueNamespace)("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
            }
        });
    }
    // Analytics Plugin
    // Removed Stub for Initialization.prototype.getCookieMgr.
    // Removed Stub for Initialization.prototype.trackEvent.
    // Removed Stub for Initialization.prototype.trackPageView.
    // Removed Stub for Initialization.prototype.trackPageViewPerformance.
    // Removed Stub for Initialization.prototype.trackException.
    // Removed Stub for Initialization.prototype._onerror.
    // Removed Stub for Initialization.prototype.trackTrace.
    // Removed Stub for Initialization.prototype.trackMetric.
    // Removed Stub for Initialization.prototype.startTrackPage.
    // Removed Stub for Initialization.prototype.stopTrackPage.
    // Removed Stub for Initialization.prototype.startTrackEvent.
    // Removed Stub for Initialization.prototype.stopTrackEvent.
    // Removed Stub for Initialization.prototype.addTelemetryInitializer.
    // Properties Plugin
    // Removed Stub for Initialization.prototype.setAuthenticatedUserContext.
    // Removed Stub for Initialization.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
    // Removed Stub for Initialization.prototype.trackDependencyData.
    // Misc
    // Removed Stub for Initialization.prototype.flush.
    // Removed Stub for Initialization.prototype.onunloadFlush.
    // Removed Stub for Initialization.prototype.loadAppInsights.
    // Removed Stub for Initialization.prototype.updateSnippetDefinitions.
    // Removed Stub for Initialization.prototype.emptyQueue.
    // Removed Stub for Initialization.prototype.pollInternalLogs.
    // Removed Stub for Initialization.prototype.stopPollingInternalLogs.
    // Removed Stub for Initialization.prototype.addHousekeepingBeforeUnload.
    // Removed Stub for Initialization.prototype.getSender.
    // Removed Stub for Initialization.prototype.unload.
    // Removed Stub for Initialization.prototype.getPlugin.
    // Removed Stub for Initialization.prototype.addPlugin.
    // Removed Stub for Initialization.prototype.evtNamespace.
    // Removed Stub for Initialization.prototype.addUnloadCb.
    // Removed Stub for Initialization.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ Initialization.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for Initialization.prototype.getTraceCtx.
    return Initialization;
}();
// tslint:disable-next-line
(function() {
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) sdkSrc = scrpt.src;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    if (sdkSrc) try {
        var url = sdkSrc.toLowerCase();
        if (url) {
            var src = "";
            for(var idx = 0; idx < cdns.length; idx++)if (url[0, $9gNlH._DYN_INDEX_OF /* @min:%2eindexOf */ ](cdns[idx]) !== -1) {
                src = "cdn" + (idx + 1);
                if (url[0, $9gNlH._DYN_INDEX_OF /* @min:%2eindexOf */ ]("/scripts/") === -1) {
                    if (url[0, $9gNlH._DYN_INDEX_OF /* @min:%2eindexOf */ ]("/next/") !== -1) src += "-next";
                    else if (url[0, $9gNlH._DYN_INDEX_OF /* @min:%2eindexOf */ ]("/beta/") !== -1) src += "-beta";
                }
                $1c177a2a4b3f2253$var$_internalSdkSrc = src + (isModule ? ".mod" : "");
                break;
            }
        }
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
})();

});
parcelRegister("bO3cR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8986d9efc35886ea$export$2e2bcd8739ae039; });
/*!
 * Microsoft Dynamic Proto Utility, 1.1.11
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $8986d9efc35886ea$var$_a;
var $8986d9efc35886ea$var$UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $8986d9efc35886ea$var$Constructor = "constructor";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $8986d9efc35886ea$var$Prototype = "prototype";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $8986d9efc35886ea$var$strFunction = "function";
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */ var $8986d9efc35886ea$var$DynInstFuncTable = "_dynInstFuncs";
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */ var $8986d9efc35886ea$var$DynProxyTag = "_isDynProxy";
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */ var $8986d9efc35886ea$var$DynClassName = "_dynClass";
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */ var $8986d9efc35886ea$var$DynClassNamePrefix = "_dynCls$";
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */ var $8986d9efc35886ea$var$DynInstChkTag = "_dynInstChk";
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */ var $8986d9efc35886ea$var$DynAllowInstChkTag = $8986d9efc35886ea$var$DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */ var $8986d9efc35886ea$var$DynProtoDefaultOptions = "_dfOpts";
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */ var $8986d9efc35886ea$var$UnknownValue = "_unknown_";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $8986d9efc35886ea$var$str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */ var $8986d9efc35886ea$var$DynProtoBaseProto = "_dyn" + $8986d9efc35886ea$var$str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */ var $8986d9efc35886ea$var$DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */ var $8986d9efc35886ea$var$DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $8986d9efc35886ea$var$strUseBaseInst = "useBaseInst";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $8986d9efc35886ea$var$strSetInstFuncs = "setInstFuncs";
var $8986d9efc35886ea$var$Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $8986d9efc35886ea$var$_objGetPrototypeOf = $8986d9efc35886ea$var$Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */ var $8986d9efc35886ea$var$_objGetOwnProps = $8986d9efc35886ea$var$Obj["getOwnPropertyNames"];
/**
 * Gets the runtime global reference
 * @returns
 */ function $8986d9efc35886ea$var$_getGlobal() {
    var result;
    if (typeof globalThis !== $8986d9efc35886ea$var$UNDEFINED) result = globalThis;
    if (!result && typeof self !== $8986d9efc35886ea$var$UNDEFINED) result = self;
    if (!result && typeof window !== $8986d9efc35886ea$var$UNDEFINED) result = window;
    if (!result && typeof $parcel$global !== $8986d9efc35886ea$var$UNDEFINED) result = $parcel$global;
    return result || {};
}
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var $8986d9efc35886ea$var$_gbl = $8986d9efc35886ea$var$_getGlobal();
var $8986d9efc35886ea$var$_gblInst = $8986d9efc35886ea$var$_gbl[$8986d9efc35886ea$var$DynProtoGlobalSettings] || ($8986d9efc35886ea$var$_gbl[$8986d9efc35886ea$var$DynProtoGlobalSettings] = {
    o: ($8986d9efc35886ea$var$_a = {}, $8986d9efc35886ea$var$_a[$8986d9efc35886ea$var$strSetInstFuncs] = true, $8986d9efc35886ea$var$_a[$8986d9efc35886ea$var$strUseBaseInst] = true, $8986d9efc35886ea$var$_a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */ function $8986d9efc35886ea$var$_hasOwnProperty(obj, prop) {
    return obj && $8986d9efc35886ea$var$Obj[$8986d9efc35886ea$var$Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */ function $8986d9efc35886ea$var$_isObjectOrArrayPrototype(target) {
    return target && (target === $8986d9efc35886ea$var$Obj[$8986d9efc35886ea$var$Prototype] || target === Array[$8986d9efc35886ea$var$Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */ function $8986d9efc35886ea$var$_isObjectArrayOrFunctionPrototype(target) {
    return $8986d9efc35886ea$var$_isObjectOrArrayPrototype(target) || target === Function[$8986d9efc35886ea$var$Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */ function $8986d9efc35886ea$var$_getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if ($8986d9efc35886ea$var$_objGetPrototypeOf) return $8986d9efc35886ea$var$_objGetPrototypeOf(target);
        var curProto = target[$8986d9efc35886ea$var$str__Proto] || target[$8986d9efc35886ea$var$Prototype] || (target[$8986d9efc35886ea$var$Constructor] ? target[$8986d9efc35886ea$var$Constructor][$8986d9efc35886ea$var$Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[$8986d9efc35886ea$var$DynProtoBaseProto] || curProto;
        if (!$8986d9efc35886ea$var$_hasOwnProperty(target, $8986d9efc35886ea$var$DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[$8986d9efc35886ea$var$DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[$8986d9efc35886ea$var$DynProtoBaseProto] = target[$8986d9efc35886ea$var$DynProtoCurrent] || target[$8986d9efc35886ea$var$DynProtoBaseProto];
            target[$8986d9efc35886ea$var$DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */ function $8986d9efc35886ea$var$_forEachProp(target, func) {
    var props = [];
    if ($8986d9efc35886ea$var$_objGetOwnProps) props = $8986d9efc35886ea$var$_objGetOwnProps(target);
    else {
        for(var name_1 in target)if (typeof name_1 === "string" && $8986d9efc35886ea$var$_hasOwnProperty(target, name_1)) props.push(name_1);
    }
    if (props && props.length > 0) for(var lp = 0; lp < props.length; lp++)func(props[lp]);
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */ function $8986d9efc35886ea$var$_isDynamicCandidate(target, funcName, skipOwn) {
    return funcName !== $8986d9efc35886ea$var$Constructor && typeof target[funcName] === $8986d9efc35886ea$var$strFunction && (skipOwn || $8986d9efc35886ea$var$_hasOwnProperty(target, funcName)) && funcName !== $8986d9efc35886ea$var$str__Proto && funcName !== $8986d9efc35886ea$var$Prototype;
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */ function $8986d9efc35886ea$var$_throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
function $8986d9efc35886ea$var$_newObject() {
    return Object.create ? function(obj) {
        var func = Object["create"];
        if (func) return func(obj);
        if (obj == null) return {};
        var type = typeof obj;
        if (type !== "object" && type !== "function") throw new TypeError("Object prototype may only be an Object:" + obj);
        function tmpFunc() {}
        tmpFunc.prototype = obj;
        return new tmpFunc();
    }(null) : {};
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */ function $8986d9efc35886ea$var$_getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = $8986d9efc35886ea$var$_newObject();
    // Save any existing instance functions
    $8986d9efc35886ea$var$_forEachProp(thisTarget, function(name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && $8986d9efc35886ea$var$_isDynamicCandidate(thisTarget, name, false)) // Create an instance callback for passing the base function to the caller
        instFuncs[name] = thisTarget[name];
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */ function $8986d9efc35886ea$var$_hasVisited(values, value) {
    for(var lp = values.length - 1; lp >= 0; lp--){
        if (values[lp] === value) return true;
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */ function $8986d9efc35886ea$var$_getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[$8986d9efc35886ea$var$DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[$8986d9efc35886ea$var$DynInstFuncTable] || {};
            if (instFuncTable[$8986d9efc35886ea$var$DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[$8986d9efc35886ea$var$DynClassName]] || {})[funcName] || theFunc;
        }
        return function() {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = $8986d9efc35886ea$var$_newObject();
    $8986d9efc35886ea$var$_forEachProp(instFuncs, function(name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = $8986d9efc35886ea$var$_getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while(baseProto && !$8986d9efc35886ea$var$_isObjectArrayOrFunctionPrototype(baseProto) && !$8986d9efc35886ea$var$_hasVisited(visited, baseProto)){
        // look for prototype functions
        $8986d9efc35886ea$var$_forEachProp(baseProto, function(name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && $8986d9efc35886ea$var$_isDynamicCandidate(baseProto, name, !$8986d9efc35886ea$var$_objGetPrototypeOf)) // Create an instance callback for passing the base function to the caller
            baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = $8986d9efc35886ea$var$_getObjProto(baseProto);
    }
    return baseFuncs;
}
function $8986d9efc35886ea$var$_getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && $8986d9efc35886ea$var$_hasOwnProperty(proto, $8986d9efc35886ea$var$DynClassName)) {
        var instFuncTable = target[$8986d9efc35886ea$var$DynInstFuncTable] || $8986d9efc35886ea$var$_newObject();
        instFunc = (instFuncTable[proto[$8986d9efc35886ea$var$DynClassName]] || $8986d9efc35886ea$var$_newObject())[funcName];
        if (!instFunc) // Avoid stack overflow from recursive calling the same function
        $8986d9efc35886ea$var$_throwTypeError("Missing [" + funcName + "] " + $8986d9efc35886ea$var$strFunction);
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[$8986d9efc35886ea$var$DynInstChkTag] && instFuncTable[$8986d9efc35886ea$var$DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !$8986d9efc35886ea$var$_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = $8986d9efc35886ea$var$_getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while(canAddInst && objProto && !$8986d9efc35886ea$var$_isObjectArrayOrFunctionPrototype(objProto) && !$8986d9efc35886ea$var$_hasVisited(visited, objProto)){
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = protoFunc === currentDynProtoProxy;
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = $8986d9efc35886ea$var$_getObjProto(objProto);
            }
            try {
                if (canAddInst) // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                // so it's safe to directly assign for any subsequent calls (for better performance)
                target[funcName] = instFunc;
                // Block further attempts to set the instance function for any
                instFunc[$8986d9efc35886ea$var$DynInstChkTag] = 1;
            } catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[$8986d9efc35886ea$var$DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function $8986d9efc35886ea$var$_getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) // It is so lookup the base prototype
    protoFunc = $8986d9efc35886ea$var$_getObjProto(proto)[funcName];
    if (typeof protoFunc !== $8986d9efc35886ea$var$strFunction) $8986d9efc35886ea$var$_throwTypeError("[" + funcName + "] is not a " + $8986d9efc35886ea$var$strFunction);
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */ function $8986d9efc35886ea$var$_populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function() {
            // Use the instance or prototype function
            var instFunc = $8986d9efc35886ea$var$_getInstFunc(this, funcName, proto, dynProtoProxy) || $8986d9efc35886ea$var$_getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[$8986d9efc35886ea$var$DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!$8986d9efc35886ea$var$_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[$8986d9efc35886ea$var$DynInstFuncTable] = target[$8986d9efc35886ea$var$DynInstFuncTable] || $8986d9efc35886ea$var$_newObject();
        if (!$8986d9efc35886ea$var$_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || $8986d9efc35886ea$var$_newObject(); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[$8986d9efc35886ea$var$DynAllowInstChkTag] !== false) instFuncTable[$8986d9efc35886ea$var$DynAllowInstChkTag] = !!setInstanceFunc;
            if (!$8986d9efc35886ea$var$_isObjectOrArrayPrototype(instFuncs_1)) $8986d9efc35886ea$var$_forEachProp(target, function(name) {
                // Only add overridden functions
                if ($8986d9efc35886ea$var$_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                    // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                    instFuncs_1[name] = target[name];
                    delete target[name];
                    // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                    if (!$8986d9efc35886ea$var$_hasOwnProperty(proto, name) || proto[name] && !proto[name][$8986d9efc35886ea$var$DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
                }
            });
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */ function $8986d9efc35886ea$var$_checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if ($8986d9efc35886ea$var$_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = $8986d9efc35886ea$var$_getObjProto(thisTarget);
        while(thisProto && !$8986d9efc35886ea$var$_isObjectArrayOrFunctionPrototype(thisProto) && !$8986d9efc35886ea$var$_hasVisited(visited, thisProto)){
            if (thisProto === classProto) return true;
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = $8986d9efc35886ea$var$_getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */ function $8986d9efc35886ea$var$_getObjName(target, unknownValue) {
    if ($8986d9efc35886ea$var$_hasOwnProperty(target, $8986d9efc35886ea$var$Prototype)) // Look like a prototype
    return target.name || unknownValue || $8986d9efc35886ea$var$UnknownValue;
    return ((target || {})[$8986d9efc35886ea$var$Constructor] || {}).name || unknownValue || $8986d9efc35886ea$var$UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */ function $8986d9efc35886ea$export$2e2bcd8739ae039(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!$8986d9efc35886ea$var$_hasOwnProperty(theClass, $8986d9efc35886ea$var$Prototype)) $8986d9efc35886ea$var$_throwTypeError("theClass is an invalid class definition.");
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[$8986d9efc35886ea$var$Prototype];
    if (!$8986d9efc35886ea$var$_checkPrototype(classProto, target)) $8986d9efc35886ea$var$_throwTypeError("[" + $8986d9efc35886ea$var$_getObjName(theClass) + "] not in hierarchy of [" + $8986d9efc35886ea$var$_getObjName(target) + "]");
    var className = null;
    if ($8986d9efc35886ea$var$_hasOwnProperty(classProto, $8986d9efc35886ea$var$DynClassName)) // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
    className = classProto[$8986d9efc35886ea$var$DynClassName];
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = $8986d9efc35886ea$var$DynClassNamePrefix + $8986d9efc35886ea$var$_getObjName(theClass, "_") + "$" + $8986d9efc35886ea$var$_gblInst.n;
        $8986d9efc35886ea$var$_gblInst.n++;
        classProto[$8986d9efc35886ea$var$DynClassName] = className;
    }
    var perfOptions = $8986d9efc35886ea$export$2e2bcd8739ae039[$8986d9efc35886ea$var$DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[$8986d9efc35886ea$var$strUseBaseInst];
    if (useBaseInst && options && options[$8986d9efc35886ea$var$strUseBaseInst] !== undefined) useBaseInst = !!options[$8986d9efc35886ea$var$strUseBaseInst];
    // Get the current instance functions
    var instFuncs = $8986d9efc35886ea$var$_getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = $8986d9efc35886ea$var$_getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!$8986d9efc35886ea$var$_objGetPrototypeOf && !!perfOptions[$8986d9efc35886ea$var$strSetInstFuncs];
    if (setInstanceFunc && options) setInstanceFunc = !!options[$8986d9efc35886ea$var$strSetInstFuncs];
    // Populate the Prototype for any overridden instance functions
    $8986d9efc35886ea$var$_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */ $8986d9efc35886ea$export$2e2bcd8739ae039[$8986d9efc35886ea$var$DynProtoDefaultOptions] = $8986d9efc35886ea$var$_gblInst.o;

});

parcelRegister("31FNP", function(module, exports) {

$parcel$export(module.exports, "AnalyticsPlugin", function () { return $2341e43fd52aa7b6$export$ca681bfeb2cf0fca; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/ 
var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $HME9b = parcelRequire("HME9b");
var $rOoAk = parcelRequire("rOoAk");
var $fAiTL = parcelRequire("fAiTL");
var $55exP = parcelRequire("55exP");
var $i2MiW = parcelRequire("i2MiW");
var $9rbbk = parcelRequire("9rbbk");
var $g5yzi = parcelRequire("g5yzi");
var $6bipl = parcelRequire("6bipl");
var $jMj33 = parcelRequire("jMj33");
var $czkZK = parcelRequire("czkZK");
var $cAmBy = parcelRequire("cAmBy");
var $cXuOT = parcelRequire("cXuOT");
var $cVsUj = parcelRequire("cVsUj");
var $7iT8I = parcelRequire("7iT8I");
var $h1GMI = parcelRequire("h1GMI");

var $hGXAo = parcelRequire("hGXAo");
var $dtXLi = parcelRequire("dtXLi");
var $jx9Ci = parcelRequire("jx9Ci");
var $5GGqM = parcelRequire("5GGqM");
var $bU24K = parcelRequire("bU24K");
var $lhl6R = parcelRequire("lhl6R");
var $k0iSW = parcelRequire("k0iSW");
var $77mRF = parcelRequire("77mRF");
var $hB9U1 = parcelRequire("hB9U1");
var $82FQ4 = parcelRequire("82FQ4");

var $h90r2 = parcelRequire("h90r2");

var $lmTkX = parcelRequire("lmTkX");

var $kLCwi = parcelRequire("kLCwi");

var $99PJK = parcelRequire("99PJK");

var $7Ub2w = parcelRequire("7Ub2w");
var $2341e43fd52aa7b6$var$strEvent = "event";
function $2341e43fd52aa7b6$var$_dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) target.dispatchEvent(evnt);
}
function $2341e43fd52aa7b6$var$_getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!(0, $hGXAo.isString)(reason) && (0, $hGXAo.isFunction)(reason[0, $h90r2._DYN_TO_STRING /* @min:%2etoString */ ])) return reason[0, $h90r2._DYN_TO_STRING /* @min:%2etoString */ ]();
        return (0, $bU24K.dumpObj)(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var $2341e43fd52aa7b6$var$MinMilliSeconds = 60000;
function $2341e43fd52aa7b6$var$_configMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < $2341e43fd52aa7b6$var$MinMilliSeconds) value = $2341e43fd52aa7b6$var$MinMilliSeconds;
    return value;
}
function $2341e43fd52aa7b6$var$_getDefaultConfig(config) {
    if (!config) config = {};
    // set default values
    config.sessionRenewalMs = $2341e43fd52aa7b6$var$_configMilliseconds(config.sessionRenewalMs, 1800000);
    config.sessionExpirationMs = $2341e43fd52aa7b6$var$_configMilliseconds(config.sessionExpirationMs, 86400000);
    config[0, $h90r2._DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */ ]);
    config[0, $h90r2._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ]);
    config[0, $h90r2._DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */ ]);
    config[0, $h90r2._DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ]);
    if (isNaN(config[0, $h90r2._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ]) || config[0, $h90r2._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ] <= 0 || config[0, $h90r2._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ] >= 100) config[0, $h90r2._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ] = 100;
    config[0, $h90r2._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ]);
    config[0, $h90r2._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ]);
    config[0, $h90r2._DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */ ]);
    config[0, $h90r2._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] = config[0, $h90r2._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] || "";
    config.enableDebug = (0, $6bipl.stringToBoolOrDefault)(config.enableDebug);
    config[0, $h90r2._DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */ ] = (0, $6bipl.stringToBoolOrDefault)(config[0, $h90r2._DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */ ]);
    config.disableFlushOnUnload = (0, $6bipl.stringToBoolOrDefault)(config.disableFlushOnUnload, config[0, $h90r2._DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */ ]);
    return config;
}
function $2341e43fd52aa7b6$var$_updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!(0, $hGXAo.isUndefined)(extConfig[0, $h90r2._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ])) {
        if (extConfig[0, $h90r2._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ]) (0, $h1GMI.utlDisableStorage)();
        else (0, $h1GMI.utlEnableStorage)();
    }
}
var $2341e43fd52aa7b6$export$ca681bfeb2cf0fca = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = (0, $HME9b.AnalyticsPluginIdentifier); // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        var _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        (0, $bO3cR.default)(AnalyticsPlugin, _this, function(_self, _base) {
            var _addHook = _base._addHook;
            _initDefaults();
            _self.getCookieMgr = function() {
                return (0, $hB9U1.safeGetCookieMgr)(_self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ]);
            };
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function(event, customProperties) {
                try {
                    var telemetryItem = (0, $55exP.createTelemetryItem)(event, (0, $9rbbk.Event)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $9rbbk.Event)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */ _self.startTrackEvent = function(name) {
                try {
                    _eventTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 29 /* _eInternalMessageId.StartTrackEventFailed */ , "startTrackEvent failed, event will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackEvent = function(name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 30 /* _eInternalMessageId.StopTrackEventFailed */ , "stopTrackEvent failed, event will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param {ITraceTelemetry} trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */ _self.trackTrace = function(trace, customProperties) {
                try {
                    var telemetryItem = (0, $55exP.createTelemetryItem)(trace, (0, $7iT8I.Trace)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $7iT8I.Trace)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param {IMetricTelemetry} metric input object argument. Only name and average are mandatory.
             * @param {{[key: string]: any}} customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */ _self.trackMetric = function(metric, customProperties) {
                try {
                    var telemetryItem = (0, $55exP.createTelemetryItem)(metric, (0, $jMj33.Metric)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $jMj33.Metric)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 36 /* _eInternalMessageId.TrackMetricFailed */ , "trackMetric failed, metric will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */ _self[0, $h90r2._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[0, $h90r2._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ](inPv, (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, inPv.properties), inPv.measurements), customProperties));
                    if (_self.config[0, $h90r2._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ]) _pageVisitTimeManager[0, $h90r2._DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */ ](inPv.name, inPv.uri);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageView failed, page view will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView Page view item to be sent
             * @param properties Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties System level properties (Part A) that a user can add to the telemetry item
             */ _self[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ] = function(pageView, properties, systemProperties) {
                var doc = (0, $bU24K.getDocument)();
                if (doc) pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                var telemetryItem = (0, $55exP.createTelemetryItem)(pageView, (0, $czkZK.PageView)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $czkZK.PageView)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                // reset ajaxes counter
                _trackAjaxAttempts = 0;
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */ _self[0, $h90r2._DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */ ] = function(pageViewPerformance, properties, systemProperties) {
                var telemetryItem = (0, $55exP.createTelemetryItem)(pageViewPerformance, (0, $cAmBy.PageViewPerformance)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $cAmBy.PageViewPerformance)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */ _self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[0, $h90r2._DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */ ](inPvp);
                    _self[0, $h90r2._DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */ ](inPvp, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageViewPerformance failed, page view will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */ _self.startTrackPage = function(name) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $bU24K.getDocument)();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 31 /* _eInternalMessageId.StartTrackFailed */ , "startTrackPage failed, page view may not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackPage = function(name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $bU24K.getDocument)();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = (0, $bU24K.getLocation)();
                        url = loc && loc[0, $h90r2._DYN_HREF /* @min:%2ehref */ ] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_self.config[0, $h90r2._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ]) _pageVisitTimeManager[0, $h90r2._DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */ ](name, url);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 32 /* _eInternalMessageId.StopTrackFailed */ , "stopTrackPage failed, page view will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */ _self[0, $h90r2._DYN_SEND_EXCEPTION_INTER13 /* @min:%2esendExceptionInternal */ ] = function(exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = exception && (exception[0, $h90r2._DYN_EXCEPTION /* @min:%2eexception */ ] || exception[0, $h90r2._DYN_ERROR /* @min:%2eerror */ ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
                (0, $hGXAo.isError)(exception) && exception || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                //   is preserved and does not list ApplicationInsights code as the source
                {
                    name: exception && typeof exception,
                    message: exception || (0, $cVsUj.strNotSpecified)
                };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new (0, $g5yzi.Exception)(_self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = (0, $55exP.createTelemetryItem)(exceptionPartB, (0, $g5yzi.Exception)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $g5yzi.Exception)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties, systemProperties);
                _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param {IExceptionTelemetry} exception   Object which contains exception to be sent
             * @param {{[key: string]: any}} customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */ _self.trackException = function(exception, customProperties) {
                if (exception && !exception[0, $h90r2._DYN_EXCEPTION /* @min:%2eexception */ ] && exception[0, $h90r2._DYN_ERROR /* @min:%2eerror */ ]) exception[0, $h90r2._DYN_EXCEPTION /* @min:%2eexception */ ] = exception[0, $h90r2._DYN_ERROR /* @min:%2eerror */ ];
                try {
                    _self[0, $h90r2._DYN_SEND_EXCEPTION_INTER13 /* @min:%2esendExceptionInternal */ ](exception, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 35 /* _eInternalMessageId.TrackExceptionFailed */ , "trackException failed, exception will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param {IAutoExceptionTelemetry} exception
             * @memberof ApplicationInsights
             */ _self[0, $h90r2._DYN__ONERROR /* @min:%2e_onerror */ ] = function(exception) {
                var error = exception && exception[0, $h90r2._DYN_ERROR /* @min:%2eerror */ ];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = (0, $bU24K.getWindow)();
                        if (_window) evt = _window[$2341e43fd52aa7b6$var$strEvent];
                    }
                    var url = exception && exception.url || ((0, $bU24K.getDocument)() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[0, $h90r2._DYN_ERROR_SRC /* @min:%2eerrorSrc */ ] || "window.onerror@" + url + ":" + (exception[0, $h90r2._DYN_LINE_NUMBER /* @min:%2elineNumber */ ] || 0) + ":" + (exception[0, $h90r2._DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */ ] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[0, $h90r2._DYN_LINE_NUMBER /* @min:%2elineNumber */ ] || 0,
                        columnNumber: exception[0, $h90r2._DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */ ] || 0,
                        message: exception[0, $h90r2._DYN_MESSAGE /* @min:%2emessage */ ]
                    };
                    if ((0, $6bipl.isCrossOriginError)(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[0, $h90r2._DYN_ERROR /* @min:%2eerror */ ])) _sendCORSException((0, $g5yzi.Exception)[0, $h90r2._DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */ ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[0, $h90r2._DYN_LINE_NUMBER /* @min:%2elineNumber */ ] || 0, exception[0, $h90r2._DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */ ] || 0, error, evt, null, errorSrc), properties);
                    else {
                        if (!exception[0, $h90r2._DYN_ERROR_SRC /* @min:%2eerrorSrc */ ]) exception[0, $h90r2._DYN_ERROR_SRC /* @min:%2eerrorSrc */ ] = errorSrc;
                        _self.trackException({
                            exception: exception,
                            severityLevel: 3 /* eSeverityLevel.Error */ 
                        }, properties);
                    }
                } catch (e) {
                    var errorString = error ? error.name + ", " + error[0, $h90r2._DYN_MESSAGE /* @min:%2emessage */ ] : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 11 /* _eInternalMessageId.ExceptionWhileLoggingError */ , "_onError threw exception while logging error, error will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e),
                        errorString: errorString
                    });
                }
            };
            _self[0, $h90r2._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ] = function(telemetryInitializer) {
                if (_self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ]) // Just add to the core
                return _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ](telemetryInitializer);
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) _preInitTelemetryInitializers = [];
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) return;
                if ((0, $hGXAo.isNullOrUndefined)(core)) (0, $hGXAo.throwError)("Error initializing");
                _base.initialize(config, core, extensions, pluginChain);
                if (config.storagePrefix) (0, $h1GMI.utlSetStoragePrefix)(config.storagePrefix);
                try {
                    _evtNamespace = (0, $lhl6R.mergeEvtNamespace)((0, $5GGqM.createUniqueNamespace)(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        (0, $hGXAo.arrForEach)(_preInitTelemetryInitializers, function(initializer) {
                            core[0, $h90r2._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    var extConfig = _populateDefaults(config);
                    $2341e43fd52aa7b6$var$_updateStorageUsage(extConfig);
                    _pageViewPerformanceManager = new (0, $kLCwi.PageViewPerformanceManager)(_self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ]);
                    _pageViewManager = new (0, $lmTkX.PageViewManager)(_self, extConfig[0, $h90r2._DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */ ], _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new (0, $99PJK.PageVisitTimeManager)(_self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), function(pageName, pageUrl, pageVisitTime) {
                        return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
                    });
                    _updateBrowserLinkTracking(extConfig, config);
                    _eventTracking = new (0, $7Ub2w.Timing)(_self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), "trackEvent");
                    _eventTracking.action = function(name, url, duration, properties, measurements) {
                        if (!properties) properties = {};
                        if (!measurements) measurements = {};
                        properties.duration = duration[0, $h90r2._DYN_TO_STRING /* @min:%2etoString */ ]();
                        _self.trackEvent({
                            name: name,
                            properties: properties,
                            measurements: measurements
                        });
                    };
                    // initialize page view timing
                    _pageTracking = new (0, $7Ub2w.Timing)(_self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), "trackPageView");
                    _pageTracking.action = function(name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if ((0, $hGXAo.isNullOrUndefined)(properties)) properties = {};
                        properties.duration = duration[0, $h90r2._DYN_TO_STRING /* @min:%2etoString */ ]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageViewItem, properties);
                    };
                    if ((0, $bU24K.hasWindow)()) {
                        _updateExceptionTracking(extConfig);
                        _updateLocationChange(extConfig);
                    }
                } catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                (0, $lhl6R.eventOff)(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var ctx = (0, $jx9Ci.createProcessTelemetryContext)(null, config, _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ]);
                var identifier = _self.identifier;
                // load default values if specified
                var defaults = $2341e43fd52aa7b6$var$_getDefaultConfig(config);
                var extConfig = _self.config = ctx.getExtCfg(identifier);
                if (defaults !== undefined) (0, $hGXAo.objForEachKey)(defaults, function(field, value) {
                    // for each unspecified field, set the default value
                    extConfig[field] = ctx.getConfig(identifier, field, value);
                    if (extConfig[field] === undefined) extConfig = value;
                });
                return extConfig;
            }
            function _updateBrowserLinkTracking(extConfig, config) {
                _isBrowserLinkTrackingEnabled = extConfig[0, $h90r2._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ] || config[0, $h90r2._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ];
                _addDefaultTelemetryInitializers();
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milleseconds
             */ function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = {
                    PageName: pageName,
                    PageUrl: pageUrl
                };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = [
                        "/browserLinkSignalR/",
                        "/__browserLink/"
                    ];
                    var dropBrowserLinkRequests = function(envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === (0, $cXuOT.RemoteDependencyData)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) for(var i = 0; i < browserLinkPaths_1[0, $h90r2._DYN_LENGTH /* @min:%2elength */ ]; i++){
                                if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) return false;
                            }
                        }
                        return true;
                    };
                    _self[0, $h90r2._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ](dropBrowserLinkRequests);
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = (0, $55exP.createTelemetryItem)(exception, (0, $g5yzi.Exception)[0, $h90r2._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $g5yzi.Exception)[0, $h90r2._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), properties);
                _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ][0, $h90r2._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
            }
            function _updateExceptionTracking(extConfig) {
                var _window = (0, $bU24K.getWindow)();
                var locn = (0, $bU24K.getLocation)(true);
                _disableExceptionTracking = extConfig[0, $h90r2._DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */ ];
                if (!_disableExceptionTracking && !_autoExceptionInstrumented && !extConfig.autoExceptionInstrumented) {
                    // We want to enable exception auto collection and it has not been done so yet
                    _addHook((0, $77mRF.InstrumentEvent)(_window, "onerror", {
                        ns: _evtNamespace,
                        rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
                            if (!_disableExceptionTracking && callDetails.rslt !== true) _self[0, $h90r2._DYN__ONERROR /* @min:%2e_onerror */ ]((0, $g5yzi.Exception)[0, $h90r2._DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */ ](message, url, lineNumber, columnNumber, error, callDetails.evt));
                        }
                    }, false));
                    _autoExceptionInstrumented = true;
                }
                _addUnhandledPromiseRejectionTracking(extConfig, _window, locn);
            }
            function _updateLocationChange(extConfig) {
                var win = (0, $bU24K.getWindow)();
                var locn = (0, $bU24K.getLocation)(true);
                _enableAutoRouteTracking = extConfig[0, $h90r2._DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */ ] === true;
                /**
                 * Create a custom "locationchange" event which is triggered each time the history object is changed
                 */ if (win && _enableAutoRouteTracking && (0, $bU24K.hasHistory)()) {
                    var _history = (0, $bU24K.getHistory)();
                    if ((0, $hGXAo.isFunction)(_history.pushState) && (0, $hGXAo.isFunction)(_history.replaceState) && typeof Event !== (0, $82FQ4.strShimUndefined)) _addHistoryListener(extConfig, win, _history, locn);
                }
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ] && _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ].getTraceCtx(false);
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[0, $h90r2._DYN_CORE /* @min:%2ecore */ ].getPlugin((0, $HME9b.PropertiesPluginIdentifier));
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) distributedTraceCtx = (0, $rOoAk.createDistributedTraceContextFromTrace)(context.telemetryTrace);
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */ function _addHistoryListener(extConfig, win, history, locn) {
                var namePrefix = extConfig[0, $h90r2._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) $2341e43fd52aa7b6$var$_dispatchEvent(win, (0, $fAiTL.createDomEvent)(namePrefix + "locationchange"));
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[0, $h90r2._DYN_HREF /* @min:%2ehref */ ] || "";
                    } else _currUri = locn && locn[0, $h90r2._DYN_HREF /* @min:%2ehref */ ] || "";
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId((0, $k0iSW.generateW3CId)());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) traceLocationName = locn.pathname + (locn.hash || "");
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName((0, $i2MiW.dataSanitizeString)(_self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), traceLocationName));
                        }
                        setTimeout((function(uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[0, $h90r2._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ]({
                                refUri: uri,
                                properties: {
                                    duration: 0
                                }
                            }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                if (!_historyListenerAdded) {
                    _addHook((0, $77mRF.InstrumentEvent)(history, "pushState", {
                        ns: _evtNamespace,
                        rsp: function() {
                            if (_enableAutoRouteTracking) {
                                $2341e43fd52aa7b6$var$_dispatchEvent(win, (0, $fAiTL.createDomEvent)(namePrefix + "pushState"));
                                $2341e43fd52aa7b6$var$_dispatchEvent(win, (0, $fAiTL.createDomEvent)(namePrefix + "locationchange"));
                            }
                        }
                    }, true));
                    _addHook((0, $77mRF.InstrumentEvent)(history, "replaceState", {
                        ns: _evtNamespace,
                        rsp: function() {
                            if (_enableAutoRouteTracking) {
                                $2341e43fd52aa7b6$var$_dispatchEvent(win, (0, $fAiTL.createDomEvent)(namePrefix + "replaceState"));
                                $2341e43fd52aa7b6$var$_dispatchEvent(win, (0, $fAiTL.createDomEvent)(namePrefix + "locationchange"));
                            }
                        }
                    }, true));
                    (0, $lhl6R.eventOn)(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                    (0, $lhl6R.eventOn)(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                    _historyListenerAdded = true;
                }
            }
            function _addUnhandledPromiseRejectionTracking(extConfig, _window, _location) {
                _enableUnhandledPromiseRejectionTracking = extConfig[0, $h90r2._DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] === true;
                if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                    // We want to enable exception auto collection and it has not been done so yet
                    _addHook((0, $77mRF.InstrumentEvent)(_window, "onunhandledrejection", {
                        ns: _evtNamespace,
                        rsp: function(callDetails, error) {
                            if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) _self[0, $h90r2._DYN__ONERROR /* @min:%2e_onerror */ ]((0, $g5yzi.Exception)[0, $h90r2._DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */ ]($2341e43fd52aa7b6$var$_getReason(error), _location ? _location[0, $h90r2._DYN_HREF /* @min:%2ehref */ ] : "", 0, 0, error, callDetails.evt));
                        }
                    }, false));
                    _autoUnhandledPromiseInstrumented = true;
                    extConfig.autoUnhandledPromiseInstrumented = _autoUnhandledPromiseInstrumented;
                }
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {eLoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */ function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[0, $h90r2._DYN_DIAG_LOG /* @min:%2ediagLog */ ]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                // Counts number of trackAjax invocations.
                // By default we only monitor X ajax call per view to avoid too much load.
                // Default value is set in config.
                // This counter keeps increasing even after the limit is reached.
                _trackAjaxAttempts = 0;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = (0, $bU24K.getLocation)(true);
                _prevUri = location && location[0, $h90r2._DYN_HREF /* @min:%2ehref */ ] || "";
                _currUri = null;
                _evtNamespace = null;
            }
            // For backward compatibility
            (0, $hGXAo.objDefineAccessors)(_self, "_pageViewManager", function() {
                return _pageViewManager;
            });
            (0, $hGXAo.objDefineAccessors)(_self, "_pageViewPerformanceManager", function() {
                return _pageViewPerformanceManager;
            });
            (0, $hGXAo.objDefineAccessors)(_self, "_pageVisitTimeManager", function() {
                return _pageVisitTimeManager;
            });
            (0, $hGXAo.objDefineAccessors)(_self, "_evtNamespace", function() {
                return "." + _evtNamespace;
            });
        });
        return _this;
    }
    // Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
    // Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
    // Removed Stub for AnalyticsPlugin.prototype.trackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.trackTrace.
    // Removed Stub for AnalyticsPlugin.prototype.trackMetric.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageView.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackException.
    // Removed Stub for AnalyticsPlugin.prototype._onerror.
    // Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = "2.8.18"; // Not currently used anywhere
    AnalyticsPlugin.getDefaultConfig = $2341e43fd52aa7b6$var$_getDefaultConfig;
    return AnalyticsPlugin;
}((0, $dtXLi.BaseTelemetryPlugin));

});
parcelRegister("8AlFX", function(module, exports) {

$parcel$export(module.exports, "__assignFn", function () { return $64027fda739af55a$export$b3cf7a802e578501; });
$parcel$export(module.exports, "__extendsFn", function () { return $64027fda739af55a$export$1f9c32e3fbfb8e62; });
$parcel$export(module.exports, "__spreadArrayFn", function () { return $64027fda739af55a$export$643fbb7023bc1942; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var $82FQ4 = parcelRequire("82FQ4");

var $91dsF = parcelRequire("91dsF");
var $64027fda739af55a$export$3a8d60327f425095 = ((0, $91dsF.getGlobal)() || {})["Symbol"];
var $64027fda739af55a$export$904e7a8ad467688a = ((0, $91dsF.getGlobal)() || {})["Reflect"];
var $64027fda739af55a$export$b26f3a0ab26820ca = !!$64027fda739af55a$export$3a8d60327f425095;
var $64027fda739af55a$export$9f6bdf37c7d86dfe = !!$64027fda739af55a$export$904e7a8ad467688a;
var $64027fda739af55a$var$strDecorate = "decorate";
var $64027fda739af55a$var$strMetadata = "metadata";
var $64027fda739af55a$var$strGetOwnPropertySymbols = "getOwnPropertySymbols";
var $64027fda739af55a$var$strIterator = "iterator";
var $64027fda739af55a$export$64ecba31e1fc6f1e = function(t) {
    // tslint:disable-next-line: ban-comma-operator
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if ((0, $82FQ4.ObjProto)[0, $82FQ4.strShimHasOwnProperty].call(s, p)) t[p] = s[p];
    }
    return t;
};
var $64027fda739af55a$export$b3cf7a802e578501 = (0, $82FQ4.ObjAssign) || $64027fda739af55a$export$64ecba31e1fc6f1e;
// tslint:disable-next-line: only-arrow-functions
var $64027fda739af55a$var$extendStaticsFn = function(d, b) {
    $64027fda739af55a$var$extendStaticsFn = (0, $82FQ4.ObjClass)["setPrototypeOf"] || // tslint:disable-next-line: only-arrow-functions
    ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || // tslint:disable-next-line: only-arrow-functions
    function(d, b) {
        for(var p in b)if (b[0, $82FQ4.strShimHasOwnProperty](p)) d[p] = b[p];
    };
    return $64027fda739af55a$var$extendStaticsFn(d, b);
};
function $64027fda739af55a$export$1f9c32e3fbfb8e62(d, b) {
    if (typeof b !== (0, $82FQ4.strShimFunction) && b !== null) (0, $91dsF.throwTypeError)("Class extends value " + String(b) + " is not a constructor or null");
    $64027fda739af55a$var$extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[0, $82FQ4.strShimPrototype] = b === null ? (0, $91dsF.objCreateFn)(b) : (__[0, $82FQ4.strShimPrototype] = b[0, $82FQ4.strShimPrototype], new __());
}
function $64027fda739af55a$export$b0e1e04064f2edd0(s, e) {
    var t = {};
    for(var k in s)if ((0, $82FQ4.ObjHasOwnProperty).call(s, k) && e.indexOf(k) < 0) t[k] = s[k];
    if (s != null && typeof (0, $82FQ4.ObjClass)[$64027fda739af55a$var$strGetOwnPropertySymbols] === (0, $82FQ4.strShimFunction)) {
        for(var i = 0, p = (0, $82FQ4.ObjClass)[$64027fda739af55a$var$strGetOwnPropertySymbols](s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && (0, $82FQ4.ObjProto)["propertyIsEnumerable"].call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $64027fda739af55a$export$1f334cb233663b35(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = (0, $82FQ4.ObjClass)["getOwnPropertyDescriptor"](target, key) : desc, d;
    if ($64027fda739af55a$export$9f6bdf37c7d86dfe && typeof $64027fda739af55a$export$904e7a8ad467688a[$64027fda739af55a$var$strDecorate] === (0, $82FQ4.strShimFunction)) r = $64027fda739af55a$export$904e7a8ad467688a[$64027fda739af55a$var$strDecorate](decorators, target, key, desc);
    else {
        for(var i = decorators.length - 1; i >= 0; i--)// eslint-disable-next-line no-cond-assign
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && (0, $82FQ4.ObjDefineProperty)(target, key, r), r;
}
function $64027fda739af55a$export$a862c09c17c00454(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $64027fda739af55a$export$652131891efe9c32(metadataKey, metadataValue) {
    if ($64027fda739af55a$export$9f6bdf37c7d86dfe && $64027fda739af55a$export$904e7a8ad467688a[$64027fda739af55a$var$strMetadata] === (0, $82FQ4.strShimFunction)) return $64027fda739af55a$export$904e7a8ad467688a[$64027fda739af55a$var$strMetadata](metadataKey, metadataValue);
}
function $64027fda739af55a$export$11150685fa6930db(m, o) {
    for(var p in m)if (p !== (0, $82FQ4.strDefault) && !(0, $82FQ4.ObjHasOwnProperty).call(o, p)) $64027fda739af55a$export$1ea27411cf67499d(o, m, p);
}
function $64027fda739af55a$export$1ea27411cf67499d(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    if (!!(0, $82FQ4.ObjCreate)) (0, $82FQ4.ObjDefineProperty)(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
    else o[k2] = m[k];
}
function $64027fda739af55a$export$19cc45bf4f6ae179(o) {
    var s = typeof $64027fda739af55a$export$3a8d60327f425095 === (0, $82FQ4.strShimFunction) && $64027fda739af55a$export$3a8d60327f425095[$64027fda739af55a$var$strIterator], m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    (0, $91dsF.throwTypeError)(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $64027fda739af55a$export$18637e2f1e451a15(o, n) {
    var m = typeof $64027fda739af55a$export$3a8d60327f425095 === (0, $82FQ4.strShimFunction) && o[$64027fda739af55a$export$3a8d60327f425095[$64027fda739af55a$var$strIterator]];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) // eslint-disable-next-line no-unsafe-finally
            throw e.error;
        }
    }
    return ar;
}
function $64027fda739af55a$export$e4572e1e87bd3458() {
    var theArgs = arguments;
    // Calculate new total size
    for(var s = 0, i = 0, il = theArgs.length; i < il; i++)s += theArgs[i].length;
    // Create new full array
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $64027fda739af55a$export$643fbb7023bc1942(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}
function $64027fda739af55a$export$b4774f2d9ed4def4(cooked, raw) {
    if (0, $82FQ4.ObjDefineProperty) (0, $82FQ4.ObjDefineProperty)(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $64027fda739af55a$export$8f42f3b1d1cb5f6d(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== (0, $82FQ4.strDefault) && Object.prototype.hasOwnProperty.call(mod, k)) $64027fda739af55a$export$1ea27411cf67499d(result, mod, k);
    }
    // Set default module
    if (!!(0, $82FQ4.ObjCreate)) (0, $82FQ4.ObjDefineProperty)(result, (0, $82FQ4.strDefault), {
        enumerable: true,
        value: mod
    });
    else result[0, $82FQ4.strDefault] = mod;
    return result;
}
function $64027fda739af55a$export$b2781524d4888cea(mod) {
    return mod && mod.__esModule ? mod : {
        strDefault: mod
    };
}

});
parcelRegister("82FQ4", function(module, exports) {

$parcel$export(module.exports, "strShimFunction", function () { return $5daef6f39e1b6714$export$327014e6dfd5ba11; });
$parcel$export(module.exports, "strShimObject", function () { return $5daef6f39e1b6714$export$127e9c2439c2ee16; });
$parcel$export(module.exports, "strShimUndefined", function () { return $5daef6f39e1b6714$export$9b7d2d86cf58b987; });
$parcel$export(module.exports, "strShimPrototype", function () { return $5daef6f39e1b6714$export$ecddaaeb55ecf049; });
$parcel$export(module.exports, "strShimHasOwnProperty", function () { return $5daef6f39e1b6714$export$fdeb660efff83bae; });
$parcel$export(module.exports, "strDefault", function () { return $5daef6f39e1b6714$export$b39d4edf23d6f14c; });
$parcel$export(module.exports, "ObjClass", function () { return $5daef6f39e1b6714$export$9ec954dd81c90a5d; });
$parcel$export(module.exports, "ObjProto", function () { return $5daef6f39e1b6714$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "ObjAssign", function () { return $5daef6f39e1b6714$export$c06e62a67f43408b; });
$parcel$export(module.exports, "ObjCreate", function () { return $5daef6f39e1b6714$export$62f62a547092e54f; });
$parcel$export(module.exports, "ObjDefineProperty", function () { return $5daef6f39e1b6714$export$5cec132417feb069; });
$parcel$export(module.exports, "ObjHasOwnProperty", function () { return $5daef6f39e1b6714$export$e75288e2c24be908; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $5daef6f39e1b6714$export$327014e6dfd5ba11 = "function";
var $5daef6f39e1b6714$export$127e9c2439c2ee16 = "object";
var $5daef6f39e1b6714$export$9b7d2d86cf58b987 = "undefined";
var $5daef6f39e1b6714$export$ecddaaeb55ecf049 = "prototype";
var $5daef6f39e1b6714$export$fdeb660efff83bae = "hasOwnProperty";
var $5daef6f39e1b6714$export$b39d4edf23d6f14c = "default";
var $5daef6f39e1b6714$export$9ec954dd81c90a5d = Object;
var $5daef6f39e1b6714$export$e77bb59b5e655b3d = $5daef6f39e1b6714$export$9ec954dd81c90a5d[$5daef6f39e1b6714$export$ecddaaeb55ecf049];
var $5daef6f39e1b6714$export$c06e62a67f43408b = $5daef6f39e1b6714$export$9ec954dd81c90a5d["assign"];
var $5daef6f39e1b6714$export$62f62a547092e54f = $5daef6f39e1b6714$export$9ec954dd81c90a5d["create"];
var $5daef6f39e1b6714$export$5cec132417feb069 = $5daef6f39e1b6714$export$9ec954dd81c90a5d["defineProperty"];
var $5daef6f39e1b6714$export$e75288e2c24be908 = $5daef6f39e1b6714$export$e77bb59b5e655b3d[$5daef6f39e1b6714$export$fdeb660efff83bae];

});

parcelRegister("91dsF", function(module, exports) {

$parcel$export(module.exports, "getGlobal", function () { return $690ea6387e1f30f4$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "throwTypeError", function () { return $690ea6387e1f30f4$export$3f7738bd7dcba681; });
$parcel$export(module.exports, "objCreateFn", function () { return $690ea6387e1f30f4$export$9b0ce7e59d72f357; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var $82FQ4 = parcelRequire("82FQ4");
var $690ea6387e1f30f4$var$_cachedGlobal = null;
function $690ea6387e1f30f4$export$a4e55266d2135a7f(useCached) {
    if (useCached === void 0) useCached = true;
    var result = useCached === false ? null : $690ea6387e1f30f4$var$_cachedGlobal;
    if (!result) {
        if (typeof globalThis !== (0, $82FQ4.strShimUndefined)) result = globalThis;
        if (!result && typeof self !== (0, $82FQ4.strShimUndefined)) result = self;
        if (!result && typeof window !== (0, $82FQ4.strShimUndefined)) result = window;
        if (!result && typeof $parcel$global !== (0, $82FQ4.strShimUndefined)) result = $parcel$global;
        $690ea6387e1f30f4$var$_cachedGlobal = result;
    }
    return result;
}
function $690ea6387e1f30f4$export$3f7738bd7dcba681(message) {
    throw new TypeError(message);
}
function $690ea6387e1f30f4$export$9b0ce7e59d72f357(obj) {
    var func = (0, $82FQ4.ObjCreate);
    // Use build in Object.create
    if (func) // Use Object create method if it exists
    return func(obj);
    if (obj == null) return {};
    var type = typeof obj;
    if (type !== (0, $82FQ4.strShimObject) && type !== (0, $82FQ4.strShimFunction)) $690ea6387e1f30f4$export$3f7738bd7dcba681("Object prototype may only be an Object:" + obj);
    function tmpFunc() {}
    tmpFunc[0, $82FQ4.strShimPrototype] = obj;
    return new tmpFunc();
}

});


parcelRegister("HME9b", function(module, exports) {

$parcel$export(module.exports, "PropertiesPluginIdentifier", function () { return $0839c0748a6e841f$export$2268e69a6d93b7cc; });
$parcel$export(module.exports, "BreezeChannelIdentifier", function () { return $0839c0748a6e841f$export$a714a094d3058c99; });
$parcel$export(module.exports, "AnalyticsPluginIdentifier", function () { return $0839c0748a6e841f$export$862d858b0002f352; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Licensed under the

var $rOoAk = parcelRequire("rOoAk");


var $cYGa2 = parcelRequire("cYGa2");

var $ddqo3 = parcelRequire("ddqo3");

var $cVsUj = parcelRequire("cVsUj");

var $awDWn = parcelRequire("awDWn");

var $9rbbk = parcelRequire("9rbbk");

var $g5yzi = parcelRequire("g5yzi");

var $jMj33 = parcelRequire("jMj33");

var $czkZK = parcelRequire("czkZK");

var $cXuOT = parcelRequire("cXuOT");

var $7iT8I = parcelRequire("7iT8I");

var $cAmBy = parcelRequire("cAmBy");

var $03HBY = parcelRequire("03HBY");

var $fIGMW = parcelRequire("fIGMW");

var $hkZeA = parcelRequire("hkZeA");

var $llS2C = parcelRequire("llS2C");

var $i2MiW = parcelRequire("i2MiW");

var $55exP = parcelRequire("55exP");

var $cWQSw = parcelRequire("cWQSw");

var $dU7nU = parcelRequire("dU7nU");

var $6bipl = parcelRequire("6bipl");

var $cseB2 = parcelRequire("cseB2");

var $fAiTL = parcelRequire("fAiTL");

var $h1GMI = parcelRequire("h1GMI");

var $3uBtC = parcelRequire("3uBtC");
var $0839c0748a6e841f$export$2268e69a6d93b7cc = "AppInsightsPropertiesPlugin";
var $0839c0748a6e841f$export$a714a094d3058c99 = "AppInsightsChannelPlugin";
var $0839c0748a6e841f$export$862d858b0002f352 = "ApplicationInsightsAnalytics";

});
parcelRegister("rOoAk", function(module, exports) {

$parcel$export(module.exports, "isInternalApplicationInsightsEndpoint", function () { return $05399d3bde773e5f$export$edade5317663baa4; });
$parcel$export(module.exports, "Util", function () { return $05399d3bde773e5f$export$f8f26dd395d7e1bd; });
$parcel$export(module.exports, "UrlHelper", function () { return $05399d3bde773e5f$export$bacbc496e850c0a4; });
$parcel$export(module.exports, "CorrelationIdHelper", function () { return $05399d3bde773e5f$export$2f59e8ce91f8e350; });
$parcel$export(module.exports, "AjaxHelperParseDependencyPath", function () { return $05399d3bde773e5f$export$92b0aba7cb1d0e30; });
$parcel$export(module.exports, "dateTimeUtilsNow", function () { return $05399d3bde773e5f$export$30a447e32c58a836; });
$parcel$export(module.exports, "dateTimeUtilsDuration", function () { return $05399d3bde773e5f$export$bfc7deb7f4f00987; });
$parcel$export(module.exports, "DateTimeUtils", function () { return $05399d3bde773e5f$export$db030d70d2d24a2b; });
$parcel$export(module.exports, "createDistributedTraceContextFromTrace", function () { return $05399d3bde773e5f$export$847d5dabba5fabb9; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");
var $lhl6R = parcelRequire("lhl6R");
var $k0iSW = parcelRequire("k0iSW");
var $bU24K = parcelRequire("bU24K");
var $cseB2 = parcelRequire("cseB2");
var $1iY3X = parcelRequire("1iY3X");
var $hB9U1 = parcelRequire("hB9U1");

var $cVsUj = parcelRequire("cVsUj");

var $fAiTL = parcelRequire("fAiTL");

var $6bipl = parcelRequire("6bipl");

var $ddqo3 = parcelRequire("ddqo3");

var $h1GMI = parcelRequire("h1GMI");

var $i2MiW = parcelRequire("i2MiW");

var $3uBtC = parcelRequire("3uBtC");

var $d8tQM = parcelRequire("d8tQM");
// listing only non-geo specific locations
var $05399d3bde773e5f$var$_internalEndpoints = [
    (0, $cVsUj.DEFAULT_BREEZE_ENDPOINT) + (0, $cVsUj.DEFAULT_BREEZE_PATH),
    "https://breeze.aimon.applicationinsights.io" + (0, $cVsUj.DEFAULT_BREEZE_PATH),
    "https://dc-int.services.visualstudio.com" + (0, $cVsUj.DEFAULT_BREEZE_PATH)
];
function $05399d3bde773e5f$export$edade5317663baa4(endpointUrl) {
    return (0, $hGXAo.arrIndexOf)($05399d3bde773e5f$var$_internalEndpoints, endpointUrl[0, $d8tQM._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]()) !== -1;
}
var $05399d3bde773e5f$export$f8f26dd395d7e1bd = {
    NotSpecified: (0, $cVsUj.strNotSpecified),
    createDomEvent: (0, $fAiTL.createDomEvent),
    disableStorage: (0, $h1GMI.utlDisableStorage),
    isInternalApplicationInsightsEndpoint: $05399d3bde773e5f$export$edade5317663baa4,
    canUseLocalStorage: (0, $h1GMI.utlCanUseLocalStorage),
    getStorage: (0, $h1GMI.utlGetLocalStorage),
    setStorage: (0, $h1GMI.utlSetLocalStorage),
    removeStorage: (0, $h1GMI.utlRemoveStorage),
    canUseSessionStorage: (0, $h1GMI.utlCanUseSessionStorage),
    getSessionStorageKeys: (0, $h1GMI.utlGetSessionStorageKeys),
    getSessionStorage: (0, $h1GMI.utlGetSessionStorage),
    setSessionStorage: (0, $h1GMI.utlSetSessionStorage),
    removeSessionStorage: (0, $h1GMI.utlRemoveSessionStorage),
    disableCookies: (0, $k0iSW.disableCookies),
    canUseCookies: (0, $k0iSW.canUseCookies),
    disallowsSameSiteNone: (0, $hB9U1.uaDisallowsSameSiteNone),
    setCookie: (0, $k0iSW.setCookie),
    stringToBoolOrDefault: (0, $6bipl.stringToBoolOrDefault),
    getCookie: (0, $k0iSW.getCookie),
    deleteCookie: (0, $k0iSW.deleteCookie),
    trim: (0, $hGXAo.strTrim),
    newId: (0, $1iY3X.newId),
    random32: function() {
        return (0, $1iY3X.random32)(true);
    },
    generateW3CId: (0, $k0iSW.generateW3CId),
    isArray: (0, $hGXAo.isArray),
    isError: (0, $hGXAo.isError),
    isDate: (0, $hGXAo.isDate),
    toISOStringForIE8: (0, $hGXAo.toISOString),
    getIEVersion: (0, $bU24K.getIEVersion),
    msToTimeSpan: (0, $6bipl.msToTimeSpan),
    isCrossOriginError: (0, $6bipl.isCrossOriginError),
    dump: (0, $bU24K.dumpObj),
    getExceptionName: (0, $hGXAo.getExceptionName),
    addEventHandler: (0, $lhl6R.attachEvent),
    IsBeaconApiSupported: (0, $bU24K.isBeaconsSupported),
    getExtension: (0, $6bipl.getExtensionByName)
};
var $05399d3bde773e5f$export$bacbc496e850c0a4 = {
    parseUrl: (0, $3uBtC.urlParseUrl),
    getAbsoluteUrl: (0, $3uBtC.urlGetAbsoluteUrl),
    getPathName: (0, $3uBtC.urlGetPathName),
    getCompleteUrl: (0, $3uBtC.urlGetCompleteUrl),
    parseHost: (0, $3uBtC.urlParseHost),
    parseFullHost: (0, $3uBtC.urlParseFullHost)
};
var $05399d3bde773e5f$export$2f59e8ce91f8e350 = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */ canIncludeCorrelationHeader: function(config, requestUrl, currentHost) {
        if (!requestUrl || config && config.disableCorrelationHeaders) return false;
        if (config && config[0, $d8tQM._DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */ ]) for(var i = 0; i < config.correlationHeaderExcludePatterns[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ]; i++){
            if (config[0, $d8tQM._DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */ ][i].test(requestUrl)) return false;
        }
        var requestHost = (0, $3uBtC.urlParseUrl)(requestUrl).host[0, $d8tQM._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
        if (requestHost && (requestHost[0, $d8tQM._DYN_INDEX_OF /* @min:%2eindexOf */ ](":443") !== -1 || requestHost[0, $d8tQM._DYN_INDEX_OF /* @min:%2eindexOf */ ](":80") !== -1)) // [Bug #1260] IE can include the port even for http and https URLs so if present
        // try and parse it to remove if it matches the default protocol port
        requestHost = ((0, $3uBtC.urlParseFullHost)(requestUrl, true) || "")[0, $d8tQM._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
        if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            (0, $hGXAo.arrForEach)(includedDomains, function(domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) return false;
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] === 0) return true;
        for(var i = 0; i < excludedDomains[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ]; i++){
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) return false;
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */ getCorrelationContext: function(responseHeader) {
        if (responseHeader) {
            var correlationId = $05399d3bde773e5f$export$2f59e8ce91f8e350.getCorrelationContextValue(responseHeader, (0, $ddqo3.RequestHeaders)[1 /* eRequestHeaders.requestContextTargetKey */ ]);
            if (correlationId && correlationId !== $05399d3bde773e5f$export$2f59e8ce91f8e350.correlationIdPrefix) return correlationId;
        }
    },
    /**
     * Gets key from correlation response header
     */ getCorrelationContextValue: function(responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader[0, $d8tQM._DYN_SPLIT /* @min:%2esplit */ ](",");
            for(var i = 0; i < keyValues[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ]; ++i){
                var keyValue = keyValues[i][0, $d8tQM._DYN_SPLIT /* @min:%2esplit */ ]("=");
                if (keyValue[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] === 2 && keyValue[0] === key) return keyValue[1];
            }
        }
    }
};
function $05399d3bde773e5f$export$92b0aba7cb1d0e30(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        var parsedUrl = (0, $3uBtC.urlParseUrl)(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[0, $d8tQM._DYN_PATHNAME /* @min:%2epathname */ ] != null) {
                var pathName = parsedUrl.pathname[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] === 0 ? "/" : parsedUrl[0, $d8tQM._DYN_PATHNAME /* @min:%2epathname */ ];
                if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
                data = parsedUrl[0, $d8tQM._DYN_PATHNAME /* @min:%2epathname */ ];
                name = (0, $i2MiW.dataSanitizeString)(logger, method ? method + " " + pathName : pathName);
            } else name = (0, $i2MiW.dataSanitizeString)(logger, absoluteUrl);
        }
    } else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function $05399d3bde773e5f$export$30a447e32c58a836() {
    // returns the window or webworker performance object
    var perf = (0, $bU24K.getPerformance)();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) return now;
    }
    return (0, $hGXAo.dateNow)();
}
function $05399d3bde773e5f$export$bfc7deb7f4f00987(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !(0, $hGXAo.isNullOrUndefined)(start) && !(0, $hGXAo.isNullOrUndefined)(end)) result = end - start;
    return result;
}
var $05399d3bde773e5f$export$db030d70d2d24a2b = {
    Now: $05399d3bde773e5f$export$30a447e32c58a836,
    GetDuration: $05399d3bde773e5f$export$bfc7deb7f4f00987
};
function $05399d3bde773e5f$export$847d5dabba5fabb9(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function() {
            return trace[0, $d8tQM._DYN_NAME /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace.traceID;
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $cseB2.isValidTraceId)(newValue)) trace.traceID = newValue;
        },
        getSpanId: function() {
            return trace.parentID;
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $cseB2.isValidSpanId)(newValue)) trace.parentID = newValue;
        },
        getTraceFlags: function() {
            return trace.traceFlags;
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}

});
parcelRegister("hGXAo", function(module, exports) {

$parcel$export(module.exports, "_getObjProto", function () { return $ce14946c0a4b33ca$export$821e81707b1677f9; });
$parcel$export(module.exports, "isTypeof", function () { return $ce14946c0a4b33ca$export$aa336f94d74d9e02; });
$parcel$export(module.exports, "isUndefined", function () { return $ce14946c0a4b33ca$export$fce6876652108ab; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $ce14946c0a4b33ca$export$bedb7023a7733221; });
$parcel$export(module.exports, "isNotNullOrUndefined", function () { return $ce14946c0a4b33ca$export$71fc1ee3e76bc1fe; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $ce14946c0a4b33ca$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "isObject", function () { return $ce14946c0a4b33ca$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isFunction", function () { return $ce14946c0a4b33ca$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "normalizeJsName", function () { return $ce14946c0a4b33ca$export$f60443f194e40bc2; });
$parcel$export(module.exports, "isString", function () { return $ce14946c0a4b33ca$export$844ec244b1367d54; });
$parcel$export(module.exports, "objForEachKey", function () { return $ce14946c0a4b33ca$export$aa0705d5774c95d1; });
$parcel$export(module.exports, "strEndsWith", function () { return $ce14946c0a4b33ca$export$5222b9460f3ddbec; });
$parcel$export(module.exports, "strContains", function () { return $ce14946c0a4b33ca$export$3185d777c612e61f; });
$parcel$export(module.exports, "isDate", function () { return $ce14946c0a4b33ca$export$871608497c498473; });
$parcel$export(module.exports, "isArray", function () { return $ce14946c0a4b33ca$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isError", function () { return $ce14946c0a4b33ca$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isNumber", function () { return $ce14946c0a4b33ca$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isBoolean", function () { return $ce14946c0a4b33ca$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "toISOString", function () { return $ce14946c0a4b33ca$export$dfaaa8705752128f; });
$parcel$export(module.exports, "arrForEach", function () { return $ce14946c0a4b33ca$export$e2e5bcdbdc49c586; });
$parcel$export(module.exports, "arrIndexOf", function () { return $ce14946c0a4b33ca$export$9f3b3ffa84393d30; });
$parcel$export(module.exports, "arrMap", function () { return $ce14946c0a4b33ca$export$76f1a28030e24fa6; });
$parcel$export(module.exports, "arrReduce", function () { return $ce14946c0a4b33ca$export$a16e2b23dbd5466c; });
$parcel$export(module.exports, "strTrim", function () { return $ce14946c0a4b33ca$export$ef0e11c5f5f351f7; });
$parcel$export(module.exports, "objKeys", function () { return $ce14946c0a4b33ca$export$f7628dc18f4211e5; });
$parcel$export(module.exports, "objDefineAccessors", function () { return $ce14946c0a4b33ca$export$5525b807dcec3e1b; });
$parcel$export(module.exports, "deepFreeze", function () { return $ce14946c0a4b33ca$export$7e32b29e1cb162e1; });
$parcel$export(module.exports, "objFreeze", function () { return $ce14946c0a4b33ca$export$5da24d7703175bc5; });
$parcel$export(module.exports, "dateNow", function () { return $ce14946c0a4b33ca$export$ceae11818251d43c; });
$parcel$export(module.exports, "getExceptionName", function () { return $ce14946c0a4b33ca$export$39c4487b36c98fec; });
$parcel$export(module.exports, "setValue", function () { return $ce14946c0a4b33ca$export$80746c6bc6142fc8; });
$parcel$export(module.exports, "getSetValue", function () { return $ce14946c0a4b33ca$export$51417ccc212471e; });
$parcel$export(module.exports, "getCfgValue", function () { return $ce14946c0a4b33ca$export$2f28e79027e1dc43; });
$parcel$export(module.exports, "isTruthy", function () { return $ce14946c0a4b33ca$export$8f9cae6546f97a9f; });
$parcel$export(module.exports, "throwError", function () { return $ce14946c0a4b33ca$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "proxyAssign", function () { return $ce14946c0a4b33ca$export$21c1f632458708da; });
$parcel$export(module.exports, "proxyFunctionAs", function () { return $ce14946c0a4b33ca$export$5dd8d245f6f94a18; });
$parcel$export(module.exports, "proxyFunctions", function () { return $ce14946c0a4b33ca$export$94f4c7fb7e7d8dc7; });
$parcel$export(module.exports, "createClassFromInterface", function () { return $ce14946c0a4b33ca$export$f0facb5bce2741f0; });
$parcel$export(module.exports, "optimizeObject", function () { return $ce14946c0a4b33ca$export$3e03fa3fc3e422d7; });
$parcel$export(module.exports, "objExtend", function () { return $ce14946c0a4b33ca$export$a7f7e50f928053df; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $82FQ4 = parcelRequire("82FQ4");
var $91dsF = parcelRequire("91dsF");

var $j5TD0 = parcelRequire("j5TD0");

var $59IxV = parcelRequire("59IxV");
// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var $ce14946c0a4b33ca$var$strToISOString = "toISOString";
var $ce14946c0a4b33ca$var$cStrEndsWith = "endsWith";
var $ce14946c0a4b33ca$var$cStrStartsWith = "startsWith";
var $ce14946c0a4b33ca$var$strIndexOf = "indexOf";
var $ce14946c0a4b33ca$var$strMap = "map";
var $ce14946c0a4b33ca$var$strReduce = "reduce";
var $ce14946c0a4b33ca$var$cStrTrim = "trim";
var $ce14946c0a4b33ca$var$strToString = "toString";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $ce14946c0a4b33ca$var$str__Proto = "__proto__";
/**
  * Constant string defined to support minimization
  * @ignore
  */ var $ce14946c0a4b33ca$var$strConstructor = "constructor";
var $ce14946c0a4b33ca$var$_objDefineProperty = (0, $82FQ4.ObjDefineProperty);
var $ce14946c0a4b33ca$var$_objFreeze = (0, $82FQ4.ObjClass).freeze;
var $ce14946c0a4b33ca$var$_objSeal = (0, $82FQ4.ObjClass).seal;
var $ce14946c0a4b33ca$var$_objKeys = (0, $82FQ4.ObjClass).keys;
var $ce14946c0a4b33ca$var$StringProto = String[0, $82FQ4.strShimPrototype];
var $ce14946c0a4b33ca$var$_strTrim = $ce14946c0a4b33ca$var$StringProto[$ce14946c0a4b33ca$var$cStrTrim];
var $ce14946c0a4b33ca$var$_strEndsWith = $ce14946c0a4b33ca$var$StringProto[$ce14946c0a4b33ca$var$cStrEndsWith];
var $ce14946c0a4b33ca$var$_strStartsWith = $ce14946c0a4b33ca$var$StringProto[$ce14946c0a4b33ca$var$cStrStartsWith];
var $ce14946c0a4b33ca$var$DateProto = Date[0, $82FQ4.strShimPrototype];
var $ce14946c0a4b33ca$var$_dataToISOString = $ce14946c0a4b33ca$var$DateProto[$ce14946c0a4b33ca$var$strToISOString];
var $ce14946c0a4b33ca$var$_isArray = Array.isArray;
var $ce14946c0a4b33ca$var$_objToString = (0, $82FQ4.ObjProto)[$ce14946c0a4b33ca$var$strToString];
var $ce14946c0a4b33ca$var$_fnToString = (0, $82FQ4.ObjHasOwnProperty)[$ce14946c0a4b33ca$var$strToString];
// Cache what this browser reports as the object function constructor (as a string)
var $ce14946c0a4b33ca$var$_objFunctionString = $ce14946c0a4b33ca$var$_fnToString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ]((0, $82FQ4.ObjClass));
var $ce14946c0a4b33ca$var$rCamelCase = /-([a-z])/g;
var $ce14946c0a4b33ca$var$rNormalizeInvalid = /([^\w\d_$])/g;
var $ce14946c0a4b33ca$var$rLeadingNumeric = /^(\d+[\w\d_$])/;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $ce14946c0a4b33ca$var$_objGetPrototypeOf = Object["getPrototypeOf"];
function $ce14946c0a4b33ca$export$821e81707b1677f9(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if ($ce14946c0a4b33ca$var$_objGetPrototypeOf) return $ce14946c0a4b33ca$var$_objGetPrototypeOf(target);
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[$ce14946c0a4b33ca$var$str__Proto] || target[0, $82FQ4.strShimPrototype] || target[$ce14946c0a4b33ca$var$strConstructor];
        if (newProto) return newProto;
    }
    return null;
}
function $ce14946c0a4b33ca$export$3cbb80dec8953997(obj) {
    return $ce14946c0a4b33ca$var$_objToString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj);
}
function $ce14946c0a4b33ca$export$aa336f94d74d9e02(value, theType) {
    return typeof value === theType;
}
function $ce14946c0a4b33ca$export$fce6876652108ab(value) {
    return value === undefined || typeof value === (0, $82FQ4.strShimUndefined);
}
function $ce14946c0a4b33ca$export$e7321bf46d18757f(value) {
    return !$ce14946c0a4b33ca$export$fce6876652108ab(value);
}
function $ce14946c0a4b33ca$export$bedb7023a7733221(value) {
    return value === null || $ce14946c0a4b33ca$export$fce6876652108ab(value);
}
function $ce14946c0a4b33ca$export$71fc1ee3e76bc1fe(value) {
    return !$ce14946c0a4b33ca$export$bedb7023a7733221(value);
}
function $ce14946c0a4b33ca$export$5a15a386532a5ea4(obj, prop) {
    return !!(obj && (0, $82FQ4.ObjHasOwnProperty)[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj, prop));
}
function $ce14946c0a4b33ca$export$a6cdc56e425d0d0a(value) {
    // Changing to inline for performance
    return !!(value && typeof value === (0, $82FQ4.strShimObject));
}
function $ce14946c0a4b33ca$export$f6e2535fb5126e54(value) {
    // Changing to inline for performance
    return !!(value && typeof value === (0, $82FQ4.strShimFunction));
}
function $ce14946c0a4b33ca$export$ae936b9d47e5870e(value) {
    return value && $ce14946c0a4b33ca$export$f6e2535fb5126e54(value.then);
}
function $ce14946c0a4b33ca$export$f60443f194e40bc2(name) {
    var value = name;
    if (value && $ce14946c0a4b33ca$export$844ec244b1367d54(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ]($ce14946c0a4b33ca$var$rCamelCase, function(_all, letter) {
            return letter.toUpperCase();
        });
        value = value[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ]($ce14946c0a4b33ca$var$rNormalizeInvalid, "_");
        value = value[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ]($ce14946c0a4b33ca$var$rLeadingNumeric, function(_all, match) {
            return "_" + match;
        });
    }
    return value;
}
function $ce14946c0a4b33ca$export$aa0705d5774c95d1(target, callbackfn) {
    if (target) {
        for(var prop in target)if ((0, $82FQ4.ObjHasOwnProperty)[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](target, prop)) callbackfn[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](target, prop, target[prop]);
    }
}
function $ce14946c0a4b33ca$export$5222b9460f3ddbec(value, search) {
    var result = false;
    if (value && search && !(result = value === search)) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    result = $ce14946c0a4b33ca$var$_strEndsWith ? value[$ce14946c0a4b33ca$var$cStrEndsWith](search) : $ce14946c0a4b33ca$export$2df85a6147c3ff40(value, search);
    return result;
}
function $ce14946c0a4b33ca$export$2df85a6147c3ff40(value, search) {
    var result = false;
    var searchLen = search ? search[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] : 0;
    var valLen = value ? value[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] : 0;
    if (searchLen && valLen && valLen >= searchLen && !(result = value === search)) {
        var pos = valLen - 1;
        for(var lp = searchLen - 1; lp >= 0; lp--){
            if (value[pos] != search[lp]) return false;
            pos--;
        }
        result = true;
    }
    return result;
}
function $ce14946c0a4b33ca$export$da061769d961e150(value, checkValue) {
    var result = false;
    if (value && checkValue && !(result = value === checkValue)) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    result = $ce14946c0a4b33ca$var$_strStartsWith ? value[$ce14946c0a4b33ca$var$cStrStartsWith](checkValue) : $ce14946c0a4b33ca$export$cb4f052c3fee979b(value, checkValue);
    return result;
}
function $ce14946c0a4b33ca$export$cb4f052c3fee979b(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    var chkLen = checkValue ? checkValue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] : 0;
    if (value && chkLen && value[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] >= chkLen && !(result = value === checkValue)) {
        for(var lp = 0; lp < chkLen; lp++){
            if (value[lp] !== checkValue[lp]) return false;
        }
        result = true;
    }
    return result;
}
function $ce14946c0a4b33ca$export$3185d777c612e61f(value, search) {
    if (value && search) return value[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ](search) !== -1;
    return false;
}
function $ce14946c0a4b33ca$export$871608497c498473(obj) {
    return !!(obj && $ce14946c0a4b33ca$var$_objToString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj) === "[object Date]");
}
var $ce14946c0a4b33ca$export$43bee75e5e14138e = $ce14946c0a4b33ca$var$_isArray || $ce14946c0a4b33ca$var$_isArrayPoly;
function $ce14946c0a4b33ca$var$_isArrayPoly(obj) {
    return !!(obj && $ce14946c0a4b33ca$var$_objToString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj) === "[object Array]");
}
function $ce14946c0a4b33ca$export$e6127cc7fe7395c3(obj) {
    return !!(obj && $ce14946c0a4b33ca$var$_objToString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj) === "[object Error]");
}
function $ce14946c0a4b33ca$export$844ec244b1367d54(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
function $ce14946c0a4b33ca$export$7e4aa119212bc614(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
function $ce14946c0a4b33ca$export$f9ce7b637dfbe238(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
function $ce14946c0a4b33ca$export$a244864fd9645c7f(value) {
    return typeof value === "symbol";
}
function $ce14946c0a4b33ca$export$53b83ca8eaab0383(value) {
    var result = false;
    if (value && typeof value === "object") {
        // Inlining _objGetPrototypeOf for performance to avoid an additional function call
        var proto = $ce14946c0a4b33ca$var$_objGetPrototypeOf ? $ce14946c0a4b33ca$var$_objGetPrototypeOf(value) : $ce14946c0a4b33ca$export$821e81707b1677f9(value);
        if (!proto) // No prototype found so this is a plain Object eg. 'Object.create(null)'
        result = true;
        else {
            // Objects that have a prototype are plain only if they were created using the Object global (native) function
            if (proto[$ce14946c0a4b33ca$var$strConstructor] && (0, $82FQ4.ObjHasOwnProperty)[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](proto, $ce14946c0a4b33ca$var$strConstructor)) proto = proto[$ce14946c0a4b33ca$var$strConstructor];
            result = typeof proto === (0, $82FQ4.strShimFunction) && $ce14946c0a4b33ca$var$_fnToString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](proto) === $ce14946c0a4b33ca$var$_objFunctionString;
        }
    }
    return result;
}
function $ce14946c0a4b33ca$export$dfaaa8705752128f(date) {
    if (date) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    return $ce14946c0a4b33ca$var$_dataToISOString ? date[$ce14946c0a4b33ca$var$strToISOString]() : $ce14946c0a4b33ca$export$1a9b608c6a599ac2(date);
}
function $ce14946c0a4b33ca$export$1a9b608c6a599ac2(date) {
    if (date && date.getUTCFullYear) {
        var pad = function(num) {
            var r = String(num);
            if (r[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] === 1) r = "0" + r;
            return r;
        };
        return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + "Z";
    }
}
function $ce14946c0a4b33ca$export$e2e5bcdbdc49c586(arr, callbackfn, thisArg) {
    var len = arr[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
    try {
        for(var idx = 0; idx < len; idx++)if (idx in arr) {
            if (callbackfn[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](thisArg || arr, arr[idx], idx, arr) === -1) break;
        }
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
}
function $ce14946c0a4b33ca$export$9f3b3ffa84393d30(arr, searchElement, fromIndex) {
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[$ce14946c0a4b33ca$var$strIndexOf]) return arr[$ce14946c0a4b33ca$var$strIndexOf](searchElement, fromIndex);
        var len = arr[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
        var from = fromIndex || 0;
        try {
            for(var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++){
                if (lp in arr && arr[lp] === searchElement) return lp;
            }
        } catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
        }
    }
    return -1;
}
function $ce14946c0a4b33ca$export$76f1a28030e24fa6(arr, callbackfn, thisArg) {
    var results;
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[$ce14946c0a4b33ca$var$strMap]) return arr[$ce14946c0a4b33ca$var$strMap](callbackfn, thisArg);
        var len = arr[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
        var _this = thisArg || arr;
        results = new Array(len);
        try {
            for(var lp = 0; lp < len; lp++)if (lp in arr) results[lp] = callbackfn[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](_this, arr[lp], arr);
        } catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
        }
    }
    return results;
}
function $ce14946c0a4b33ca$export$a16e2b23dbd5466c(arr, callbackfn, initialValue) {
    var value;
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[$ce14946c0a4b33ca$var$strReduce]) return arr[$ce14946c0a4b33ca$var$strReduce](callbackfn, initialValue);
        var len = arr[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
        var lp = 0;
        // Specifically checking the number of passed arguments as the value could be anything
        if (arguments[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] >= 3) value = arguments[2];
        else {
            while(lp < len && !(lp in arr))lp++;
            value = arr[lp++];
        }
        while(lp < len){
            if (lp in arr) value = callbackfn(value, arr[lp], lp, arr);
            lp++;
        }
    }
    return value;
}
function $ce14946c0a4b33ca$export$ef0e11c5f5f351f7(str) {
    if (str) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    str = $ce14946c0a4b33ca$var$_strTrim && str[$ce14946c0a4b33ca$var$cStrTrim] ? str[$ce14946c0a4b33ca$var$cStrTrim]() : str[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ] ? str[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ](/^\s+|(?=\s)\s+$/g, (0, $59IxV.STR_EMPTY)) : str;
    return str;
}
var $ce14946c0a4b33ca$var$_objKeysHasDontEnumBug = !({
    toString: null
}).propertyIsEnumerable("toString");
var $ce14946c0a4b33ca$var$_objKeysDontEnums = [
    "toString",
    "toLocaleString",
    "valueOf",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "constructor"
];
function $ce14946c0a4b33ca$export$f7628dc18f4211e5(obj) {
    var objType = typeof obj;
    if (objType !== (0, $82FQ4.strShimFunction) && (objType !== (0, $82FQ4.strShimObject) || obj === null)) (0, $91dsF.throwTypeError)("objKeys called on non-object");
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    if (!$ce14946c0a4b33ca$var$_objKeysHasDontEnumBug && $ce14946c0a4b33ca$var$_objKeys) return $ce14946c0a4b33ca$var$_objKeys(obj);
    var result = [];
    for(var prop in obj)if (obj && (0, $82FQ4.ObjHasOwnProperty)[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj, prop)) result[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](prop);
    if ($ce14946c0a4b33ca$var$_objKeysHasDontEnumBug) {
        var dontEnumsLength = $ce14946c0a4b33ca$var$_objKeysDontEnums[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
        for(var lp = 0; lp < dontEnumsLength; lp++)if (obj && (0, $82FQ4.ObjHasOwnProperty)[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](obj, $ce14946c0a4b33ca$var$_objKeysDontEnums[lp])) result[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ]($ce14946c0a4b33ca$var$_objKeysDontEnums[lp]);
    }
    return result;
}
function $ce14946c0a4b33ca$export$5525b807dcec3e1b(target, prop, getProp, setProp) {
    if ($ce14946c0a4b33ca$var$_objDefineProperty) try {
        var descriptor = {
            enumerable: true,
            configurable: true
        };
        if (getProp) descriptor.get = getProp;
        if (setProp) descriptor.set = setProp;
        $ce14946c0a4b33ca$var$_objDefineProperty(target, prop, descriptor);
        return true;
    } catch (e) {
    // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
    // We will just ignore this here.
    }
    return false;
}
function $ce14946c0a4b33ca$var$_doNothing(value) {
    return value;
}
function $ce14946c0a4b33ca$export$7e32b29e1cb162e1(obj) {
    if ($ce14946c0a4b33ca$var$_objFreeze) $ce14946c0a4b33ca$export$aa0705d5774c95d1(obj, function(name, value) {
        if ($ce14946c0a4b33ca$export$43bee75e5e14138e(value) || $ce14946c0a4b33ca$export$a6cdc56e425d0d0a(value)) $ce14946c0a4b33ca$var$_objFreeze(value);
    });
    return $ce14946c0a4b33ca$export$5da24d7703175bc5(obj);
}
var $ce14946c0a4b33ca$export$5da24d7703175bc5 = $ce14946c0a4b33ca$var$_objFreeze || $ce14946c0a4b33ca$var$_doNothing;
var $ce14946c0a4b33ca$export$8bbd42c2bec875c8 = $ce14946c0a4b33ca$var$_objSeal || $ce14946c0a4b33ca$var$_doNothing;
function $ce14946c0a4b33ca$export$ceae11818251d43c() {
    var dt = Date;
    return dt.now ? dt.now() : new dt().getTime();
}
function $ce14946c0a4b33ca$export$39c4487b36c98fec(object) {
    if ($ce14946c0a4b33ca$export$e6127cc7fe7395c3(object)) return object[0, $j5TD0._DYN_NAME /* @min:%2ename */ ];
    return 0, $59IxV.STR_EMPTY;
}
function $ce14946c0a4b33ca$export$80746c6bc6142fc8(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
function $ce14946c0a4b33ca$export$51417ccc212471e(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && $ce14946c0a4b33ca$export$bedb7023a7733221(theValue)) {
            // Supports having the default as null
            theValue = !$ce14946c0a4b33ca$export$fce6876652108ab(defValue) ? defValue : {};
            target[field] = theValue;
        }
    } else // Expanded for performance so we only check defValue if required
    theValue = !$ce14946c0a4b33ca$export$fce6876652108ab(defValue) ? defValue : {};
    return theValue;
}
function $ce14946c0a4b33ca$export$2f28e79027e1dc43(theValue, defaultValue) {
    return !$ce14946c0a4b33ca$export$bedb7023a7733221(theValue) ? theValue : defaultValue;
}
function $ce14946c0a4b33ca$export$5f2b986706b25721(value) {
    return !value;
}
function $ce14946c0a4b33ca$export$8f9cae6546f97a9f(value) {
    return !!value;
}
function $ce14946c0a4b33ca$export$8bf7aba4a9e09055(message) {
    throw new Error(message);
}
function $ce14946c0a4b33ca$var$_createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if ($ce14946c0a4b33ca$export$f6e2535fb5126e54(source)) srcFunc = source;
    else src = source;
    return function() {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) src = srcFunc();
        if (src) return src[funcName][0, $j5TD0._DYN_APPLY /* @min:%2eapply */ ](src, originalArguments);
    };
}
function $ce14946c0a4b33ca$export$21c1f632458708da(target, source, chkSet) {
    if (target && source && $ce14946c0a4b33ca$export$a6cdc56e425d0d0a(target) && $ce14946c0a4b33ca$export$a6cdc56e425d0d0a(source)) {
        var _loop_1 = function(field) {
            if ($ce14946c0a4b33ca$export$844ec244b1367d54(field)) {
                var value = source[field];
                if ($ce14946c0a4b33ca$export$f6e2535fb5126e54(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                    target[field] = $ce14946c0a4b33ca$var$_createProxyFunction(source, field);
                } else if (!chkSet || chkSet(field, false, source, target)) {
                    if ($ce14946c0a4b33ca$export$5a15a386532a5ea4(target, field)) // Remove any previous instance property
                    delete target[field];
                    if (!$ce14946c0a4b33ca$export$5525b807dcec3e1b(target, field, function() {
                        return source[field];
                    }, function(theValue) {
                        source[field] = theValue;
                    })) // Unable to create an accessor, so just assign the values as a fallback
                    // -- this will (mostly) work for objects
                    // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                    target[field] = value;
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for(var field in source)_loop_1(field);
    }
    return target;
}
function $ce14946c0a4b33ca$export$5dd8d245f6f94a18(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || $ce14946c0a4b33ca$export$fce6876652108ab(target[name])) target[name] = $ce14946c0a4b33ca$var$_createProxyFunction(source, theFunc);
    }
}
function $ce14946c0a4b33ca$export$94f4c7fb7e7d8dc7(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && $ce14946c0a4b33ca$export$a6cdc56e425d0d0a(target) && $ce14946c0a4b33ca$export$43bee75e5e14138e(functionsToProxy)) $ce14946c0a4b33ca$export$e2e5bcdbdc49c586(functionsToProxy, function(theFuncName) {
        if ($ce14946c0a4b33ca$export$844ec244b1367d54(theFuncName)) $ce14946c0a4b33ca$export$5dd8d245f6f94a18(target, theFuncName, source, theFuncName, overwriteTarget);
    });
    return target;
}
function $ce14946c0a4b33ca$export$f0facb5bce2741f0(defaults) {
    return /** @class */ function() {
        function class_1() {
            var _this_1 = this;
            if (defaults) $ce14946c0a4b33ca$export$aa0705d5774c95d1(defaults, function(field, value) {
                _this_1[field] = value;
            });
        }
        return class_1;
    }();
}
function $ce14946c0a4b33ca$export$3e03fa3fc3e422d7(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && (0, $82FQ4.ObjAssign)) theObject = (0, $82FQ4.ObjClass)((0, $82FQ4.ObjAssign)({}, theObject));
    return theObject;
}
function $ce14946c0a4b33ca$export$a7f7e50f928053df(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && $ce14946c0a4b33ca$export$f9ce7b637dfbe238(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!$ce14946c0a4b33ca$export$a6cdc56e425d0d0a(extended)) extended = {};
    // Loop through each remaining object and conduct a merge
    for(; idx < argLen; idx++){
        var arg = theArgs[idx];
        var isArgArray = $ce14946c0a4b33ca$export$43bee75e5e14138e(arg);
        var isArgObj = $ce14946c0a4b33ca$export$a6cdc56e425d0d0a(arg);
        for(var prop in arg){
            var propOk = isArgArray && prop in arg || isArgObj && (0, $82FQ4.ObjHasOwnProperty)[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](arg, prop);
            if (!propOk) continue;
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = $ce14946c0a4b33ca$export$43bee75e5e14138e(newValue)) || $ce14946c0a4b33ca$export$53b83ca8eaab0383(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!$ce14946c0a4b33ca$export$43bee75e5e14138e(clone)) // We can't "merge" an array with a non-array so overwrite the original
                    clone = [];
                } else if (!$ce14946c0a4b33ca$export$53b83ca8eaab0383(clone)) // We can't "merge" an object with a non-object
                clone = {};
                // Never move the original objects always clone them
                newValue = $ce14946c0a4b33ca$export$a7f7e50f928053df(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) extended[prop] = newValue;
        }
    }
    return extended;
}

});
parcelRegister("j5TD0", function(module, exports) {

$parcel$export(module.exports, "_DYN_INITIALIZE", function () { return $de69a28e0bb3098d$export$65cd33bb52d04675; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $de69a28e0bb3098d$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_GET_NOTIFY_MGR", function () { return $de69a28e0bb3098d$export$3a09068de032bb32; });
$parcel$export(module.exports, "_DYN_IDENTIFIER", function () { return $de69a28e0bb3098d$export$f001befbf8417151; });
$parcel$export(module.exports, "_DYN_PUSH", function () { return $de69a28e0bb3098d$export$a0a330e7fa1e278c; });
$parcel$export(module.exports, "_DYN_IS_INITIALIZED", function () { return $de69a28e0bb3098d$export$2e2716e9c35a66a8; });
$parcel$export(module.exports, "_DYN_CONFIG", function () { return $de69a28e0bb3098d$export$25fc8bd3fb7f1e5a; });
$parcel$export(module.exports, "_DYN_INSTRUMENTATION_KEY", function () { return $de69a28e0bb3098d$export$81cfd43387c8dbcc; });
$parcel$export(module.exports, "_DYN_LOGGER", function () { return $de69a28e0bb3098d$export$e6a243fe757439f9; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $de69a28e0bb3098d$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_TIME", function () { return $de69a28e0bb3098d$export$7b5ba5854159c1f0; });
$parcel$export(module.exports, "_DYN_PROCESS_NEXT", function () { return $de69a28e0bb3098d$export$5c220169317cd6de; });
$parcel$export(module.exports, "_DYN_GET_PROCESS_TEL_CONT0", function () { return $de69a28e0bb3098d$export$a08d24db8e8aa3f3; });
$parcel$export(module.exports, "_DYN_ADD_NOTIFICATION_LIS1", function () { return $de69a28e0bb3098d$export$5c8bcfab4f42ca62; });
$parcel$export(module.exports, "_DYN_REMOVE_NOTIFICATION_2", function () { return $de69a28e0bb3098d$export$861144ba9c13be60; });
$parcel$export(module.exports, "_DYN_STOP_POLLING_INTERNA3", function () { return $de69a28e0bb3098d$export$8d1c48dba7ad83a; });
$parcel$export(module.exports, "_DYN_ON_COMPLETE", function () { return $de69a28e0bb3098d$export$8693bdba21bfca93; });
$parcel$export(module.exports, "_DYN_GET_PLUGIN", function () { return $de69a28e0bb3098d$export$37717a508eca6e2d; });
$parcel$export(module.exports, "_DYN_FLUSH", function () { return $de69a28e0bb3098d$export$cb47434b4a1b13a1; });
$parcel$export(module.exports, "_DYN__EXTENSIONS", function () { return $de69a28e0bb3098d$export$f97d4195cc7ba3fc; });
$parcel$export(module.exports, "_DYN_SPLICE", function () { return $de69a28e0bb3098d$export$84020a2e4fe863b0; });
$parcel$export(module.exports, "_DYN_TEARDOWN", function () { return $de69a28e0bb3098d$export$7176fb2a7d11927e; });
$parcel$export(module.exports, "_DYN_MESSAGE_ID", function () { return $de69a28e0bb3098d$export$2cc5b49df2eed261; });
$parcel$export(module.exports, "_DYN_MESSAGE", function () { return $de69a28e0bb3098d$export$923606b70907833e; });
$parcel$export(module.exports, "_DYN_IS_ASYNC", function () { return $de69a28e0bb3098d$export$d8114c9e990204cb; });
$parcel$export(module.exports, "_DYN__DO_TEARDOWN", function () { return $de69a28e0bb3098d$export$458d234b616d0745; });
$parcel$export(module.exports, "_DYN_UPDATE", function () { return $de69a28e0bb3098d$export$c9f4bebf02f459de; });
$parcel$export(module.exports, "_DYN_GET_NEXT", function () { return $de69a28e0bb3098d$export$36754a48de7fd714; });
$parcel$export(module.exports, "_DYN_DIAG_LOG", function () { return $de69a28e0bb3098d$export$c7ff2c36e5c78421; });
$parcel$export(module.exports, "_DYN_SET_NEXT_PLUGIN", function () { return $de69a28e0bb3098d$export$55d672a1dc4d50c1; });
$parcel$export(module.exports, "_DYN_CREATE_NEW", function () { return $de69a28e0bb3098d$export$1e6514b499ba4d34; });
$parcel$export(module.exports, "_DYN_COOKIE_CFG", function () { return $de69a28e0bb3098d$export$e090c68eb6dfd391; });
$parcel$export(module.exports, "_DYN_INDEX_OF", function () { return $de69a28e0bb3098d$export$a3d3f936db372b4b; });
$parcel$export(module.exports, "_DYN_SUBSTRING", function () { return $de69a28e0bb3098d$export$20dce058fdd3c573; });
$parcel$export(module.exports, "_DYN_USER_AGENT", function () { return $de69a28e0bb3098d$export$2e850152cb3355e2; });
$parcel$export(module.exports, "_DYN_SPLIT", function () { return $de69a28e0bb3098d$export$b889f1d4cb07c706; });
$parcel$export(module.exports, "_DYN_SET_ENABLED", function () { return $de69a28e0bb3098d$export$7fd5fce894e4cf77; });
$parcel$export(module.exports, "_DYN_SUBSTR", function () { return $de69a28e0bb3098d$export$5d9064a330e4b089; });
$parcel$export(module.exports, "_DYN_NODE_TYPE", function () { return $de69a28e0bb3098d$export$aa192ee35fac3196; });
$parcel$export(module.exports, "_DYN_APPLY", function () { return $de69a28e0bb3098d$export$2f85ca6962b15ff8; });
$parcel$export(module.exports, "_DYN_REPLACE", function () { return $de69a28e0bb3098d$export$ef9ef3ed86c4485; });
$parcel$export(module.exports, "_DYN_ENABLE_DEBUG_EXCEPTI4", function () { return $de69a28e0bb3098d$export$89fbbfd80220a152; });
$parcel$export(module.exports, "_DYN_LOG_INTERNAL_MESSAGE", function () { return $de69a28e0bb3098d$export$6a3333b2109fff2a; });
$parcel$export(module.exports, "_DYN_TO_LOWER_CASE", function () { return $de69a28e0bb3098d$export$e4eaee9e01d9baaa; });
$parcel$export(module.exports, "_DYN_CALL", function () { return $de69a28e0bb3098d$export$c9d274370e1187e2; });
$parcel$export(module.exports, "_DYN_TYPE", function () { return $de69a28e0bb3098d$export$8fdcd26070ec159; });
$parcel$export(module.exports, "_DYN_HANDLER", function () { return $de69a28e0bb3098d$export$b353fcbe1ae31450; });
$parcel$export(module.exports, "_DYN_LISTENERS", function () { return $de69a28e0bb3098d$export$2f9a1089308fc768; });
$parcel$export(module.exports, "_DYN_IS_CHILD_EVT", function () { return $de69a28e0bb3098d$export$3a89026537e5dfec; });
$parcel$export(module.exports, "_DYN_GET_CTX", function () { return $de69a28e0bb3098d$export$c405fd80acb80a5b; });
$parcel$export(module.exports, "_DYN_SET_CTX", function () { return $de69a28e0bb3098d$export$2ec27a3df8fa4130; });
$parcel$export(module.exports, "_DYN_COMPLETE", function () { return $de69a28e0bb3098d$export$b6736e780b133181; });
$parcel$export(module.exports, "_DYN_TRACE_ID", function () { return $de69a28e0bb3098d$export$a5eb52c53bba8560; });
$parcel$export(module.exports, "_DYN_SPAN_ID", function () { return $de69a28e0bb3098d$export$c105b94efa183847; });
$parcel$export(module.exports, "_DYN_TRACE_FLAGS", function () { return $de69a28e0bb3098d$export$4e92e4b92b41ba2d; });
$parcel$export(module.exports, "_DYN_VERSION", function () { return $de69a28e0bb3098d$export$568c4302d11f2b22; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $de69a28e0bb3098d$export$65cd33bb52d04675 = "initialize"; // Count: 8
var $de69a28e0bb3098d$export$9734b0a24bf02e93 = "name"; // Count: 11
var $de69a28e0bb3098d$export$3a09068de032bb32 = "getNotifyMgr"; // Count: 3
var $de69a28e0bb3098d$export$f001befbf8417151 = "identifier"; // Count: 8
var $de69a28e0bb3098d$export$a0a330e7fa1e278c = "push"; // Count: 30
var $de69a28e0bb3098d$export$2e2716e9c35a66a8 = "isInitialized"; // Count: 10
var $de69a28e0bb3098d$export$25fc8bd3fb7f1e5a = "config"; // Count: 7
var $de69a28e0bb3098d$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 3
var $de69a28e0bb3098d$export$e6a243fe757439f9 = "logger"; // Count: 10
var $de69a28e0bb3098d$export$6eae51590aaea43 = "length"; // Count: 45
var $de69a28e0bb3098d$export$7b5ba5854159c1f0 = "time"; // Count: 5
var $de69a28e0bb3098d$export$5c220169317cd6de = "processNext"; // Count: 21
var $de69a28e0bb3098d$export$a08d24db8e8aa3f3 = "getProcessTelContext"; // Count: 2
var $de69a28e0bb3098d$export$5c8bcfab4f42ca62 = "addNotificationListener"; // Count: 5
var $de69a28e0bb3098d$export$861144ba9c13be60 = "removeNotificationListener"; // Count: 5
var $de69a28e0bb3098d$export$8d1c48dba7ad83a = "stopPollingInternalLogs"; // Count: 2
var $de69a28e0bb3098d$export$8693bdba21bfca93 = "onComplete"; // Count: 6
var $de69a28e0bb3098d$export$37717a508eca6e2d = "getPlugin"; // Count: 5
var $de69a28e0bb3098d$export$cb47434b4a1b13a1 = "flush"; // Count: 5
var $de69a28e0bb3098d$export$f97d4195cc7ba3fc = "_extensions"; // Count: 4
var $de69a28e0bb3098d$export$84020a2e4fe863b0 = "splice"; // Count: 6
var $de69a28e0bb3098d$export$7176fb2a7d11927e = "teardown"; // Count: 10
var $de69a28e0bb3098d$export$2cc5b49df2eed261 = "messageId"; // Count: 4
var $de69a28e0bb3098d$export$923606b70907833e = "message"; // Count: 7
var $de69a28e0bb3098d$export$d8114c9e990204cb = "isAsync"; // Count: 7
var $de69a28e0bb3098d$export$458d234b616d0745 = "_doTeardown"; // Count: 4
var $de69a28e0bb3098d$export$c9f4bebf02f459de = "update"; // Count: 7
var $de69a28e0bb3098d$export$36754a48de7fd714 = "getNext"; // Count: 12
var $de69a28e0bb3098d$export$c7ff2c36e5c78421 = "diagLog"; // Count: 8
var $de69a28e0bb3098d$export$55d672a1dc4d50c1 = "setNextPlugin"; // Count: 5
var $de69a28e0bb3098d$export$1e6514b499ba4d34 = "createNew"; // Count: 6
var $de69a28e0bb3098d$export$e090c68eb6dfd391 = "cookieCfg"; // Count: 3
var $de69a28e0bb3098d$export$a3d3f936db372b4b = "indexOf"; // Count: 7
var $de69a28e0bb3098d$export$20dce058fdd3c573 = "substring"; // Count: 10
var $de69a28e0bb3098d$export$2e850152cb3355e2 = "userAgent"; // Count: 5
var $de69a28e0bb3098d$export$b889f1d4cb07c706 = "split"; // Count: 6
var $de69a28e0bb3098d$export$7fd5fce894e4cf77 = "setEnabled"; // Count: 5
var $de69a28e0bb3098d$export$5d9064a330e4b089 = "substr"; // Count: 6
var $de69a28e0bb3098d$export$aa192ee35fac3196 = "nodeType"; // Count: 3
var $de69a28e0bb3098d$export$2f85ca6962b15ff8 = "apply"; // Count: 6
var $de69a28e0bb3098d$export$ef9ef3ed86c4485 = "replace"; // Count: 10
var $de69a28e0bb3098d$export$89fbbfd80220a152 = "enableDebugExceptions"; // Count: 2
var $de69a28e0bb3098d$export$6a3333b2109fff2a = "logInternalMessage"; // Count: 2
var $de69a28e0bb3098d$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 8
var $de69a28e0bb3098d$export$c9d274370e1187e2 = "call"; // Count: 18
var $de69a28e0bb3098d$export$8fdcd26070ec159 = "type"; // Count: 14
var $de69a28e0bb3098d$export$b353fcbe1ae31450 = "handler"; // Count: 5
var $de69a28e0bb3098d$export$2f9a1089308fc768 = "listeners"; // Count: 6
var $de69a28e0bb3098d$export$3a89026537e5dfec = "isChildEvt"; // Count: 3
var $de69a28e0bb3098d$export$c405fd80acb80a5b = "getCtx"; // Count: 6
var $de69a28e0bb3098d$export$2ec27a3df8fa4130 = "setCtx"; // Count: 10
var $de69a28e0bb3098d$export$b6736e780b133181 = "complete"; // Count: 3
var $de69a28e0bb3098d$export$a5eb52c53bba8560 = "traceId"; // Count: 5
var $de69a28e0bb3098d$export$c105b94efa183847 = "spanId"; // Count: 5
var $de69a28e0bb3098d$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 6
var $de69a28e0bb3098d$export$568c4302d11f2b22 = "version"; // Count: 4

});

parcelRegister("59IxV", function(module, exports) {

$parcel$export(module.exports, "STR_EMPTY", function () { return $3c1058f5e8e38154$export$5e8607ab26634759; });
$parcel$export(module.exports, "STR_CHANNELS", function () { return $3c1058f5e8e38154$export$829012af4b2055a2; });
$parcel$export(module.exports, "STR_CORE", function () { return $3c1058f5e8e38154$export$3094ace9cd82ff99; });
$parcel$export(module.exports, "STR_CREATE_PERF_MGR", function () { return $3c1058f5e8e38154$export$1cf3476332da55b3; });
$parcel$export(module.exports, "STR_DISABLED", function () { return $3c1058f5e8e38154$export$49e9417944569ae8; });
$parcel$export(module.exports, "STR_EXTENSION_CONFIG", function () { return $3c1058f5e8e38154$export$ffb2356587263734; });
$parcel$export(module.exports, "STR_EXTENSIONS", function () { return $3c1058f5e8e38154$export$a077ce616a1ab4ee; });
$parcel$export(module.exports, "STR_PROCESS_TELEMETRY", function () { return $3c1058f5e8e38154$export$820a3bce4a265606; });
$parcel$export(module.exports, "STR_PRIORITY", function () { return $3c1058f5e8e38154$export$58efcc07763b37be; });
$parcel$export(module.exports, "STR_EVENTS_SENT", function () { return $3c1058f5e8e38154$export$bb3c4bc1b1175d3d; });
$parcel$export(module.exports, "STR_EVENTS_DISCARDED", function () { return $3c1058f5e8e38154$export$bacb5b2f4c1081b9; });
$parcel$export(module.exports, "STR_EVENTS_SEND_REQUEST", function () { return $3c1058f5e8e38154$export$d75e063cb88a1c25; });
$parcel$export(module.exports, "STR_PERF_EVENT", function () { return $3c1058f5e8e38154$export$5d265841733c97c3; });
$parcel$export(module.exports, "STR_ERROR_TO_CONSOLE", function () { return $3c1058f5e8e38154$export$5b92b2b2ccf8eb40; });
$parcel$export(module.exports, "STR_WARN_TO_CONSOLE", function () { return $3c1058f5e8e38154$export$9068ba2f859ec94f; });
$parcel$export(module.exports, "STR_GET_PERF_MGR", function () { return $3c1058f5e8e38154$export$f8b08c7de64edfbf; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// ###################################################################################################################################################
var $3c1058f5e8e38154$export$5e8607ab26634759 = "";
var $3c1058f5e8e38154$export$829012af4b2055a2 = "channels";
var $3c1058f5e8e38154$export$3094ace9cd82ff99 = "core";
var $3c1058f5e8e38154$export$1cf3476332da55b3 = "createPerfMgr";
var $3c1058f5e8e38154$export$49e9417944569ae8 = "disabled";
var $3c1058f5e8e38154$export$ffb2356587263734 = "extensionConfig";
var $3c1058f5e8e38154$export$a077ce616a1ab4ee = "extensions";
var $3c1058f5e8e38154$export$820a3bce4a265606 = "processTelemetry";
var $3c1058f5e8e38154$export$58efcc07763b37be = "priority";
var $3c1058f5e8e38154$export$bb3c4bc1b1175d3d = "eventsSent";
var $3c1058f5e8e38154$export$bacb5b2f4c1081b9 = "eventsDiscarded";
var $3c1058f5e8e38154$export$d75e063cb88a1c25 = "eventsSendRequest";
var $3c1058f5e8e38154$export$5d265841733c97c3 = "perfEvent";
var $3c1058f5e8e38154$export$5b92b2b2ccf8eb40 = "errorToConsole";
var $3c1058f5e8e38154$export$9068ba2f859ec94f = "warnToConsole";
var $3c1058f5e8e38154$export$f8b08c7de64edfbf = "getPerfMgr";

});


parcelRegister("lhl6R", function(module, exports) {

$parcel$export(module.exports, "mergeEvtNamespace", function () { return $f7db8f758e8b2a94$export$3f37a50e0edde3be; });
$parcel$export(module.exports, "eventOn", function () { return $f7db8f758e8b2a94$export$324ab159353a60a9; });
$parcel$export(module.exports, "eventOff", function () { return $f7db8f758e8b2a94$export$51dedceb7c784eff; });
$parcel$export(module.exports, "attachEvent", function () { return $f7db8f758e8b2a94$export$c7861dcba2385fcd; });
$parcel$export(module.exports, "detachEvent", function () { return $f7db8f758e8b2a94$export$647f6b935c1d6b6; });
$parcel$export(module.exports, "addEventHandler", function () { return $f7db8f758e8b2a94$export$3b37be979ee3303a; });
$parcel$export(module.exports, "addPageUnloadEventListener", function () { return $f7db8f758e8b2a94$export$f16ce149aca77fdd; });
$parcel$export(module.exports, "removePageUnloadEventListener", function () { return $f7db8f758e8b2a94$export$272dc813b0b2654c; });
$parcel$export(module.exports, "addPageHideEventListener", function () { return $f7db8f758e8b2a94$export$46744aee53e5e558; });
$parcel$export(module.exports, "removePageHideEventListener", function () { return $f7db8f758e8b2a94$export$6aca6ee3a147169f; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $5GGqM = parcelRequire("5GGqM");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
// Added to help with minfication
var $f7db8f758e8b2a94$var$strOnPrefix = "on";
var $f7db8f758e8b2a94$var$strAttachEvent = "attachEvent";
var $f7db8f758e8b2a94$var$strAddEventHelper = "addEventListener";
var $f7db8f758e8b2a94$var$strDetachEvent = "detachEvent";
var $f7db8f758e8b2a94$var$strRemoveEventListener = "removeEventListener";
var $f7db8f758e8b2a94$var$strEvents = "events";
var $f7db8f758e8b2a94$var$strVisibilityChangeEvt = "visibilitychange";
var $f7db8f758e8b2a94$var$strPageHide = "pagehide";
var $f7db8f758e8b2a94$var$strPageShow = "pageshow";
var $f7db8f758e8b2a94$var$strUnload = "unload";
var $f7db8f758e8b2a94$var$strBeforeUnload = "beforeunload";
var $f7db8f758e8b2a94$var$strPageHideNamespace = (0, $5GGqM.createUniqueNamespace)("aiEvtPageHide");
var $f7db8f758e8b2a94$var$strPageShowNamespace = (0, $5GGqM.createUniqueNamespace)("aiEvtPageShow");
var $f7db8f758e8b2a94$var$rRemoveEmptyNs = /\.[\.]+/g;
var $f7db8f758e8b2a94$var$rRemoveTrailingEmptyNs = /[\.]+$/;
var $f7db8f758e8b2a94$var$_guid = 1;
var $f7db8f758e8b2a94$var$elmNodeData = (0, $5GGqM.createElmNodeData)("events");
var $f7db8f758e8b2a94$var$eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function $f7db8f758e8b2a94$var$_normalizeNamespace(name) {
    if (name && name[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ]) return name[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, (0, $59IxV.STR_EMPTY));
    return name;
}
function $f7db8f758e8b2a94$var$_getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = (0, $59IxV.STR_EMPTY);
        if ((0, $hGXAo.isArray)(evtNamespace)) {
            theNamespace_1 = (0, $59IxV.STR_EMPTY);
            (0, $hGXAo.arrForEach)(evtNamespace, function(name) {
                name = $f7db8f758e8b2a94$var$_normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") name = "." + name;
                    theNamespace_1 += name;
                }
            });
        } else theNamespace_1 = $f7db8f758e8b2a94$var$_normalizeNamespace(evtNamespace);
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
            // We may only have the namespace and not an eventName
            eventName = (eventName || (0, $59IxV.STR_EMPTY)) + theNamespace_1;
        }
    }
    var parsedEvent = $f7db8f758e8b2a94$var$eventNamespace.exec(eventName || (0, $59IxV.STR_EMPTY)) || [];
    return _a = {}, _a[0, $j5TD0._DYN_TYPE /* @min:type */ ] = parsedEvent[1], _a.ns = (parsedEvent[2] || (0, $59IxV.STR_EMPTY)).replace($f7db8f758e8b2a94$var$rRemoveEmptyNs, ".").replace($f7db8f758e8b2a94$var$rRemoveTrailingEmptyNs, (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_SPLIT /* @min:%2esplit */ ](".").sort().join("."), _a;
}
function $f7db8f758e8b2a94$export$e2bcc16f65e2a5d2(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = $f7db8f758e8b2a94$var$elmNodeData.get(target, $f7db8f758e8b2a94$var$strEvents, {}, false);
    var evtName = $f7db8f758e8b2a94$var$_getEvtNamespace(eventName, evtNamespace);
    (0, $hGXAo.objForEachKey)(eventCache, function(evtType, registeredEvents) {
        (0, $hGXAo.arrForEach)(registeredEvents, function(value) {
            var _a;
            if (!evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ] || evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ] === value.evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ]) {
                if (!evtName.ns || evtName.ns === evtName.ns) theEvents[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ]((_a = {}, _a[0, $j5TD0._DYN_NAME /* @min:name */ ] = value.evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ] + (value.evtName.ns ? "." + value.evtName.ns : (0, $59IxV.STR_EMPTY)), _a.handler = value[0, $j5TD0._DYN_HANDLER /* @min:%2ehandler */ ], _a));
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
function $f7db8f758e8b2a94$var$_getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) addDefault = true;
    var aiEvts = $f7db8f758e8b2a94$var$elmNodeData.get(target, $f7db8f758e8b2a94$var$strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
    return registeredEvents;
}
function $f7db8f758e8b2a94$var$_doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ]) {
        if (obj[$f7db8f758e8b2a94$var$strRemoveEventListener]) obj[$f7db8f758e8b2a94$var$strRemoveEventListener](evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ], handlerRef, useCapture);
        else if (obj[$f7db8f758e8b2a94$var$strDetachEvent]) obj[$f7db8f758e8b2a94$var$strDetachEvent]($f7db8f758e8b2a94$var$strOnPrefix + evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ], handlerRef);
    }
}
function $f7db8f758e8b2a94$var$_doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ] && handlerRef) {
        if (obj[$f7db8f758e8b2a94$var$strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[$f7db8f758e8b2a94$var$strAddEventHelper](evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ], handlerRef, useCapture);
            result = true;
        } else if (obj[$f7db8f758e8b2a94$var$strAttachEvent]) {
            // IE before version 9
            obj[$f7db8f758e8b2a94$var$strAttachEvent]($f7db8f758e8b2a94$var$strOnPrefix + evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ], handlerRef);
            result = true;
        }
    }
    return result;
}
function $f7db8f758e8b2a94$var$_doUnregister(target, events, evtName, unRegFn) {
    var idx = events[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
    while(idx--){
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    $f7db8f758e8b2a94$var$_doDetach(target, theEvent.evtName, theEvent[0, $j5TD0._DYN_HANDLER /* @min:%2ehandler */ ], theEvent.capture);
                    // Remove the registered event
                    events[0, $j5TD0._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                }
            }
        }
    }
}
function $f7db8f758e8b2a94$var$_unregisterEvents(target, evtName, unRegFn) {
    if (evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ]) $f7db8f758e8b2a94$var$_doUnregister(target, $f7db8f758e8b2a94$var$_getRegisteredEvents(target, evtName[0, $j5TD0._DYN_TYPE /* @min:%2etype */ ]), evtName, unRegFn);
    else {
        var eventCache = $f7db8f758e8b2a94$var$elmNodeData.get(target, $f7db8f758e8b2a94$var$strEvents, {});
        (0, $hGXAo.objForEachKey)(eventCache, function(evtType, events) {
            $f7db8f758e8b2a94$var$_doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if ((0, $hGXAo.objKeys)(eventCache)[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] === 0) $f7db8f758e8b2a94$var$elmNodeData.kill(target, $f7db8f758e8b2a94$var$strEvents);
    }
}
function $f7db8f758e8b2a94$export$3f37a50e0edde3be(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if ((0, $hGXAo.isArray)(namespaces)) newNamespaces = [
            theNamespace
        ].concat(namespaces);
        else newNamespaces = [
            theNamespace,
            namespaces
        ];
        // resort the namespaces so they are always in order
        newNamespaces = $f7db8f758e8b2a94$var$_getEvtNamespace("xx", newNamespaces).ns[0, $j5TD0._DYN_SPLIT /* @min:%2esplit */ ](".");
    } else newNamespaces = theNamespace;
    return newNamespaces;
}
function $f7db8f758e8b2a94$export$324ab159353a60a9(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) useCapture = false;
    var result = false;
    if (target) try {
        var evtName = $f7db8f758e8b2a94$var$_getEvtNamespace(eventName, evtNamespace);
        result = $f7db8f758e8b2a94$var$_doAttach(target, evtName, handlerRef, useCapture);
        if (result && $f7db8f758e8b2a94$var$elmNodeData.accept(target)) {
            var registeredEvent = (_a = {
                guid: $f7db8f758e8b2a94$var$_guid++,
                evtName: evtName
            }, _a[0, $j5TD0._DYN_HANDLER /* @min:handler */ ] = handlerRef, _a.capture = useCapture, _a);
            $f7db8f758e8b2a94$var$_getRegisteredEvents(target, evtName.type)[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](registeredEvent);
        }
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
    return result;
}
function $f7db8f758e8b2a94$export$51dedceb7c784eff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) useCapture = false;
    if (target) try {
        var evtName_1 = $f7db8f758e8b2a94$var$_getEvtNamespace(eventName, evtNamespace);
        var found_1 = false;
        $f7db8f758e8b2a94$var$_unregisterEvents(target, evtName_1, function(regEvent) {
            if (evtName_1.ns && !handlerRef || regEvent[0, $j5TD0._DYN_HANDLER /* @min:%2ehandler */ ] === handlerRef) {
                found_1 = true;
                return true;
            }
            return false;
        });
        if (!found_1) // fallback to try and remove as requested
        $f7db8f758e8b2a94$var$_doDetach(target, evtName_1, handlerRef, useCapture);
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
}
function $f7db8f758e8b2a94$export$c7861dcba2385fcd(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    return $f7db8f758e8b2a94$export$324ab159353a60a9(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $f7db8f758e8b2a94$export$647f6b935c1d6b6(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    $f7db8f758e8b2a94$export$51dedceb7c784eff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $f7db8f758e8b2a94$export$3b37be979ee3303a(eventName, callback, evtNamespace) {
    var result = false;
    var w = (0, $bU24K.getWindow)();
    if (w) {
        result = $f7db8f758e8b2a94$export$324ab159353a60a9(w, eventName, callback, evtNamespace);
        result = $f7db8f758e8b2a94$export$324ab159353a60a9(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = (0, $bU24K.getDocument)();
    if (doc) result = $f7db8f758e8b2a94$export$324ab159353a60a9(doc, eventName, callback, evtNamespace) || result;
    return result;
}
function $f7db8f758e8b2a94$export$546f5991fce5bf06(eventName, callback, evtNamespace) {
    var w = (0, $bU24K.getWindow)();
    if (w) {
        $f7db8f758e8b2a94$export$51dedceb7c784eff(w, eventName, callback, evtNamespace);
        $f7db8f758e8b2a94$export$51dedceb7c784eff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = (0, $bU24K.getDocument)();
    if (doc) $f7db8f758e8b2a94$export$51dedceb7c784eff(doc, eventName, callback, evtNamespace);
}
/**
 * Bind the listener to the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */ function $f7db8f758e8b2a94$var$_addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $hGXAo.arrForEach)(events, function(name) {
        if (name) {
            if (!excludeEvents || (0, $hGXAo.arrIndexOf)(excludeEvents, name) === -1) added = $f7db8f758e8b2a94$export$3b37be979ee3303a(name, listener, evtNamespace) || added;
        }
    });
    return added;
}
function $f7db8f758e8b2a94$export$40a4ed63e5cb7043(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && (0, $hGXAo.isArray)(events)) {
        added = $f7db8f758e8b2a94$var$_addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
        added = $f7db8f758e8b2a94$var$_addEventListeners(events, listener, null, evtNamespace);
    }
    return added;
}
function $f7db8f758e8b2a94$export$8c7b13b21690651d(events, listener, evtNamespace) {
    if (events && (0, $hGXAo.isArray)(events)) (0, $hGXAo.arrForEach)(events, function(name) {
        if (name) $f7db8f758e8b2a94$export$546f5991fce5bf06(name, listener, evtNamespace);
    });
}
function $f7db8f758e8b2a94$export$f16ce149aca77fdd(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return $f7db8f758e8b2a94$export$40a4ed63e5cb7043([
        $f7db8f758e8b2a94$var$strBeforeUnload,
        $f7db8f758e8b2a94$var$strUnload,
        $f7db8f758e8b2a94$var$strPageHide
    ], listener, excludeEvents, evtNamespace);
}
function $f7db8f758e8b2a94$export$272dc813b0b2654c(listener, evtNamespace) {
    $f7db8f758e8b2a94$export$8c7b13b21690651d([
        $f7db8f758e8b2a94$var$strBeforeUnload,
        $f7db8f758e8b2a94$var$strUnload,
        $f7db8f758e8b2a94$var$strPageHide
    ], listener, evtNamespace);
}
function $f7db8f758e8b2a94$export$46744aee53e5e558(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $bU24K.getDocument)();
        if (listener && doc && doc.visibilityState === "hidden") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = $f7db8f758e8b2a94$export$3f37a50e0edde3be($f7db8f758e8b2a94$var$strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = $f7db8f758e8b2a94$var$_addEventListeners([
        $f7db8f758e8b2a94$var$strPageHide
    ], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || (0, $hGXAo.arrIndexOf)(excludeEvents, $f7db8f758e8b2a94$var$strVisibilityChangeEvt) === -1) pageUnloadAdded = $f7db8f758e8b2a94$var$_addEventListeners([
        $f7db8f758e8b2a94$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    if (!pageUnloadAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageUnloadAdded = $f7db8f758e8b2a94$export$46744aee53e5e558(listener, null, evtNamespace);
    return pageUnloadAdded;
}
function $f7db8f758e8b2a94$export$6aca6ee3a147169f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = $f7db8f758e8b2a94$export$3f37a50e0edde3be($f7db8f758e8b2a94$var$strPageHideNamespace, evtNamespace);
    $f7db8f758e8b2a94$export$8c7b13b21690651d([
        $f7db8f758e8b2a94$var$strPageHide
    ], listener, newNamespaces);
    $f7db8f758e8b2a94$export$8c7b13b21690651d([
        $f7db8f758e8b2a94$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}
function $f7db8f758e8b2a94$export$cce4a6563c734c0(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $bU24K.getDocument)();
        if (listener && doc && doc.visibilityState === "visible") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = $f7db8f758e8b2a94$export$3f37a50e0edde3be($f7db8f758e8b2a94$var$strPageShowNamespace, evtNamespace);
    var pageShowAdded = $f7db8f758e8b2a94$var$_addEventListeners([
        $f7db8f758e8b2a94$var$strPageShow
    ], listener, excludeEvents, newNamespaces);
    pageShowAdded = $f7db8f758e8b2a94$var$_addEventListeners([
        $f7db8f758e8b2a94$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageShowAdded = $f7db8f758e8b2a94$export$cce4a6563c734c0(listener, null, evtNamespace);
    return pageShowAdded;
}
function $f7db8f758e8b2a94$export$c49093a8bd06690f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = $f7db8f758e8b2a94$export$3f37a50e0edde3be($f7db8f758e8b2a94$var$strPageShowNamespace, evtNamespace);
    $f7db8f758e8b2a94$export$8c7b13b21690651d([
        $f7db8f758e8b2a94$var$strPageShow
    ], listener, newNamespaces);
    $f7db8f758e8b2a94$export$8c7b13b21690651d([
        $f7db8f758e8b2a94$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}

});
parcelRegister("5GGqM", function(module, exports) {

$parcel$export(module.exports, "createUniqueNamespace", function () { return $4241c9e91bc14bbe$export$eb4a6badb18ead04; });
$parcel$export(module.exports, "createElmNodeData", function () { return $4241c9e91bc14bbe$export$b95c3438408d78aa; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $82FQ4 = parcelRequire("82FQ4");

var $j5TD0 = parcelRequire("j5TD0");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $1iY3X = parcelRequire("1iY3X");
var $4241c9e91bc14bbe$var$_objDefineProperty = (0, $82FQ4.ObjDefineProperty);
var $4241c9e91bc14bbe$var$version = "2.8.18";
var $4241c9e91bc14bbe$var$instanceName = "." + (0, $1iY3X.newId)(6);
var $4241c9e91bc14bbe$var$_dataUid = 0;
function $4241c9e91bc14bbe$var$_createAccessor(target, prop, value) {
    if ($4241c9e91bc14bbe$var$_objDefineProperty) try {
        $4241c9e91bc14bbe$var$_objDefineProperty(target, prop, {
            value: value,
            enumerable: false,
            configurable: true
        });
        return true;
    } catch (e) {
    // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
    // We will just ignore this here.
    }
    return false;
}
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function $4241c9e91bc14bbe$var$_canAcceptData(target) {
    return target[0, $j5TD0._DYN_NODE_TYPE /* @min:%2enodeType */ ] === 1 || target[0, $j5TD0._DYN_NODE_TYPE /* @min:%2enodeType */ ] === 9 || !+target[0, $j5TD0._DYN_NODE_TYPE /* @min:%2enodeType */ ];
}
function $4241c9e91bc14bbe$var$_getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if ($4241c9e91bc14bbe$var$_canAcceptData(target)) {
                if (!$4241c9e91bc14bbe$var$_createAccessor(target, data.id, theCache)) // Environment doesn't support accessor, so just use direct assignment
                target[data.id] = theCache;
            }
        } catch (e) {
        // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function $4241c9e91bc14bbe$export$eb4a6badb18ead04(name, includeVersion) {
    if (includeVersion === void 0) includeVersion = false;
    return (0, $hGXAo.normalizeJsName)(name + $4241c9e91bc14bbe$var$_dataUid++ + (includeVersion ? "." + $4241c9e91bc14bbe$var$version : (0, $59IxV.STR_EMPTY)) + $4241c9e91bc14bbe$var$instanceName);
}
function $4241c9e91bc14bbe$export$b95c3438408d78aa(name) {
    var data = {
        id: $4241c9e91bc14bbe$export$eb4a6badb18ead04("_aiData-" + (name || (0, $59IxV.STR_EMPTY)) + "." + $4241c9e91bc14bbe$var$version),
        accept: function(target) {
            return $4241c9e91bc14bbe$var$_canAcceptData(target);
        },
        get: function(target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = $4241c9e91bc14bbe$var$_getCache(data, target);
                    theCache[(0, $hGXAo.normalizeJsName)(name)] = defValue;
                }
                return defValue;
            }
            return theCache[(0, $hGXAo.normalizeJsName)(name)];
        },
        kill: function(target, name) {
            if (target && target[name]) try {
                delete target[name];
            } catch (e) {
            // Just cleaning up, so if this fails -- ignore
            }
        }
    };
    return data;
}

});
parcelRegister("1iY3X", function(module, exports) {

$parcel$export(module.exports, "randomValue", function () { return $0f3610207ff40f43$export$b2cfcb5c32671fa4; });
$parcel$export(module.exports, "random32", function () { return $0f3610207ff40f43$export$aec042b223b6f5f9; });
$parcel$export(module.exports, "mwcRandom32", function () { return $0f3610207ff40f43$export$3ffb74f7babdd68f; });
$parcel$export(module.exports, "mwcRandomSeed", function () { return $0f3610207ff40f43$export$195aff7adbfe974f; });
$parcel$export(module.exports, "newId", function () { return $0f3610207ff40f43$export$9ffd10a3fbdc175b; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
var $0f3610207ff40f43$var$UInt32Mask = 0x100000000;
var $0f3610207ff40f43$var$MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var $0f3610207ff40f43$var$_mwcSeeded = false;
var $0f3610207ff40f43$var$_mwcW = 123456789;
var $0f3610207ff40f43$var$_mwcZ = 987654321;
// Takes any integer
function $0f3610207ff40f43$var$_mwcSeed(seedValue) {
    if (seedValue < 0) // Make sure we end up with a positive number and not -ve one.
    seedValue >>>= 0;
    $0f3610207ff40f43$var$_mwcW = 123456789 + seedValue & $0f3610207ff40f43$var$MaxUInt32;
    $0f3610207ff40f43$var$_mwcZ = 987654321 - seedValue & $0f3610207ff40f43$var$MaxUInt32;
    $0f3610207ff40f43$var$_mwcSeeded = true;
}
function $0f3610207ff40f43$var$_autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = (0, $hGXAo.dateNow)() & 0x7fffffff;
        $0f3610207ff40f43$var$_mwcSeed((Math.random() * $0f3610207ff40f43$var$UInt32Mask ^ now) + now);
    } catch (e) {
    // Don't crash if something goes wrong
    }
}
function $0f3610207ff40f43$export$b2cfcb5c32671fa4(maxValue) {
    if (maxValue > 0) return Math.floor($0f3610207ff40f43$export$aec042b223b6f5f9() / $0f3610207ff40f43$var$MaxUInt32 * (maxValue + 1)) >>> 0;
    return 0;
}
function $0f3610207ff40f43$export$aec042b223b6f5f9(signed) {
    var value = 0;
    var c = (0, $bU24K.getCrypto)() || (0, $bU24K.getMsCrypto)();
    if (c && c.getRandomValues) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = c.getRandomValues(new Uint32Array(1))[0] & $0f3610207ff40f43$var$MaxUInt32;
    if (value === 0 && (0, $bU24K.isIE)()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!$0f3610207ff40f43$var$_mwcSeeded) // Set the seed for the Mwc algorithm
        $0f3610207ff40f43$var$_autoSeedMwc();
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = $0f3610207ff40f43$export$3ffb74f7babdd68f() & $0f3610207ff40f43$var$MaxUInt32;
    }
    if (value === 0) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = Math.floor($0f3610207ff40f43$var$UInt32Mask * Math.random() | 0);
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $0f3610207ff40f43$export$195aff7adbfe974f(value) {
    if (!value) $0f3610207ff40f43$var$_autoSeedMwc();
    else $0f3610207ff40f43$var$_mwcSeed(value);
}
function $0f3610207ff40f43$export$3ffb74f7babdd68f(signed) {
    $0f3610207ff40f43$var$_mwcZ = 36969 * ($0f3610207ff40f43$var$_mwcZ & 0xFFFF) + ($0f3610207ff40f43$var$_mwcZ >> 16) & $0f3610207ff40f43$var$MaxUInt32;
    $0f3610207ff40f43$var$_mwcW = 18000 * ($0f3610207ff40f43$var$_mwcW & 0xFFFF) + ($0f3610207ff40f43$var$_mwcW >> 16) & $0f3610207ff40f43$var$MaxUInt32;
    var value = ($0f3610207ff40f43$var$_mwcZ << 16) + ($0f3610207ff40f43$var$_mwcW & 0xFFFF) >>> 0 & $0f3610207ff40f43$var$MaxUInt32 | 0;
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $0f3610207ff40f43$export$9ffd10a3fbdc175b(maxLength) {
    if (maxLength === void 0) maxLength = 22;
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = $0f3610207ff40f43$export$aec042b223b6f5f9() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = (0, $59IxV.STR_EMPTY);
    while(result[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] < maxLength){
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = ($0f3610207ff40f43$export$aec042b223b6f5f9() << 2 & 0xFFFFFFFF | number & 0x03) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}

});
parcelRegister("bU24K", function(module, exports) {

$parcel$export(module.exports, "getGlobalInst", function () { return $8aa688d4747ad7ed$export$516e580f5eed5df7; });
$parcel$export(module.exports, "hasWindow", function () { return $8aa688d4747ad7ed$export$fef62134eea24008; });
$parcel$export(module.exports, "getWindow", function () { return $8aa688d4747ad7ed$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "hasDocument", function () { return $8aa688d4747ad7ed$export$c4372eca9c56fe99; });
$parcel$export(module.exports, "getDocument", function () { return $8aa688d4747ad7ed$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getNavigator", function () { return $8aa688d4747ad7ed$export$a56241c767c1d89f; });
$parcel$export(module.exports, "hasHistory", function () { return $8aa688d4747ad7ed$export$b79afd6d47f11781; });
$parcel$export(module.exports, "getHistory", function () { return $8aa688d4747ad7ed$export$f9582a3c130d9538; });
$parcel$export(module.exports, "getLocation", function () { return $8aa688d4747ad7ed$export$e7fd20fad3cf4b5f; });
$parcel$export(module.exports, "getConsole", function () { return $8aa688d4747ad7ed$export$bbe488cec1edd401; });
$parcel$export(module.exports, "getPerformance", function () { return $8aa688d4747ad7ed$export$28a0276e10aa78d7; });
$parcel$export(module.exports, "hasJSON", function () { return $8aa688d4747ad7ed$export$a2856ab6913b9fff; });
$parcel$export(module.exports, "getJSON", function () { return $8aa688d4747ad7ed$export$d047a7c56db64af4; });
$parcel$export(module.exports, "getCrypto", function () { return $8aa688d4747ad7ed$export$e003cc239f955cb6; });
$parcel$export(module.exports, "getMsCrypto", function () { return $8aa688d4747ad7ed$export$6bc5093edbd2ea6; });
$parcel$export(module.exports, "isReactNative", function () { return $8aa688d4747ad7ed$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $8aa688d4747ad7ed$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "getIEVersion", function () { return $8aa688d4747ad7ed$export$eb7ff627fa81c42e; });
$parcel$export(module.exports, "dumpObj", function () { return $8aa688d4747ad7ed$export$21fce7cbd4dc679f; });
$parcel$export(module.exports, "isBeaconsSupported", function () { return $8aa688d4747ad7ed$export$cf496c79c05967a0; });
$parcel$export(module.exports, "isFetchSupported", function () { return $8aa688d4747ad7ed$export$f8c1c61350d9749; });
$parcel$export(module.exports, "useXDomainRequest", function () { return $8aa688d4747ad7ed$export$b9f2bc09e5ac0fa5; });
$parcel$export(module.exports, "isXhrSupported", function () { return $8aa688d4747ad7ed$export$cfeac9aa070f0108; });
$parcel$export(module.exports, "findMetaTag", function () { return $8aa688d4747ad7ed$export$cdb9869d6805c74f; });
$parcel$export(module.exports, "findNamedServerTiming", function () { return $8aa688d4747ad7ed$export$a25efeeb107534e6; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $91dsF = parcelRequire("91dsF");
var $82FQ4 = parcelRequire("82FQ4");

var $j5TD0 = parcelRequire("j5TD0");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
"use strict";
/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */ var $8aa688d4747ad7ed$var$strWindow = "window";
var $8aa688d4747ad7ed$var$strDocument = "document";
var $8aa688d4747ad7ed$var$strDocumentMode = "documentMode";
var $8aa688d4747ad7ed$var$strNavigator = "navigator";
var $8aa688d4747ad7ed$var$strHistory = "history";
var $8aa688d4747ad7ed$var$strLocation = "location";
var $8aa688d4747ad7ed$var$strConsole = "console";
var $8aa688d4747ad7ed$var$strPerformance = "performance";
var $8aa688d4747ad7ed$var$strJSON = "JSON";
var $8aa688d4747ad7ed$var$strCrypto = "crypto";
var $8aa688d4747ad7ed$var$strMsCrypto = "msCrypto";
var $8aa688d4747ad7ed$var$strReactNative = "ReactNative";
var $8aa688d4747ad7ed$var$strMsie = "msie";
var $8aa688d4747ad7ed$var$strTrident = "trident/";
var $8aa688d4747ad7ed$var$strXMLHttpRequest = "XMLHttpRequest";
var $8aa688d4747ad7ed$var$_isTrident = null;
var $8aa688d4747ad7ed$var$_navUserAgentCheck = null;
var $8aa688d4747ad7ed$var$_enableMocks = false;
var $8aa688d4747ad7ed$var$_useXDomainRequest = null;
var $8aa688d4747ad7ed$var$_beaconsSupported = null;
function $8aa688d4747ad7ed$var$_hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[0, $82FQ4.strShimPrototype];
                if (proto) supported = property in proto;
            }
        } catch (e) {
        // Do Nothing
        }
        if (!supported) try {
            var tmp = new theClass();
            supported = !(0, $hGXAo.isUndefined)(tmp[property]);
        } catch (e) {
        // Do Nothing
        }
    }
    return supported;
}
function $8aa688d4747ad7ed$export$6b8934f3c937d22f(enabled) {
    $8aa688d4747ad7ed$var$_enableMocks = enabled;
}
function $8aa688d4747ad7ed$export$516e580f5eed5df7(name) {
    var gbl = (0, $91dsF.getGlobal)();
    if (gbl && gbl[name]) return gbl[name];
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === $8aa688d4747ad7ed$var$strWindow && $8aa688d4747ad7ed$export$fef62134eea24008()) // tslint:disable-next-line: no-angle-bracket-type-assertion
    return window;
    return null;
}
function $8aa688d4747ad7ed$export$fef62134eea24008() {
    return Boolean(typeof window === (0, $82FQ4.strShimObject) && window);
}
function $8aa688d4747ad7ed$export$38b2d434cce3ea22() {
    if ($8aa688d4747ad7ed$export$fef62134eea24008()) return window;
    // Return the global instance or null
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strWindow);
}
function $8aa688d4747ad7ed$export$c4372eca9c56fe99() {
    return Boolean(typeof document === (0, $82FQ4.strShimObject) && document);
}
function $8aa688d4747ad7ed$export$f65ca476c09acec0() {
    if ($8aa688d4747ad7ed$export$c4372eca9c56fe99()) return document;
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strDocument);
}
function $8aa688d4747ad7ed$export$bd82d106260417bf() {
    return Boolean(typeof navigator === (0, $82FQ4.strShimObject) && navigator);
}
function $8aa688d4747ad7ed$export$a56241c767c1d89f() {
    if ($8aa688d4747ad7ed$export$bd82d106260417bf()) return navigator;
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strNavigator);
}
function $8aa688d4747ad7ed$export$b79afd6d47f11781() {
    return Boolean(typeof history === (0, $82FQ4.strShimObject) && history);
}
function $8aa688d4747ad7ed$export$f9582a3c130d9538() {
    if ($8aa688d4747ad7ed$export$b79afd6d47f11781()) return history;
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strHistory);
}
function $8aa688d4747ad7ed$export$e7fd20fad3cf4b5f(checkForMock) {
    if (checkForMock && $8aa688d4747ad7ed$var$_enableMocks) {
        var mockLocation = $8aa688d4747ad7ed$export$516e580f5eed5df7("__mockLocation");
        if (mockLocation) return mockLocation;
    }
    if (typeof location === (0, $82FQ4.strShimObject) && location) return location;
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strLocation);
}
function $8aa688d4747ad7ed$export$bbe488cec1edd401() {
    if (typeof console !== (0, $82FQ4.strShimUndefined)) return console;
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strConsole);
}
function $8aa688d4747ad7ed$export$28a0276e10aa78d7() {
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strPerformance);
}
function $8aa688d4747ad7ed$export$a2856ab6913b9fff() {
    return Boolean(typeof JSON === (0, $82FQ4.strShimObject) && JSON || $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strJSON) !== null);
}
function $8aa688d4747ad7ed$export$d047a7c56db64af4() {
    if ($8aa688d4747ad7ed$export$a2856ab6913b9fff()) return JSON || $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strJSON);
    return null;
}
function $8aa688d4747ad7ed$export$e003cc239f955cb6() {
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strCrypto);
}
function $8aa688d4747ad7ed$export$6bc5093edbd2ea6() {
    return $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strMsCrypto);
}
function $8aa688d4747ad7ed$export$f7a1e23e542d38e3() {
    // If running in React Native, navigator.product will be populated
    var nav = $8aa688d4747ad7ed$export$a56241c767c1d89f();
    if (nav && nav.product) return nav.product === $8aa688d4747ad7ed$var$strReactNative;
    return false;
}
function $8aa688d4747ad7ed$export$7e7b1a9668aaed8() {
    var nav = $8aa688d4747ad7ed$export$a56241c767c1d89f();
    if (nav && (nav[0, $j5TD0._DYN_USER_AGENT /* @min:%2euserAgent */ ] !== $8aa688d4747ad7ed$var$_navUserAgentCheck || $8aa688d4747ad7ed$var$_isTrident === null)) {
        // Added to support test mocking of the user agent
        $8aa688d4747ad7ed$var$_navUserAgentCheck = nav[0, $j5TD0._DYN_USER_AGENT /* @min:%2euserAgent */ ];
        var userAgent = ($8aa688d4747ad7ed$var$_navUserAgentCheck || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
        $8aa688d4747ad7ed$var$_isTrident = (0, $hGXAo.strContains)(userAgent, $8aa688d4747ad7ed$var$strMsie) || (0, $hGXAo.strContains)(userAgent, $8aa688d4747ad7ed$var$strTrident);
    }
    return $8aa688d4747ad7ed$var$_isTrident;
}
function $8aa688d4747ad7ed$export$eb7ff627fa81c42e(userAgentStr) {
    if (userAgentStr === void 0) userAgentStr = null;
    if (!userAgentStr) {
        var navigator_1 = $8aa688d4747ad7ed$export$a56241c767c1d89f() || {};
        userAgentStr = navigator_1 ? (navigator_1[0, $j5TD0._DYN_USER_AGENT /* @min:%2euserAgent */ ] || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() : (0, $59IxV.STR_EMPTY);
    }
    var ua = (userAgentStr || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if ((0, $hGXAo.strContains)(ua, $8aa688d4747ad7ed$var$strMsie)) {
        var doc = $8aa688d4747ad7ed$export$f65ca476c09acec0() || {};
        return Math.max(parseInt(ua[0, $j5TD0._DYN_SPLIT /* @min:%2esplit */ ]($8aa688d4747ad7ed$var$strMsie)[1]), doc[$8aa688d4747ad7ed$var$strDocumentMode] || 0);
    } else if ((0, $hGXAo.strContains)(ua, $8aa688d4747ad7ed$var$strTrident)) {
        var tridentVer = parseInt(ua[0, $j5TD0._DYN_SPLIT /* @min:%2esplit */ ]($8aa688d4747ad7ed$var$strTrident)[1]);
        if (tridentVer) return tridentVer + 4;
    }
    return null;
}
function $8aa688d4747ad7ed$export$21fce7cbd4dc679f(object) {
    var objectTypeDump = Object[0, $82FQ4.strShimPrototype].toString[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](object);
    var propertyValueDump = (0, $59IxV.STR_EMPTY);
    if (objectTypeDump === "[object Error]") propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object[0, $j5TD0._DYN_NAME /* @min:%2ename */ ] + "'";
    else if ($8aa688d4747ad7ed$export$a2856ab6913b9fff()) propertyValueDump = $8aa688d4747ad7ed$export$d047a7c56db64af4().stringify(object);
    return objectTypeDump + propertyValueDump;
}
function $8aa688d4747ad7ed$export$95df08bae54cb4df(userAgentStr) {
    if (!userAgentStr || !(0, $hGXAo.isString)(userAgentStr)) {
        var navigator_2 = $8aa688d4747ad7ed$export$a56241c767c1d89f() || {};
        userAgentStr = navigator_2 ? (navigator_2[0, $j5TD0._DYN_USER_AGENT /* @min:%2euserAgent */ ] || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() : (0, $59IxV.STR_EMPTY);
    }
    var ua = (userAgentStr || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
    return ua[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ]("safari") >= 0;
}
function $8aa688d4747ad7ed$export$cf496c79c05967a0() {
    if ($8aa688d4747ad7ed$var$_beaconsSupported === null) $8aa688d4747ad7ed$var$_beaconsSupported = $8aa688d4747ad7ed$export$bd82d106260417bf() && Boolean($8aa688d4747ad7ed$export$a56241c767c1d89f().sendBeacon);
    return $8aa688d4747ad7ed$var$_beaconsSupported;
}
function $8aa688d4747ad7ed$export$f8c1c61350d9749(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!$8aa688d4747ad7ed$export$516e580f5eed5df7("fetch");
        var request = $8aa688d4747ad7ed$export$516e580f5eed5df7("Request");
        if (isSupported && withKeepAlive && request) isSupported = $8aa688d4747ad7ed$var$_hasProperty(request, "keepalive");
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $8aa688d4747ad7ed$export$b9f2bc09e5ac0fa5() {
    if ($8aa688d4747ad7ed$var$_useXDomainRequest === null) {
        $8aa688d4747ad7ed$var$_useXDomainRequest = typeof XDomainRequest !== (0, $82FQ4.strShimUndefined);
        if ($8aa688d4747ad7ed$var$_useXDomainRequest && $8aa688d4747ad7ed$export$cfeac9aa070f0108()) $8aa688d4747ad7ed$var$_useXDomainRequest = $8aa688d4747ad7ed$var$_useXDomainRequest && !$8aa688d4747ad7ed$var$_hasProperty($8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strXMLHttpRequest), "withCredentials");
    }
    return $8aa688d4747ad7ed$var$_useXDomainRequest;
}
function $8aa688d4747ad7ed$export$cfeac9aa070f0108() {
    var isSupported = false;
    try {
        var xmlHttpRequest = $8aa688d4747ad7ed$export$516e580f5eed5df7($8aa688d4747ad7ed$var$strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $8aa688d4747ad7ed$var$_getNamedValue(values, name) {
    if (values) for(var i = 0; i < values[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ]; i++){
        var value = values[i];
        if (value[0, $j5TD0._DYN_NAME /* @min:%2ename */ ]) {
            if (value[0, $j5TD0._DYN_NAME /* @min:%2ename */ ] === name) return value;
        }
    }
    return {};
}
function $8aa688d4747ad7ed$export$cdb9869d6805c74f(name) {
    var doc = $8aa688d4747ad7ed$export$f65ca476c09acec0();
    if (doc && name) // Look for a meta-tag
    return $8aa688d4747ad7ed$var$_getNamedValue(doc.querySelectorAll("meta"), name).content;
    return null;
}
function $8aa688d4747ad7ed$export$a25efeeb107534e6(name) {
    var value;
    var perf = $8aa688d4747ad7ed$export$28a0276e10aa78d7();
    if (perf) {
        // Try looking for a server-timing header
        var navPerf = perf.getEntriesByType("navigation") || [];
        value = $8aa688d4747ad7ed$var$_getNamedValue((navPerf[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0 ? navPerf[0] : {}).serverTiming, name).description;
    }
    return value;
}
function $8aa688d4747ad7ed$export$716a11175c03fb4e(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function $8aa688d4747ad7ed$export$8e16c003644f99f2(eventName, details) {
    var event = null;
    var detail = {
        detail: details || null
    };
    if ((0, $hGXAo.isFunction)(CustomEvent)) event = new CustomEvent(eventName, detail);
    else {
        var doc = $8aa688d4747ad7ed$export$f65ca476c09acec0();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function $8aa688d4747ad7ed$export$af531f0ca2964c96(evtName, cfg, customDetails) {
    var global = (0, $91dsF.getGlobal)();
    if (global && global.CustomEvent) try {
        var details = {
            cfg: cfg || null,
            customDetails: customDetails || null
        };
        return $8aa688d4747ad7ed$export$716a11175c03fb4e(global, $8aa688d4747ad7ed$export$8e16c003644f99f2(evtName, details));
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return false;
}

});




parcelRegister("k0iSW", function(module, exports) {

$parcel$export(module.exports, "generateW3CId", function () { return $e90274f10f9bf40d$export$58d1fad45f39d957; });
$parcel$export(module.exports, "disableCookies", function () { return $e90274f10f9bf40d$export$62933da51d94d272; });
$parcel$export(module.exports, "canUseCookies", function () { return $e90274f10f9bf40d$export$304a5ec8c5d7d95; });
$parcel$export(module.exports, "getCookie", function () { return $e90274f10f9bf40d$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "setCookie", function () { return $e90274f10f9bf40d$export$110700823644f4a6; });
$parcel$export(module.exports, "deleteCookie", function () { return $e90274f10f9bf40d$export$b43e45590305ffaa; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $91dsF = parcelRequire("91dsF");
var $82FQ4 = parcelRequire("82FQ4");

var $j5TD0 = parcelRequire("j5TD0");

var $hB9U1 = parcelRequire("hB9U1");

var $bU24K = parcelRequire("bU24K");

var $lhl6R = parcelRequire("lhl6R");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $1iY3X = parcelRequire("1iY3X");
"use strict";
var $e90274f10f9bf40d$var$_cookieMgrs = null;
var $e90274f10f9bf40d$var$_canUseCookies; // legacy supported config
var $e90274f10f9bf40d$export$3bac393b8225adab = (0, $82FQ4.strShimUndefined);
function $e90274f10f9bf40d$export$665eeb3ced5fba0b() {
    var uuid = $e90274f10f9bf40d$export$58d1fad45f39d957();
    return uuid[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 8) + "-" + uuid[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](8, 12) + "-" + uuid[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](12, 16) + "-" + uuid[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](16, 20) + "-" + uuid[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](20);
}
function $e90274f10f9bf40d$export$ba2b1ec760f018ed() {
    var perf = (0, $bU24K.getPerformance)();
    if (perf && perf.now) return perf.now();
    return (0, $hGXAo.dateNow)();
}
function $e90274f10f9bf40d$export$5222b9460f3ddbec(value, search) {
    if (value && search) {
        var len = value[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
        var start = len - search[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
        return value[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](start >= 0 ? start : 0, len) === search;
    }
    return false;
}
function $e90274f10f9bf40d$export$58d1fad45f39d957() {
    var hexValues = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
    ];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = (0, $59IxV.STR_EMPTY), tmp;
    for(var a = 0; a < 4; a++){
        tmp = (0, $1iY3X.random32)();
        oct += hexValues[tmp & 0xF] + hexValues[tmp >> 4 & 0xF] + hexValues[tmp >> 8 & 0xF] + hexValues[tmp >> 12 & 0xF] + hexValues[tmp >> 16 & 0xF] + hexValues[tmp >> 20 & 0xF] + hexValues[tmp >> 24 & 0xF] + hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + ((0, $1iY3X.random32)() & 0x03) | 0];
    return oct[0, $j5TD0._DYN_SUBSTR /* @min:%2esubstr */ ](0, 8) + oct[0, $j5TD0._DYN_SUBSTR /* @min:%2esubstr */ ](9, 4) + "4" + oct[0, $j5TD0._DYN_SUBSTR /* @min:%2esubstr */ ](13, 3) + clockSequenceHi + oct[0, $j5TD0._DYN_SUBSTR /* @min:%2esubstr */ ](16, 3) + oct[0, $j5TD0._DYN_SUBSTR /* @min:%2esubstr */ ](19, 12);
}
var $e90274f10f9bf40d$export$8e4719d8761024a1 = {
    _canUseCookies: undefined,
    isTypeof: (0, $hGXAo.isTypeof),
    isUndefined: (0, $hGXAo.isUndefined),
    isNullOrUndefined: (0, $hGXAo.isNullOrUndefined),
    hasOwnProperty: (0, $hGXAo.hasOwnProperty),
    isFunction: (0, $hGXAo.isFunction),
    isObject: (0, $hGXAo.isObject),
    isDate: (0, $hGXAo.isDate),
    isArray: (0, $hGXAo.isArray),
    isError: (0, $hGXAo.isError),
    isString: (0, $hGXAo.isString),
    isNumber: (0, $hGXAo.isNumber),
    isBoolean: (0, $hGXAo.isBoolean),
    toISOString: (0, $hGXAo.toISOString),
    arrForEach: (0, $hGXAo.arrForEach),
    arrIndexOf: (0, $hGXAo.arrIndexOf),
    arrMap: (0, $hGXAo.arrMap),
    arrReduce: (0, $hGXAo.arrReduce),
    strTrim: (0, $hGXAo.strTrim),
    objCreate: (0, $91dsF.objCreateFn),
    objKeys: (0, $hGXAo.objKeys),
    objDefineAccessors: (0, $hGXAo.objDefineAccessors),
    addEventHandler: (0, $lhl6R.addEventHandler),
    dateNow: (0, $hGXAo.dateNow),
    isIE: (0, $bU24K.isIE),
    disableCookies: $e90274f10f9bf40d$export$62933da51d94d272,
    newGuid: $e90274f10f9bf40d$export$665eeb3ced5fba0b,
    perfNow: $e90274f10f9bf40d$export$ba2b1ec760f018ed,
    newId: (0, $1iY3X.newId),
    randomValue: (0, $1iY3X.randomValue),
    random32: (0, $1iY3X.random32),
    mwcRandomSeed: (0, $1iY3X.mwcRandomSeed),
    mwcRandom32: (0, $1iY3X.mwcRandom32),
    generateW3CId: $e90274f10f9bf40d$export$58d1fad45f39d957
};
var $e90274f10f9bf40d$var$GuidRegex = /[xy]/g;
var $e90274f10f9bf40d$export$b75a658845002fd7 = {
    Attach: (0, $lhl6R.attachEvent),
    AttachEvent: (0, $lhl6R.attachEvent),
    Detach: (0, $lhl6R.detachEvent),
    DetachEvent: (0, $lhl6R.detachEvent)
};
function $e90274f10f9bf40d$export$9e27a47477d3d546(config, logger) {
    var cookieMgr = (0, $hB9U1._gblCookieMgr)(config, logger);
    var legacyCanUseCookies = $e90274f10f9bf40d$export$8e4719d8761024a1._canUseCookies;
    if ($e90274f10f9bf40d$var$_cookieMgrs === null) {
        $e90274f10f9bf40d$var$_cookieMgrs = [];
        $e90274f10f9bf40d$var$_canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        (0, $hGXAo.objDefineAccessors)($e90274f10f9bf40d$export$8e4719d8761024a1, "_canUseCookies", function() {
            return $e90274f10f9bf40d$var$_canUseCookies;
        }, function(value) {
            $e90274f10f9bf40d$var$_canUseCookies = value;
            (0, $hGXAo.arrForEach)($e90274f10f9bf40d$var$_cookieMgrs, function(mgr) {
                mgr[0, $j5TD0._DYN_SET_ENABLED /* @min:%2esetEnabled */ ](value);
            });
        });
    }
    if ((0, $hGXAo.arrIndexOf)($e90274f10f9bf40d$var$_cookieMgrs, cookieMgr) === -1) $e90274f10f9bf40d$var$_cookieMgrs[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](cookieMgr);
    if ((0, $hGXAo.isBoolean)(legacyCanUseCookies)) cookieMgr[0, $j5TD0._DYN_SET_ENABLED /* @min:%2esetEnabled */ ](legacyCanUseCookies);
    if ((0, $hGXAo.isBoolean)($e90274f10f9bf40d$var$_canUseCookies)) cookieMgr[0, $j5TD0._DYN_SET_ENABLED /* @min:%2esetEnabled */ ]($e90274f10f9bf40d$var$_canUseCookies);
    return cookieMgr;
}
function $e90274f10f9bf40d$export$62933da51d94d272() {
    $e90274f10f9bf40d$export$9e27a47477d3d546()[0, $j5TD0._DYN_SET_ENABLED /* @min:%2esetEnabled */ ](false);
}
function $e90274f10f9bf40d$export$304a5ec8c5d7d95(logger) {
    return $e90274f10f9bf40d$export$9e27a47477d3d546(null, logger).isEnabled();
}
function $e90274f10f9bf40d$export$4be65e66cfa2648a(logger, name) {
    return $e90274f10f9bf40d$export$9e27a47477d3d546(null, logger).get(name);
}
function $e90274f10f9bf40d$export$110700823644f4a6(logger, name, value, domain) {
    $e90274f10f9bf40d$export$9e27a47477d3d546(null, logger).set(name, value, null, domain);
}
function $e90274f10f9bf40d$export$b43e45590305ffaa(logger, name) {
    return $e90274f10f9bf40d$export$9e27a47477d3d546(null, logger).del(name);
}

});
parcelRegister("hB9U1", function(module, exports) {

$parcel$export(module.exports, "_gblCookieMgr", function () { return $ccfd92d0d4574179$export$ad5eff295dee5ae1; });
$parcel$export(module.exports, "createCookieMgr", function () { return $ccfd92d0d4574179$export$2ae082191ac44e5a; });
$parcel$export(module.exports, "safeGetCookieMgr", function () { return $ccfd92d0d4574179$export$76c0b273586c25c7; });
$parcel$export(module.exports, "uaDisallowsSameSiteNone", function () { return $ccfd92d0d4574179$export$e44499c7a8a6a268; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $i86yL = parcelRequire("i86yL");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
var $ccfd92d0d4574179$var$strToGMTString = "toGMTString";
var $ccfd92d0d4574179$var$strToUTCString = "toUTCString";
var $ccfd92d0d4574179$var$strCookie = "cookie";
var $ccfd92d0d4574179$var$strExpires = "expires";
var $ccfd92d0d4574179$var$strEnabled = "enabled";
var $ccfd92d0d4574179$var$strIsCookieUseDisabled = "isCookieUseDisabled";
var $ccfd92d0d4574179$var$strDisableCookiesUsage = "disableCookiesUsage";
var $ccfd92d0d4574179$var$strConfigCookieMgr = "_ckMgr";
var $ccfd92d0d4574179$var$_supportsCookies = null;
var $ccfd92d0d4574179$var$_allowUaSameSite = null;
var $ccfd92d0d4574179$var$_parsedCookieValue = null;
var $ccfd92d0d4574179$var$_doc = (0, $bU24K.getDocument)();
var $ccfd92d0d4574179$var$_cookieCache = {};
var $ccfd92d0d4574179$var$_globalCookieConfig = {};
function $ccfd92d0d4574179$export$ad5eff295dee5ae1(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = $ccfd92d0d4574179$export$2ae082191ac44e5a[$ccfd92d0d4574179$var$strConfigCookieMgr] || $ccfd92d0d4574179$var$_globalCookieConfig[$ccfd92d0d4574179$var$strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = $ccfd92d0d4574179$export$2ae082191ac44e5a[$ccfd92d0d4574179$var$strConfigCookieMgr] = $ccfd92d0d4574179$export$2ae082191ac44e5a(config, logger);
        $ccfd92d0d4574179$var$_globalCookieConfig[$ccfd92d0d4574179$var$strConfigCookieMgr] = inst;
    }
    return inst;
}
function $ccfd92d0d4574179$var$_isMgrEnabled(cookieMgr) {
    if (cookieMgr) return cookieMgr.isEnabled();
    return true;
}
function $ccfd92d0d4574179$var$_createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig[0, $j5TD0._DYN_COOKIE_CFG /* @min:%2ecookieCfg */ ] = rootConfig[0, $j5TD0._DYN_COOKIE_CFG /* @min:%2ecookieCfg */ ] || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    (0, $hGXAo.setValue)(cookieMgrCfg, "domain", rootConfig.cookieDomain, (0, $hGXAo.isNotNullOrUndefined), (0, $hGXAo.isNullOrUndefined));
    (0, $hGXAo.setValue)(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, (0, $hGXAo.isNullOrUndefined));
    if ((0, $hGXAo.isNullOrUndefined)(cookieMgrCfg[$ccfd92d0d4574179$var$strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!(0, $hGXAo.isUndefined)(rootConfig[$ccfd92d0d4574179$var$strIsCookieUseDisabled])) cookieEnabled = !rootConfig[$ccfd92d0d4574179$var$strIsCookieUseDisabled];
        if (!(0, $hGXAo.isUndefined)(rootConfig[$ccfd92d0d4574179$var$strDisableCookiesUsage])) cookieEnabled = !rootConfig[$ccfd92d0d4574179$var$strDisableCookiesUsage];
        cookieMgrCfg[$ccfd92d0d4574179$var$strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
function $ccfd92d0d4574179$var$_isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $hGXAo.isArray)(cookieMgrCfg.ignoreCookies)) return cookieMgrCfg.ignoreCookies[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ](name) !== -1;
    return false;
}
function $ccfd92d0d4574179$var$_isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $hGXAo.isArray)(cookieMgrCfg.blockedCookies)) {
        if (cookieMgrCfg.blockedCookies[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ](name) !== -1) return true;
    }
    return $ccfd92d0d4574179$var$_isIgnoredCookie(cookieMgrCfg, name);
}
function $ccfd92d0d4574179$export$76c0b273586c25c7(core, config) {
    var cookieMgr;
    if (core) // Always returns an instance
    cookieMgr = core.getCookieMgr();
    else if (config) {
        var cookieCfg = config[0, $j5TD0._DYN_COOKIE_CFG /* @min:%2ecookieCfg */ ];
        if (cookieCfg[$ccfd92d0d4574179$var$strConfigCookieMgr]) cookieMgr = cookieCfg[$ccfd92d0d4574179$var$strConfigCookieMgr];
        else cookieMgr = $ccfd92d0d4574179$export$2ae082191ac44e5a(config);
    }
    if (!cookieMgr) // Get or initialize the default global (legacy) cookie manager if we couldn't find one
    cookieMgr = $ccfd92d0d4574179$export$ad5eff295dee5ae1(config, (core || {})[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ]);
    return cookieMgr;
}
function $ccfd92d0d4574179$export$2ae082191ac44e5a(rootConfig, logger) {
    var _a;
    var cookieMgrConfig = $ccfd92d0d4574179$var$_createCookieMgrConfig(rootConfig || $ccfd92d0d4574179$var$_globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[$ccfd92d0d4574179$var$strEnabled] !== false;
    var cookieMgr = (_a = {
        isEnabled: function() {
            var enabled = _enabled && $ccfd92d0d4574179$export$25d06da9c29ef62a(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = $ccfd92d0d4574179$var$_globalCookieConfig[$ccfd92d0d4574179$var$strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
            // As the global (deprecated) functions may have been called (for backward compatibility)
            enabled = $ccfd92d0d4574179$var$_isMgrEnabled(gblManager);
            return enabled;
        }
    }, _a[0, $j5TD0._DYN_SET_ENABLED /* @min:setEnabled */ ] = function(value) {
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = value !== false;
    }, _a.set = function(name, value, maxAgeSec, domain, path) {
        var result = false;
        if ($ccfd92d0d4574179$var$_isMgrEnabled(cookieMgr) && !$ccfd92d0d4574179$var$_isBlockedCookie(cookieMgrConfig, name)) {
            var values = {};
            var theValue = (0, $hGXAo.strTrim)(value || (0, $59IxV.STR_EMPTY));
            var idx = theValue[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ](";");
            if (idx !== -1) {
                theValue = (0, $hGXAo.strTrim)(value[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](0, idx));
                values = $ccfd92d0d4574179$var$_extractParts(value[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](idx + 1));
            }
            // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
            (0, $hGXAo.setValue)(values, "domain", domain || _domain, (0, $hGXAo.isTruthy), (0, $hGXAo.isUndefined));
            if (!(0, $hGXAo.isNullOrUndefined)(maxAgeSec)) {
                var _isIE = (0, $bU24K.isIE)();
                if ((0, $hGXAo.isUndefined)(values[$ccfd92d0d4574179$var$strExpires])) {
                    var nowMs = (0, $hGXAo.dateNow)();
                    // Only add expires if not already present
                    var expireMs = nowMs + maxAgeSec * 1000;
                    // Sanity check, if zero or -ve then ignore
                    if (expireMs > 0) {
                        var expiry = new Date();
                        expiry.setTime(expireMs);
                        (0, $hGXAo.setValue)(values, $ccfd92d0d4574179$var$strExpires, $ccfd92d0d4574179$var$_formatDate(expiry, !_isIE ? $ccfd92d0d4574179$var$strToUTCString : $ccfd92d0d4574179$var$strToGMTString) || $ccfd92d0d4574179$var$_formatDate(expiry, _isIE ? $ccfd92d0d4574179$var$strToGMTString : $ccfd92d0d4574179$var$strToUTCString) || (0, $59IxV.STR_EMPTY), (0, $hGXAo.isTruthy));
                    }
                }
                if (!_isIE) // Only replace if not already present
                (0, $hGXAo.setValue)(values, "max-age", (0, $59IxV.STR_EMPTY) + maxAgeSec, null, (0, $hGXAo.isUndefined));
            }
            var location_1 = (0, $bU24K.getLocation)();
            if (location_1 && location_1.protocol === "https:") {
                (0, $hGXAo.setValue)(values, "secure", null, null, (0, $hGXAo.isUndefined));
                // Only set same site if not also secure
                if ($ccfd92d0d4574179$var$_allowUaSameSite === null) $ccfd92d0d4574179$var$_allowUaSameSite = !$ccfd92d0d4574179$export$e44499c7a8a6a268(((0, $bU24K.getNavigator)() || {})[0, $j5TD0._DYN_USER_AGENT /* @min:%2euserAgent */ ]);
                if ($ccfd92d0d4574179$var$_allowUaSameSite) (0, $hGXAo.setValue)(values, "SameSite", "None", null, (0, $hGXAo.isUndefined));
            }
            (0, $hGXAo.setValue)(values, "path", path || _path, null, (0, $hGXAo.isUndefined));
            var setCookieFn = cookieMgrConfig.setCookie || $ccfd92d0d4574179$var$_setCookieValue;
            setCookieFn(name, $ccfd92d0d4574179$var$_formatCookieValue(theValue, values));
            result = true;
        }
        return result;
    }, _a.get = function(name) {
        var value = (0, $59IxV.STR_EMPTY);
        if ($ccfd92d0d4574179$var$_isMgrEnabled(cookieMgr) && !$ccfd92d0d4574179$var$_isIgnoredCookie(cookieMgrConfig, name)) value = (cookieMgrConfig.getCookie || $ccfd92d0d4574179$var$_getCookieValue)(name);
        return value;
    }, _a.del = function(name, path) {
        var result = false;
        if ($ccfd92d0d4574179$var$_isMgrEnabled(cookieMgr)) // Only remove the cookie if the manager and cookie support has not been disabled
        result = cookieMgr.purge(name, path);
        return result;
    }, _a.purge = function(name, path) {
        var _a;
        var result = false;
        if ($ccfd92d0d4574179$export$25d06da9c29ef62a(logger)) {
            // Setting the expiration date in the past immediately removes the cookie
            var values = (_a = {}, _a["path"] = path ? path : "/", _a[$ccfd92d0d4574179$var$strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
            if (!(0, $bU24K.isIE)()) // Set max age to expire now
            values["max-age"] = "0";
            var delCookie = cookieMgrConfig.delCookie || $ccfd92d0d4574179$var$_setCookieValue;
            delCookie(name, $ccfd92d0d4574179$var$_formatCookieValue((0, $59IxV.STR_EMPTY), values));
            result = true;
        }
        return result;
    }, _a);
    // Associated this cookie manager with the config
    cookieMgr[$ccfd92d0d4574179$var$strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
function $ccfd92d0d4574179$export$25d06da9c29ef62a(logger) {
    if ($ccfd92d0d4574179$var$_supportsCookies === null) {
        $ccfd92d0d4574179$var$_supportsCookies = false;
        try {
            var doc = $ccfd92d0d4574179$var$_doc || {};
            $ccfd92d0d4574179$var$_supportsCookies = doc[$ccfd92d0d4574179$var$strCookie] !== undefined;
        } catch (e) {
            (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 68 /* _eInternalMessageId.CannotAccessCookie */ , "Cannot access document.cookie - " + (0, $hGXAo.getExceptionName)(e), {
                exception: (0, $bU24K.dumpObj)(e)
            });
        }
    }
    return $ccfd92d0d4574179$var$_supportsCookies;
}
function $ccfd92d0d4574179$var$_extractParts(theValue) {
    var values = {};
    if (theValue && theValue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ]) {
        var parts = (0, $hGXAo.strTrim)(theValue)[0, $j5TD0._DYN_SPLIT /* @min:%2esplit */ ](";");
        (0, $hGXAo.arrForEach)(parts, function(thePart) {
            thePart = (0, $hGXAo.strTrim)(thePart || (0, $59IxV.STR_EMPTY));
            if (thePart) {
                var idx = thePart[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ]("=");
                if (idx === -1) values[thePart] = null;
                else values[(0, $hGXAo.strTrim)(thePart[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](0, idx))] = (0, $hGXAo.strTrim)(thePart[0, $j5TD0._DYN_SUBSTRING /* @min:%2esubstring */ ](idx + 1));
            }
        });
    }
    return values;
}
function $ccfd92d0d4574179$var$_formatDate(theDate, func) {
    if ((0, $hGXAo.isFunction)(theDate[func])) return theDate[func]();
    return null;
}
function $ccfd92d0d4574179$var$_formatCookieValue(value, values) {
    var cookieValue = value || (0, $59IxV.STR_EMPTY);
    (0, $hGXAo.objForEachKey)(values, function(name, theValue) {
        cookieValue += "; " + name + (!(0, $hGXAo.isNullOrUndefined)(theValue) ? "=" + theValue : (0, $59IxV.STR_EMPTY));
    });
    return cookieValue;
}
function $ccfd92d0d4574179$var$_getCookieValue(name) {
    var cookieValue = (0, $59IxV.STR_EMPTY);
    if ($ccfd92d0d4574179$var$_doc) {
        var theCookie = $ccfd92d0d4574179$var$_doc[$ccfd92d0d4574179$var$strCookie] || (0, $59IxV.STR_EMPTY);
        if ($ccfd92d0d4574179$var$_parsedCookieValue !== theCookie) {
            $ccfd92d0d4574179$var$_cookieCache = $ccfd92d0d4574179$var$_extractParts(theCookie);
            $ccfd92d0d4574179$var$_parsedCookieValue = theCookie;
        }
        cookieValue = (0, $hGXAo.strTrim)($ccfd92d0d4574179$var$_cookieCache[name] || (0, $59IxV.STR_EMPTY));
    }
    return cookieValue;
}
function $ccfd92d0d4574179$var$_setCookieValue(name, cookieValue) {
    if ($ccfd92d0d4574179$var$_doc) $ccfd92d0d4574179$var$_doc[$ccfd92d0d4574179$var$strCookie] = name + "=" + cookieValue;
}
function $ccfd92d0d4574179$export$e44499c7a8a6a268(userAgent) {
    if (!(0, $hGXAo.isString)(userAgent)) return false;
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if ((0, $hGXAo.strContains)(userAgent, "CPU iPhone OS 12") || (0, $hGXAo.strContains)(userAgent, "iPad; CPU OS 12")) return true;
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $hGXAo.strContains)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $hGXAo.strContains)(userAgent, "Version/") && (0, $hGXAo.strContains)(userAgent, "Safari")) return true;
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $hGXAo.strContains)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $hGXAo.strEndsWith)(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if ((0, $hGXAo.strContains)(userAgent, "Chrome/5") || (0, $hGXAo.strContains)(userAgent, "Chrome/6")) return true;
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if ((0, $hGXAo.strContains)(userAgent, "UnrealEngine") && !(0, $hGXAo.strContains)(userAgent, "Chrome")) return true;
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if ((0, $hGXAo.strContains)(userAgent, "UCBrowser/12") || (0, $hGXAo.strContains)(userAgent, "UCBrowser/11")) return true;
    return false;
}

});
parcelRegister("i86yL", function(module, exports) {

$parcel$export(module.exports, "_InternalLogMessage", function () { return $d32e0ff7bb82903d$export$70ef838ed08aad47; });
$parcel$export(module.exports, "safeGetLogger", function () { return $d32e0ff7bb82903d$export$5102d32ea1d740a; });
$parcel$export(module.exports, "DiagnosticLogger", function () { return $d32e0ff7bb82903d$export$4f80edb2e10dc14c; });
$parcel$export(module.exports, "_throwInternal", function () { return $d32e0ff7bb82903d$export$c7ca1fcbf1d310c4; });
$parcel$export(module.exports, "_warnToConsole", function () { return $d32e0ff7bb82903d$export$25fb4cb97863f0a8; });
$parcel$export(module.exports, "_logInternalMessage", function () { return $d32e0ff7bb82903d$export$e15fbe42d9bc9d3d; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $39sw1 = parcelRequire("39sw1");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
"use strict";
/**
 * For user non actionable traces use AI Internal prefix.
 */ var $d32e0ff7bb82903d$var$AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */ var $d32e0ff7bb82903d$var$AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */ var $d32e0ff7bb82903d$var$AIInternalMessagePrefix = "AITR_";
function $d32e0ff7bb82903d$var$_sanitizeDiagnosticText(text) {
    if (text) return '"' + text[0, $j5TD0._DYN_REPLACE /* @min:%2ereplace */ ](/\"/g, (0, $59IxV.STR_EMPTY)) + '"';
    return 0, $59IxV.STR_EMPTY;
}
function $d32e0ff7bb82903d$var$_logToConsole(func, message) {
    var theConsole = (0, $bU24K.getConsole)();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) logFunc = func;
        if ((0, $hGXAo.isFunction)(theConsole[logFunc])) theConsole[logFunc](message);
    }
}
var $d32e0ff7bb82903d$export$70ef838ed08aad47 = /** @class */ function() {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) isUserAct = false;
        var _self = this;
        _self[0, $j5TD0._DYN_MESSAGE_ID /* @min:%2emessageId */ ] = msgId;
        _self[0, $j5TD0._DYN_MESSAGE /* @min:%2emessage */ ] = (isUserAct ? $d32e0ff7bb82903d$var$AiUserActionablePrefix : $d32e0ff7bb82903d$var$AiNonUserActionablePrefix) + msgId;
        var strProps = (0, $59IxV.STR_EMPTY);
        if ((0, $bU24K.hasJSON)()) strProps = (0, $bU24K.getJSON)().stringify(properties);
        var diagnosticText = (msg ? " message:" + $d32e0ff7bb82903d$var$_sanitizeDiagnosticText(msg) : (0, $59IxV.STR_EMPTY)) + (properties ? " props:" + $d32e0ff7bb82903d$var$_sanitizeDiagnosticText(strProps) : (0, $59IxV.STR_EMPTY));
        _self[0, $j5TD0._DYN_MESSAGE /* @min:%2emessage */ ] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}();
function $d32e0ff7bb82903d$export$5102d32ea1d740a(core, config) {
    return (core || {})[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ] || new $d32e0ff7bb82903d$export$4f80edb2e10dc14c(config);
}
var $d32e0ff7bb82903d$export$4f80edb2e10dc14c = /** @class */ function() {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */ this.queue = [];
        /**
         * Count of internal messages sent
         */ var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */ var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        (0, $bO3cR.default)(DiagnosticLogger, this, function(_self) {
            _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function() {
                return _loggingLevelConsole;
            };
            _self.telemetryLoggingLevel = function() {
                return _loggingLevelTelemetry;
            };
            _self.maxInternalMessageLimit = function() {
                return _maxInternalMessageLimit;
            };
            _self[0, $j5TD0._DYN_ENABLE_DEBUG_EXCEPTI4 /* @min:%2eenableDebugExceptions */ ] = function() {
                return _enableDebug;
            };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */ _self.throwInternal = function(severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) isUserAct = false;
                var message = new $d32e0ff7bb82903d$export$70ef838ed08aad47(msgId, msg, isUserAct, properties);
                if (_enableDebug) throw (0, $bU24K.dumpObj)(message);
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = severity === 1 /* eLoggingSeverity.CRITICAL */  ? (0, $59IxV.STR_ERROR_TO_CONSOLE) : (0, $59IxV.STR_WARN_TO_CONSOLE);
                    if (!(0, $hGXAo.isUndefined)(message[0, $j5TD0._DYN_MESSAGE /* @min:%2emessage */ ])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[0, $j5TD0._DYN_MESSAGE_ID /* @min:%2emessageId */ ];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[0, $j5TD0._DYN_MESSAGE /* @min:%2emessage */ ]);
                                _messageLogged[messageKey] = true;
                            }
                        } else // Only log traces if the console Logging Level is >= the throwInternal severity level
                        if (_loggingLevelConsole >= severity) _self[logFunc](message[0, $j5TD0._DYN_MESSAGE /* @min:%2emessage */ ]);
                        _logInternalMessage(severity, message);
                    } else _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */  ? "Critical" : "Warning"), message);
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */ _self[0, $59IxV.STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */ ] = function(message) {
                $d32e0ff7bb82903d$var$_logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            /**
             * This will write an error to the console if possible
             * @param message {string} - The error message
             */ _self[0, $59IxV.STR_ERROR_TO_CONSOLE /* @min:%2eerrorToConsole */ ] = function(message) {
                $d32e0ff7bb82903d$var$_logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            /**
             * Resets the internal message count
             */ _self.resetInternalMessageCount = function() {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */ _self[0, $j5TD0._DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */ ] = _logInternalMessage;
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) return;
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = $d32e0ff7bb82903d$var$AIInternalMessagePrefix + message[0, $j5TD0._DYN_MESSAGE_ID /* @min:%2emessageId */ ];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) logMessage = false;
                else _messageLogged[messageKey] = true;
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](message);
                        _messageCount++;
                        _debugExtMsg(severity === 1 /* eLoggingSeverity.CRITICAL */  ? "error" : "warn", message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new $d32e0ff7bb82903d$export$70ef838ed08aad47(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */ , throttleLimitMessage, false);
                        _self.queue[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */ ) _self[0, $59IxV.STR_ERROR_TO_CONSOLE /* @min:%2eerrorToConsole */ ](throttleLimitMessage);
                        else _self[0, $59IxV.STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */ ](throttleLimitMessage);
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                _loggingLevelConsole = (0, $hGXAo.getCfgValue)(config.loggingLevelConsole, 0);
                _loggingLevelTelemetry = (0, $hGXAo.getCfgValue)(config.loggingLevelTelemetry, 1);
                _maxInternalMessageLimit = (0, $hGXAo.getCfgValue)(config.maxMessageLimit, 25);
                _enableDebug = (0, $hGXAo.getCfgValue)(config.enableDebug, (0, $hGXAo.getCfgValue)(config[0, $j5TD0._DYN_ENABLE_DEBUG_EXCEPTI4 /* @min:%2eenableDebugExceptions */ ], false));
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = (0, $39sw1.getDebugExt)(config || {});
                if (dbgExt && dbgExt[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ]) dbgExt[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ](name, data);
            }
        });
    }
    // Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
    // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
    // Removed Stub for DiagnosticLogger.prototype.throwInternal.
    // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
    // Removed Stub for DiagnosticLogger.prototype.errorToConsole.
    // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
    // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    DiagnosticLogger.__ieDyn = 1;
    return DiagnosticLogger;
}();
function $d32e0ff7bb82903d$var$_getLogger(logger) {
    return logger || new $d32e0ff7bb82903d$export$4f80edb2e10dc14c();
}
function $d32e0ff7bb82903d$export$c7ca1fcbf1d310c4(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) isUserAct = false;
    $d32e0ff7bb82903d$var$_getLogger(logger).throwInternal(severity, msgId, msg, properties, isUserAct);
}
function $d32e0ff7bb82903d$export$25fb4cb97863f0a8(logger, message) {
    $d32e0ff7bb82903d$var$_getLogger(logger)[0, $59IxV.STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */ ](message);
}
function $d32e0ff7bb82903d$export$e15fbe42d9bc9d3d(logger, severity, message) {
    $d32e0ff7bb82903d$var$_getLogger(logger)[0, $j5TD0._DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */ ](severity, message);
}

});
parcelRegister("39sw1", function(module, exports) {

$parcel$export(module.exports, "getDebugExt", function () { return $24b854ecbb49817b$export$a0b1f407ae6b45dc; });
$parcel$export(module.exports, "getDebugListener", function () { return $24b854ecbb49817b$export$dae5ac50a0df0f5f; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $bU24K = parcelRequire("bU24K");
var $24b854ecbb49817b$var$listenerFuncs = [
    "eventsSent",
    "eventsDiscarded",
    "eventsSendRequest",
    "perfEvent"
];
var $24b854ecbb49817b$var$_aiNamespace = null;
var $24b854ecbb49817b$var$_debugListener;
function $24b854ecbb49817b$var$_listenerProxyFunc(name, config) {
    return function() {
        var args = arguments;
        var dbgExt = $24b854ecbb49817b$export$a0b1f407ae6b45dc(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) listener[name][0, $j5TD0._DYN_APPLY /* @min:%2eapply */ ](listener, args);
        }
    };
}
function $24b854ecbb49817b$var$_getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = (0, $bU24K.getGlobalInst)("Microsoft");
    if (target) $24b854ecbb49817b$var$_aiNamespace = target["ApplicationInsights"];
    return $24b854ecbb49817b$var$_aiNamespace;
}
function $24b854ecbb49817b$export$a0b1f407ae6b45dc(config) {
    var ns = $24b854ecbb49817b$var$_aiNamespace;
    if (!ns && config.disableDbgExt !== true) ns = $24b854ecbb49817b$var$_aiNamespace || $24b854ecbb49817b$var$_getExtensionNamespace();
    return ns ? ns["ChromeDbgExt"] : null;
}
function $24b854ecbb49817b$export$dae5ac50a0df0f5f(config) {
    if (!$24b854ecbb49817b$var$_debugListener) {
        $24b854ecbb49817b$var$_debugListener = {};
        for(var lp = 0; lp < $24b854ecbb49817b$var$listenerFuncs[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ]; lp++)$24b854ecbb49817b$var$_debugListener[$24b854ecbb49817b$var$listenerFuncs[lp]] = $24b854ecbb49817b$var$_listenerProxyFunc($24b854ecbb49817b$var$listenerFuncs[lp], config);
    }
    return $24b854ecbb49817b$var$_debugListener;
}

});




parcelRegister("cseB2", function(module, exports) {

$parcel$export(module.exports, "createTraceParent", function () { return $025705df7b4496ab$export$2f21fe23413fe96b; });
$parcel$export(module.exports, "isValidTraceId", function () { return $025705df7b4496ab$export$29dd34cf1269f6da; });
$parcel$export(module.exports, "isValidSpanId", function () { return $025705df7b4496ab$export$8e51c6d8f0586aff; });
$parcel$export(module.exports, "formatTraceParent", function () { return $025705df7b4496ab$export$55f8c39d2c902d0d; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $k0iSW = parcelRequire("k0iSW");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var $025705df7b4496ab$var$TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var $025705df7b4496ab$var$DEFAULT_VERSION = "00";
var $025705df7b4496ab$var$INVALID_VERSION = "ff";
var $025705df7b4496ab$var$INVALID_TRACE_ID = "00000000000000000000000000000000";
var $025705df7b4496ab$var$INVALID_SPAN_ID = "0000000000000000";
var $025705df7b4496ab$var$SAMPLED_FLAG = 0x01;
function $025705df7b4496ab$var$_isValid(value, len, invalidValue) {
    if (value && value[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
    return false;
}
function $025705df7b4496ab$var$_formatValue(value, len, defValue) {
    if ($025705df7b4496ab$var$_isValid(value, len)) return value;
    return defValue;
}
function $025705df7b4496ab$var$_formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) value = 0x01;
    var result = value.toString(16);
    while(result[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] < 2)result = "0" + result;
    return result;
}
function $025705df7b4496ab$export$2f21fe23413fe96b(traceId, spanId, flags, version) {
    var _a;
    return _a = {}, _a[0, $j5TD0._DYN_VERSION /* @min:version */ ] = $025705df7b4496ab$var$_isValid(version, 2, $025705df7b4496ab$var$INVALID_VERSION) ? version : $025705df7b4496ab$var$DEFAULT_VERSION, _a[0, $j5TD0._DYN_TRACE_ID /* @min:traceId */ ] = $025705df7b4496ab$export$29dd34cf1269f6da(traceId) ? traceId : (0, $k0iSW.generateW3CId)(), _a.spanId = $025705df7b4496ab$export$8e51c6d8f0586aff(spanId) ? spanId : (0, $k0iSW.generateW3CId)()[0, $j5TD0._DYN_SUBSTR /* @min:%2esubstr */ ](0, 16), _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1, _a;
}
function $025705df7b4496ab$export$f4d87f8901a93f5d(value, selectIdx) {
    var _a;
    if (!value) // Don't pass a null/undefined or empty string
    return null;
    if ((0, $hGXAo.isArray)(value)) // The value may have been encoded on the page into an array so handle this automatically
    value = value[0] || "";
    if (!value || !(0, $hGXAo.isString)(value) || value[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 8192) // limit potential processing based on total length
    return null;
    if (value[0, $j5TD0._DYN_INDEX_OF /* @min:%2eindexOf */ ](",") !== -1) {
        var values = value[0, $j5TD0._DYN_SPLIT /* @min:%2esplit */ ](",");
        value = values[selectIdx > 0 && values[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > selectIdx ? selectIdx : 0];
    }
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    var match = $025705df7b4496ab$var$TRACE_PARENT_REGEX.exec((0, $hGXAo.strTrim)(value));
    if (!match || // No match
    match[1] === $025705df7b4496ab$var$INVALID_VERSION || // version ff is forbidden
    match[2] === $025705df7b4496ab$var$INVALID_TRACE_ID || // All zeros is considered to be invalid
    match[3] === $025705df7b4496ab$var$INVALID_SPAN_ID) return null;
    return _a = {
        version: (match[1] || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](),
        traceId: (match[2] || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](),
        spanId: (match[3] || (0, $59IxV.STR_EMPTY))[0, $j5TD0._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]()
    }, _a[0, $j5TD0._DYN_TRACE_FLAGS /* @min:traceFlags */ ] = parseInt(match[4], 16), _a;
}
function $025705df7b4496ab$export$29dd34cf1269f6da(value) {
    return $025705df7b4496ab$var$_isValid(value, 32, $025705df7b4496ab$var$INVALID_TRACE_ID);
}
function $025705df7b4496ab$export$8e51c6d8f0586aff(value) {
    return $025705df7b4496ab$var$_isValid(value, 16, $025705df7b4496ab$var$INVALID_SPAN_ID);
}
function $025705df7b4496ab$export$a210ed246a03bbf(value) {
    if (!value || !$025705df7b4496ab$var$_isValid(value[0, $j5TD0._DYN_VERSION /* @min:%2eversion */ ], 2, $025705df7b4496ab$var$INVALID_VERSION) || !$025705df7b4496ab$var$_isValid(value[0, $j5TD0._DYN_TRACE_ID /* @min:%2etraceId */ ], 32, $025705df7b4496ab$var$INVALID_TRACE_ID) || !$025705df7b4496ab$var$_isValid(value[0, $j5TD0._DYN_SPAN_ID /* @min:%2espanId */ ], 16, $025705df7b4496ab$var$INVALID_SPAN_ID) || !$025705df7b4496ab$var$_isValid($025705df7b4496ab$var$_formatFlags(value[0, $j5TD0._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ]), 2)) // Each known field must contain a valid value
    return false;
    return true;
}
function $025705df7b4496ab$export$8577d514cd55191e(value) {
    if ($025705df7b4496ab$export$a210ed246a03bbf(value)) return (value[0, $j5TD0._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] & $025705df7b4496ab$var$SAMPLED_FLAG) === $025705df7b4496ab$var$SAMPLED_FLAG;
    return false;
}
function $025705df7b4496ab$export$55f8c39d2c902d0d(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = $025705df7b4496ab$var$_formatFlags(value[0, $j5TD0._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ]);
        if (!$025705df7b4496ab$var$_isValid(flags, 2)) flags = "01";
        var version = value[0, $j5TD0._DYN_VERSION /* @min:%2eversion */ ] || $025705df7b4496ab$var$DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") // Reduce version to "00"
        version = $025705df7b4496ab$var$DEFAULT_VERSION;
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat($025705df7b4496ab$var$_formatValue(value.traceId, 32, $025705df7b4496ab$var$INVALID_TRACE_ID).toLowerCase(), "-").concat($025705df7b4496ab$var$_formatValue(value.spanId, 16, $025705df7b4496ab$var$INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}
function $025705df7b4496ab$export$2a00dfdbe257ef74(selectIdx) {
    var name = "traceparent";
    var traceParent = $025705df7b4496ab$export$f4d87f8901a93f5d((0, $bU24K.findMetaTag)(name), selectIdx);
    if (!traceParent) traceParent = $025705df7b4496ab$export$f4d87f8901a93f5d((0, $bU24K.findNamedServerTiming)(name), selectIdx);
    return traceParent;
}

});

parcelRegister("cVsUj", function(module, exports) {

$parcel$export(module.exports, "DisabledPropertyName", function () { return $96913b44137055ca$export$7c6abff2f2bdd9c0; });
$parcel$export(module.exports, "SampleRate", function () { return $96913b44137055ca$export$dc288b6444e20c04; });
$parcel$export(module.exports, "ProcessLegacy", function () { return $96913b44137055ca$export$ea8a69bf327def66; });
$parcel$export(module.exports, "HttpMethod", function () { return $96913b44137055ca$export$8343e6f32f5246de; });
$parcel$export(module.exports, "DEFAULT_BREEZE_ENDPOINT", function () { return $96913b44137055ca$export$5c9ec0fce655ebcf; });
$parcel$export(module.exports, "DEFAULT_BREEZE_PATH", function () { return $96913b44137055ca$export$e6c0f3431c6cd728; });
$parcel$export(module.exports, "strNotSpecified", function () { return $96913b44137055ca$export$4003f5e1672d759; });
$parcel$export(module.exports, "strIkey", function () { return $96913b44137055ca$export$7d566319b90dbb26; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */ var $96913b44137055ca$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $96913b44137055ca$export$dc288b6444e20c04 = "sampleRate";
var $96913b44137055ca$export$ea8a69bf327def66 = "ProcessLegacy";
var $96913b44137055ca$export$8343e6f32f5246de = "http.method";
var $96913b44137055ca$export$5c9ec0fce655ebcf = "https://dc.services.visualstudio.com";
var $96913b44137055ca$export$e6c0f3431c6cd728 = "/v2/track";
var $96913b44137055ca$export$4003f5e1672d759 = "not_specified";
var $96913b44137055ca$export$7d566319b90dbb26 = "iKey";

});

parcelRegister("fAiTL", function(module, exports) {

$parcel$export(module.exports, "createDomEvent", function () { return $b588e09ebe38c85b$export$58aa8b47bf337bc8; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");
function $b588e09ebe38c85b$export$58aa8b47bf337bc8(eventName) {
    var event = null;
    if ((0, $hGXAo.isFunction)(Event)) event = new Event(eventName);
    else {
        var doc = (0, $bU24K.getDocument)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}

});

parcelRegister("6bipl", function(module, exports) {

$parcel$export(module.exports, "stringToBoolOrDefault", function () { return $48020c950dc0d420$export$4e47185aa280358c; });
$parcel$export(module.exports, "msToTimeSpan", function () { return $48020c950dc0d420$export$4460ed97e7c4a927; });
$parcel$export(module.exports, "getExtensionByName", function () { return $48020c950dc0d420$export$80a37ba429dff231; });
$parcel$export(module.exports, "isCrossOriginError", function () { return $48020c950dc0d420$export$8c465f5f14327ccd; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");

var $d8tQM = parcelRequire("d8tQM");
var $48020c950dc0d420$var$strEmpty = "";
function $48020c950dc0d420$export$4e47185aa280358c(str, defaultValue) {
    if (defaultValue === void 0) defaultValue = false;
    if (str === undefined || str === null) return defaultValue;
    return str.toString()[0, $d8tQM._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() === "true";
}
function $48020c950dc0d420$export$4460ed97e7c4a927(totalms) {
    if (isNaN(totalms) || totalms < 0) totalms = 0;
    totalms = Math.round(totalms);
    var ms = $48020c950dc0d420$var$strEmpty + totalms % 1000;
    var sec = $48020c950dc0d420$var$strEmpty + Math.floor(totalms / 1000) % 60;
    var min = $48020c950dc0d420$var$strEmpty + Math.floor(totalms / 60000) % 60;
    var hour = $48020c950dc0d420$var$strEmpty + Math.floor(totalms / 3600000) % 24;
    var days = Math.floor(totalms / 86400000);
    ms = ms[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] === 1 ? "00" + ms : ms[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] === 2 ? "0" + ms : ms;
    sec = sec[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] < 2 ? "0" + sec : sec;
    min = min[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] < 2 ? "0" + min : min;
    hour = hour[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : $48020c950dc0d420$var$strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function $48020c950dc0d420$export$80a37ba429dff231(extensions, identifier) {
    var extension = null;
    (0, $hGXAo.arrForEach)(extensions, function(value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function $48020c950dc0d420$export$8c465f5f14327ccd(message, url, lineNumber, columnNumber, error) {
    return !error && (0, $hGXAo.isString)(message) && (message === "Script error." || message === "Script error");
}

});
parcelRegister("d8tQM", function(module, exports) {

$parcel$export(module.exports, "_DYN_SPLIT", function () { return $99032d637085a8fc$export$b889f1d4cb07c706; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $99032d637085a8fc$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_TO_LOWER_CASE", function () { return $99032d637085a8fc$export$e4eaee9e01d9baaa; });
$parcel$export(module.exports, "_DYN_INGESTIONENDPOINT", function () { return $99032d637085a8fc$export$3960f2eafedb8f1; });
$parcel$export(module.exports, "_DYN_TO_STRING", function () { return $99032d637085a8fc$export$e2818d11505fa034; });
$parcel$export(module.exports, "_DYN_REMOVE_ITEM", function () { return $99032d637085a8fc$export$596e0e0dc14a1e9b; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $99032d637085a8fc$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_MESSAGE", function () { return $99032d637085a8fc$export$923606b70907833e; });
$parcel$export(module.exports, "_DYN_COUNT", function () { return $99032d637085a8fc$export$e9679ef501b0d1; });
$parcel$export(module.exports, "_DYN_STRINGIFY", function () { return $99032d637085a8fc$export$a318a8141fc98747; });
$parcel$export(module.exports, "_DYN_PATHNAME", function () { return $99032d637085a8fc$export$34ec22d747521ad; });
$parcel$export(module.exports, "_DYN_CORRELATION_HEADER_E0", function () { return $99032d637085a8fc$export$89ce3552c03e8ec9; });
$parcel$export(module.exports, "_DYN_INDEX_OF", function () { return $99032d637085a8fc$export$a3d3f936db372b4b; });
$parcel$export(module.exports, "_DYN_EXTENSION_CONFIG", function () { return $99032d637085a8fc$export$e298802ab42a3b7f; });
$parcel$export(module.exports, "_DYN_EXCEPTIONS", function () { return $99032d637085a8fc$export$967696d490ed5a4a; });
$parcel$export(module.exports, "_DYN_PARSED_STACK", function () { return $99032d637085a8fc$export$4b848bcab7cafe5d; });
$parcel$export(module.exports, "_DYN_PROPERTIES", function () { return $99032d637085a8fc$export$14814e6f9bf337b4; });
$parcel$export(module.exports, "_DYN_MEASUREMENTS", function () { return $99032d637085a8fc$export$32fc64677eb5b7a2; });
$parcel$export(module.exports, "_DYN_SIZE_IN_BYTES", function () { return $99032d637085a8fc$export$59a1581bc81a9aae; });
$parcel$export(module.exports, "_DYN_TYPE_NAME", function () { return $99032d637085a8fc$export$6008dba8ea08a587; });
$parcel$export(module.exports, "_DYN_SEVERITY_LEVEL", function () { return $99032d637085a8fc$export$2675b0014c60aa10; });
$parcel$export(module.exports, "_DYN_PROBLEM_GROUP", function () { return $99032d637085a8fc$export$5bc84cbcfe97e161; });
$parcel$export(module.exports, "_DYN_IS_MANUAL", function () { return $99032d637085a8fc$export$880f71e9a894c474; });
$parcel$export(module.exports, "_DYN__CREATE_FROM_INTERFA1", function () { return $99032d637085a8fc$export$aadef743ee7d1db8; });
$parcel$export(module.exports, "_DYN_ASSEMBLY", function () { return $99032d637085a8fc$export$7e3ee7b01672f321; });
$parcel$export(module.exports, "_DYN_FILE_NAME", function () { return $99032d637085a8fc$export$8ea03ef8a4bcfeeb; });
$parcel$export(module.exports, "_DYN_HAS_FULL_STACK", function () { return $99032d637085a8fc$export$b1b7551538b2085; });
$parcel$export(module.exports, "_DYN_LEVEL", function () { return $99032d637085a8fc$export$25f3022e0cda8855; });
$parcel$export(module.exports, "_DYN_METHOD", function () { return $99032d637085a8fc$export$47d30bd816d62bdc; });
$parcel$export(module.exports, "_DYN_LINE", function () { return $99032d637085a8fc$export$138215f6c1f0eedf; });
$parcel$export(module.exports, "_DYN_DURATION", function () { return $99032d637085a8fc$export$aa395e58f404db90; });
$parcel$export(module.exports, "_DYN_RECEIVED_RESPONSE", function () { return $99032d637085a8fc$export$e046465ee502552; });
$parcel$export(module.exports, "_DYN_SUBSTRING", function () { return $99032d637085a8fc$export$20dce058fdd3c573; });
$parcel$export(module.exports, "_DYN_SANITIZE_KEY_AND_ADD2", function () { return $99032d637085a8fc$export$3e2d26f886f27705; });
$parcel$export(module.exports, "_DYN_SANITIZE_EXCEPTION", function () { return $99032d637085a8fc$export$d41b8d8cb03ef566; });
$parcel$export(module.exports, "_DYN_SANITIZE_PROPERTIES", function () { return $99032d637085a8fc$export$f3c9f4fd45ed1e80; });
$parcel$export(module.exports, "_DYN_SANITIZE_MEASUREMENT3", function () { return $99032d637085a8fc$export$914f75e18f2d539f; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $99032d637085a8fc$export$b889f1d4cb07c706 = "split"; // Count: 6
var $99032d637085a8fc$export$6eae51590aaea43 = "length"; // Count: 41
var $99032d637085a8fc$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $99032d637085a8fc$export$3960f2eafedb8f1 = "ingestionendpoint"; // Count: 6
var $99032d637085a8fc$export$e2818d11505fa034 = "toString"; // Count: 12
var $99032d637085a8fc$export$596e0e0dc14a1e9b = "removeItem"; // Count: 3
var $99032d637085a8fc$export$9734b0a24bf02e93 = "name"; // Count: 11
var $99032d637085a8fc$export$923606b70907833e = "message"; // Count: 10
var $99032d637085a8fc$export$e9679ef501b0d1 = "count"; // Count: 8
var $99032d637085a8fc$export$89a9ed6e0f1c703a = "preTriggerDate"; // Count: 4
var $99032d637085a8fc$export$bf48f5cc9167f468 = "disabled"; // Count: 3
var $99032d637085a8fc$export$67d4e5d95e63e1b3 = "interval"; // Count: 3
var $99032d637085a8fc$export$ffc8d7f1d37c54ec = "daysOfMonth"; // Count: 3
var $99032d637085a8fc$export$abbddaba4ad71f38 = "date"; // Count: 5
var $99032d637085a8fc$export$44cd8e854cee592d = "getUTCDate"; // Count: 3
var $99032d637085a8fc$export$a318a8141fc98747 = "stringify"; // Count: 4
var $99032d637085a8fc$export$34ec22d747521ad = "pathname"; // Count: 4
var $99032d637085a8fc$export$89ce3552c03e8ec9 = "correlationHeaderExcludePatterns"; // Count: 2
var $99032d637085a8fc$export$a3d3f936db372b4b = "indexOf"; // Count: 4
var $99032d637085a8fc$export$e298802ab42a3b7f = "extensionConfig"; // Count: 4
var $99032d637085a8fc$export$967696d490ed5a4a = "exceptions"; // Count: 6
var $99032d637085a8fc$export$4b848bcab7cafe5d = "parsedStack"; // Count: 13
var $99032d637085a8fc$export$14814e6f9bf337b4 = "properties"; // Count: 9
var $99032d637085a8fc$export$32fc64677eb5b7a2 = "measurements"; // Count: 9
var $99032d637085a8fc$export$59a1581bc81a9aae = "sizeInBytes"; // Count: 11
var $99032d637085a8fc$export$6008dba8ea08a587 = "typeName"; // Count: 11
var $99032d637085a8fc$export$2675b0014c60aa10 = "severityLevel"; // Count: 5
var $99032d637085a8fc$export$5bc84cbcfe97e161 = "problemGroup"; // Count: 3
var $99032d637085a8fc$export$880f71e9a894c474 = "isManual"; // Count: 3
var $99032d637085a8fc$export$aadef743ee7d1db8 = "CreateFromInterface"; // Count: 2
var $99032d637085a8fc$export$7e3ee7b01672f321 = "assembly"; // Count: 7
var $99032d637085a8fc$export$8ea03ef8a4bcfeeb = "fileName"; // Count: 8
var $99032d637085a8fc$export$b1b7551538b2085 = "hasFullStack"; // Count: 6
var $99032d637085a8fc$export$25f3022e0cda8855 = "level"; // Count: 5
var $99032d637085a8fc$export$47d30bd816d62bdc = "method"; // Count: 7
var $99032d637085a8fc$export$138215f6c1f0eedf = "line"; // Count: 6
var $99032d637085a8fc$export$aa395e58f404db90 = "duration"; // Count: 4
var $99032d637085a8fc$export$e046465ee502552 = "receivedResponse"; // Count: 2
var $99032d637085a8fc$export$20dce058fdd3c573 = "substring"; // Count: 6
var $99032d637085a8fc$export$3e2d26f886f27705 = "sanitizeKeyAndAddUniqueness"; // Count: 2
var $99032d637085a8fc$export$d41b8d8cb03ef566 = "sanitizeException"; // Count: 2
var $99032d637085a8fc$export$f3c9f4fd45ed1e80 = "sanitizeProperties"; // Count: 2
var $99032d637085a8fc$export$914f75e18f2d539f = "sanitizeMeasurements"; // Count: 2

});


parcelRegister("ddqo3", function(module, exports) {

$parcel$export(module.exports, "RequestHeaders", function () { return $99f0f528bd9545ee$export$e499e02a1fe05177; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4X2WW = parcelRequire("4X2WW");
var $99f0f528bd9545ee$export$e499e02a1fe05177 = (0, $4X2WW.createValueMap)({
    requestContextHeader: [
        0 /* eRequestHeaders.requestContextHeader */ ,
        "Request-Context"
    ],
    requestContextTargetKey: [
        1 /* eRequestHeaders.requestContextTargetKey */ ,
        "appId"
    ],
    requestContextAppIdFormat: [
        2 /* eRequestHeaders.requestContextAppIdFormat */ ,
        "appId=cid-v1:"
    ],
    requestIdHeader: [
        3 /* eRequestHeaders.requestIdHeader */ ,
        "Request-Id"
    ],
    traceParentHeader: [
        4 /* eRequestHeaders.traceParentHeader */ ,
        "traceparent"
    ],
    traceStateHeader: [
        5 /* eRequestHeaders.traceStateHeader */ ,
        "tracestate"
    ],
    sdkContextHeader: [
        6 /* eRequestHeaders.sdkContextHeader */ ,
        "Sdk-Context"
    ],
    sdkContextHeaderAppIdRequest: [
        7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ,
        "appId"
    ],
    requestContextHeaderLowerCase: [
        8 /* eRequestHeaders.requestContextHeaderLowerCase */ ,
        "request-context"
    ]
});

});
parcelRegister("4X2WW", function(module, exports) {

$parcel$export(module.exports, "createEnumStyle", function () { return $39aef5d867971764$export$fd52abd0b2703048; });
$parcel$export(module.exports, "createValueMap", function () { return $39aef5d867971764$export$8980fe7abaa99712; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");
function $39aef5d867971764$export$fd52abd0b2703048(values) {
    var enumClass = {};
    (0, $hGXAo.objForEachKey)(values, function(field, value) {
        enumClass[field] = value;
        enumClass[value] = field;
    });
    return (0, $hGXAo.deepFreeze)(enumClass);
}
function $39aef5d867971764$export$a317a23ffc37c9e6(values) {
    var mapClass = {};
    (0, $hGXAo.objForEachKey)(values, function(field, value) {
        mapClass[field] = field;
        mapClass[value] = field;
    });
    return (0, $hGXAo.deepFreeze)(mapClass);
}
function $39aef5d867971764$export$8980fe7abaa99712(values) {
    var mapClass = {};
    (0, $hGXAo.objForEachKey)(values, function(field, value) {
        mapClass[field] = value[1];
        mapClass[value[0]] = value[1];
    });
    return (0, $hGXAo.deepFreeze)(mapClass);
}

});


parcelRegister("h1GMI", function(module, exports) {

$parcel$export(module.exports, "utlCanUseLocalStorage", function () { return $c653b7d5b02eb85c$export$f28746933126d63f; });
$parcel$export(module.exports, "utlCanUseSessionStorage", function () { return $c653b7d5b02eb85c$export$c81985c4209bac26; });
$parcel$export(module.exports, "utlDisableStorage", function () { return $c653b7d5b02eb85c$export$53ddd0ab7db9403; });
$parcel$export(module.exports, "utlSetStoragePrefix", function () { return $c653b7d5b02eb85c$export$a08dccf4adbf6df9; });
$parcel$export(module.exports, "utlEnableStorage", function () { return $c653b7d5b02eb85c$export$f08cf9bcd292b981; });
$parcel$export(module.exports, "utlGetLocalStorage", function () { return $c653b7d5b02eb85c$export$c3876355f131c85c; });
$parcel$export(module.exports, "utlSetLocalStorage", function () { return $c653b7d5b02eb85c$export$631bce20500dc098; });
$parcel$export(module.exports, "utlRemoveStorage", function () { return $c653b7d5b02eb85c$export$63137c65c2cc6743; });
$parcel$export(module.exports, "utlGetSessionStorageKeys", function () { return $c653b7d5b02eb85c$export$42f95336fa01d38e; });
$parcel$export(module.exports, "utlGetSessionStorage", function () { return $c653b7d5b02eb85c$export$a398bd2f40e2eb6e; });
$parcel$export(module.exports, "utlSetSessionStorage", function () { return $c653b7d5b02eb85c$export$21abea3a85fee3f5; });
$parcel$export(module.exports, "utlRemoveSessionStorage", function () { return $c653b7d5b02eb85c$export$9f411b4ea05fb92a; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $i86yL = parcelRequire("i86yL");
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");
var $91dsF = parcelRequire("91dsF");

var $dU7nU = parcelRequire("dU7nU");

var $d8tQM = parcelRequire("d8tQM");
var $c653b7d5b02eb85c$var$_canUseLocalStorage = undefined;
var $c653b7d5b02eb85c$var$_canUseSessionStorage = undefined;
var $c653b7d5b02eb85c$var$_storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $c653b7d5b02eb85c$var$_getLocalStorageObject() {
    if ($c653b7d5b02eb85c$export$f28746933126d63f()) return $c653b7d5b02eb85c$var$_getVerifiedStorageObject((0, $dU7nU.StorageType).LocalStorage);
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */ function $c653b7d5b02eb85c$var$_getVerifiedStorageObject(storageType) {
    try {
        if ((0, $hGXAo.isNullOrUndefined)((0, $91dsF.getGlobal)())) return null;
        var uid = (new Date)[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]();
        var storage = (0, $bU24K.getGlobalInst)(storageType === (0, $dU7nU.StorageType).LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = $c653b7d5b02eb85c$var$_storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[0, $d8tQM._DYN_REMOVE_ITEM /* @min:%2eremoveItem */ ](name_1);
        if (!fail) return storage;
    } catch (exception) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $c653b7d5b02eb85c$var$_getSessionStorageObject() {
    if ($c653b7d5b02eb85c$export$c81985c4209bac26()) return $c653b7d5b02eb85c$var$_getVerifiedStorageObject((0, $dU7nU.StorageType).SessionStorage);
    return null;
}
function $c653b7d5b02eb85c$export$53ddd0ab7db9403() {
    $c653b7d5b02eb85c$var$_canUseLocalStorage = false;
    $c653b7d5b02eb85c$var$_canUseSessionStorage = false;
}
function $c653b7d5b02eb85c$export$a08dccf4adbf6df9(storagePrefix) {
    $c653b7d5b02eb85c$var$_storagePrefix = storagePrefix || "";
}
function $c653b7d5b02eb85c$export$f08cf9bcd292b981() {
    $c653b7d5b02eb85c$var$_canUseLocalStorage = $c653b7d5b02eb85c$export$f28746933126d63f(true);
    $c653b7d5b02eb85c$var$_canUseSessionStorage = $c653b7d5b02eb85c$export$c81985c4209bac26(true);
}
function $c653b7d5b02eb85c$export$f28746933126d63f(reset) {
    if (reset || $c653b7d5b02eb85c$var$_canUseLocalStorage === undefined) $c653b7d5b02eb85c$var$_canUseLocalStorage = !!$c653b7d5b02eb85c$var$_getVerifiedStorageObject((0, $dU7nU.StorageType).LocalStorage);
    return $c653b7d5b02eb85c$var$_canUseLocalStorage;
}
function $c653b7d5b02eb85c$export$c3876355f131c85c(logger, name) {
    var storage = $c653b7d5b02eb85c$var$_getLocalStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $c653b7d5b02eb85c$var$_canUseLocalStorage = false;
        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */ , "Browser failed read of local storage. " + (0, $hGXAo.getExceptionName)(e), {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return null;
}
function $c653b7d5b02eb85c$export$631bce20500dc098(logger, name, data) {
    var storage = $c653b7d5b02eb85c$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $c653b7d5b02eb85c$var$_canUseLocalStorage = false;
        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */ , "Browser failed write to local storage. " + (0, $hGXAo.getExceptionName)(e), {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return false;
}
function $c653b7d5b02eb85c$export$63137c65c2cc6743(logger, name) {
    var storage = $c653b7d5b02eb85c$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage[0, $d8tQM._DYN_REMOVE_ITEM /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $c653b7d5b02eb85c$var$_canUseLocalStorage = false;
        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */ , "Browser failed removal of local storage item. " + (0, $hGXAo.getExceptionName)(e), {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return false;
}
function $c653b7d5b02eb85c$export$c81985c4209bac26(reset) {
    if (reset || $c653b7d5b02eb85c$var$_canUseSessionStorage === undefined) $c653b7d5b02eb85c$var$_canUseSessionStorage = !!$c653b7d5b02eb85c$var$_getVerifiedStorageObject((0, $dU7nU.StorageType).SessionStorage);
    return $c653b7d5b02eb85c$var$_canUseSessionStorage;
}
function $c653b7d5b02eb85c$export$42f95336fa01d38e() {
    var keys = [];
    if ($c653b7d5b02eb85c$export$c81985c4209bac26()) (0, $hGXAo.objForEachKey)((0, $bU24K.getGlobalInst)("sessionStorage"), function(key) {
        keys.push(key);
    });
    return keys;
}
function $c653b7d5b02eb85c$export$a398bd2f40e2eb6e(logger, name) {
    var storage = $c653b7d5b02eb85c$var$_getSessionStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $c653b7d5b02eb85c$var$_canUseSessionStorage = false;
        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */ , "Browser failed read of session storage. " + (0, $hGXAo.getExceptionName)(e), {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return null;
}
function $c653b7d5b02eb85c$export$21abea3a85fee3f5(logger, name, data) {
    var storage = $c653b7d5b02eb85c$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $c653b7d5b02eb85c$var$_canUseSessionStorage = false;
        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */ , "Browser failed write to session storage. " + (0, $hGXAo.getExceptionName)(e), {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return false;
}
function $c653b7d5b02eb85c$export$9f411b4ea05fb92a(logger, name) {
    var storage = $c653b7d5b02eb85c$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage[0, $d8tQM._DYN_REMOVE_ITEM /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $c653b7d5b02eb85c$var$_canUseSessionStorage = false;
        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */ , "Browser failed removal of session storage item. " + (0, $hGXAo.getExceptionName)(e), {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return false;
}

});
parcelRegister("dU7nU", function(module, exports) {

$parcel$export(module.exports, "StorageType", function () { return $a1f63bc1f2220833$export$d5f3ec63cad061d9; });
$parcel$export(module.exports, "DistributedTracingModes", function () { return $a1f63bc1f2220833$export$29bb472f6d62625c; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4X2WW = parcelRequire("4X2WW");
var $a1f63bc1f2220833$export$d5f3ec63cad061d9 = (0, $4X2WW.createEnumStyle)({
    LocalStorage: 0 /* eStorageType.LocalStorage */ ,
    SessionStorage: 1 /* eStorageType.SessionStorage */ 
});
var $a1f63bc1f2220833$export$29bb472f6d62625c = (0, $4X2WW.createEnumStyle)({
    AI: 0 /* eDistributedTracingModes.AI */ ,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
    W3C: 2 /* eDistributedTracingModes.W3C */ 
});

});


parcelRegister("i2MiW", function(module, exports) {

$parcel$export(module.exports, "dataSanitizeString", function () { return $d22de2270ee4bd71$export$4e25b1d4bcd67eb8; });
$parcel$export(module.exports, "dataSanitizeUrl", function () { return $d22de2270ee4bd71$export$356146502a9f860c; });
$parcel$export(module.exports, "dataSanitizeMessage", function () { return $d22de2270ee4bd71$export$dff84a9939b48dc0; });
$parcel$export(module.exports, "dataSanitizeException", function () { return $d22de2270ee4bd71$export$e47d8a961052f8bc; });
$parcel$export(module.exports, "dataSanitizeProperties", function () { return $d22de2270ee4bd71$export$efba9e468fe3b2cf; });
$parcel$export(module.exports, "dataSanitizeMeasurements", function () { return $d22de2270ee4bd71$export$3f0e10abe91e800b; });
$parcel$export(module.exports, "dataSanitizeId", function () { return $d22de2270ee4bd71$export$808d3905d3d31f01; });
$parcel$export(module.exports, "DataSanitizer", function () { return $d22de2270ee4bd71$export$e8f2853040e43d45; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $i86yL = parcelRequire("i86yL");
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");

var $d8tQM = parcelRequire("d8tQM");
var $d22de2270ee4bd71$var$_a;
function $d22de2270ee4bd71$export$1e3742b0a5fad0e9(logger, key, map) {
    var origLength = key[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ];
    var field = $d22de2270ee4bd71$export$100c3b44eeb2bd0b(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while(map[uniqueField] !== undefined){
            i++;
            uniqueField = field[0, $d8tQM._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 147) + $d22de2270ee4bd71$export$d924cb9df01a6484(i);
        }
        field = uniqueField;
    }
    return field;
}
function $d22de2270ee4bd71$export$100c3b44eeb2bd0b(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = (0, $hGXAo.strTrim)(name[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]());
        // truncate the string to 150 chars
        if (name[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ) {
            nameTrunc = name[0, $d8tQM._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ );
            (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 57 /* _eInternalMessageId.NameTooLong */ , "name is too long.  It has been truncated to 150 characters.", {
                name: name
            }, true);
        }
    }
    return nameTrunc || name;
}
function $d22de2270ee4bd71$export$4e25b1d4bcd67eb8(logger, value, maxLength) {
    if (maxLength === void 0) maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ;
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ; // in case default parameters dont work
        value = (0, $hGXAo.strTrim)(value);
        if (value.toString()[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > maxLength) {
            valueTrunc = value[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]()[0, $d8tQM._DYN_SUBSTRING /* @min:%2esubstring */ ](0, maxLength);
            (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 61 /* _eInternalMessageId.StringValueTooLong */ , "string value is too long. It has been truncated to " + maxLength + " characters.", {
                value: value
            }, true);
        }
    }
    return valueTrunc || value;
}
function $d22de2270ee4bd71$export$356146502a9f860c(logger, url) {
    return $d22de2270ee4bd71$export$8860beb3484248f1(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ , 66 /* _eInternalMessageId.UrlTooLong */ );
}
function $d22de2270ee4bd71$export$dff84a9939b48dc0(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ) {
            messageTrunc = message[0, $d8tQM._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ );
            (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 56 /* _eInternalMessageId.MessageTruncated */ , "message is too long, it has been truncated to 32768 characters.", {
                message: message
            }, true);
        }
    }
    return messageTrunc || message;
}
function $d22de2270ee4bd71$export$e47d8a961052f8bc(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ ) {
            exceptionTrunc = value[0, $d8tQM._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ );
            (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 52 /* _eInternalMessageId.ExceptionTruncated */ , "exception is too long, it has been truncated to 32768 characters.", {
                exception: exception
            }, true);
        }
    }
    return exceptionTrunc || exception;
}
function $d22de2270ee4bd71$export$efba9e468fe3b2cf(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        (0, $hGXAo.objForEachKey)(properties, function(prop, value) {
            if ((0, $hGXAo.isObject)(value) && (0, $bU24K.hasJSON)()) // Stringify any part C properties
            try {
                value = (0, $bU24K.getJSON)()[0, $d8tQM._DYN_STRINGIFY /* @min:%2estringify */ ](value);
            } catch (e) {
                (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "custom property is not valid", {
                    exception: e
                }, true);
            }
            value = $d22de2270ee4bd71$export$4e25b1d4bcd67eb8(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ );
            prop = $d22de2270ee4bd71$export$1e3742b0a5fad0e9(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function $d22de2270ee4bd71$export$3f0e10abe91e800b(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        (0, $hGXAo.objForEachKey)(measurements, function(measure, value) {
            measure = $d22de2270ee4bd71$export$1e3742b0a5fad0e9(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function $d22de2270ee4bd71$export$808d3905d3d31f01(logger, id) {
    return id ? $d22de2270ee4bd71$export$8860beb3484248f1(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */ , 69 /* _eInternalMessageId.IdTooLong */ )[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]() : id;
}
function $d22de2270ee4bd71$export$8860beb3484248f1(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = (0, $hGXAo.strTrim)(input);
        if (input[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > maxLength) {
            inputTrunc = input[0, $d8tQM._DYN_SUBSTRING /* @min:%2esubstring */ ](0, maxLength);
            (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", {
                data: input
            }, true);
        }
    }
    return inputTrunc || input;
}
function $d22de2270ee4bd71$export$d924cb9df01a6484(num) {
    var s = "00" + num;
    return s.substr(s[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] - 3);
}
var $d22de2270ee4bd71$export$e8f2853040e43d45 = ($d22de2270ee4bd71$var$_a = {
    MAX_NAME_LENGTH: 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ,
    MAX_ID_LENGTH: 128 /* DataSanitizerValues.MAX_ID_LENGTH */ ,
    MAX_PROPERTY_LENGTH: 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ ,
    MAX_STRING_LENGTH: 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ,
    MAX_URL_LENGTH: 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ ,
    MAX_MESSAGE_LENGTH: 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ,
    MAX_EXCEPTION_LENGTH: 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ 
}, $d22de2270ee4bd71$var$_a[0, $d8tQM._DYN_SANITIZE_KEY_AND_ADD2 /* @min:sanitizeKeyAndAddUniqueness */ ] = $d22de2270ee4bd71$export$1e3742b0a5fad0e9, $d22de2270ee4bd71$var$_a.sanitizeKey = $d22de2270ee4bd71$export$100c3b44eeb2bd0b, $d22de2270ee4bd71$var$_a.sanitizeString = $d22de2270ee4bd71$export$4e25b1d4bcd67eb8, $d22de2270ee4bd71$var$_a.sanitizeUrl = $d22de2270ee4bd71$export$356146502a9f860c, $d22de2270ee4bd71$var$_a.sanitizeMessage = $d22de2270ee4bd71$export$dff84a9939b48dc0, $d22de2270ee4bd71$var$_a[0, $d8tQM._DYN_SANITIZE_EXCEPTION /* @min:sanitizeException */ ] = $d22de2270ee4bd71$export$e47d8a961052f8bc, $d22de2270ee4bd71$var$_a[0, $d8tQM._DYN_SANITIZE_PROPERTIES /* @min:sanitizeProperties */ ] = $d22de2270ee4bd71$export$efba9e468fe3b2cf, $d22de2270ee4bd71$var$_a[0, $d8tQM._DYN_SANITIZE_MEASUREMENT3 /* @min:sanitizeMeasurements */ ] = $d22de2270ee4bd71$export$3f0e10abe91e800b, $d22de2270ee4bd71$var$_a.sanitizeId = $d22de2270ee4bd71$export$808d3905d3d31f01, $d22de2270ee4bd71$var$_a.sanitizeInput = $d22de2270ee4bd71$export$8860beb3484248f1, $d22de2270ee4bd71$var$_a.padNumber = $d22de2270ee4bd71$export$d924cb9df01a6484, $d22de2270ee4bd71$var$_a.trim = (0, $hGXAo.strTrim), $d22de2270ee4bd71$var$_a);

});

parcelRegister("3uBtC", function(module, exports) {

$parcel$export(module.exports, "urlParseUrl", function () { return $28b13e86b931896f$export$7121b8cb971a9df2; });
$parcel$export(module.exports, "urlParseHost", function () { return $28b13e86b931896f$export$ff1d1b7a9bae98f; });
$parcel$export(module.exports, "urlGetAbsoluteUrl", function () { return $28b13e86b931896f$export$a98678973ebe2123; });
$parcel$export(module.exports, "urlGetPathName", function () { return $28b13e86b931896f$export$d19e0ccf7100cfb3; });
$parcel$export(module.exports, "urlGetCompleteUrl", function () { return $28b13e86b931896f$export$b959f3bc0a239498; });
$parcel$export(module.exports, "urlParseFullHost", function () { return $28b13e86b931896f$export$eac70d47569302de; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");

var $d8tQM = parcelRequire("d8tQM");
var $28b13e86b931896f$var$_document = (0, $bU24K.getDocument)() || {};
var $28b13e86b931896f$var$_htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var $28b13e86b931896f$var$_htmlAnchorElement = [
    null,
    null,
    null,
    null,
    null
];
function $28b13e86b931896f$export$7121b8cb971a9df2(url) {
    var anchorIdx = $28b13e86b931896f$var$_htmlAnchorIdx;
    var anchorCache = $28b13e86b931896f$var$_htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!$28b13e86b931896f$var$_document.createElement) // Always create the temp instance if createElement is not available
    tempAnchor = {
        host: $28b13e86b931896f$export$ff1d1b7a9bae98f(url, true)
    };
    else if (!anchorCache[anchorIdx]) // Create and cache the unattached anchor instance
    tempAnchor = anchorCache[anchorIdx] = $28b13e86b931896f$var$_document.createElement("a");
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ]) anchorIdx = 0;
    $28b13e86b931896f$var$_htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function $28b13e86b931896f$export$a98678973ebe2123(url) {
    var result;
    var a = $28b13e86b931896f$export$7121b8cb971a9df2(url);
    if (a) result = a.href;
    return result;
}
function $28b13e86b931896f$export$d19e0ccf7100cfb3(url) {
    var result;
    var a = $28b13e86b931896f$export$7121b8cb971a9df2(url);
    if (a) result = a[0, $d8tQM._DYN_PATHNAME /* @min:%2epathname */ ];
    return result;
}
function $28b13e86b931896f$export$b959f3bc0a239498(method, absoluteUrl) {
    if (method) return method.toUpperCase() + " " + absoluteUrl;
    return absoluteUrl;
}
function $28b13e86b931896f$export$ff1d1b7a9bae98f(url, inclPort) {
    var fullHost = $28b13e86b931896f$export$eac70d47569302de(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 3 && (0, $hGXAo.isString)(match[2]) && match[2][0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0) return match[2] + (match[3] || "");
    }
    return fullHost;
}
function $28b13e86b931896f$export$eac70d47569302de(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 2 && (0, $hGXAo.isString)(match[2]) && match[2][0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0) {
            result = match[2] || "";
            if (inclPort && match[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 2) {
                var protocol = (match[1] || "")[0, $d8tQM._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") port = "";
                else if (protocol === "https" && port === ":443") port = "";
                result += port;
            }
        }
    }
    return result;
}

});


parcelRegister("cYGa2", function(module, exports) {

$parcel$export(module.exports, "parseConnectionString", function () { return $972bcae68b3cc124$export$6369f286b474466d; });
$parcel$export(module.exports, "ConnectionStringParser", function () { return $972bcae68b3cc124$export$9fc8be9be2105769; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");

var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");
var $972bcae68b3cc124$var$_FIELDS_SEPARATOR = ";";
var $972bcae68b3cc124$var$_FIELD_KEY_VALUE_SEPARATOR = "=";
function $972bcae68b3cc124$export$6369f286b474466d(connectionString) {
    if (!connectionString) return {};
    var kvPairs = connectionString[0, $d8tQM._DYN_SPLIT /* @min:%2esplit */ ]($972bcae68b3cc124$var$_FIELDS_SEPARATOR);
    var result = (0, $hGXAo.arrReduce)(kvPairs, function(fields, kv) {
        var kvParts = kv[0, $d8tQM._DYN_SPLIT /* @min:%2esplit */ ]($972bcae68b3cc124$var$_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] === 2) {
            var key = kvParts[0][0, $d8tQM._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if ((0, $hGXAo.objKeys)(result)[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] = result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
            if ((0, $hGXAo.strEndsWith)(result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ], "/")) result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] = result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ].slice(0, -1);
        }
        // apply the default endpoints
        result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] = result[0, $d8tQM._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] || (0, $cVsUj.DEFAULT_BREEZE_ENDPOINT);
    }
    return result;
}
var $972bcae68b3cc124$export$9fc8be9be2105769 = {
    parse: $972bcae68b3cc124$export$6369f286b474466d
};

});

parcelRegister("awDWn", function(module, exports) {

$parcel$export(module.exports, "Envelope", function () { return $7a9bdfec6dfb3289$export$4e2d65a9843399df; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");

var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $7a9bdfec6dfb3289$export$4e2d65a9843399df = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = (0, $i2MiW.dataSanitizeString)(logger, name) || (0, $cVsUj.strNotSpecified);
        _self.data = data;
        _self.time = (0, $hGXAo.toISOString)(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */ ,
            iKey: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            sampleRate: function() {
                return _this.sampleRate === 100 ? 4 /* FieldType.Hidden */  : 1 /* FieldType.Required */ ;
            },
            tags: 1 /* FieldType.Required */ ,
            data: 1 /* FieldType.Required */ 
        };
    }
    return Envelope;
}();

});

parcelRegister("9rbbk", function(module, exports) {

$parcel$export(module.exports, "Event", function () { return $6def4f255d43092d$export$d61e24a684f9e51; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $6def4f255d43092d$export$d61e24a684f9e51 = /** @class */ function() {
    /**
     * Constructs a new instance of the EventTelemetry object
     */ function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = (0, $i2MiW.dataSanitizeString)(logger, name) || (0, $cVsUj.strNotSpecified);
        _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
        _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}();

});

parcelRegister("g5yzi", function(module, exports) {

$parcel$export(module.exports, "Exception", function () { return $bb67ed820c674286$export$e2f174de097e0bcd; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $hGXAo = parcelRequire("hGXAo");

var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $bb67ed820c674286$var$NoMethod = "<no_method>";
var $bb67ed820c674286$var$strError = "error";
var $bb67ed820c674286$var$strStack = "stack";
var $bb67ed820c674286$var$strStackDetails = "stackDetails";
var $bb67ed820c674286$var$strErrorSrc = "errorSrc";
var $bb67ed820c674286$var$strMessage = "message";
var $bb67ed820c674286$var$strDescription = "description";
function $bb67ed820c674286$var$_stringify(value, convertToString) {
    var result = value;
    if (result && !(0, $hGXAo.isString)(result)) {
        if (JSON && JSON[0, $d8tQM._DYN_STRINGIFY /* @min:%2estringify */ ]) {
            result = JSON[0, $d8tQM._DYN_STRINGIFY /* @min:%2estringify */ ](value);
            if (convertToString && (!result || result === "{}")) {
                if ((0, $hGXAo.isFunction)(value[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ])) result = value[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]();
                else result = "" + value;
            }
        } else result = "" + value + " - (Missing JSON.stringify)";
    }
    return result || "";
}
function $bb67ed820c674286$var$_formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !(0, $hGXAo.isString)(evtMessage)) evtMessage = theEvent[$bb67ed820c674286$var$strMessage] || theEvent[$bb67ed820c674286$var$strDescription] || evtMessage;
        // Make sure the message is a string
        if (evtMessage && !(0, $hGXAo.isString)(evtMessage)) // tslint:disable-next-line: prefer-conditional-expression
        evtMessage = $bb67ed820c674286$var$_stringify(evtMessage, true);
        if (theEvent["filename"]) // Looks like an event object with filename
        evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "")[0, $d8tQM._DYN_INDEX_OF /* @min:%2eindexOf */ ](errorType) === -1) evtMessage = errorType + ": " + evtMessage;
    return evtMessage || "";
}
function $bb67ed820c674286$var$_isExceptionDetailsInternal(value) {
    try {
        if ((0, $hGXAo.isObject)(value)) return "hasFullStack" in value && "typeName" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $bb67ed820c674286$var$_isExceptionInternal(value) {
    try {
        if ((0, $hGXAo.isObject)(value)) return "ver" in value && "exceptions" in value && "properties" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $bb67ed820c674286$var$_isStackDetails(details) {
    return details && details.src && (0, $hGXAo.isString)(details.src) && details.obj && (0, $hGXAo.isArray)(details.obj);
}
function $bb67ed820c674286$var$_convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!(0, $hGXAo.isString)(src)) {
        if ((0, $hGXAo.isString)(src[$bb67ed820c674286$var$strStack])) src = src[$bb67ed820c674286$var$strStack];
        else src = "" + src;
    }
    var items = src[0, $d8tQM._DYN_SPLIT /* @min:%2esplit */ ]("\n");
    return {
        src: src,
        obj: items
    };
}
function $bb67ed820c674286$var$_getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[0, $d8tQM._DYN_SPLIT /* @min:%2esplit */ ]("\n");
    for(var lp = 0; lp < lines[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ]; lp++){
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function $bb67ed820c674286$var$_getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) try {
        /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */ if (errorObj[$bb67ed820c674286$var$strStack]) // Chrome/Firefox
        details = $bb67ed820c674286$var$_convertStackObj(errorObj[$bb67ed820c674286$var$strStack]);
        else if (errorObj[$bb67ed820c674286$var$strError] && errorObj[$bb67ed820c674286$var$strError][$bb67ed820c674286$var$strStack]) // Edge error event provides the stack and error object
        details = $bb67ed820c674286$var$_convertStackObj(errorObj[$bb67ed820c674286$var$strError][$bb67ed820c674286$var$strStack]);
        else if (errorObj["exception"] && errorObj.exception[$bb67ed820c674286$var$strStack]) details = $bb67ed820c674286$var$_convertStackObj(errorObj.exception[$bb67ed820c674286$var$strStack]);
        else if ($bb67ed820c674286$var$_isStackDetails(errorObj)) details = errorObj;
        else if ($bb67ed820c674286$var$_isStackDetails(errorObj[$bb67ed820c674286$var$strStackDetails])) details = errorObj[$bb67ed820c674286$var$strStackDetails];
        else if (window && window["opera"] && errorObj[$bb67ed820c674286$var$strMessage]) // Opera
        details = $bb67ed820c674286$var$_getOperaStack(errorObj[0, $d8tQM._DYN_MESSAGE /* @min:%2emessage */ ]);
        else if (errorObj["reason"] && errorObj.reason[$bb67ed820c674286$var$strStack]) // UnhandledPromiseRejection
        details = $bb67ed820c674286$var$_convertStackObj(errorObj.reason[$bb67ed820c674286$var$strStack]);
        else if ((0, $hGXAo.isString)(errorObj)) details = $bb67ed820c674286$var$_convertStackObj(errorObj);
        else {
            var evtMessage = errorObj[$bb67ed820c674286$var$strMessage] || errorObj[$bb67ed820c674286$var$strDescription] || "";
            if ((0, $hGXAo.isString)(errorObj[$bb67ed820c674286$var$strErrorSrc])) {
                if (evtMessage) evtMessage += "\n";
                evtMessage += " from " + errorObj[$bb67ed820c674286$var$strErrorSrc];
            }
            if (evtMessage) details = $bb67ed820c674286$var$_convertStackObj(evtMessage);
        }
    } catch (e) {
        // something unexpected happened so to avoid failing to report any error lets swallow the exception
        // and fallback to the callee/caller method
        details = $bb67ed820c674286$var$_convertStackObj(e);
    }
    return details || {
        src: "",
        obj: null
    };
}
function $bb67ed820c674286$var$_formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) (0, $hGXAo.arrForEach)(stackDetails.obj, function(entry) {
            stack += entry + "\n";
        });
        else stack = stackDetails.src || "";
    }
    return stack;
}
function $bb67ed820c674286$var$_parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        (0, $hGXAo.arrForEach)(frames, function(frame) {
            var theFrame = frame[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]();
            if ($bb67ed820c674286$export$b9d0519a34c90616.regex.test(theFrame)) {
                var parsedFrame = new $bb67ed820c674286$export$b9d0519a34c90616(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[0, $d8tQM._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ];
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32768;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while(left < right){
                // check size
                var lSize = parsedStack[left][0, $d8tQM._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ];
                var rSize = parsedStack[right][0, $d8tQM._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function $bb67ed820c674286$var$_getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] || "";
        if (!typeName) try {
            var funcNameRegex = /function (.{1,200})\(/;
            var results = funcNameRegex.exec(errorType.constructor[0, $d8tQM._DYN_TO_STRING /* @min:%2etoString */ ]());
            typeName = results && results[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 1 ? results[1] : "";
        } catch (e) {
        // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    return typeName;
}
function $bb67ed820c674286$export$7eb96e918bb60d21(errorObj) {
    if (errorObj) try {
        if (!(0, $hGXAo.isString)(errorObj)) {
            var errorType = $bb67ed820c674286$var$_getErrorType(errorObj);
            var result = $bb67ed820c674286$var$_stringify(errorObj, false);
            if (!result || result === "{}") {
                if (errorObj[$bb67ed820c674286$var$strError]) {
                    // Looks like an MS Error Event
                    errorObj = errorObj[$bb67ed820c674286$var$strError];
                    errorType = $bb67ed820c674286$var$_getErrorType(errorObj);
                }
                result = $bb67ed820c674286$var$_stringify(errorObj, true);
            }
            if (result[0, $d8tQM._DYN_INDEX_OF /* @min:%2eindexOf */ ](errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
            return result;
        }
    } catch (e) {
    // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var $bb67ed820c674286$export$e2f174de097e0bcd = /** @class */ function() {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */ function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            exceptions: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!$bb67ed820c674286$var$_isExceptionInternal(exception)) {
            if (!properties) properties = {};
            _self[0, $d8tQM._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] = [
                new $bb67ed820c674286$export$39152eac9dc76c5e(logger, exception, properties)
            ];
            _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
            _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
            if (severityLevel) _self[0, $d8tQM._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ] = severityLevel;
            if (id) _self.id = id;
        } else {
            _self[0, $d8tQM._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] = exception[0, $d8tQM._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] || [];
            _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = exception[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ];
            _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = exception[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ];
            if (exception[0, $d8tQM._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ]) _self[0, $d8tQM._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ] = exception[0, $d8tQM._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ];
            if (exception.id) _self.id = exception.id;
            if (exception[0, $d8tQM._DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */ ]) _self[0, $d8tQM._DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */ ] = exception[0, $d8tQM._DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */ ];
            // bool/int types, use isNullOrUndefined
            if (!(0, $hGXAo.isNullOrUndefined)(exception[0, $d8tQM._DYN_IS_MANUAL /* @min:%2eisManual */ ])) _self[0, $d8tQM._DYN_IS_MANUAL /* @min:%2eisManual */ ] = exception[0, $d8tQM._DYN_IS_MANUAL /* @min:%2eisManual */ ];
        }
    }
    Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = $bb67ed820c674286$var$_getErrorType(error || evt || message);
        return _a = {}, _a[0, $d8tQM._DYN_MESSAGE /* @min:message */ ] = $bb67ed820c674286$var$_formatMessage(message, errorType), _a.url = url, _a.lineNumber = lineNumber, _a.columnNumber = columnNumber, _a.error = $bb67ed820c674286$export$7eb96e918bb60d21(error || evt || message), _a.evt = $bb67ed820c674286$export$7eb96e918bb60d21(evt || message), _a[0, $d8tQM._DYN_TYPE_NAME /* @min:typeName */ ] = errorType, _a.stackDetails = $bb67ed820c674286$var$_getStackFromErrorObj(stack || error || evt), _a.errorSrc = errorSrc, _a;
    };
    Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
        var exceptions = exception[0, $d8tQM._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] && (0, $hGXAo.arrMap)(exception[0, $d8tQM._DYN_EXCEPTIONS /* @min:%2eexceptions */ ], function(ex) {
            return $bb67ed820c674286$export$39152eac9dc76c5e[0, $d8tQM._DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */ ](logger, ex);
        });
        var exceptionData = new Exception(logger, (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, exception), {
            exceptions: exceptions
        }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function() {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array && (0, $hGXAo.arrMap)(exceptions, function(exception) {
            return exception.toInterface();
        }) || undefined;
        return _a = {
            ver: "4.0"
        }, _a[0, $d8tQM._DYN_EXCEPTIONS /* @min:exceptions */ ] = exceptionDetailsInterface, _a.severityLevel = severityLevel, _a.properties = properties, _a.measurements = measurements, _a.problemGroup = problemGroup, _a.id = id, _a.isManual = isManual, _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */ Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {}, _a[0, $d8tQM._DYN_HAS_FULL_STACK /* @min:hasFullStack */ ] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = $bb67ed820c674286$export$7eb96e918bb60d21;
    return Exception;
}();
var $bb67ed820c674286$export$39152eac9dc76c5e = /** @class */ function() {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */ ,
            outerId: 0 /* FieldType.Default */ ,
            typeName: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            hasFullStack: 0 /* FieldType.Default */ ,
            stack: 0 /* FieldType.Default */ ,
            parsedStack: 2 /* FieldType.Array */ 
        };
        var _self = this;
        if (!$bb67ed820c674286$var$_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!(0, $hGXAo.isError)(error)) error = error[$bb67ed820c674286$var$strError] || evt || error;
            _self[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ] = (0, $i2MiW.dataSanitizeString)(logger, $bb67ed820c674286$var$_getErrorType(error)) || (0, $cVsUj.strNotSpecified);
            _self[0, $d8tQM._DYN_MESSAGE /* @min:%2emessage */ ] = (0, $i2MiW.dataSanitizeMessage)(logger, $bb67ed820c674286$var$_formatMessage(exception || error, _self[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ])) || (0, $cVsUj.strNotSpecified);
            var stack = exception[$bb67ed820c674286$var$strStackDetails] || $bb67ed820c674286$var$_getStackFromErrorObj(exception);
            _self[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] = $bb67ed820c674286$var$_parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if ((0, $hGXAo.isArray)(_self[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ])) (0, $hGXAo.arrMap)(_self[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ], function(frame) {
                frame[0, $d8tQM._DYN_ASSEMBLY /* @min:%2eassembly */ ] = (0, $i2MiW.dataSanitizeString)(logger, frame[0, $d8tQM._DYN_ASSEMBLY /* @min:%2eassembly */ ]);
                frame[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ] = (0, $i2MiW.dataSanitizeString)(logger, frame[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ]);
            });
            _self[$bb67ed820c674286$var$strStack] = (0, $i2MiW.dataSanitizeException)(logger, $bb67ed820c674286$var$_formatStackTrace(stack));
            _self.hasFullStack = (0, $hGXAo.isArray)(_self.parsedStack) && _self.parsedStack[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] > 0;
            if (properties) properties[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ] = properties[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ] || _self[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ];
        } else {
            _self[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ] = exception[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ];
            _self[0, $d8tQM._DYN_MESSAGE /* @min:%2emessage */ ] = exception[0, $d8tQM._DYN_MESSAGE /* @min:%2emessage */ ];
            _self[$bb67ed820c674286$var$strStack] = exception[$bb67ed820c674286$var$strStack];
            _self[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] = exception[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] || [];
            _self[0, $d8tQM._DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */ ] = exception[0, $d8tQM._DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */ ];
        }
    }
    _ExceptionDetails.prototype.toInterface = function() {
        var _a;
        var _self = this;
        var parsedStack = _self[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] instanceof Array && (0, $hGXAo.arrMap)(_self[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ], function(frame) {
            return frame.toInterface();
        });
        var exceptionDetailsInterface = (_a = {
            id: _self.id,
            outerId: _self.outerId,
            typeName: _self[0, $d8tQM._DYN_TYPE_NAME /* @min:%2etypeName */ ],
            message: _self[0, $d8tQM._DYN_MESSAGE /* @min:%2emessage */ ],
            hasFullStack: _self[0, $d8tQM._DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */ ],
            stack: _self[$bb67ed820c674286$var$strStack]
        }, _a[0, $d8tQM._DYN_PARSED_STACK /* @min:parsedStack */ ] = parsedStack || undefined, _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function(logger, exception) {
        var parsedStack = exception[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] instanceof Array && (0, $hGXAo.arrMap)(exception[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ], function(frame) {
            return $bb67ed820c674286$export$b9d0519a34c90616[0, $d8tQM._DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */ ](frame);
        }) || exception[0, $d8tQM._DYN_PARSED_STACK /* @min:%2eparsedStack */ ];
        var exceptionDetails = new _ExceptionDetails(logger, (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, exception), {
            parsedStack: parsedStack
        }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}();
var $bb67ed820c674286$export$b9d0519a34c90616 = /** @class */ function() {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */ ,
            method: 1 /* FieldType.Required */ ,
            assembly: 0 /* FieldType.Default */ ,
            fileName: 0 /* FieldType.Default */ ,
            line: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self[0, $d8tQM._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[0, $d8tQM._DYN_LEVEL /* @min:%2elevel */ ] = level;
            _self[0, $d8tQM._DYN_METHOD /* @min:%2emethod */ ] = $bb67ed820c674286$var$NoMethod;
            _self[0, $d8tQM._DYN_ASSEMBLY /* @min:%2eassembly */ ] = (0, $hGXAo.strTrim)(frame);
            _self[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ] = "";
            _self[0, $d8tQM._DYN_LINE /* @min:%2eline */ ] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ] >= 5) {
                _self[0, $d8tQM._DYN_METHOD /* @min:%2emethod */ ] = (0, $hGXAo.strTrim)(matches[2]) || _self[0, $d8tQM._DYN_METHOD /* @min:%2emethod */ ];
                _self[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ] = (0, $hGXAo.strTrim)(matches[4]);
                _self[0, $d8tQM._DYN_LINE /* @min:%2eline */ ] = parseInt(matches[5]) || 0;
            }
        } else {
            _self[0, $d8tQM._DYN_LEVEL /* @min:%2elevel */ ] = sourceFrame[0, $d8tQM._DYN_LEVEL /* @min:%2elevel */ ];
            _self[0, $d8tQM._DYN_METHOD /* @min:%2emethod */ ] = sourceFrame[0, $d8tQM._DYN_METHOD /* @min:%2emethod */ ];
            _self[0, $d8tQM._DYN_ASSEMBLY /* @min:%2eassembly */ ] = sourceFrame[0, $d8tQM._DYN_ASSEMBLY /* @min:%2eassembly */ ];
            _self[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ] = sourceFrame[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ];
            _self[0, $d8tQM._DYN_LINE /* @min:%2eline */ ] = sourceFrame[0, $d8tQM._DYN_LINE /* @min:%2eline */ ];
            _self[0, $d8tQM._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ] = 0;
        }
        _self.sizeInBytes += _self.method[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ];
        _self.sizeInBytes += _self.fileName[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ];
        _self.sizeInBytes += _self.assembly[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[0, $d8tQM._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ];
        _self.sizeInBytes += _self.line.toString()[0, $d8tQM._DYN_LENGTH /* @min:%2elength */ ];
    }
    _StackFrame.CreateFromInterface = function(frame) {
        return new _StackFrame(frame, null);
    };
    _StackFrame.prototype.toInterface = function() {
        var _self = this;
        return {
            level: _self[0, $d8tQM._DYN_LEVEL /* @min:%2elevel */ ],
            method: _self[0, $d8tQM._DYN_METHOD /* @min:%2emethod */ ],
            assembly: _self[0, $d8tQM._DYN_ASSEMBLY /* @min:%2eassembly */ ],
            fileName: _self[0, $d8tQM._DYN_FILE_NAME /* @min:%2efileName */ ],
            line: _self[0, $d8tQM._DYN_LINE /* @min:%2eline */ ]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}();

});

parcelRegister("jMj33", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $e661469805fe3351$export$efdd3e096bc27746; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");

var $bodpN = parcelRequire("bodpN");

var $i2MiW = parcelRequire("i2MiW");
var $e661469805fe3351$export$efdd3e096bc27746 = /** @class */ function() {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */ function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            metrics: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new (0, $bodpN.DataPoint)();
        dataPoint[0, $d8tQM._DYN_COUNT /* @min:%2ecount */ ] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = (0, $i2MiW.dataSanitizeString)(logger, name) || (0, $cVsUj.strNotSpecified);
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [
            dataPoint
        ];
        _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
        _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}();

});
parcelRegister("bodpN", function(module, exports) {

$parcel$export(module.exports, "DataPoint", function () { return $84ac5790492f4177$export$7e0232b0f089a6b8; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $84ac5790492f4177$export$7e0232b0f089a6b8 = /** @class */ function() {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            name: 1 /* FieldType.Required */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 1 /* FieldType.Required */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ 
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */ this.kind = 0 /* DataPointType.Measurement */ ;
    }
    return DataPoint;
}();

});


parcelRegister("czkZK", function(module, exports) {

$parcel$export(module.exports, "PageView", function () { return $92690a12c5720d0f$export$12c0fdede1c6bc6c; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $cVsUj = parcelRequire("cVsUj");

var $6bipl = parcelRequire("6bipl");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $92690a12c5720d0f$export$12c0fdede1c6bc6c = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            id: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = (0, $i2MiW.dataSanitizeId)(logger, id);
        _self.url = (0, $i2MiW.dataSanitizeUrl)(logger, url);
        _self[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = (0, $i2MiW.dataSanitizeString)(logger, name) || (0, $cVsUj.strNotSpecified);
        if (!isNaN(durationMs)) _self[0, $d8tQM._DYN_DURATION /* @min:%2eduration */ ] = (0, $6bipl.msToTimeSpan)(durationMs);
        _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
        _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}();

});

parcelRegister("cXuOT", function(module, exports) {

$parcel$export(module.exports, "RemoteDependencyData", function () { return $96f2e6e570499feb$export$a7b48490930dbffa; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $6bipl = parcelRequire("6bipl");

var $rOoAk = parcelRequire("rOoAk");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $96f2e6e570499feb$export$a7b48490930dbffa = /** @class */ function() {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */ function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) requestAPI = "Ajax";
        this.aiDataContract = {
            id: 1 /* FieldType.Required */ ,
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            resultCode: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            success: 0 /* FieldType.Default */ ,
            data: 0 /* FieldType.Default */ ,
            target: 0 /* FieldType.Default */ ,
            type: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 0 /* FieldType.Default */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ ,
            dependencyKind: 0 /* FieldType.Default */ ,
            dependencySource: 0 /* FieldType.Default */ ,
            commandName: 0 /* FieldType.Default */ ,
            dependencyTypeName: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[0, $d8tQM._DYN_DURATION /* @min:%2eduration */ ] = (0, $6bipl.msToTimeSpan)(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = (0, $i2MiW.dataSanitizeString)(logger, requestAPI);
        var dependencyFields = (0, $rOoAk.AjaxHelperParseDependencyPath)(logger, absoluteUrl, method, commandName);
        _self.data = (0, $i2MiW.dataSanitizeUrl)(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = (0, $i2MiW.dataSanitizeString)(logger, dependencyFields.target);
        if (correlationContext) _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        _self[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = (0, $i2MiW.dataSanitizeString)(logger, dependencyFields[0, $d8tQM._DYN_NAME /* @min:%2ename */ ]);
        _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
        _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}();

});

parcelRegister("7iT8I", function(module, exports) {

$parcel$export(module.exports, "Trace", function () { return $5514fc6de5ea4c64$export$78e1bea9036f120f; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $5514fc6de5ea4c64$export$78e1bea9036f120f = /** @class */ function() {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */ function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        message = message || (0, $cVsUj.strNotSpecified);
        _self[0, $d8tQM._DYN_MESSAGE /* @min:%2emessage */ ] = (0, $i2MiW.dataSanitizeMessage)(logger, message);
        _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
        _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
        if (severityLevel) _self[0, $d8tQM._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ] = severityLevel;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}();

});

parcelRegister("cAmBy", function(module, exports) {

$parcel$export(module.exports, "PageViewPerformance", function () { return $929a61a574031f2f$export$709aae57ec681346; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $cVsUj = parcelRequire("cVsUj");

var $d8tQM = parcelRequire("d8tQM");

var $i2MiW = parcelRequire("i2MiW");
var $929a61a574031f2f$export$709aae57ec681346 = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            perfTotal: 0 /* FieldType.Default */ ,
            networkConnect: 0 /* FieldType.Default */ ,
            sentRequest: 0 /* FieldType.Default */ ,
            receivedResponse: 0 /* FieldType.Default */ ,
            domProcessing: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.url = (0, $i2MiW.dataSanitizeUrl)(logger, url);
        _self[0, $d8tQM._DYN_NAME /* @min:%2ename */ ] = (0, $i2MiW.dataSanitizeString)(logger, name) || (0, $cVsUj.strNotSpecified);
        _self[0, $d8tQM._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $i2MiW.dataSanitizeProperties)(logger, properties);
        _self[0, $d8tQM._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $i2MiW.dataSanitizeMeasurements)(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[0, $d8tQM._DYN_DURATION /* @min:%2eduration */ ] = cs4BaseData[0, $d8tQM._DYN_DURATION /* @min:%2eduration */ ];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[0, $d8tQM._DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */ ] = cs4BaseData[0, $d8tQM._DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */ ];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}();

});

parcelRegister("03HBY", function(module, exports) {

$parcel$export(module.exports, "Data", function () { return $00b21c4958c4da62$export$2d0294657ab35f1b; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $00b21c4958c4da62$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            baseType: 1 /* FieldType.Required */ ,
            baseData: 1 /* FieldType.Required */ 
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}();

});

parcelRegister("fIGMW", function(module, exports) {

$parcel$export(module.exports, "SeverityLevel", function () { return $b71c27f0ce6464ae$export$ee93949637004a58; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4X2WW = parcelRequire("4X2WW");
var $b71c27f0ce6464ae$export$ee93949637004a58 = (0, $4X2WW.createEnumStyle)({
    Verbose: 0 /* eSeverityLevel.Verbose */ ,
    Information: 1 /* eSeverityLevel.Information */ ,
    Warning: 2 /* eSeverityLevel.Warning */ ,
    Error: 3 /* eSeverityLevel.Error */ ,
    Critical: 4 /* eSeverityLevel.Critical */ 
});

});

parcelRegister("hkZeA", function(module, exports) {

$parcel$export(module.exports, "ConfigurationManager", function () { return $c9f3cdc8f80e8443$export$20f75fb4cfd446c4; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");

var $d8tQM = parcelRequire("d8tQM");
var $c9f3cdc8f80e8443$export$20f75fb4cfd446c4 = /** @class */ function() {
    function ConfigurationManager() {}
    ConfigurationManager.getConfig = function(config, field, identifier, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var configValue;
        if (identifier && config[0, $d8tQM._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ] && config[0, $d8tQM._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ][identifier] && !(0, $hGXAo.isNullOrUndefined)(config[0, $d8tQM._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ][identifier][field])) configValue = config[0, $d8tQM._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ][identifier][field];
        else configValue = config[field];
        return !(0, $hGXAo.isNullOrUndefined)(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}();

});

parcelRegister("llS2C", function(module, exports) {

$parcel$export(module.exports, "ContextTagKeys", function () { return $f8b57aa0cb86a600$export$8e2bcdf18620784a; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $hGXAo = parcelRequire("hGXAo");
function $f8b57aa0cb86a600$var$_aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function(name) {
        return aiName + name;
    };
}
var $f8b57aa0cb86a600$var$_aiApplication = $f8b57aa0cb86a600$var$_aiNameFunc("application");
var $f8b57aa0cb86a600$var$_aiDevice = $f8b57aa0cb86a600$var$_aiNameFunc("device");
var $f8b57aa0cb86a600$var$_aiLocation = $f8b57aa0cb86a600$var$_aiNameFunc("location");
var $f8b57aa0cb86a600$var$_aiOperation = $f8b57aa0cb86a600$var$_aiNameFunc("operation");
var $f8b57aa0cb86a600$var$_aiSession = $f8b57aa0cb86a600$var$_aiNameFunc("session");
var $f8b57aa0cb86a600$var$_aiUser = $f8b57aa0cb86a600$var$_aiNameFunc("user");
var $f8b57aa0cb86a600$var$_aiCloud = $f8b57aa0cb86a600$var$_aiNameFunc("cloud");
var $f8b57aa0cb86a600$var$_aiInternal = $f8b57aa0cb86a600$var$_aiNameFunc("internal");
var $f8b57aa0cb86a600$export$8e2bcdf18620784a = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}((0, $hGXAo.createClassFromInterface)({
    applicationVersion: $f8b57aa0cb86a600$var$_aiApplication("ver"),
    applicationBuild: $f8b57aa0cb86a600$var$_aiApplication("build"),
    applicationTypeId: $f8b57aa0cb86a600$var$_aiApplication("typeId"),
    applicationId: $f8b57aa0cb86a600$var$_aiApplication("applicationId"),
    applicationLayer: $f8b57aa0cb86a600$var$_aiApplication("layer"),
    deviceId: $f8b57aa0cb86a600$var$_aiDevice("id"),
    deviceIp: $f8b57aa0cb86a600$var$_aiDevice("ip"),
    deviceLanguage: $f8b57aa0cb86a600$var$_aiDevice("language"),
    deviceLocale: $f8b57aa0cb86a600$var$_aiDevice("locale"),
    deviceModel: $f8b57aa0cb86a600$var$_aiDevice("model"),
    deviceFriendlyName: $f8b57aa0cb86a600$var$_aiDevice("friendlyName"),
    deviceNetwork: $f8b57aa0cb86a600$var$_aiDevice("network"),
    deviceNetworkName: $f8b57aa0cb86a600$var$_aiDevice("networkName"),
    deviceOEMName: $f8b57aa0cb86a600$var$_aiDevice("oemName"),
    deviceOS: $f8b57aa0cb86a600$var$_aiDevice("os"),
    deviceOSVersion: $f8b57aa0cb86a600$var$_aiDevice("osVersion"),
    deviceRoleInstance: $f8b57aa0cb86a600$var$_aiDevice("roleInstance"),
    deviceRoleName: $f8b57aa0cb86a600$var$_aiDevice("roleName"),
    deviceScreenResolution: $f8b57aa0cb86a600$var$_aiDevice("screenResolution"),
    deviceType: $f8b57aa0cb86a600$var$_aiDevice("type"),
    deviceMachineName: $f8b57aa0cb86a600$var$_aiDevice("machineName"),
    deviceVMName: $f8b57aa0cb86a600$var$_aiDevice("vmName"),
    deviceBrowser: $f8b57aa0cb86a600$var$_aiDevice("browser"),
    deviceBrowserVersion: $f8b57aa0cb86a600$var$_aiDevice("browserVersion"),
    locationIp: $f8b57aa0cb86a600$var$_aiLocation("ip"),
    locationCountry: $f8b57aa0cb86a600$var$_aiLocation("country"),
    locationProvince: $f8b57aa0cb86a600$var$_aiLocation("province"),
    locationCity: $f8b57aa0cb86a600$var$_aiLocation("city"),
    operationId: $f8b57aa0cb86a600$var$_aiOperation("id"),
    operationName: $f8b57aa0cb86a600$var$_aiOperation("name"),
    operationParentId: $f8b57aa0cb86a600$var$_aiOperation("parentId"),
    operationRootId: $f8b57aa0cb86a600$var$_aiOperation("rootId"),
    operationSyntheticSource: $f8b57aa0cb86a600$var$_aiOperation("syntheticSource"),
    operationCorrelationVector: $f8b57aa0cb86a600$var$_aiOperation("correlationVector"),
    sessionId: $f8b57aa0cb86a600$var$_aiSession("id"),
    sessionIsFirst: $f8b57aa0cb86a600$var$_aiSession("isFirst"),
    sessionIsNew: $f8b57aa0cb86a600$var$_aiSession("isNew"),
    userAccountAcquisitionDate: $f8b57aa0cb86a600$var$_aiUser("accountAcquisitionDate"),
    userAccountId: $f8b57aa0cb86a600$var$_aiUser("accountId"),
    userAgent: $f8b57aa0cb86a600$var$_aiUser("userAgent"),
    userId: $f8b57aa0cb86a600$var$_aiUser("id"),
    userStoreRegion: $f8b57aa0cb86a600$var$_aiUser("storeRegion"),
    userAuthUserId: $f8b57aa0cb86a600$var$_aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: $f8b57aa0cb86a600$var$_aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: $f8b57aa0cb86a600$var$_aiUser("authUserAcquisitionDate"),
    cloudName: $f8b57aa0cb86a600$var$_aiCloud("name"),
    cloudRole: $f8b57aa0cb86a600$var$_aiCloud("role"),
    cloudRoleVer: $f8b57aa0cb86a600$var$_aiCloud("roleVer"),
    cloudRoleInstance: $f8b57aa0cb86a600$var$_aiCloud("roleInstance"),
    cloudEnvironment: $f8b57aa0cb86a600$var$_aiCloud("environment"),
    cloudLocation: $f8b57aa0cb86a600$var$_aiCloud("location"),
    cloudDeploymentUnit: $f8b57aa0cb86a600$var$_aiCloud("deploymentUnit"),
    internalNodeName: $f8b57aa0cb86a600$var$_aiInternal("nodeName"),
    internalSdkVersion: $f8b57aa0cb86a600$var$_aiInternal("sdkVersion"),
    internalAgentVersion: $f8b57aa0cb86a600$var$_aiInternal("agentVersion"),
    internalSnippet: $f8b57aa0cb86a600$var$_aiInternal("snippet"),
    internalSdkSrc: $f8b57aa0cb86a600$var$_aiInternal("sdkSrc")
}));

});

parcelRegister("55exP", function(module, exports) {

$parcel$export(module.exports, "createTelemetryItem", function () { return $3b38b3a1aa8bd05e$export$2dc41327de8d98f1; });
$parcel$export(module.exports, "TelemetryItemCreator", function () { return $3b38b3a1aa8bd05e$export$7af32501561f3b4a; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $hGXAo = parcelRequire("hGXAo");

var $cVsUj = parcelRequire("cVsUj");

var $i2MiW = parcelRequire("i2MiW");

var $d8tQM = parcelRequire("d8tQM");
function $3b38b3a1aa8bd05e$export$2dc41327de8d98f1(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = (0, $i2MiW.dataSanitizeString)(logger, envelopeName) || (0, $cVsUj.strNotSpecified);
    if ((0, $hGXAo.isNullOrUndefined)(item) || (0, $hGXAo.isNullOrUndefined)(baseType) || (0, $hGXAo.isNullOrUndefined)(envelopeName)) (0, $hGXAo.throwError)("Input doesn't contain all required fields");
    var iKey = "";
    if (item[0, $cVsUj.strIkey]) {
        iKey = item[0, $cVsUj.strIkey];
        delete item[0, $cVsUj.strIkey];
    }
    var telemetryItem = (_a = {}, _a[0, $d8tQM._DYN_NAME /* @min:name */ ] = envelopeName, _a.time = (0, $hGXAo.toISOString)(new Date()), _a.iKey = iKey, _a.ext = systemProperties ? systemProperties : {}, _a.tags = [], _a.data = {}, _a.baseType = baseType, _a.baseData = item // Part B
    , _a);
    // Part C
    if (!(0, $hGXAo.isNullOrUndefined)(customProperties)) (0, $hGXAo.objForEachKey)(customProperties, function(prop, value) {
        telemetryItem.data[prop] = value;
    });
    return telemetryItem;
}
var $3b38b3a1aa8bd05e$export$7af32501561f3b4a = /** @class */ function() {
    function TelemetryItemCreator() {}
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */ TelemetryItemCreator.create = $3b38b3a1aa8bd05e$export$2dc41327de8d98f1;
    return TelemetryItemCreator;
}();

});

parcelRegister("cWQSw", function(module, exports) {

$parcel$export(module.exports, "Extensions", function () { return $96d3eb56d31bf46c$export$152f4bb29f8263d0; });
$parcel$export(module.exports, "CtxTagKeys", function () { return $96d3eb56d31bf46c$export$ebc7727f2a4272f6; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $llS2C = parcelRequire("llS2C");
var $96d3eb56d31bf46c$export$152f4bb29f8263d0 = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var $96d3eb56d31bf46c$export$ebc7727f2a4272f6 = new (0, $llS2C.ContextTagKeys)();

});


parcelRegister("dtXLi", function(module, exports) {

$parcel$export(module.exports, "BaseTelemetryPlugin", function () { return $9d0c5741de1fa07e$export$64a11c2f90e6766c; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $jx9Ci = parcelRequire("jx9Ci");

var $eOe4Z = parcelRequire("eOe4Z");
"use strict";
var $9d0c5741de1fa07e$var$strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */ var $9d0c5741de1fa07e$export$64a11c2f90e6766c = /** @class */ function() {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hooks;
        _initDefaults();
        (0, $bO3cR.default)(BaseTelemetryPlugin, _self, function(_self) {
            _self[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ] = function(unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $59IxV.STR_CORE /* @min:%2ecore */ ];
                if (!core || unloadCtx && core !== unloadCtx[0, $59IxV.STR_CORE /* @min:%2ecore */ ]()) // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                return;
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || (0, $jx9Ci.createProcessTelemetryUnloadContext)(null, core, _nextPlugin && _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin] ? _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                    reason: 0 /* TelemetryUnloadReason.ManualTeardown */ 
                }, _a[0, $j5TD0._DYN_IS_ASYNC /* @min:isAsync */ ] = false, _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        var oldHooks = _hooks;
                        _hooks = [];
                        // Remove all instrumentation hooks
                        (0, $hGXAo.arrForEach)(oldHooks, function(fn) {
                            fn.rm();
                        });
                        if (result === true) theUnloadCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUnloadState);
                        _initDefaults();
                    }
                }
                if (!_self[0, $j5TD0._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ] || _self[0, $j5TD0._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
                else // Tell the caller that we will be calling processNext()
                result = true;
                return result;
            };
            _self[0, $j5TD0._DYN_UPDATE /* @min:%2eupdate */ ] = function(updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $59IxV.STR_CORE /* @min:%2ecore */ ];
                if (!core || updateCtx && core !== updateCtx[0, $59IxV.STR_CORE /* @min:%2ecore */ ]()) // Do Nothing
                return;
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || (0, $jx9Ci.createProcessTelemetryUpdateContext)(null, core, _nextPlugin && _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin] ? _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */ 
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
                else result = true;
                return result;
            };
            _self._addHook = function(hooks) {
                if (hooks) {
                    if ((0, $hGXAo.isArray)(hooks)) _hooks = _hooks.concat(hooks);
                    else _hooks[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](hooks);
                }
            };
            (0, $hGXAo.proxyFunctionAs)(_self, "_addUnloadCb", function() {
                return _unloadHandlerContainer;
            }, "add");
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ] = function(itemCtx) {
            return _getTelCtx(itemCtx)[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ]();
        };
        _self[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = function() {
            return _isinitialized;
        };
        _self.setInitialized = function(isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[0, $j5TD0._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ] = function(next) {
            _nextPlugin = next;
        };
        _self[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = function(env, itemCtx) {
            if (itemCtx) // Normal core execution sequence
            itemCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](env);
            else if (_nextPlugin && (0, $hGXAo.isFunction)(_nextPlugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ])) // Looks like backward compatibility or out of band processing. And as it looks
            // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
            _nextPlugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ](env, null);
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) currentCtx = null;
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || (0, $jx9Ci.createProcessTelemetryContext)(null, {}, _self[0, $59IxV.STR_CORE /* @min:%2ecore */ ]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin]) // Looks like a chain object
                itemCtx = rootCtx[0, $j5TD0._DYN_CREATE_NEW /* @min:%2ecreateNew */ ](null, _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin]);
                else itemCtx = rootCtx[0, $j5TD0._DYN_CREATE_NEW /* @min:%2ecreateNew */ ](null, _nextPlugin);
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            if (config) // Make sure the extensionConfig exists
            (0, $hGXAo.setValue)(config, (0, $59IxV.STR_EXTENSION_CONFIG), [], null, (0, $hGXAo.isNullOrUndefined));
            if (!pluginChain && core) // Get the first plugin from the core
            pluginChain = core[0, $j5TD0._DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */ ]()[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]();
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin]) // If it looks like a proxy/chain then get the plugin
            nextPlugin = _nextPlugin[$9d0c5741de1fa07e$var$strGetPlugin]();
            // Support legacy plugins where core was defined as a property
            _self[0, $59IxV.STR_CORE /* @min:%2ecore */ ] = core;
            _rootCtx = (0, $jx9Ci.createProcessTelemetryContext)(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[0, $59IxV.STR_CORE /* @min:%2ecore */ ] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hooks = [];
            _unloadHandlerContainer = (0, $eOe4Z.createUnloadHandlerContainer)();
        }
    }
    // Removed Stub for BaseTelemetryPlugin.prototype.initialize.
    // Removed Stub for BaseTelemetryPlugin.prototype.teardown.
    // Removed Stub for BaseTelemetryPlugin.prototype.update.
    // Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
    // Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseTelemetryPlugin.__ieDyn = 1;
    return BaseTelemetryPlugin;
}();

});
parcelRegister("jx9Ci", function(module, exports) {

$parcel$export(module.exports, "createTelemetryProxyChain", function () { return $e3888f09142d01dd$export$107e639207cdf742; });
$parcel$export(module.exports, "createProcessTelemetryContext", function () { return $e3888f09142d01dd$export$ca98f11e981bcfd6; });
$parcel$export(module.exports, "createProcessTelemetryUnloadContext", function () { return $e3888f09142d01dd$export$91bbbd4999751948; });
$parcel$export(module.exports, "createProcessTelemetryUpdateContext", function () { return $e3888f09142d01dd$export$e4c32b40c4fbf98a; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $i86yL = parcelRequire("i86yL");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $4LGgU = parcelRequire("4LGgU");

var $8ZAtX = parcelRequire("8ZAtX");
"use strict";
var $e3888f09142d01dd$var$strTelemetryPluginChain = "TelemetryPluginChain";
var $e3888f09142d01dd$var$strHasRunFlags = "_hasRun";
var $e3888f09142d01dd$var$strGetTelCtx = "_getTelCtx";
var $e3888f09142d01dd$var$_chainId = 0;
function $e3888f09142d01dd$var$_getNextProxyStart(proxy, core, startAt) {
    while(proxy){
        if (proxy[0, $j5TD0._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ]() === startAt) return proxy;
        proxy = proxy[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return $e3888f09142d01dd$export$107e639207cdf742([
        startAt
    ], core[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ] || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param config
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */ function $e3888f09142d01dd$var$_createInternalContext(telemetryChain, config, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (startAt !== null) // There is no next element (null) vs not defined (undefined) so use the full chain
    _nextProxy = startAt ? $e3888f09142d01dd$var$_getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    var context = {
        _next: _moveNext,
        ctx: {
            core: function() {
                return core;
            },
            diagLog: function() {
                return (0, $i86yL.safeGetLogger)(core, config);
            },
            getCfg: function() {
                return config;
            },
            getExtCfg: _getExtCfg,
            getConfig: _getConfig,
            hasNext: function() {
                return !!_nextProxy;
            },
            getNext: function() {
                return _nextProxy;
            },
            setNext: function(nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        if (onComplete) _onComplete[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ]({
            func: onComplete,
            self: !(0, $hGXAo.isUndefined)(that) ? that : context.ctx,
            args: args
        });
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                (0, $hGXAo.arrForEach)(onComplete, function(completeDetails) {
                    try {
                        completeDetails.func[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](completeDetails.self, completeDetails.args);
                    } catch (e) {
                        (0, $i86yL._throwInternal)(core[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ], 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected Exception during onComplete - " + (0, $bU24K.dumpObj)(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, defaultValue, mergeDefault) {
        if (defaultValue === void 0) defaultValue = {};
        if (mergeDefault === void 0) mergeDefault = 0 /* GetExtCfgMergeType.None */ ;
        var theConfig;
        if (config) {
            var extConfig = config[0, $59IxV.STR_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ];
            if (extConfig && identifier) theConfig = extConfig[identifier];
        }
        if (!theConfig) // Just use the defaults
        theConfig = defaultValue;
        else if ((0, $hGXAo.isObject)(defaultValue)) {
            if (mergeDefault !== 0 /* GetExtCfgMergeType.None */ ) {
                // Merge the defaults and configured values
                var newConfig_1 = (0, $hGXAo.objExtend)(true, defaultValue, theConfig);
                if (config && mergeDefault === 2 /* GetExtCfgMergeType.MergeDefaultFromRootOrDefault */ ) // Enumerate over the defaultValues and if not already populated attempt to
                // find a value from the root config
                (0, $hGXAo.objForEachKey)(defaultValue, function(field) {
                    // for each unspecified field, set the default value
                    if ((0, $hGXAo.isNullOrUndefined)(newConfig_1[field])) {
                        var cfgValue = config[field];
                        if (!(0, $hGXAo.isNullOrUndefined)(cfgValue)) newConfig_1[field] = cfgValue;
                    }
                });
                theConfig = newConfig_1;
            }
        }
        return theConfig;
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var theValue;
        var extConfig = _getExtCfg(identifier, null);
        if (extConfig && !(0, $hGXAo.isNullOrUndefined)(extConfig[field])) theValue = extConfig[field];
        else if (config && !(0, $hGXAo.isNullOrUndefined)(config[field])) theValue = config[field];
        return !(0, $hGXAo.isNullOrUndefined)(theValue) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while(!!(nextPlugin = context._next())){
            var plugin = nextPlugin[0, $j5TD0._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ]();
            if (plugin) // callback with the current on
            cb(plugin);
        }
    }
    return context;
}
function $e3888f09142d01dd$export$ca98f11e981bcfd6(telemetryChain, config, core, startAt) {
    var internalContext = $e3888f09142d01dd$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        // Run the next plugin which will call "processNext()"
        nextPlugin && nextPlugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ](env, context);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $hGXAo.isArray)(plugins)) plugins = $e3888f09142d01dd$export$107e639207cdf742(plugins, config, core, startAt);
        return $e3888f09142d01dd$export$ca98f11e981bcfd6(plugins || context[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ](), config, core, startAt);
    }
    context[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $j5TD0._DYN_CREATE_NEW /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $e3888f09142d01dd$export$91bbbd4999751948(telemetryChain, core, startAt) {
    var config = core[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ] || {};
    var internalContext = $e3888f09142d01dd$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin.unload(context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $hGXAo.isArray)(plugins)) plugins = $e3888f09142d01dd$export$107e639207cdf742(plugins, config, core, startAt);
        return $e3888f09142d01dd$export$91bbbd4999751948(plugins || context[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $j5TD0._DYN_CREATE_NEW /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $e3888f09142d01dd$export$e4c32b40c4fbf98a(telemetryChain, core, startAt) {
    var config = core[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ] || {};
    var internalContext = $e3888f09142d01dd$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function(plugin) {
            if ((0, $hGXAo.isFunction)(plugin[0, $j5TD0._DYN_UPDATE /* @min:%2eupdate */ ])) plugin[0, $j5TD0._DYN_UPDATE /* @min:%2eupdate */ ](context, updateState);
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $hGXAo.isArray)(plugins)) plugins = $e3888f09142d01dd$export$107e639207cdf742(plugins, config, core, startAt);
        return $e3888f09142d01dd$export$e4c32b40c4fbf98a(plugins || context[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $j5TD0._DYN_CREATE_NEW /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $e3888f09142d01dd$export$107e639207cdf742(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if ((0, $hGXAo.isArray)(plugins) && plugins[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        (0, $hGXAo.arrForEach)(plugins, function(thePlugin) {
            if (!add && startAt === thePlugin) add = true;
            if (add && thePlugin && (0, $hGXAo.isFunction)(thePlugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ])) {
                // Only add plugins that are processors
                var newProxy = $e3888f09142d01dd$export$7f7b955927f4ae5e(thePlugin, config, core);
                if (!firstProxy) firstProxy = newProxy;
                if (lastProxy_1) // Set this new proxy as the next for the previous one
                lastProxy_1._setNext(newProxy);
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) // Special case where the "startAt" was not in the original list of plugins
    return $e3888f09142d01dd$export$107e639207cdf742([
        startAt
    ], config, core);
    return firstProxy;
}
function $e3888f09142d01dd$export$7f7b955927f4ae5e(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = (0, $hGXAo.isFunction)(plugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ]);
    var hasSetNext = (0, $hGXAo.isFunction)(plugin[0, $j5TD0._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ]);
    var chainId;
    if (plugin) chainId = plugin[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ] + "-" + plugin[0, $59IxV.STR_PRIORITY /* @min:%2epriority */ ] + "-" + $e3888f09142d01dd$var$_chainId++;
    else chainId = "Unknown-0-" + $e3888f09142d01dd$var$_chainId++;
    var proxyChain = {
        getPlugin: function() {
            return plugin;
        },
        getNext: function() {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function(nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && (0, $hGXAo.isFunction)(plugin[$e3888f09142d01dd$var$strGetTelCtx])) // This plugin extends from the BaseTelemetryPlugin so lets use it
        itemCtx = plugin[$e3888f09142d01dd$var$strGetTelCtx]();
        if (!itemCtx) // Create a temporary one
        itemCtx = $e3888f09142d01dd$export$ca98f11e981bcfd6(proxyChain, config, core);
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ] : $e3888f09142d01dd$var$strTelemetryPluginChain;
        var hasRunContext = itemCtx[$e3888f09142d01dd$var$strHasRunFlags];
        if (!hasRunContext) // Assign and populate
        hasRunContext = itemCtx[$e3888f09142d01dd$var$strHasRunFlags] = {};
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) (0, $4LGgU.doPerf)(itemCtx[0, $59IxV.STR_CORE /* @min:%2ecore */ ](), function() {
            return identifier + ":" + name;
        }, function() {
            // Mark this component as having run
            hasRunContext[chainId] = true;
            try {
                // Set a flag on the next plugin so we know if it was attempted to be executed
                var nextId = nextProxy ? nextProxy._id : (0, $59IxV.STR_EMPTY);
                if (nextId) hasRunContext[nextId] = false;
                hasRun = processPluginFn(itemCtx);
            } catch (error) {
                var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                if (hasNextRun) // The next plugin after us has already run so set this one as complete
                hasRun = true;
                if (!nextProxy || !hasNextRun) // Either we have no next plugin or the current one did not attempt to call the next plugin
                // Which means the current one is the root of the failure so log/report this failure
                (0, $i86yL._throwInternal)(itemCtx[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 73 /* _eInternalMessageId.PluginException */ , "Plugin [" + identifier + "] failed during " + name + " - " + (0, $bU24K.dumpObj)(error) + ", run flags: " + (0, $bU24K.dumpObj)(hasRunContext));
            }
        }, details, isAsync);
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) return false;
            var pluginState = (0, $8ZAtX._getPluginState)(plugin);
            if (pluginState[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ] || pluginState[0, $59IxV.STR_DISABLED]) return false;
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) // Backward compatibility setting the next plugin on the instance
            plugin[0, $j5TD0._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ](nextProxy);
            plugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
            return {
                item: env
            };
        }, !env.sync)) // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
        // so we still want the next plugin to be executed.
        itemCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](env);
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $8ZAtX._getPluginState)(plugin);
                var pluginCore = plugin[0, $59IxV.STR_CORE] || pluginState[0, $59IxV.STR_CORE /* @min:%2ecore */ ];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[0, $59IxV.STR_CORE /* @min:%2ecore */ ] = null;
                    pluginState[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ] = true;
                    pluginState[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = false;
                    if (plugin[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ] && plugin[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ](unloadCtx, unloadState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function() {}, unloadState[0, $j5TD0._DYN_IS_ASYNC /* @min:%2eisAsync */ ])) // Only called if we hasRun was not true
        unloadCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](unloadState);
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $8ZAtX._getPluginState)(plugin);
                var pluginCore = plugin[0, $59IxV.STR_CORE] || pluginState[0, $59IxV.STR_CORE /* @min:%2ecore */ ];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ]) {
                    if (plugin[0, $j5TD0._DYN_UPDATE /* @min:%2eupdate */ ] && plugin[0, $j5TD0._DYN_UPDATE /* @min:%2eupdate */ ](updateCtx, updateState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function() {}, false)) // Only called if we hasRun was not true
        updateCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](updateState);
    }
    return (0, $hGXAo.objFreeze)(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */ var $e3888f09142d01dd$export$7c2ac74a00234af1 = /** @class */ function() {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */ function ProcessTelemetryContext(pluginChain, config, core, startAt) {
        var _self = this;
        var context = $e3888f09142d01dd$export$ca98f11e981bcfd6(pluginChain, config, core, startAt);
        // Proxy all functions of the context to this object
        (0, $hGXAo.proxyFunctions)(_self, context, (0, $hGXAo.objKeys)(context));
    }
    return ProcessTelemetryContext;
}();

});
parcelRegister("4LGgU", function(module, exports) {

$parcel$export(module.exports, "PerfManager", function () { return $378c577b02d2c347$export$cbeb6df2e8e9b5ae; });
$parcel$export(module.exports, "doPerf", function () { return $378c577b02d2c347$export$c6fbeb260600c482; });
$parcel$export(module.exports, "getGblPerfMgr", function () { return $378c577b02d2c347$export$6cdbf3f34ace6568; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
var $378c577b02d2c347$var$strExecutionContextKey = "ctx";
var $378c577b02d2c347$var$strParentContextKey = "ParentContextKey";
var $378c577b02d2c347$var$strChildrenContextKey = "ChildrenContextKey";
var $378c577b02d2c347$var$_defaultPerfManager = null;
var $378c577b02d2c347$export$e3556d2ce46cdae0 = /** @class */ function() {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = (0, $hGXAo.dateNow)();
        _self[0, $j5TD0._DYN_NAME /* @min:%2ename */ ] = name;
        _self[0, $j5TD0._DYN_IS_ASYNC /* @min:%2eisAsync */ ] = isAsync;
        _self[0, $j5TD0._DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */ ] = function() {
            return false;
        };
        if ((0, $hGXAo.isFunction)(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = (0, $hGXAo.objDefineAccessors)(_self, "payload", function() {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && (0, $hGXAo.isFunction)(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self[0, $j5TD0._DYN_GET_CTX /* @min:%2egetCtx */ ] = function(key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$378c577b02d2c347$var$strParentContextKey] || key === PerfEvent[$378c577b02d2c347$var$strChildrenContextKey]) return _self[key];
                return (_self[$378c577b02d2c347$var$strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ] = function(key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$378c577b02d2c347$var$strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) _self[0, $j5TD0._DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */ ] = function() {
                        return true;
                    };
                    _self[key] = value;
                } else if (key === PerfEvent[$378c577b02d2c347$var$strChildrenContextKey]) _self[key] = value;
                else {
                    var ctx = _self[$378c577b02d2c347$var$strExecutionContextKey] = _self[$378c577b02d2c347$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[0, $j5TD0._DYN_COMPLETE /* @min:%2ecomplete */ ] = function() {
            var childTime = 0;
            var childEvts = _self[0, $j5TD0._DYN_GET_CTX /* @min:%2egetCtx */ ](PerfEvent[$378c577b02d2c347$var$strChildrenContextKey]);
            if ((0, $hGXAo.isArray)(childEvts)) for(var lp = 0; lp < childEvts[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ]; lp++){
                var childEvt = childEvts[lp];
                if (childEvt) childTime += childEvt[0, $j5TD0._DYN_TIME /* @min:%2etime */ ];
            }
            _self[0, $j5TD0._DYN_TIME /* @min:%2etime */ ] = (0, $hGXAo.dateNow)() - _self.start;
            _self.exTime = _self[0, $j5TD0._DYN_TIME /* @min:%2etime */ ] - childTime;
            _self[0, $j5TD0._DYN_COMPLETE /* @min:%2ecomplete */ ] = function() {};
            if (!accessorDefined && (0, $hGXAo.isFunction)(payloadDetails)) // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
            _self.payload = payloadDetails();
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}();
var $378c577b02d2c347$export$cbeb6df2e8e9b5ae = /** @class */ function() {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */ this.ctx = {};
        (0, $bO3cR.default)(PerfManager, this, function(_self) {
            _self.create = function(src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new $378c577b02d2c347$export$e3556d2ce46cdae0(src, payloadDetails, isAsync);
            };
            _self.fire = function(perfEvent) {
                if (perfEvent) {
                    perfEvent[0, $j5TD0._DYN_COMPLETE /* @min:%2ecomplete */ ]();
                    if (manager && (0, $hGXAo.isFunction)(manager[0, $59IxV.STR_PERF_EVENT /* @min:%2eperfEvent */ ])) manager[0, $59IxV.STR_PERF_EVENT /* @min:%2eperfEvent */ ](perfEvent);
                }
            };
            _self[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ] = function(key, value) {
                if (key) {
                    var ctx = _self[$378c577b02d2c347$var$strExecutionContextKey] = _self[$378c577b02d2c347$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[0, $j5TD0._DYN_GET_CTX /* @min:%2egetCtx */ ] = function(key) {
                return (_self[$378c577b02d2c347$var$strExecutionContextKey] || {})[key];
            };
        });
    }
    // Removed Stub for PerfManager.prototype.create.
    // Removed Stub for PerfManager.prototype.fire.
    // Removed Stub for PerfManager.prototype.setCtx.
    // Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PerfManager.__ieDyn = 1;
    return PerfManager;
}();
var $378c577b02d2c347$var$doPerfActiveKey = "CoreUtils.doPerf";
function $378c577b02d2c347$export$c6fbeb260600c482(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[0, $59IxV.STR_GET_PERF_MGR]) // Looks like a perf manager provider object
        perfMgr = perfMgr[0, $59IxV.STR_GET_PERF_MGR]();
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[0, $j5TD0._DYN_GET_CTX /* @min:%2egetCtx */ ]($378c577b02d2c347$var$doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]) {
                        perfEvt[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]($378c577b02d2c347$export$e3556d2ce46cdae0[$378c577b02d2c347$var$strParentContextKey], currentActive);
                        if (currentActive[0, $j5TD0._DYN_GET_CTX /* @min:%2egetCtx */ ] && currentActive[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]) {
                            var children = currentActive[0, $j5TD0._DYN_GET_CTX /* @min:%2egetCtx */ ]($378c577b02d2c347$export$e3556d2ce46cdae0[$378c577b02d2c347$var$strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]($378c577b02d2c347$export$e3556d2ce46cdae0[$378c577b02d2c347$var$strChildrenContextKey], children);
                            }
                            children[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]($378c577b02d2c347$var$doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            } catch (ex) {
                if (perfEvt && perfEvt[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]) perfEvt[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]("exception", ex);
            } finally{
                // fire the perf event
                if (perfEvt) perfMgr.fire(perfEvt);
                // Reset the active event to the previous value
                perfMgr[0, $j5TD0._DYN_SET_CTX /* @min:%2esetCtx */ ]($378c577b02d2c347$var$doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
function $378c577b02d2c347$export$1e94af82fd6977f1(perfManager) {
    $378c577b02d2c347$var$_defaultPerfManager = perfManager;
}
function $378c577b02d2c347$export$6cdbf3f34ace6568() {
    return $378c577b02d2c347$var$_defaultPerfManager;
}

});

parcelRegister("8ZAtX", function(module, exports) {

$parcel$export(module.exports, "_getPluginState", function () { return $68c051d73dd28077$export$37cfaecb9b4b1b3b; });
$parcel$export(module.exports, "initializePlugins", function () { return $68c051d73dd28077$export$be211df7b1eeb33e; });
$parcel$export(module.exports, "sortPlugins", function () { return $68c051d73dd28077$export$478771939b7b39a2; });
$parcel$export(module.exports, "createDistributedTraceContext", function () { return $68c051d73dd28077$export$10fa4480433f402c; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $5GGqM = parcelRequire("5GGqM");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $cseB2 = parcelRequire("cseB2");
"use strict";
var $68c051d73dd28077$var$pluginStateData = (0, $5GGqM.createElmNodeData)("plugin");
function $68c051d73dd28077$export$37cfaecb9b4b1b3b(plugin) {
    return $68c051d73dd28077$var$pluginStateData.get(plugin, "state", {}, true);
}
function $68c051d73dd28077$export$be211df7b1eeb33e(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]();
    var pluginState;
    while(proxy){
        var thePlugin = proxy[0, $j5TD0._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ]();
        if (thePlugin) {
            if (lastPlugin && (0, $hGXAo.isFunction)(lastPlugin[0, $j5TD0._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ]) && (0, $hGXAo.isFunction)(thePlugin[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ])) // Set this plugin as the next for the previous one
            lastPlugin[0, $j5TD0._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ](thePlugin);
            var isInitialized = false;
            if ((0, $hGXAo.isFunction)(thePlugin[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ])) isInitialized = thePlugin[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ]();
            else {
                pluginState = $68c051d73dd28077$export$37cfaecb9b4b1b3b(thePlugin);
                isInitialized = pluginState[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ];
            }
            if (!isInitialized) initPlugins[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](thePlugin);
            lastPlugin = thePlugin;
            proxy = proxy[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]();
        }
    }
    // Now initialize the plugins
    (0, $hGXAo.arrForEach)(initPlugins, function(thePlugin) {
        var core = processContext[0, $59IxV.STR_CORE]();
        thePlugin[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ](processContext.getCfg(), core, extensions, processContext[0, $j5TD0._DYN_GET_NEXT /* @min:%2egetNext */ ]());
        pluginState = $68c051d73dd28077$export$37cfaecb9b4b1b3b(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extent from BaseTelemetryPlugin)
        if (!thePlugin[0, $59IxV.STR_CORE] && !pluginState[0, $59IxV.STR_CORE]) pluginState[0, $59IxV.STR_CORE] = core;
        pluginState[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = true;
        delete pluginState[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ];
    });
}
function $68c051d73dd28077$export$478771939b7b39a2(plugins) {
    // Sort by priority
    return plugins.sort(function(extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = (0, $hGXAo.isFunction)(extB[0, $59IxV.STR_PROCESS_TELEMETRY]);
            if ((0, $hGXAo.isFunction)(extA[0, $59IxV.STR_PROCESS_TELEMETRY])) result = bHasProcess ? extA[0, $59IxV.STR_PRIORITY] - extB[0, $59IxV.STR_PRIORITY] : 1;
            else if (bHasProcess) result = -1;
        } else result = extA ? 1 : -1;
        return result;
    });
// sort complete
}
function $68c051d73dd28077$export$24978f1b175640d9(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while(idx < components[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ]){
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[0, $j5TD0._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ];
                if ((0, $hGXAo.isFunction)(func)) {
                    if (func[0, $j5TD0._DYN_CALL /* @min:%2ecall */ ](component, unloadCtx, unloadState, _doUnload) === true) return true;
                }
            }
        }
    }
    return _doUnload();
}
function $68c051d73dd28077$export$10fa4480433f402c(parentCtx) {
    var trace = {};
    return {
        getName: function() {
            return trace[0, $j5TD0._DYN_NAME /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $j5TD0._DYN_NAME /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace[0, $j5TD0._DYN_TRACE_ID /* @min:%2etraceId */ ];
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $cseB2.isValidTraceId)(newValue)) trace[0, $j5TD0._DYN_TRACE_ID /* @min:%2etraceId */ ] = newValue;
        },
        getSpanId: function() {
            return trace[0, $j5TD0._DYN_SPAN_ID /* @min:%2espanId */ ];
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $cseB2.isValidSpanId)(newValue)) trace[0, $j5TD0._DYN_SPAN_ID /* @min:%2espanId */ ] = newValue;
        },
        getTraceFlags: function() {
            return trace[0, $j5TD0._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[0, $j5TD0._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = newTraceFlags;
        }
    };
}

});


parcelRegister("eOe4Z", function(module, exports) {

$parcel$export(module.exports, "createUnloadHandlerContainer", function () { return $ac80a8154871e542$export$1dd1604aeaf8cfed; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $j5TD0 = parcelRequire("j5TD0");

var $i86yL = parcelRequire("i86yL");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");
function $ac80a8154871e542$export$1dd1604aeaf8cfed() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) handlers[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](handler);
    }
    function _runHandlers(unloadCtx, unloadState) {
        (0, $hGXAo.arrForEach)(handlers, function(handler) {
            try {
                handler(unloadCtx, unloadState);
            } catch (e) {
                (0, $i86yL._throwInternal)(unloadCtx[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected error calling unload handler - " + (0, $bU24K.dumpObj)(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}

});


parcelRegister("77mRF", function(module, exports) {

$parcel$export(module.exports, "InstrumentProto", function () { return $52eaec46a1db39f7$export$6b32104a5f4313f6; });
$parcel$export(module.exports, "InstrumentFunc", function () { return $52eaec46a1db39f7$export$152e6c4c396a57a; });
$parcel$export(module.exports, "InstrumentEvent", function () { return $52eaec46a1db39f7$export$b96f6cbe9b035430; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $82FQ4 = parcelRequire("82FQ4");

var $j5TD0 = parcelRequire("j5TD0");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");
var $52eaec46a1db39f7$var$aiInstrumentHooks = "_aiHooks";
var $52eaec46a1db39f7$var$cbNames = [
    "req",
    "rsp",
    "hkErr",
    "fnErr"
];
/** @ignore */ function $52eaec46a1db39f7$var$_arrLoop(arr, fn) {
    if (arr) for(var lp = 0; lp < arr[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ]; lp++){
        if (fn(arr[lp], lp)) break;
    }
}
/** @ignore */ function $52eaec46a1db39f7$var$_doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */  && type <= 2 /* CallbackType.HookError */ ) $52eaec46a1db39f7$var$_arrLoop(hooks, function(hook, idx) {
        var cbks = hook.cbks;
        var cb = cbks[$52eaec46a1db39f7$var$cbNames[type]];
        if (cb) {
            // Set the specific hook context implementation using a lazy creation pattern
            callDetails.ctx = function() {
                var ctx = hookCtx[idx] = hookCtx[idx] || {};
                return ctx;
            };
            try {
                cb[0, $j5TD0._DYN_APPLY /* @min:%2eapply */ ](callDetails.inst, cbArgs);
            } catch (err) {
                var orgEx = callDetails.err;
                try {
                    // Report Hook error via the callback
                    var hookErrorCb = cbks[$52eaec46a1db39f7$var$cbNames[2 /* CallbackType.HookError */ ]];
                    if (hookErrorCb) {
                        callDetails.err = err;
                        hookErrorCb[0, $j5TD0._DYN_APPLY /* @min:%2eapply */ ](callDetails.inst, cbArgs);
                    }
                } catch (e) {
                // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                } finally{
                    // restore the original exception (if any)
                    callDetails.err = orgEx;
                }
            }
        }
    });
}
/** @ignore */ function $52eaec46a1db39f7$var$_createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function() {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {}, _a[0, $j5TD0._DYN_NAME /* @min:name */ ] = aiHook.n, _a.inst = funcThis, _a.ctx = null, _a.set = _replaceArg, _a);
        var hookCtx = [];
        var cbArgs = _createArgs([
            funcArgs
        ], orgArgs);
        funcArgs.evt = (0, $bU24K.getGlobalInst)("event");
        function _createArgs(target, theArgs) {
            $52eaec46a1db39f7$var$_arrLoop(theArgs, function(arg) {
                target[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([
                funcArgs
            ], orgArgs);
        }
        // Call the pre-request hooks
        $52eaec46a1db39f7$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */ );
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) try {
            funcArgs.rslt = theFunc[0, $j5TD0._DYN_APPLY /* @min:%2eapply */ ](funcThis, orgArgs);
        } catch (err) {
            // Report the request callback
            funcArgs.err = err;
            $52eaec46a1db39f7$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */ );
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        $52eaec46a1db39f7$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */ );
        return funcArgs.rslt;
    };
}
/** @ignore */ function $52eaec46a1db39f7$var$_getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if ((0, $hGXAo.hasOwnProperty)(target, name)) owner = target;
        else if (checkPrototype) owner = $52eaec46a1db39f7$var$_getOwner((0, $hGXAo._getObjProto)(target), name, checkParentProto, false);
    }
    return owner;
}
function $52eaec46a1db39f7$export$6b32104a5f4313f6(target, funcName, callbacks) {
    if (target) return $52eaec46a1db39f7$export$152e6c4c396a57a(target[0, $82FQ4.strShimPrototype], funcName, callbacks, false);
    return null;
}
function $52eaec46a1db39f7$export$aaa214566a8b50d(target, funcNames, callbacks) {
    if (target) return $52eaec46a1db39f7$export$3bccad25f6aafea4(target[0, $82FQ4.strShimPrototype], funcNames, callbacks, false);
    return null;
}
function $52eaec46a1db39f7$var$_createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[$52eaec46a1db39f7$var$aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = $52eaec46a1db39f7$var$_createFunctionHook(aiHook);
        newFunc[$52eaec46a1db39f7$var$aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function() {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            $52eaec46a1db39f7$var$_arrLoop(aiHook.h, function(hook, idx) {
                if (hook.id === id) {
                    aiHook.h[0, $j5TD0._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                    return 1;
                }
            });
        }
    };
    aiHook.i++;
    aiHook.h[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](theHook);
    return theHook;
}
function $52eaec46a1db39f7$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    if (target && funcName && callbacks) {
        var owner = $52eaec46a1db39f7$var$_getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === (0, $82FQ4.strShimFunction)) return $52eaec46a1db39f7$var$_createInstrumentHook(owner, funcName, fn, callbacks);
        }
    }
    return null;
}
function $52eaec46a1db39f7$export$3bccad25f6aafea4(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    var hooks = null;
    $52eaec46a1db39f7$var$_arrLoop(funcNames, function(funcName) {
        var hook = $52eaec46a1db39f7$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) hooks = [];
            hooks[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](hook);
        }
    });
    return hooks;
}
function $52eaec46a1db39f7$export$b96f6cbe9b035430(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = $52eaec46a1db39f7$var$_getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) return $52eaec46a1db39f7$var$_createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
    return null;
}

});

parcelRegister("h90r2", function(module, exports) {

$parcel$export(module.exports, "_DYN_TO_STRING", function () { return $c7b39d59aa5a7f60$export$e2818d11505fa034; });
$parcel$export(module.exports, "_DYN_DISABLE_EXCEPTION_TR0", function () { return $c7b39d59aa5a7f60$export$f8c520424f754c1c; });
$parcel$export(module.exports, "_DYN_AUTO_TRACK_PAGE_VISI1", function () { return $c7b39d59aa5a7f60$export$65bc351810f367dc; });
$parcel$export(module.exports, "_DYN_OVERRIDE_PAGE_VIEW_D2", function () { return $c7b39d59aa5a7f60$export$d0a26b7eaadd0d4e; });
$parcel$export(module.exports, "_DYN_ENABLE_UNHANDLED_PRO3", function () { return $c7b39d59aa5a7f60$export$4f55a24a56b3d5ca; });
$parcel$export(module.exports, "_DYN_SAMPLING_PERCENTAGE", function () { return $c7b39d59aa5a7f60$export$51ccd61d31b31ade; });
$parcel$export(module.exports, "_DYN_IS_STORAGE_USE_DISAB4", function () { return $c7b39d59aa5a7f60$export$c8f0ddf05bfb48a8; });
$parcel$export(module.exports, "_DYN_IS_BROWSER_LINK_TRAC5", function () { return $c7b39d59aa5a7f60$export$8f81e2d5093195fc; });
$parcel$export(module.exports, "_DYN_ENABLE_AUTO_ROUTE_TR6", function () { return $c7b39d59aa5a7f60$export$2c102e3a86379a7; });
$parcel$export(module.exports, "_DYN_NAME_PREFIX", function () { return $c7b39d59aa5a7f60$export$6d013a7bc2da53c1; });
$parcel$export(module.exports, "_DYN_DISABLE_FLUSH_ON_BEF7", function () { return $c7b39d59aa5a7f60$export$9173a290c0626b54; });
$parcel$export(module.exports, "_DYN_CORE", function () { return $c7b39d59aa5a7f60$export$f9ae8d0acf86503e; });
$parcel$export(module.exports, "_DYN_DATA_TYPE", function () { return $c7b39d59aa5a7f60$export$9e16762ab4f2648; });
$parcel$export(module.exports, "_DYN_ENVELOPE_TYPE", function () { return $c7b39d59aa5a7f60$export$2672d4f7ccc80348; });
$parcel$export(module.exports, "_DYN_DIAG_LOG", function () { return $c7b39d59aa5a7f60$export$c7ff2c36e5c78421; });
$parcel$export(module.exports, "_DYN_TRACK", function () { return $c7b39d59aa5a7f60$export$548634e98b3af9c4; });
$parcel$export(module.exports, "_DYN_TRACK_PAGE_VIEW", function () { return $c7b39d59aa5a7f60$export$ab1a8669316b7a02; });
$parcel$export(module.exports, "_DYN_TRACK_PREVIOUS_PAGE_9", function () { return $c7b39d59aa5a7f60$export$e468e9c9816152cf; });
$parcel$export(module.exports, "_DYN_SEND_PAGE_VIEW_INTER10", function () { return $c7b39d59aa5a7f60$export$a6c6e891ce0a5106; });
$parcel$export(module.exports, "_DYN_SEND_PAGE_VIEW_PERFO11", function () { return $c7b39d59aa5a7f60$export$982b1825c068e342; });
$parcel$export(module.exports, "_DYN_POPULATE_PAGE_VIEW_P12", function () { return $c7b39d59aa5a7f60$export$81995f88bf49a98b; });
$parcel$export(module.exports, "_DYN_HREF", function () { return $c7b39d59aa5a7f60$export$8d0bd9d006f3ecea; });
$parcel$export(module.exports, "_DYN_SEND_EXCEPTION_INTER13", function () { return $c7b39d59aa5a7f60$export$f59078bb778c9553; });
$parcel$export(module.exports, "_DYN_EXCEPTION", function () { return $c7b39d59aa5a7f60$export$4852fd87b68a6e1f; });
$parcel$export(module.exports, "_DYN_ERROR", function () { return $c7b39d59aa5a7f60$export$ff0a0f80c43edd37; });
$parcel$export(module.exports, "_DYN__ONERROR", function () { return $c7b39d59aa5a7f60$export$31fe7bcf0f7c83e8; });
$parcel$export(module.exports, "_DYN_ERROR_SRC", function () { return $c7b39d59aa5a7f60$export$d190ee0b6bfe36d8; });
$parcel$export(module.exports, "_DYN_LINE_NUMBER", function () { return $c7b39d59aa5a7f60$export$4d19a8ea486d5967; });
$parcel$export(module.exports, "_DYN_COLUMN_NUMBER", function () { return $c7b39d59aa5a7f60$export$91a182df12726bcd; });
$parcel$export(module.exports, "_DYN_MESSAGE", function () { return $c7b39d59aa5a7f60$export$923606b70907833e; });
$parcel$export(module.exports, "_DYN__CREATE_AUTO_EXCEPTI14", function () { return $c7b39d59aa5a7f60$export$5ad7f2cdb26509a7; });
$parcel$export(module.exports, "_DYN_ADD_TELEMETRY_INITIA15", function () { return $c7b39d59aa5a7f60$export$d4bb20b04e217271; });
$parcel$export(module.exports, "_DYN_DURATION", function () { return $c7b39d59aa5a7f60$export$aa395e58f404db90; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $c7b39d59aa5a7f60$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_IS_PERFORMANCE_TIMIN16", function () { return $c7b39d59aa5a7f60$export$22b3a1855dbf3858; });
$parcel$export(module.exports, "_DYN_GET_PERFORMANCE_TIMI17", function () { return $c7b39d59aa5a7f60$export$ab75e037bf1b3e24; });
$parcel$export(module.exports, "_DYN_NAVIGATION_START", function () { return $c7b39d59aa5a7f60$export$f8670e269dbf7411; });
$parcel$export(module.exports, "_DYN_SHOULD_COLLECT_DURAT18", function () { return $c7b39d59aa5a7f60$export$29c6d1b9c4ab3707; });
$parcel$export(module.exports, "_DYN_IS_PERFORMANCE_TIMIN19", function () { return $c7b39d59aa5a7f60$export$ad0658e0d367af69; });
$parcel$export(module.exports, "_DYN_GET_ENTRIES_BY_TYPE", function () { return $c7b39d59aa5a7f60$export$96ba0dffa6c93bb1; });
$parcel$export(module.exports, "_DYN_RESPONSE_START", function () { return $c7b39d59aa5a7f60$export$efd7bea2390142dc; });
$parcel$export(module.exports, "_DYN_REQUEST_START", function () { return $c7b39d59aa5a7f60$export$2a979904ebe4c805; });
$parcel$export(module.exports, "_DYN_LOAD_EVENT_END", function () { return $c7b39d59aa5a7f60$export$3e2743adb5050880; });
$parcel$export(module.exports, "_DYN_RESPONSE_END", function () { return $c7b39d59aa5a7f60$export$cb472b94f03785cf; });
$parcel$export(module.exports, "_DYN_CONNECT_END", function () { return $c7b39d59aa5a7f60$export$ade5c25ec120f74e; });
$parcel$export(module.exports, "_DYN_PAGE_VISIT_START_TIM20", function () { return $c7b39d59aa5a7f60$export$9c1a08f4929dd5e8; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $c7b39d59aa5a7f60$export$e2818d11505fa034 = "toString"; // Count: 4
var $c7b39d59aa5a7f60$export$f8c520424f754c1c = "disableExceptionTracking"; // Count: 3
var $c7b39d59aa5a7f60$export$65bc351810f367dc = "autoTrackPageVisitTime"; // Count: 4
var $c7b39d59aa5a7f60$export$d0a26b7eaadd0d4e = "overridePageViewDuration"; // Count: 3
var $c7b39d59aa5a7f60$export$4f55a24a56b3d5ca = "enableUnhandledPromiseRejectionTracking"; // Count: 3
var $c7b39d59aa5a7f60$export$51ccd61d31b31ade = "samplingPercentage"; // Count: 4
var $c7b39d59aa5a7f60$export$c8f0ddf05bfb48a8 = "isStorageUseDisabled"; // Count: 4
var $c7b39d59aa5a7f60$export$8f81e2d5093195fc = "isBrowserLinkTrackingEnabled"; // Count: 4
var $c7b39d59aa5a7f60$export$2c102e3a86379a7 = "enableAutoRouteTracking"; // Count: 3
var $c7b39d59aa5a7f60$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 3
var $c7b39d59aa5a7f60$export$9173a290c0626b54 = "disableFlushOnBeforeUnload"; // Count: 3
var $c7b39d59aa5a7f60$export$89658174a707d672 = "disableFlushOnUnload"; // Count: 2
var $c7b39d59aa5a7f60$export$f9ae8d0acf86503e = "core"; // Count: 7
var $c7b39d59aa5a7f60$export$9e16762ab4f2648 = "dataType"; // Count: 8
var $c7b39d59aa5a7f60$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $c7b39d59aa5a7f60$export$c7ff2c36e5c78421 = "diagLog"; // Count: 13
var $c7b39d59aa5a7f60$export$548634e98b3af9c4 = "track"; // Count: 7
var $c7b39d59aa5a7f60$export$ab1a8669316b7a02 = "trackPageView"; // Count: 4
var $c7b39d59aa5a7f60$export$e468e9c9816152cf = "trackPreviousPageVisit"; // Count: 3
var $c7b39d59aa5a7f60$export$a6c6e891ce0a5106 = "sendPageViewInternal"; // Count: 7
var $c7b39d59aa5a7f60$export$982b1825c068e342 = "sendPageViewPerformanceInternal"; // Count: 3
var $c7b39d59aa5a7f60$export$81995f88bf49a98b = "populatePageViewPerformanceEvent"; // Count: 3
var $c7b39d59aa5a7f60$export$8d0bd9d006f3ecea = "href"; // Count: 6
var $c7b39d59aa5a7f60$export$f59078bb778c9553 = "sendExceptionInternal"; // Count: 2
var $c7b39d59aa5a7f60$export$4852fd87b68a6e1f = "exception"; // Count: 3
var $c7b39d59aa5a7f60$export$ff0a0f80c43edd37 = "error"; // Count: 5
var $c7b39d59aa5a7f60$export$31fe7bcf0f7c83e8 = "_onerror"; // Count: 3
var $c7b39d59aa5a7f60$export$d190ee0b6bfe36d8 = "errorSrc"; // Count: 3
var $c7b39d59aa5a7f60$export$4d19a8ea486d5967 = "lineNumber"; // Count: 5
var $c7b39d59aa5a7f60$export$91a182df12726bcd = "columnNumber"; // Count: 5
var $c7b39d59aa5a7f60$export$923606b70907833e = "message"; // Count: 4
var $c7b39d59aa5a7f60$export$5ad7f2cdb26509a7 = "CreateAutoException"; // Count: 3
var $c7b39d59aa5a7f60$export$d4bb20b04e217271 = "addTelemetryInitializer"; // Count: 4
var $c7b39d59aa5a7f60$export$aa395e58f404db90 = "duration"; // Count: 10
var $c7b39d59aa5a7f60$export$6eae51590aaea43 = "length"; // Count: 5
var $c7b39d59aa5a7f60$export$22b3a1855dbf3858 = "isPerformanceTimingSupported"; // Count: 2
var $c7b39d59aa5a7f60$export$ab75e037bf1b3e24 = "getPerformanceTiming"; // Count: 2
var $c7b39d59aa5a7f60$export$f8670e269dbf7411 = "navigationStart"; // Count: 4
var $c7b39d59aa5a7f60$export$29c6d1b9c4ab3707 = "shouldCollectDuration"; // Count: 3
var $c7b39d59aa5a7f60$export$ad0658e0d367af69 = "isPerformanceTimingDataReady"; // Count: 2
var $c7b39d59aa5a7f60$export$96ba0dffa6c93bb1 = "getEntriesByType"; // Count: 3
var $c7b39d59aa5a7f60$export$efd7bea2390142dc = "responseStart"; // Count: 5
var $c7b39d59aa5a7f60$export$2a979904ebe4c805 = "requestStart"; // Count: 3
var $c7b39d59aa5a7f60$export$3e2743adb5050880 = "loadEventEnd"; // Count: 4
var $c7b39d59aa5a7f60$export$cb472b94f03785cf = "responseEnd"; // Count: 5
var $c7b39d59aa5a7f60$export$ade5c25ec120f74e = "connectEnd"; // Count: 4
var $c7b39d59aa5a7f60$export$9c1a08f4929dd5e8 = "pageVisitStartTime"; // Count: 2

});

parcelRegister("lmTkX", function(module, exports) {

$parcel$export(module.exports, "PageViewManager", function () { return $f8e693d5f6a6f18e$export$5bb8d6768724bf86; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $rOoAk = parcelRequire("rOoAk");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $bU24K = parcelRequire("bU24K");

var $h90r2 = parcelRequire("h90r2");
var $f8e693d5f6a6f18e$var$_isWebWorker = null;
function $f8e693d5f6a6f18e$var$isWebWorker() {
    if ($f8e693d5f6a6f18e$var$_isWebWorker == null) try {
        $f8e693d5f6a6f18e$var$_isWebWorker = !!(self && self instanceof WorkerGlobalScope);
    } catch (e) {
        $f8e693d5f6a6f18e$var$_isWebWorker = false;
    }
    return $f8e693d5f6a6f18e$var$_isWebWorker;
}
/**
 * Class encapsulates sending page views and page view performance telemetry.
 */ var $f8e693d5f6a6f18e$export$5bb8d6768724bf86 = /** @class */ function() {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        (0, $bO3cR.default)(PageViewManager, this, function(_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var _logger;
            if (core) _logger = core.logger;
            function _flushChannels(isAsync) {
                if (core) core.flush(isAsync);
            }
            function _startTimer() {
                if (!queueTimer) queueTimer = setTimeout(function() {
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush = false;
                    itemQueue = [];
                    (0, $hGXAo.arrForEach)(allItems, function(item) {
                        if (!item()) // Not processed so rescheduled
                        itemQueue.push(item);
                        else doFlush = true;
                    });
                    if (itemQueue[0, $h90r2._DYN_LENGTH /* @min:%2elength */ ] > 0) _startTimer();
                    if (doFlush) // We process at least one item so flush the queue
                    _flushChannels(true);
                }, 100);
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[0, $h90r2._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                var name = pageView.name;
                if ((0, $hGXAo.isNullOrUndefined)(name) || typeof name !== "string") {
                    var doc = (0, $bU24K.getDocument)();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if ((0, $hGXAo.isNullOrUndefined)(uri) || typeof uri !== "string") {
                    var location_1 = (0, $bU24K.getLocation)();
                    uri = pageView.uri = location_1 && location_1[0, $h90r2._DYN_HREF /* @min:%2ehref */ ] || "";
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[0, $h90r2._DYN_IS_PERFORMANCE_TIMIN16 /* @min:%2eisPerformanceTimingSupported */ ]()) {
                    appInsights[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    if (!$f8e693d5f6a6f18e$var$isWebWorker()) // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 25 /* _eInternalMessageId.NavigationTimingNotSupported */ , "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[0, $h90r2._DYN_GET_PERFORMANCE_TIMI17 /* @min:%2egetPerformanceTiming */ ]()[0, $h90r2._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ];
                if (start > 0) {
                    customDuration = (0, $rOoAk.dateTimeUtilsDuration)(start, +new Date);
                    if (!pageViewPerformanceManager[0, $h90r2._DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */ ](customDuration)) customDuration = undefined;
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!(0, $hGXAo.isNullOrUndefined)(customProperties) && !(0, $hGXAo.isNullOrUndefined)(customProperties[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ])) duration = customProperties[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ];
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) customProperties = {};
                        customProperties[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ] = customDuration;
                    }
                    // case 2
                    appInsights[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) customProperties = {};
                // Queue the event for processing
                _addQueue(function() {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[0, $h90r2._DYN_IS_PERFORMANCE_TIMIN19 /* @min:%2eisPerformanceTimingDataReady */ ]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[0, $h90r2._DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */ ](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ] = customDuration;
                                appInsights[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            } else {
                                if (!pageViewSent) {
                                    customProperties[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ] = pageViewPerformance.durationMs;
                                    appInsights[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[0, $h90r2._DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */ ](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        } else if (start > 0 && (0, $rOoAk.dateTimeUtilsDuration)(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ] = maxDurationLimit;
                                appInsights[0, $h90r2._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            }
                        }
                    } catch (e) {
                        (0, $i86yL._throwInternal)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 38 /* _eInternalMessageId.TrackPVFailedCalc */ , "trackPageView failed on page load calculation: " + (0, $hGXAo.getExceptionName)(e), {
                            exception: (0, $bU24K.dumpObj)(e)
                        });
                    }
                    return processed;
                });
            };
            _self.teardown = function(unloadCtx, unloadState) {
                if (queueTimer) {
                    clearTimeout(queueTimer);
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush_1 = false;
                    itemQueue = [];
                    (0, $hGXAo.arrForEach)(allItems, function(item) {
                        if (item()) doFlush_1 = true;
                    });
                }
            };
        });
    }
    // Removed Stub for PageViewManager.prototype.trackPageView.
    // Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageViewManager.__ieDyn = 1;
    return PageViewManager;
}();

});

parcelRegister("kLCwi", function(module, exports) {

$parcel$export(module.exports, "PageViewPerformanceManager", function () { return $f1e613b03a912433$export$da80ef98bc1bafa6; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $rOoAk = parcelRequire("rOoAk");
var $6bipl = parcelRequire("6bipl");

var $i86yL = parcelRequire("i86yL");
var $bU24K = parcelRequire("bU24K");

var $h90r2 = parcelRequire("h90r2");
var $f1e613b03a912433$var$MAX_DURATION_ALLOWED = 3600000; // 1h
var $f1e613b03a912433$var$botAgentNames = [
    "googlebot",
    "adsbot-google",
    "apis-google",
    "mediapartners-google"
];
function $f1e613b03a912433$var$_isPerformanceTimingSupported() {
    var perf = (0, $bU24K.getPerformance)();
    return perf && !!perf.timing;
}
function $f1e613b03a912433$var$_isPerformanceNavigationTimingSupported() {
    var perf = (0, $bU24K.getPerformance)();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[0, $h90r2._DYN_LENGTH /* @min:%2elength */ ] > 0;
}
function $f1e613b03a912433$var$_isPerformanceTimingDataReady() {
    var perf = (0, $bU24K.getPerformance)();
    var timing = perf ? perf.timing : 0;
    return timing && timing.domainLookupStart > 0 && timing[0, $h90r2._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ] > 0 && timing[0, $h90r2._DYN_RESPONSE_START /* @min:%2eresponseStart */ ] > 0 && timing[0, $h90r2._DYN_REQUEST_START /* @min:%2erequestStart */ ] > 0 && timing[0, $h90r2._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ] > 0 && timing[0, $h90r2._DYN_RESPONSE_END /* @min:%2eresponseEnd */ ] > 0 && timing[0, $h90r2._DYN_CONNECT_END /* @min:%2econnectEnd */ ] > 0 && timing.domLoading > 0;
}
function $f1e613b03a912433$var$_getPerformanceTiming() {
    if ($f1e613b03a912433$var$_isPerformanceTimingSupported()) return (0, $bU24K.getPerformance)().timing;
    return null;
}
function $f1e613b03a912433$var$_getPerformanceNavigationTiming() {
    if ($f1e613b03a912433$var$_isPerformanceNavigationTimingSupported()) return (0, $bU24K.getPerformance)()[0, $h90r2._DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */ ]("navigation")[0];
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/ function $f1e613b03a912433$var$_shouldCollectDuration() {
    var durations = [];
    for(var _i = 0; _i < arguments.length; _i++)durations[_i] = arguments[_i];
    var _navigator = (0, $bU24K.getNavigator)() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) for(var i = 0; i < $f1e613b03a912433$var$botAgentNames[0, $h90r2._DYN_LENGTH /* @min:%2elength */ ]; i++)isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf($f1e613b03a912433$var$botAgentNames[i]) !== -1;
    if (isGoogleBot) // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
    return false;
    else // for other page views, don't report if it's outside of a reasonable range
    for(var i = 0; i < durations[0, $h90r2._DYN_LENGTH /* @min:%2elength */ ]; i++){
        if (durations[i] < 0 || durations[i] >= $f1e613b03a912433$var$MAX_DURATION_ALLOWED) return false;
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */ var $f1e613b03a912433$export$da80ef98bc1bafa6 = /** @class */ function() {
    function PageViewPerformanceManager(core) {
        var _logger = (0, $i86yL.safeGetLogger)(core);
        (0, $bO3cR.default)(PageViewPerformanceManager, this, function(_self) {
            _self[0, $h90r2._DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */ ] = function(pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */ var navigationTiming = $f1e613b03a912433$var$_getPerformanceNavigationTiming();
                var timing = $f1e613b03a912433$var$_getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */ network = navigationTiming.startTime === 0 ? navigationTiming[0, $h90r2._DYN_CONNECT_END /* @min:%2econnectEnd */ ] : (0, $rOoAk.dateTimeUtilsDuration)(navigationTiming.startTime, navigationTiming[0, $h90r2._DYN_CONNECT_END /* @min:%2econnectEnd */ ]);
                        request = (0, $rOoAk.dateTimeUtilsDuration)(navigationTiming.requestStart, navigationTiming[0, $h90r2._DYN_RESPONSE_START /* @min:%2eresponseStart */ ]);
                        response = (0, $rOoAk.dateTimeUtilsDuration)(navigationTiming[0, $h90r2._DYN_RESPONSE_START /* @min:%2eresponseStart */ ], navigationTiming[0, $h90r2._DYN_RESPONSE_END /* @min:%2eresponseEnd */ ]);
                        dom = (0, $rOoAk.dateTimeUtilsDuration)(navigationTiming.responseEnd, navigationTiming[0, $h90r2._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ]);
                    } else {
                        total = (0, $rOoAk.dateTimeUtilsDuration)(timing[0, $h90r2._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ], timing[0, $h90r2._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ]);
                        network = (0, $rOoAk.dateTimeUtilsDuration)(timing[0, $h90r2._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ], timing[0, $h90r2._DYN_CONNECT_END /* @min:%2econnectEnd */ ]);
                        request = (0, $rOoAk.dateTimeUtilsDuration)(timing.requestStart, timing[0, $h90r2._DYN_RESPONSE_START /* @min:%2eresponseStart */ ]);
                        response = (0, $rOoAk.dateTimeUtilsDuration)(timing[0, $h90r2._DYN_RESPONSE_START /* @min:%2eresponseStart */ ], timing[0, $h90r2._DYN_RESPONSE_END /* @min:%2eresponseEnd */ ]);
                        dom = (0, $rOoAk.dateTimeUtilsDuration)(timing.responseEnd, timing[0, $h90r2._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ]);
                    }
                    if (total === 0) (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 10 /* _eInternalMessageId.ErrorPVCalc */ , "error calculating page view performance.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (!_self[0, $h90r2._DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */ ](total, network, request, response, dom)) (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 45 /* _eInternalMessageId.InvalidDurationValue */ , "Invalid page load duration value. Browser perf data won't be sent.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                    // in this case, don't report client performance from this page
                    (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 8 /* _eInternalMessageId.ClientPerformanceMathError */ , "client performance math error.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[0, $h90r2._DYN_DURATION /* @min:%2eduration */ ] = (0, $6bipl.msToTimeSpan)(total);
                        pageViewPerformance.networkConnect = (0, $6bipl.msToTimeSpan)(network);
                        pageViewPerformance.sentRequest = (0, $6bipl.msToTimeSpan)(request);
                        pageViewPerformance.receivedResponse = (0, $6bipl.msToTimeSpan)(response);
                        pageViewPerformance.domProcessing = (0, $6bipl.msToTimeSpan)(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[0, $h90r2._DYN_GET_PERFORMANCE_TIMI17 /* @min:%2egetPerformanceTiming */ ] = $f1e613b03a912433$var$_getPerformanceTiming;
            _self[0, $h90r2._DYN_IS_PERFORMANCE_TIMIN16 /* @min:%2eisPerformanceTimingSupported */ ] = $f1e613b03a912433$var$_isPerformanceTimingSupported;
            _self[0, $h90r2._DYN_IS_PERFORMANCE_TIMIN19 /* @min:%2eisPerformanceTimingDataReady */ ] = $f1e613b03a912433$var$_isPerformanceTimingDataReady;
            _self[0, $h90r2._DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */ ] = $f1e613b03a912433$var$_shouldCollectDuration;
        });
    }
    // Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
    // Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
    // Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageViewPerformanceManager.__ieDyn = 1;
    return PageViewPerformanceManager;
}();

});

parcelRegister("99PJK", function(module, exports) {

$parcel$export(module.exports, "PageVisitTimeManager", function () { return $6aad162f70f02483$export$f6fdd81afb2fe76; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $h1GMI = parcelRequire("h1GMI");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $bU24K = parcelRequire("bU24K");

var $h90r2 = parcelRequire("h90r2");
/**
 * Used to track page visit durations
 */ var $6aad162f70f02483$export$f6fdd81afb2fe76 = /** @class */ function() {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */ function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        (0, $bO3cR.default)(PageVisitTimeManager, this, function(_self) {
            _self[0, $h90r2._DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */ ] = function(currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                } catch (e) {
                    (0, $i86yL._warnToConsole)(logger, "Auto track page visit time failed, metric will not be collected: " + (0, $bU24K.dumpObj)(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */ function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    startPageVisitTimer(pageName, pageUrl);
                } catch (e) {
                    (0, $i86yL._warnToConsole)(logger, "Call to restart failed: " + (0, $bU24K.dumpObj)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Starts timing visit duration of pageName
             * @param pageName
             * @returns {}
             */ function startPageVisitTimer(pageName, pageUrl) {
                try {
                    if ((0, $h1GMI.utlCanUseSessionStorage)()) {
                        if ((0, $h1GMI.utlGetSessionStorage)(logger, prevPageVisitDataKeyName) != null) (0, $hGXAo.throwError)("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        var currPageVisitData = new $6aad162f70f02483$export$513202441432a369(pageName, pageUrl);
                        var currPageVisitDataStr = (0, $bU24K.getJSON)().stringify(currPageVisitData);
                        (0, $h1GMI.utlSetSessionStorage)(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                } catch (e) {
                    // TODO: Remove this catch in next phase, since if start is called twice in a row the exception needs to be propagated out
                    (0, $i86yL._warnToConsole)(logger, "Call to start failed: " + (0, $bU24K.dumpObj)(e));
                }
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */ function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if ((0, $h1GMI.utlCanUseSessionStorage)()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = (0, $hGXAo.dateNow)();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = (0, $h1GMI.utlGetSessionStorage)(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && (0, $bU24K.hasJSON)()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = (0, $bU24K.getJSON)().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[0, $h90r2._DYN_PAGE_VISIT_START_TIM20 /* @min:%2epageVisitStartTime */ ];
                            // Remove data from storage since we already used it
                            (0, $h1GMI.utlRemoveSessionStorage)(logger, prevPageVisitDataKeyName);
                        }
                    }
                } catch (e) {
                    (0, $i86yL._warnToConsole)(logger, "Stop page visit timer failed: " + (0, $bU24K.dumpObj)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            (0, $hGXAo.objDefineAccessors)(_self, "_logger", function() {
                return logger;
            });
            (0, $hGXAo.objDefineAccessors)(_self, "pageVisitTimeTrackingHandler", function() {
                return pageVisitTimeTrackingHandler;
            });
        });
    }
    // Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageVisitTimeManager.__ieDyn = 1;
    return PageVisitTimeManager;
}();
var $6aad162f70f02483$export$513202441432a369 = /** @class */ function() {
    function PageVisitData(pageName, pageUrl) {
        this[0, $h90r2._DYN_PAGE_VISIT_START_TIM20 /* @min:%2epageVisitStartTime */ ] = (0, $hGXAo.dateNow)();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}();

});

parcelRegister("7Ub2w", function(module, exports) {

$parcel$export(module.exports, "Timing", function () { return $5c16539cfae231da$export$ef1e5872612852d1; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $rOoAk = parcelRequire("rOoAk");

var $i86yL = parcelRequire("i86yL");
/**
 * Used to record timed events and page views.
 */ var $5c16539cfae231da$export$ef1e5872612852d1 = /** @class */ function() {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function(name) {
            if (typeof _events[name] !== "undefined") (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 62 /* _eInternalMessageId.StartCalledMoreThanOnce */ , "start was called more than once for this event without calling stop.", {
                name: name,
                key: name
            }, true);
            _events[name] = +new Date;
        };
        _self.stop = function(name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 63 /* _eInternalMessageId.StopCalledWithoutStart */ , "stop was called without a corresponding start.", {
                name: name,
                key: name
            }, true);
            else {
                var end = +new Date;
                var duration = (0, $rOoAk.dateTimeUtilsDuration)(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}();

});


parcelRegister("zBQDZ", function(module, exports) {

$parcel$export(module.exports, "Sender", function () { return $06b0a0d7c89a64a7$export$c5a96f3e01fb6582; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $HME9b = parcelRequire("HME9b");
var $cVsUj = parcelRequire("cVsUj");
var $9rbbk = parcelRequire("9rbbk");
var $g5yzi = parcelRequire("g5yzi");
var $rOoAk = parcelRequire("rOoAk");
var $jMj33 = parcelRequire("jMj33");
var $czkZK = parcelRequire("czkZK");
var $cAmBy = parcelRequire("cAmBy");
var $cXuOT = parcelRequire("cXuOT");
var $ddqo3 = parcelRequire("ddqo3");
var $7iT8I = parcelRequire("7iT8I");
var $h1GMI = parcelRequire("h1GMI");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $dtXLi = parcelRequire("dtXLi");
var $5GGqM = parcelRequire("5GGqM");
var $bU24K = parcelRequire("bU24K");
var $lhl6R = parcelRequire("lhl6R");

var $ax6Lj = parcelRequire("ax6Lj");

var $6Mo87 = parcelRequire("6Mo87");

var $lGJIn = parcelRequire("lGJIn");

var $ffWC0 = parcelRequire("ffWC0");

var $gfcch = parcelRequire("gfcch");

var $a2D3N = parcelRequire("a2D3N");
var $06b0a0d7c89a64a7$var$_a;
var $06b0a0d7c89a64a7$var$FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function $06b0a0d7c89a64a7$var$_getResponseText(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function $06b0a0d7c89a64a7$var$_getDefaultAppInsightsChannelConfig() {
    var _a;
    var defaultValue;
    var defaultCustomHeaders;
    // set default values
    return _a = {
        endpointUrl: function() {
            return (0, $cVsUj.DEFAULT_BREEZE_ENDPOINT) + (0, $cVsUj.DEFAULT_BREEZE_PATH);
        }
    }, _a[0, $a2D3N._DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_MAX_BATCH_INTERVAL /* @min:maxBatchInterval */ ] = function() {
        return 15000;
    }, _a[0, $a2D3N._DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */ ] = function() {
        return 102400;
    }, _a[0, $a2D3N._DYN_DISABLE_TELEMETRY /* @min:disableTelemetry */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_ENABLE_SESSION_STORA4 /* @min:enableSessionStorageBuffer */ ] = function() {
        return true;
    }, _a[0, $a2D3N._DYN_BUFFER_OVERRIDE /* @min:bufferOverride */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_IS_RETRY_DISABLED /* @min:isRetryDisabled */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */ ] = function() {
        return true;
    }, _a[0, $a2D3N._DYN_DISABLE_XHR /* @min:disableXhr */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_ONUNLOAD_DISABLE_FET5 /* @min:onunloadDisableFetch */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */ ] = function() {
        return false;
    }, _a[0, $a2D3N._DYN_INSTRUMENTATION_KEY /* @min:instrumentationKey */ ] = function() {
        return defaultValue;
    }, _a[0, $a2D3N._DYN_NAME_PREFIX /* @min:namePrefix */ ] = function() {
        return defaultValue;
    }, _a[0, $a2D3N._DYN_SAMPLING_PERCENTAGE /* @min:samplingPercentage */ ] = function() {
        return 100;
    }, _a[0, $a2D3N._DYN_CUSTOM_HEADERS /* @min:customHeaders */ ] = function() {
        return defaultCustomHeaders;
    }, _a[0, $a2D3N._DYN_CONVERT_UNDEFINED /* @min:convertUndefined */ ] = function() {
        return defaultValue;
    }, _a[0, $a2D3N._DYN_EVENTS_LIMIT_IN_MEM /* @min:eventsLimitInMem */ ] = function() {
        return 10000;
    }, _a.retryCodes = function() {
        return null;
    }, _a;
}
var $06b0a0d7c89a64a7$var$EnvelopeTypeCreator = ($06b0a0d7c89a64a7$var$_a = {}, $06b0a0d7c89a64a7$var$_a[(0, $9rbbk.Event).dataType] = (0, $ax6Lj.EventEnvelopeCreator), $06b0a0d7c89a64a7$var$_a[(0, $7iT8I.Trace).dataType] = (0, $ax6Lj.TraceEnvelopeCreator), $06b0a0d7c89a64a7$var$_a[(0, $czkZK.PageView).dataType] = (0, $ax6Lj.PageViewEnvelopeCreator), $06b0a0d7c89a64a7$var$_a[(0, $cAmBy.PageViewPerformance).dataType] = (0, $ax6Lj.PageViewPerformanceEnvelopeCreator), $06b0a0d7c89a64a7$var$_a[(0, $g5yzi.Exception).dataType] = (0, $ax6Lj.ExceptionEnvelopeCreator), $06b0a0d7c89a64a7$var$_a[(0, $jMj33.Metric).dataType] = (0, $ax6Lj.MetricEnvelopeCreator), $06b0a0d7c89a64a7$var$_a[(0, $cXuOT.RemoteDependencyData).dataType] = (0, $ax6Lj.DependencyEnvelopeCreator), $06b0a0d7c89a64a7$var$_a);
var $06b0a0d7c89a64a7$export$c5a96f3e01fb6582 = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = (0, $HME9b.BreezeChannelIdentifier);
        /**
         * The configuration for this sender instance
         */ _this._senderConfig = $06b0a0d7c89a64a7$var$_getDefaultAppInsightsChannelConfig();
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _fallbackSender; // The sender to use if the payload size is too large
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _retryCodes;
        (0, $bO3cR.default)(Sender, _this, function(_self, _base) {
            _initDefaults();
            _self.pause = function() {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function() {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    if (_self._buffer.size() > _self._senderConfig[0, $a2D3N._DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */ ]()) _self[0, $a2D3N._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    _setupTimer();
                }
            };
            _self.flush = function(isAsync, callBack, sendReason) {
                if (isAsync === void 0) isAsync = true;
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        _self[0, $a2D3N._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */ );
                    } catch (e) {
                        (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 22 /* _eInternalMessageId.FlushFailed */ , "flush failed, telemetry will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                            exception: (0, $bU24K.dumpObj)(e)
                        });
                    }
                }
            };
            _self.onunloadFlush = function() {
                if (!_paused) {
                    if ((_self._senderConfig[0, $a2D3N._DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */ ]() === false || _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */ ]() === false) && (0, $bU24K.isBeaconsSupported)()) try {
                        _self[0, $a2D3N._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, _doUnloadSend, 2 /* SendRequestReason.Unload */ );
                    } catch (e) {
                        (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "failed to flush with beacon sender on page unload, telemetry will not be collected: " + (0, $hGXAo.getExceptionName)(e), {
                            exception: (0, $bU24K.dumpObj)(e)
                        });
                    }
                    else _self.flush();
                }
            };
            _self.addHeader = function(name, value) {
                _headers[name] = value;
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _base.initialize(config, core, extensions, pluginChain);
                var ctx = _self._getTelCtx();
                var identifier = _self.identifier;
                _serializer = new (0, $ffWC0.Serializer)(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[0, $a2D3N._DYN__SENDER /* @min:%2e_sender */ ] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ]();
                _evtNamespace = (0, $lhl6R.mergeEvtNamespace)((0, $5GGqM.createUniqueNamespace)("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = (0, $6Mo87.createOfflineListener)(_evtNamespace);
                // TODO v3.x: Change the ISenderConfig to not be function calls
                var defaultConfig = $06b0a0d7c89a64a7$var$_getDefaultAppInsightsChannelConfig();
                (0, $hGXAo.objForEachKey)(defaultConfig, function(field, value) {
                    _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][field] = function() {
                        var theValue = ctx.getConfig(identifier, field, value());
                        if (!theValue && field === "endpointUrl") // Use the default value (handles empty string in the configuration)
                        theValue = value();
                        return theValue;
                    };
                });
                _retryCodes = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ].retryCodes();
                if (config.storagePrefix) (0, $h1GMI.utlSetStoragePrefix)(config.storagePrefix);
                var useSessionStorage = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENABLE_SESSION_STORA4 /* @min:%2eenableSessionStorageBuffer */ ]() && !!(_self._senderConfig[0, $a2D3N._DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */ ]() || (0, $h1GMI.utlCanUseSessionStorage)());
                _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ] = useSessionStorage ? new (0, $lGJIn.SessionStorageSendBuffer)(diagLog, _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ]) : new (0, $lGJIn.ArraySendBuffer)(diagLog, _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ]);
                _self._sample = new (0, $gfcch.Sample)(_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ](), diagLog);
                if (!_validateInstrumentationKey(config)) (0, $i86yL._throwInternal)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , "Invalid Instrumentation key " + config[0, $a2D3N._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]);
                if (!(0, $rOoAk.isInternalApplicationInsightsEndpoint)(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders()[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $hGXAo.arrForEach)(_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */ ](), function(customHeader) {
                    _this.addHeader(customHeader.header, customHeader.value);
                });
                var senderConfig = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ];
                var sendPostFunc = null;
                if (!senderConfig[0, $a2D3N._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $bU24K.useXDomainRequest)()) sendPostFunc = _xdrSender; // IE 8 and 9
                else if (!senderConfig[0, $a2D3N._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $bU24K.isXhrSupported)()) sendPostFunc = _xhrSender;
                if (!sendPostFunc && (0, $bU24K.isFetchSupported)()) sendPostFunc = _fetchSender;
                // always fallback to XHR
                _fallbackSender = sendPostFunc || _xhrSender;
                if (!senderConfig[0, $a2D3N._DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */ ]() && (0, $bU24K.isBeaconsSupported)()) // Config is set to always used beacon sending
                sendPostFunc = _beaconSender;
                _self[0, $a2D3N._DYN__SENDER /* @min:%2e_sender */ ] = sendPostFunc || _xhrSender;
                if (!senderConfig[0, $a2D3N._DYN_ONUNLOAD_DISABLE_FET5 /* @min:%2eonunloadDisableFetch */ ]() && (0, $bU24K.isFetchSupported)(true)) // Try and use the fetch with keepalive
                _syncUnloadSender = _fetchKeepAliveSender;
                else if ((0, $bU24K.isBeaconsSupported)()) // Try and use sendBeacon
                _syncUnloadSender = _beaconSender;
                else if (!senderConfig[0, $a2D3N._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $bU24K.useXDomainRequest)()) _syncUnloadSender = _xdrSender; // IE 8 and 9
                else if (!senderConfig[0, $a2D3N._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $bU24K.isXhrSupported)()) _syncUnloadSender = _xhrSender;
                else _syncUnloadSender = _fallbackSender;
            };
            _self.processTelemetry = function(telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ]();
                try {
                    // if master off switch is set, don't send any data
                    if (_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_DISABLE_TELEMETRY /* @min:%2edisableTelemetry */ ]()) // Do not send/save data
                    return;
                    // validate input
                    if (!telemetryItem) {
                        (0, $i86yL._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */ , "Cannot send empty telemetry");
                        return;
                    }
                    // validate event
                    if (telemetryItem.baseData && !telemetryItem[0, $a2D3N._DYN_BASE_TYPE /* @min:%2ebaseType */ ]) {
                        (0, $i86yL._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 70 /* _eInternalMessageId.InvalidEvent */ , "Cannot send telemetry without baseData and baseType");
                        return;
                    }
                    if (!telemetryItem[0, $a2D3N._DYN_BASE_TYPE /* @min:%2ebaseType */ ]) // Default
                    telemetryItem[0, $a2D3N._DYN_BASE_TYPE /* @min:%2ebaseType */ ] = "EventData";
                    // ensure a sender was constructed
                    if (!_self[0, $a2D3N._DYN__SENDER /* @min:%2e_sender */ ]) {
                        (0, $i86yL._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender was not initialized");
                        return;
                    }
                    // check if this item should be sampled in, else add sampleRate tag
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        (0, $i86yL._throwInternal)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */ , "Telemetry item was sampled out and not sent", {
                            SampleRate: _self._sample[0, $a2D3N._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ]
                        });
                        return;
                    } else telemetryItem[0, $cVsUj.SampleRate] = _self._sample[0, $a2D3N._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ];
                    var convertUndefined = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_CONVERT_UNDEFINED /* @min:%2econvertUndefined */ ]() || undefined;
                    // construct an envelope that Application Insights endpoint can understand
                    // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                    var defaultEnvelopeIkey = telemetryItem.iKey || _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]();
                    var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, convertUndefined);
                    if (!aiEnvelope_1) {
                        (0, $i86yL._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 47 /* _eInternalMessageId.CreateEnvelopeError */ , "Unable to create an AppInsights envelope");
                        return;
                    }
                    var doNotSendItem_1 = false;
                    // this is for running in legacy mode, where customer may already have a custom initializer present
                    if (telemetryItem[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] && telemetryItem[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][0, $cVsUj.ProcessLegacy]) {
                        (0, $hGXAo.arrForEach)(telemetryItem[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][0, $cVsUj.ProcessLegacy], function(callBack) {
                            try {
                                if (callBack && callBack(aiEnvelope_1) === false) {
                                    doNotSendItem_1 = true;
                                    (0, $i86yL._warnToConsole)(diagLogger, "Telemetry processor check returns false");
                                }
                            } catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                (0, $i86yL._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $hGXAo.getExceptionName)(e), {
                                    exception: (0, $bU24K.dumpObj)(e)
                                }, true);
                            }
                        });
                        delete telemetryItem[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][0, $cVsUj.ProcessLegacy];
                    }
                    if (doNotSendItem_1) return; // do not send, no need to execute next plugin
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope_1);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ];
                    var bufferSize = buffer.size();
                    if (bufferSize + payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */ ]()) {
                        if (!_offlineListener || _offlineListener[0, $a2D3N._DYN_IS_ONLINE /* @min:%2eisOnline */ ]()) _self[0, $a2D3N._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    }
                    // enqueue the payload
                    buffer[0, $a2D3N._DYN_ENQUEUE /* @min:%2eenqueue */ ](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                } catch (e) {
                    (0, $i86yL._throwInternal)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            /**
             * xhr state changes
             */ _self[0, $a2D3N._DYN__XHR_READY_STATE_CHA6 /* @min:%2e_xhrReadyStateChange */ ] = function(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), $06b0a0d7c89a64a7$var$_getResponseText(xhr) || xhr.response);
            };
            /**
             * Immediately send buffered data
             * @param async {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */ _self[0, $a2D3N._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ] = function(async, forcedSender, sendReason) {
                if (async === void 0) async = true;
                if (!_paused) try {
                    var buffer = _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ];
                    // Send data only if disableTelemetry is false
                    if (!_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_DISABLE_TELEMETRY /* @min:%2edisableTelemetry */ ]()) {
                        if (buffer[0, $a2D3N._DYN_COUNT /* @min:%2ecount */ ]() > 0) {
                            var payload = buffer.getItems();
                            _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */ , async);
                            // invoke send
                            if (forcedSender) forcedSender.call(_self, payload, async);
                            else _self[0, $a2D3N._DYN__SENDER /* @min:%2e_sender */ ](payload, async);
                        }
                        // update lastSend time to enable throttling
                        _lastSend = +new Date;
                    } else buffer[0, $a2D3N._DYN_CLEAR /* @min:%2eclear */ ]();
                    _clearScheduledTimer();
                } catch (e) {
                    /* Ignore this error for IE under v10 */ var ieVer = (0, $bU24K.getIEVersion)();
                    if (!ieVer || ieVer > 9) (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Telemetry transmission failed, some telemetry will be lost: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _self.onunloadFlush();
                _offlineListener.unload();
                _initDefaults();
            };
            /**
             * error handler
             */ _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ] = function(payload, message, event) {
                (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _self._buffer && _self._buffer[0, $a2D3N._DYN_CLEAR_SENT /* @min:%2eclearSent */ ](payload);
            };
            /**
             * partial success handler
             */ _self[0, $a2D3N._DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */ ] = function(payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) retry[0, $a2D3N._DYN_PUSH /* @min:%2epush */ ](extracted);
                    else // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                    failed[0, $a2D3N._DYN_PUSH /* @min:%2epush */ ](extracted);
                }
                if (payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) _self[0, $a2D3N._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ](payload, results[0, $a2D3N._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ]);
                if (failed[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](failed, _formatErrorMessageXhr(null, [
                    "partial success",
                    results[0, $a2D3N._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ],
                    "of",
                    results.itemsReceived
                ].join(" ")));
                if (retry[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    _resendPayload(retry);
                    (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Partial success. Delivered: " + payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] + ", Failed: " + failed[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] + ". Will retry to send " + retry[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] + " our of " + results[0, $a2D3N._DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */ ] + " items");
                }
            };
            /**
             * success handler
             */ _self[0, $a2D3N._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ] = function(payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[0, $a2D3N._DYN_CLEAR_SENT /* @min:%2eclearSent */ ](payload);
            };
            /**
             * xdr state changes
             */ _self._xdrOnLoad = function(xdr, payload) {
                var responseText = $06b0a0d7c89a64a7$var$_getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[0, $a2D3N._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ](payload, 0);
                } else {
                    var results = _parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[0, $a2D3N._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ] && !_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]()) _self[0, $a2D3N._DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */ ](payload, results);
                    else _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, _formatErrorMessageXdr(xdr));
                }
            };
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = _parseResponse(res);
                    if (response && response.appId) _self._appId = response.appId;
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]() && _isRetriable(status)) {
                        _resendPayload(payload);
                        (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Response code " + status + ". Will retry to send " + payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] + " items.");
                    } else _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, errorMessage);
                } else if (_offlineListener && !_offlineListener[0, $a2D3N._DYN_IS_ONLINE /* @min:%2eisOnline */ ]()) // Note: Don't check for status == 0, since adblock gives this code
                {
                    if (!_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]()) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                } else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) response = _parseResponse(res);
                        if (response && !_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]()) _self[0, $a2D3N._DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */ ](payload, response);
                        else _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, errorMessage);
                    } else {
                        _consecutiveErrors = 0;
                        _self[0, $a2D3N._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                //  _stamp_specific_redirects = 0;
                return false;
                if (!(0, $hGXAo.isNullOrUndefined)(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]()) {
                        _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ] = function() {
                            return responseUrl;
                        };
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) // We are unloading so always call the sender with sync set to false
                _syncUnloadSender(payload, false);
                else // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                _beaconSender(payload, isAsync);
            }
            function _doBeaconSend(payload) {
                var nav = (0, $bU24K.getNavigator)();
                var buffer = _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ];
                var url = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]();
                var batch = _self._buffer[0, $a2D3N._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = new Blob([
                    batch
                ], {
                    type: "text/plain;charset=UTF-8"
                });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                if (queued) {
                    buffer[0, $a2D3N._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
                    // no response from beaconSender, clear buffer
                    _self._onSuccess(payload, payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]);
                }
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _beaconSender(payload, isAsync) {
                if ((0, $hGXAo.isArray)(payload) && payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                {
                    if (!_doBeaconSend(payload)) {
                        // Failed to send entire payload so try and split data and try to send as much events as possible
                        var droppedPayload = [];
                        for(var lp = 0; lp < payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]; lp++){
                            var thePayload = payload[lp];
                            if (!_doBeaconSend([
                                thePayload
                            ])) // Can't send anymore, so split the batch and drop the rest
                            droppedPayload[0, $a2D3N._DYN_PUSH /* @min:%2epush */ ](thePayload);
                        }
                        if (droppedPayload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                            _fallbackSender && _fallbackSender(droppedPayload, true);
                            (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                        }
                    }
                }
            }
            /**
             * Send XMLHttpRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             */ function _xhrSender(payload, isAsync) {
                var xhr = new XMLHttpRequest();
                var endPointUrl = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]();
                try {
                    xhr[0, $cVsUj.DisabledPropertyName] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                xhr.open("POST", endPointUrl, isAsync);
                xhr[0, $a2D3N._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]("Content-type", "application/json");
                // append Sdk-Context request header only in case of breeze endpoint
                if ((0, $rOoAk.isInternalApplicationInsightsEndpoint)(endPointUrl)) xhr[0, $a2D3N._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $ddqo3.RequestHeaders)[6 /* eRequestHeaders.sdkContextHeader */ ], (0, $ddqo3.RequestHeaders)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ]);
                (0, $hGXAo.arrForEach)((0, $hGXAo.objKeys)(_headers), function(headerName) {
                    xhr[0, $a2D3N._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ](headerName, _headers[headerName]);
                });
                xhr.onreadystatechange = function() {
                    return _self._xhrReadyStateChange(xhr, payload, payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]);
                };
                xhr.onerror = function(event) {
                    return _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, _formatErrorMessageXhr(xhr), event);
                };
                // compose an array of payloads
                var batch = _self._buffer[0, $a2D3N._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                xhr.send(batch);
                _self._buffer[0, $a2D3N._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                if ((0, $hGXAo.isArray)(payload)) {
                    var payloadSize = payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ];
                    for(var lp = 0; lp < payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]; lp++)payloadSize += payload[lp][0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ];
                    if (_syncFetchPayload + payloadSize <= $06b0a0d7c89a64a7$var$FetchSyncRequestSizeLimitBytes) _doFetchSender(payload, false);
                    else if ((0, $bU24K.isBeaconsSupported)()) // Fallback to beacon sender as we at least get told which events can't be scheduled
                    _beaconSender(payload, isAsync);
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        _fallbackSender && _fallbackSender(payload, true);
                        (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                }
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             */ function _fetchSender(payload, isAsync) {
                _doFetchSender(payload, true);
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */ function _doFetchSender(payload, isAsync) {
                var _a;
                var endPointUrl = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]();
                var batch = _self._buffer[0, $a2D3N._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                var plainTextBatch = new Blob([
                    batch
                ], {
                    type: "application/json"
                });
                var requestHeaders = new Headers();
                var batchLength = batch[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ];
                var ignoreResponse = false;
                var responseHandled = false;
                // append Sdk-Context request header only in case of breeze endpoint
                if ((0, $rOoAk.isInternalApplicationInsightsEndpoint)(endPointUrl)) requestHeaders.append((0, $ddqo3.RequestHeaders)[6 /* eRequestHeaders.sdkContextHeader */ ], (0, $ddqo3.RequestHeaders)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ]);
                (0, $hGXAo.arrForEach)((0, $hGXAo.objKeys)(_headers), function(headerName) {
                    requestHeaders.append(headerName, _headers[headerName]);
                });
                var init = (_a = {
                    method: "POST",
                    headers: requestHeaders,
                    body: plainTextBatch
                }, _a[0, $cVsUj.DisabledPropertyName] = true // Mark so we don't attempt to track this request
                , _a);
                if (!isAsync) {
                    init.keepalive = true;
                    // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                    // just like beacon send assume that the events have been accepted and processed
                    ignoreResponse = true;
                    _syncFetchPayload += batchLength;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[0, $cVsUj.DisabledPropertyName] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                _self._buffer[0, $a2D3N._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
                try {
                    fetch(request).then(function(response) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            /**
                             * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                             * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                             * or if anything prevented the request from completing.
                             */ if (!response.ok) _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, response.statusText);
                            else response.text().then(function(text) {
                                _checkResponsStatus(response.status, payload, response.url, payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ], response.statusText, text);
                            });
                        }
                    })["catch"](function(error) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, error.message);
                        }
                    });
                } catch (e) {
                    if (!responseHandled) _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, (0, $bU24K.dumpObj)(e));
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _self._onSuccess(payload, payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]);
                }
            }
            /**
             * Parses the response from the backend.
             * @param response - XMLHttpRequest or XDomainRequest response
             */ function _parseResponse(response) {
                try {
                    if (response && response !== "") {
                        var result = (0, $bU24K.getJSON)().parse(response);
                        if (result && result.itemsReceived && result.itemsReceived >= result[0, $a2D3N._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ] && result.itemsReceived - result.itemsAccepted === result.errors[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]) return result;
                    }
                } catch (e) {
                    (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 43 /* _eInternalMessageId.InvalidBackendResponse */ , "Cannot parse the response. " + (0, $hGXAo.getExceptionName)(e), {
                        response: response
                    });
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */ function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) linearFactor = 1;
                if (!payload || payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] === 0) return;
                var buffer = _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ];
                buffer[0, $a2D3N._DYN_CLEAR_SENT /* @min:%2eclearSent */ ](payload);
                _consecutiveErrors++;
                for(var _i = 0, payload_1 = payload; _i < payload_1.length; _i++){
                    var item = payload_1[_i];
                    buffer[0, $a2D3N._DYN_ENQUEUE /* @min:%2eenqueue */ ](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */ function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) delayInSeconds = SlotDelayInSeconds;
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = (0, $hGXAo.dateNow)() + delayInSeconds * 1000;
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */ function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - (0, $hGXAo.dateNow)()) : 0;
                    var timerValue = Math.max(_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_MAX_BATCH_INTERVAL /* @min:%2emaxBatchInterval */ ](), retryInterval);
                    _timeoutHandle = setTimeout(function() {
                        _timeoutHandle = null;
                        _self[0, $a2D3N._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, null, 1 /* SendRequestReason.NormalSchedule */ );
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                clearTimeout(_timeoutHandle);
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */ function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!(0, $hGXAo.isNullOrUndefined)(_retryCodes)) return _retryCodes[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] && (0, $hGXAo.arrIndexOf)(_retryCodes, statusCode) > -1;
                return statusCode === 401 // Unauthorized
                 || statusCode === 408 // Timeout
                 || statusCode === 429 // Too many requests.
                 || statusCode === 500 // Internal server error.
                 || statusCode === 502 // Bad Gateway.
                 || statusCode === 503 // Service unavailable.
                 || statusCode === 504; // Gateway timeout.
            }
            function _formatErrorMessageXhr(xhr, message) {
                if (xhr) return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + $06b0a0d7c89a64a7$var$_getResponseText(xhr) || xhr.response || "";
                return message;
            }
            /**
             * Send XDomainRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _xdrSender(payload, isAsync) {
                var buffer = _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ];
                var _window = (0, $bU24K.getWindow)();
                var xdr = new XDomainRequest();
                xdr.onload = function() {
                    return _self._xdrOnLoad(xdr, payload);
                };
                xdr.onerror = function(event) {
                    return _self[0, $a2D3N._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, _formatErrorMessageXdr(xdr), event);
                };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                if (_self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]().lastIndexOf(hostingProtocol, 0) !== 0) {
                    (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                    buffer[0, $a2D3N._DYN_CLEAR /* @min:%2eclear */ ]();
                    return;
                }
                var endpointUrl = _self[0, $a2D3N._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $a2D3N._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]().replace(/^(https?:)/, "");
                xdr.open("POST", endpointUrl);
                // compose an array of payloads
                var batch = buffer[0, $a2D3N._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                xdr.send(batch);
                buffer[0, $a2D3N._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
            }
            function _formatErrorMessageXdr(xdr, message) {
                if (xdr) return "XDomainRequest,Response:" + $06b0a0d7c89a64a7$var$_getResponseText(xdr);
                return message;
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) return _self.core[func]();
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[0, $a2D3N._DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ]) try {
                    manager[0, $a2D3N._DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ](sendRequest, isAsync);
                } catch (e) {
                    (0, $i86yL._throwInternal)(_self[0, $a2D3N._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 74 /* _eInternalMessageId.NotificationException */ , "send request notification failed: " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */ function _validateInstrumentationKey(config) {
                var disableIKeyValidationFlag = (0, $hGXAo.isNullOrUndefined)(config[0, $a2D3N._DYN_DISABLE_INSTRUMENTAT7 /* @min:%2edisableInstrumentationKeyValidation */ ]) ? false : config[0, $a2D3N._DYN_DISABLE_INSTRUMENTAT7 /* @min:%2edisableInstrumentationKeyValidation */ ];
                if (disableIKeyValidationFlag) return true;
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(config[0, $a2D3N._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]);
            }
            function _initDefaults() {
                _self[0, $a2D3N._DYN__SENDER /* @min:%2e_sender */ ] = null;
                _self[0, $a2D3N._DYN__BUFFER /* @min:%2e_buffer */ ] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _fallbackSender = null;
                _syncUnloadSender = null;
                _evtNamespace = null;
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !(0, $hGXAo.isNullOrUndefined)(iKey)) envelope = (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, orig), {
            iKey: iKey
        });
        else envelope = orig;
        var creator = $06b0a0d7c89a64a7$var$EnvelopeTypeCreator[envelope.baseType] || (0, $ax6Lj.EventEnvelopeCreator);
        return creator(logger, envelope, convertUndefined);
    };
    // Removed Stub for Sender.prototype.pause.
    // Removed Stub for Sender.prototype.resume.
    // Removed Stub for Sender.prototype.flush.
    // Removed Stub for Sender.prototype.onunloadFlush.
    // Removed Stub for Sender.prototype.initialize.
    // Removed Stub for Sender.prototype.processTelemetry.
    // Removed Stub for Sender.prototype._xhrReadyStateChange.
    // Removed Stub for Sender.prototype.triggerSend.
    // Removed Stub for Sender.prototype._onError.
    // Removed Stub for Sender.prototype._onPartialSuccess.
    // Removed Stub for Sender.prototype._onSuccess.
    // Removed Stub for Sender.prototype._xdrOnLoad.
    // Removed Stub for Sender.prototype.addHeader.
    return Sender;
}((0, $dtXLi.BaseTelemetryPlugin));

});
parcelRegister("ax6Lj", function(module, exports) {

$parcel$export(module.exports, "DependencyEnvelopeCreator", function () { return $7ab23b48e4b51675$export$74e603a08a7deabe; });
$parcel$export(module.exports, "EventEnvelopeCreator", function () { return $7ab23b48e4b51675$export$b74153364c2066d1; });
$parcel$export(module.exports, "ExceptionEnvelopeCreator", function () { return $7ab23b48e4b51675$export$eca78b65eeb356ed; });
$parcel$export(module.exports, "MetricEnvelopeCreator", function () { return $7ab23b48e4b51675$export$bb5bee4039a2e495; });
$parcel$export(module.exports, "PageViewEnvelopeCreator", function () { return $7ab23b48e4b51675$export$edbb8a2c6529947a; });
$parcel$export(module.exports, "PageViewPerformanceEnvelopeCreator", function () { return $7ab23b48e4b51675$export$bb801863268e7049; });
$parcel$export(module.exports, "TraceEnvelopeCreator", function () { return $7ab23b48e4b51675$export$bc9e843f2eb8a61c; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $cWQSw = parcelRequire("cWQSw");
var $03HBY = parcelRequire("03HBY");
var $i2MiW = parcelRequire("i2MiW");
var $awDWn = parcelRequire("awDWn");
var $9rbbk = parcelRequire("9rbbk");
var $g5yzi = parcelRequire("g5yzi");
var $cVsUj = parcelRequire("cVsUj");
var $jMj33 = parcelRequire("jMj33");
var $czkZK = parcelRequire("czkZK");
var $cAmBy = parcelRequire("cAmBy");
var $cXuOT = parcelRequire("cXuOT");
var $7iT8I = parcelRequire("7iT8I");

var $i86yL = parcelRequire("i86yL");
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");

var $jAvZE = parcelRequire("jAvZE");

var $a2D3N = parcelRequire("a2D3N");
// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var $7ab23b48e4b51675$var$strBaseType = "baseType";
var $7ab23b48e4b51675$var$strBaseData = "baseData";
var $7ab23b48e4b51675$var$strProperties = "properties";
var $7ab23b48e4b51675$var$strTrue = "true";
function $7ab23b48e4b51675$var$_setValueIf(target, field, value) {
    return (0, $hGXAo.setValue)(target, field, value, (0, $hGXAo.isTruthy));
}
/*
 * Maps Part A data from CS 4.0
 */ function $7ab23b48e4b51675$var$_extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] = env[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] = item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] || [];
    var extUser = itmExt.user;
    if (extUser) {
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).userAuthUserId, extUser.authId);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).sessionId, extApp.sesId);
    var extDevice = itmExt.device;
    if (extDevice) {
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceId, extDevice.id || extDevice.localId);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys)[0, $a2D3N._DYN_DEVICE_TYPE /* @min:%2edeviceType */ ], extDevice.deviceClass);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceIp, extDevice.ip);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceModel, extDevice.model);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys)[0, $a2D3N._DYN_DEVICE_TYPE /* @min:%2edeviceType */ ], extDevice[0, $a2D3N._DYN_DEVICE_TYPE /* @min:%2edeviceType */ ]);
    }
    var web = item.ext.web;
    if (web) {
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceLanguage, web.browserLang);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceBrowserVersion, web.browserVer);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceBrowser, web.browser);
        var envData = env[0, $a2D3N._DYN_DATA /* @min:%2edata */ ] = env[0, $a2D3N._DYN_DATA /* @min:%2edata */ ] || {};
        var envBaseData = envData[$7ab23b48e4b51675$var$strBaseData] = envData[$7ab23b48e4b51675$var$strBaseData] || {};
        var envProps = envBaseData[$7ab23b48e4b51675$var$strProperties] = envBaseData[$7ab23b48e4b51675$var$strProperties] || {};
        $7ab23b48e4b51675$var$_setValueIf(envProps, "domain", web.domain);
        $7ab23b48e4b51675$var$_setValueIf(envProps, "isManual", web.isManual ? $7ab23b48e4b51675$var$strTrue : null);
        $7ab23b48e4b51675$var$_setValueIf(envProps, "screenRes", web.screenRes);
        $7ab23b48e4b51675$var$_setValueIf(envProps, "userConsent", web.userConsent ? $7ab23b48e4b51675$var$strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).deviceOS, extOs[0, $a2D3N._DYN_NAME /* @min:%2ename */ ]);
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).operationParentId, extTrace.parentID);
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).operationName, (0, $i2MiW.dataSanitizeString)(logger, extTrace[0, $a2D3N._DYN_NAME /* @min:%2ename */ ]));
        $7ab23b48e4b51675$var$_setValueIf(envTags, (0, $cWQSw.CtxTagKeys).operationId, extTrace[0, $a2D3N._DYN_TRACE_ID /* @min:%2etraceID */ ]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for(var i = itmTags[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] - 1; i >= 0; i--){
        var tg = itmTags[i];
        (0, $hGXAo.objForEachKey)(tg, function(key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    (0, $hGXAo.objForEachKey)(itmTags, function(tg, value) {
        tgs[tg] = value;
    });
    var theTags = (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, envTags), tgs);
    if (!theTags[(0, $cWQSw.CtxTagKeys).internalSdkVersion]) // Append a version in case it is not already set
    theTags[(0, $cWQSw.CtxTagKeys).internalSdkVersion] = (0, $i2MiW.dataSanitizeString)(logger, "javascript:".concat($7ab23b48e4b51675$export$3f11c9a3e644970c.Version), 64);
    env[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] = (0, $hGXAo.optimizeObject)(theTags);
}
function $7ab23b48e4b51675$var$_extractPropsAndMeasurements(data, properties, measurements) {
    if (!(0, $hGXAo.isNullOrUndefined)(data)) (0, $hGXAo.objForEachKey)(data, function(key, value) {
        if ((0, $hGXAo.isNumber)(value)) measurements[key] = value;
        else if ((0, $hGXAo.isString)(value)) properties[key] = value;
        else if ((0, $bU24K.hasJSON)()) properties[key] = (0, $bU24K.getJSON)()[0, $a2D3N._DYN_STRINGIFY /* @min:%2estringify */ ](value);
    });
}
function $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!(0, $hGXAo.isNullOrUndefined)(properties)) (0, $hGXAo.objForEachKey)(properties, function(key, value) {
        properties[key] = value || customUndefinedValue;
    });
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function $7ab23b48e4b51675$var$_createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new (0, $awDWn.Envelope)(logger, data, envelopeType);
    $7ab23b48e4b51675$var$_setValueIf(envelope, "sampleRate", telemetryItem[0, $cVsUj.SampleRate]);
    if ((telemetryItem[$7ab23b48e4b51675$var$strBaseData] || {}).startTime) envelope.time = (0, $hGXAo.toISOString)(telemetryItem[$7ab23b48e4b51675$var$strBaseData].startTime);
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[0, $a2D3N._DYN_NAME /* @min:%2ename */ ] = envelope[0, $a2D3N._DYN_NAME /* @min:%2ename */ ].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    $7ab23b48e4b51675$var$_extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] = telemetryItem[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] || [];
    return (0, $hGXAo.optimizeObject)(envelope);
}
function $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem) {
    if ((0, $hGXAo.isNullOrUndefined)(telemetryItem[$7ab23b48e4b51675$var$strBaseData])) (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */ , "telemetryItem.baseData cannot be null.");
}
var $7ab23b48e4b51675$export$3f11c9a3e644970c = {
    Version: "2.8.18"
};
function $7ab23b48e4b51675$export$74e603a08a7deabe(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[$7ab23b48e4b51675$var$strBaseData][0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$7ab23b48e4b51675$var$strBaseData][$7ab23b48e4b51675$var$strProperties] || {};
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$7ab23b48e4b51675$var$strBaseData];
    if ((0, $hGXAo.isNullOrUndefined)(bd)) {
        (0, $i86yL._warnToConsole)(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[$7ab23b48e4b51675$var$strProperties] && bd[$7ab23b48e4b51675$var$strProperties][0, $cVsUj.HttpMethod] ? bd[$7ab23b48e4b51675$var$strProperties][0, $cVsUj.HttpMethod] : "GET";
    var remoteDepData = new (0, $cXuOT.RemoteDependencyData)(logger, bd.id, bd.target, bd[0, $a2D3N._DYN_NAME /* @min:%2ename */ ], bd[0, $jAvZE.STR_DURATION /* @min:%2eduration */ ], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new (0, $03HBY.Data)((0, $cXuOT.RemoteDependencyData)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], remoteDepData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $cXuOT.RemoteDependencyData)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $7ab23b48e4b51675$export$b74153364c2066d1(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[$7ab23b48e4b51675$var$strBaseType] !== (0, $9rbbk.Event)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ]) customProperties["baseTypeSource"] = telemetryItem[$7ab23b48e4b51675$var$strBaseType]; // save the passed in base type as a property
    if (telemetryItem[$7ab23b48e4b51675$var$strBaseType] === (0, $9rbbk.Event)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ]) {
        customProperties = telemetryItem[$7ab23b48e4b51675$var$strBaseData][$7ab23b48e4b51675$var$strProperties] || {};
        customMeasurements = telemetryItem[$7ab23b48e4b51675$var$strBaseData][0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    } else if (telemetryItem[$7ab23b48e4b51675$var$strBaseData]) $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[$7ab23b48e4b51675$var$strBaseData], customProperties, customMeasurements);
    // Extract root level properties from part C telemetryItem.data
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var eventName = telemetryItem[$7ab23b48e4b51675$var$strBaseData][0, $a2D3N._DYN_NAME /* @min:%2ename */ ];
    var eventData = new (0, $9rbbk.Event)(logger, eventName, customProperties, customMeasurements);
    var data = new (0, $03HBY.Data)((0, $9rbbk.Event)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], eventData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $9rbbk.Event)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $7ab23b48e4b51675$export$eca78b65eeb356ed(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[$7ab23b48e4b51675$var$strBaseData][0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$7ab23b48e4b51675$var$strBaseData][$7ab23b48e4b51675$var$strProperties] || {};
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$7ab23b48e4b51675$var$strBaseData];
    var exData = (0, $g5yzi.Exception).CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new (0, $03HBY.Data)((0, $g5yzi.Exception)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], exData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $g5yzi.Exception)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $7ab23b48e4b51675$export$bb5bee4039a2e495(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[$7ab23b48e4b51675$var$strBaseData];
    var props = baseData[$7ab23b48e4b51675$var$strProperties] || {};
    var measurements = baseData[0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], props, measurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseMetricData = new (0, $jMj33.Metric)(logger, baseData[0, $a2D3N._DYN_NAME /* @min:%2ename */ ], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new (0, $03HBY.Data)((0, $jMj33.Metric)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], baseMetricData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $jMj33.Metric)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $7ab23b48e4b51675$export$edbb8a2c6529947a(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[$7ab23b48e4b51675$var$strBaseData];
    if (!(0, $hGXAo.isNullOrUndefined)(baseData) && !(0, $hGXAo.isNullOrUndefined)(baseData[$7ab23b48e4b51675$var$strProperties]) && !(0, $hGXAo.isNullOrUndefined)(baseData[$7ab23b48e4b51675$var$strProperties][0, $jAvZE.STR_DURATION])) {
        duration = baseData[$7ab23b48e4b51675$var$strProperties][0, $jAvZE.STR_DURATION];
        delete baseData[$7ab23b48e4b51675$var$strProperties][0, $jAvZE.STR_DURATION];
    } else if (!(0, $hGXAo.isNullOrUndefined)(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ]) && !(0, $hGXAo.isNullOrUndefined)(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ][0, $jAvZE.STR_DURATION])) {
        duration = telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ][0, $jAvZE.STR_DURATION];
        delete telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ][0, $jAvZE.STR_DURATION];
    }
    var bd = telemetryItem[$7ab23b48e4b51675$var$strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[0, $a2D3N._DYN_TRACE_ID /* @min:%2etraceID */ ]) currentContextId = telemetryItem.ext.trace[0, $a2D3N._DYN_TRACE_ID /* @min:%2etraceID */ ];
    var id = bd.id || currentContextId;
    var name = bd[0, $a2D3N._DYN_NAME /* @min:%2ename */ ];
    var url = bd.uri;
    var properties = bd[$7ab23b48e4b51675$var$strProperties] || {};
    var measurements = bd[0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $hGXAo.isNullOrUndefined)(bd.refUri)) properties["refUri"] = bd.refUri;
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $hGXAo.isNullOrUndefined)(bd.pageType)) properties["pageType"] = bd.pageType;
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $hGXAo.isNullOrUndefined)(bd.isLoggedIn)) properties["isLoggedIn"] = bd.isLoggedIn[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]();
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $hGXAo.isNullOrUndefined)(bd[$7ab23b48e4b51675$var$strProperties])) {
        var pageTags = bd[$7ab23b48e4b51675$var$strProperties];
        (0, $hGXAo.objForEachKey)(pageTags, function(key, value) {
            properties[key] = value;
        });
    }
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], properties, measurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var pageViewData = new (0, $czkZK.PageView)(logger, name, url, duration, properties, measurements, id);
    var data = new (0, $03HBY.Data)((0, $czkZK.PageView)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], pageViewData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $czkZK.PageView)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $7ab23b48e4b51675$export$bb801863268e7049(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[$7ab23b48e4b51675$var$strBaseData];
    var name = bd[0, $a2D3N._DYN_NAME /* @min:%2ename */ ];
    var url = bd.uri || bd.url;
    var properties = bd[$7ab23b48e4b51675$var$strProperties] || {};
    var measurements = bd[0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], properties, measurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var baseData = new (0, $cAmBy.PageViewPerformance)(logger, name, url, undefined, properties, measurements, bd);
    var data = new (0, $03HBY.Data)((0, $cAmBy.PageViewPerformance)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], baseData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $cAmBy.PageViewPerformance)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $7ab23b48e4b51675$export$bc9e843f2eb8a61c(logger, telemetryItem, customUndefinedValue) {
    $7ab23b48e4b51675$var$EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[$7ab23b48e4b51675$var$strBaseData].message;
    var severityLevel = telemetryItem[$7ab23b48e4b51675$var$strBaseData].severityLevel;
    var props = telemetryItem[$7ab23b48e4b51675$var$strBaseData][$7ab23b48e4b51675$var$strProperties] || {};
    var measurements = telemetryItem[$7ab23b48e4b51675$var$strBaseData][0, $a2D3N._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    $7ab23b48e4b51675$var$_extractPropsAndMeasurements(telemetryItem[0, $a2D3N._DYN_DATA /* @min:%2edata */ ], props, measurements);
    if (!(0, $hGXAo.isNullOrUndefined)(customUndefinedValue)) $7ab23b48e4b51675$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseData = new (0, $7iT8I.Trace)(logger, message, severityLevel, props, measurements);
    var data = new (0, $03HBY.Data)((0, $7iT8I.Trace)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ], baseData);
    return $7ab23b48e4b51675$var$_createEnvelope(logger, (0, $7iT8I.Trace)[0, $a2D3N._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}

});
parcelRegister("jAvZE", function(module, exports) {

$parcel$export(module.exports, "STR_DURATION", function () { return $e42a325274dbe3eb$export$be41298b7716c698; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $e42a325274dbe3eb$export$be41298b7716c698 = "duration";

});

parcelRegister("a2D3N", function(module, exports) {

$parcel$export(module.exports, "_DYN_TAGS", function () { return $74f863cf9791434a$export$d0f526aa8043f6d7; });
$parcel$export(module.exports, "_DYN_DEVICE_TYPE", function () { return $74f863cf9791434a$export$f393dda3e1c87f59; });
$parcel$export(module.exports, "_DYN_DATA", function () { return $74f863cf9791434a$export$2f5ff0b46814907e; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $74f863cf9791434a$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_TRACE_ID", function () { return $74f863cf9791434a$export$a5eb52c53bba8560; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $74f863cf9791434a$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_STRINGIFY", function () { return $74f863cf9791434a$export$a318a8141fc98747; });
$parcel$export(module.exports, "_DYN_MEASUREMENTS", function () { return $74f863cf9791434a$export$32fc64677eb5b7a2; });
$parcel$export(module.exports, "_DYN_DATA_TYPE", function () { return $74f863cf9791434a$export$9e16762ab4f2648; });
$parcel$export(module.exports, "_DYN_ENVELOPE_TYPE", function () { return $74f863cf9791434a$export$2672d4f7ccc80348; });
$parcel$export(module.exports, "_DYN_TO_STRING", function () { return $74f863cf9791434a$export$e2818d11505fa034; });
$parcel$export(module.exports, "_DYN_ON_LINE", function () { return $74f863cf9791434a$export$a9130fdcd11ec7ef; });
$parcel$export(module.exports, "_DYN_IS_ONLINE", function () { return $74f863cf9791434a$export$704cf8098f85ad0f; });
$parcel$export(module.exports, "_DYN_ENQUEUE", function () { return $74f863cf9791434a$export$4aae77f3ba3c48b4; });
$parcel$export(module.exports, "_DYN_COUNT", function () { return $74f863cf9791434a$export$e9679ef501b0d1; });
$parcel$export(module.exports, "_DYN_EVENTS_LIMIT_IN_MEM", function () { return $74f863cf9791434a$export$c8dd872dc774fa7c; });
$parcel$export(module.exports, "_DYN_PUSH", function () { return $74f863cf9791434a$export$a0a330e7fa1e278c; });
$parcel$export(module.exports, "_DYN_EMIT_LINE_DELIMITED_0", function () { return $74f863cf9791434a$export$b18aabdfc0aaf6b; });
$parcel$export(module.exports, "_DYN_CLEAR", function () { return $74f863cf9791434a$export$5eeb73fac03da74a; });
$parcel$export(module.exports, "_DYN_BATCH_PAYLOADS", function () { return $74f863cf9791434a$export$a5da323a4da829fc; });
$parcel$export(module.exports, "_DYN_MARK_AS_SENT", function () { return $74f863cf9791434a$export$52e50651d87300e3; });
$parcel$export(module.exports, "_DYN_CLEAR_SENT", function () { return $74f863cf9791434a$export$13da1b5a005ef035; });
$parcel$export(module.exports, "_DYN_BUFFER_OVERRIDE", function () { return $74f863cf9791434a$export$4637bcb72c509e60; });
$parcel$export(module.exports, "_DYN__BUFFER__KEY", function () { return $74f863cf9791434a$export$63ab2dad6d8a60ed; });
$parcel$export(module.exports, "_DYN__SENT__BUFFER__KEY", function () { return $74f863cf9791434a$export$d03f333763905c89; });
$parcel$export(module.exports, "_DYN__MAX__BUFFER__SIZE", function () { return $74f863cf9791434a$export$20d3a25105cda3b1; });
$parcel$export(module.exports, "_DYN_NAME_PREFIX", function () { return $74f863cf9791434a$export$6d013a7bc2da53c1; });
$parcel$export(module.exports, "_DYN_MAX_BATCH_SIZE_IN_BY1", function () { return $74f863cf9791434a$export$803d432e48ba5ceb; });
$parcel$export(module.exports, "_DYN_TRIGGER_SEND", function () { return $74f863cf9791434a$export$df21ab0de9057cc4; });
$parcel$export(module.exports, "_DYN_DIAG_LOG", function () { return $74f863cf9791434a$export$c7ff2c36e5c78421; });
$parcel$export(module.exports, "_DYN_ONUNLOAD_DISABLE_BEA2", function () { return $74f863cf9791434a$export$6b8e1dc9b77f253c; });
$parcel$export(module.exports, "_DYN_IS_BEACON_API_DISABL3", function () { return $74f863cf9791434a$export$f5629284a6f7ec3d; });
$parcel$export(module.exports, "_DYN__SENDER", function () { return $74f863cf9791434a$export$e5390b88ba6f1b04; });
$parcel$export(module.exports, "_DYN__SENDER_CONFIG", function () { return $74f863cf9791434a$export$82b4fc64eafa0acf; });
$parcel$export(module.exports, "_DYN_ENABLE_SESSION_STORA4", function () { return $74f863cf9791434a$export$782dd40ba58c3597; });
$parcel$export(module.exports, "_DYN__BUFFER", function () { return $74f863cf9791434a$export$3f8a6394c5f7e7be; });
$parcel$export(module.exports, "_DYN_SAMPLING_PERCENTAGE", function () { return $74f863cf9791434a$export$51ccd61d31b31ade; });
$parcel$export(module.exports, "_DYN_INSTRUMENTATION_KEY", function () { return $74f863cf9791434a$export$81cfd43387c8dbcc; });
$parcel$export(module.exports, "_DYN_ENDPOINT_URL", function () { return $74f863cf9791434a$export$bfa1c9e5dcf1e78; });
$parcel$export(module.exports, "_DYN_CUSTOM_HEADERS", function () { return $74f863cf9791434a$export$dbe59923e879fdc5; });
$parcel$export(module.exports, "_DYN_DISABLE_XHR", function () { return $74f863cf9791434a$export$85f018eb7798fb52; });
$parcel$export(module.exports, "_DYN_ONUNLOAD_DISABLE_FET5", function () { return $74f863cf9791434a$export$d1f891e9714d3108; });
$parcel$export(module.exports, "_DYN_DISABLE_TELEMETRY", function () { return $74f863cf9791434a$export$99a824310ffb055; });
$parcel$export(module.exports, "_DYN_BASE_TYPE", function () { return $74f863cf9791434a$export$aa558e99f83347cf; });
$parcel$export(module.exports, "_DYN_SAMPLE_RATE", function () { return $74f863cf9791434a$export$c2afe23fa18f9dff; });
$parcel$export(module.exports, "_DYN_CONVERT_UNDEFINED", function () { return $74f863cf9791434a$export$12df46deb7379c67; });
$parcel$export(module.exports, "_DYN__XHR_READY_STATE_CHA6", function () { return $74f863cf9791434a$export$9b55da9813cf231b; });
$parcel$export(module.exports, "_DYN__ON_ERROR", function () { return $74f863cf9791434a$export$fd0c91d4da43d71b; });
$parcel$export(module.exports, "_DYN__ON_PARTIAL_SUCCESS", function () { return $74f863cf9791434a$export$689c49d56ac33585; });
$parcel$export(module.exports, "_DYN__ON_SUCCESS", function () { return $74f863cf9791434a$export$82a109ffee49e423; });
$parcel$export(module.exports, "_DYN_ITEMS_ACCEPTED", function () { return $74f863cf9791434a$export$fb8523c8667e286a; });
$parcel$export(module.exports, "_DYN_ITEMS_RECEIVED", function () { return $74f863cf9791434a$export$746df81af2cb9d94; });
$parcel$export(module.exports, "_DYN_IS_RETRY_DISABLED", function () { return $74f863cf9791434a$export$daf21ca1b4199d89; });
$parcel$export(module.exports, "_DYN_SET_REQUEST_HEADER", function () { return $74f863cf9791434a$export$84ecd29f369f5b1d; });
$parcel$export(module.exports, "_DYN_MAX_BATCH_INTERVAL", function () { return $74f863cf9791434a$export$983774f06380e463; });
$parcel$export(module.exports, "_DYN_EVENTS_SEND_REQUEST", function () { return $74f863cf9791434a$export$298b8388870fcfe9; });
$parcel$export(module.exports, "_DYN_DISABLE_INSTRUMENTAT7", function () { return $74f863cf9791434a$export$87cff5e4f8bac22c; });
$parcel$export(module.exports, "_DYN_GET_SAMPLING_SCORE", function () { return $74f863cf9791434a$export$2c3af30a5c45aa6e; });
$parcel$export(module.exports, "_DYN_GET_HASH_CODE_SCORE", function () { return $74f863cf9791434a$export$d676f8c50f371355; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $74f863cf9791434a$export$d0f526aa8043f6d7 = "tags"; // Count: 17
var $74f863cf9791434a$export$f393dda3e1c87f59 = "deviceType"; // Count: 3
var $74f863cf9791434a$export$2f5ff0b46814907e = "data"; // Count: 13
var $74f863cf9791434a$export$9734b0a24bf02e93 = "name"; // Count: 8
var $74f863cf9791434a$export$a5eb52c53bba8560 = "traceID"; // Count: 5
var $74f863cf9791434a$export$6eae51590aaea43 = "length"; // Count: 37
var $74f863cf9791434a$export$a318a8141fc98747 = "stringify"; // Count: 5
var $74f863cf9791434a$export$32fc64677eb5b7a2 = "measurements"; // Count: 7
var $74f863cf9791434a$export$9e16762ab4f2648 = "dataType"; // Count: 10
var $74f863cf9791434a$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $74f863cf9791434a$export$e2818d11505fa034 = "toString"; // Count: 7
var $74f863cf9791434a$export$a9130fdcd11ec7ef = "onLine"; // Count: 4
var $74f863cf9791434a$export$704cf8098f85ad0f = "isOnline"; // Count: 3
var $74f863cf9791434a$export$4aae77f3ba3c48b4 = "enqueue"; // Count: 5
var $74f863cf9791434a$export$e9679ef501b0d1 = "count"; // Count: 6
var $74f863cf9791434a$export$c8dd872dc774fa7c = "eventsLimitInMem"; // Count: 2
var $74f863cf9791434a$export$a0a330e7fa1e278c = "push"; // Count: 6
var $74f863cf9791434a$export$b18aabdfc0aaf6b = "emitLineDelimitedJson"; // Count: 3
var $74f863cf9791434a$export$5eeb73fac03da74a = "clear"; // Count: 6
var $74f863cf9791434a$export$a5da323a4da829fc = "batchPayloads"; // Count: 5
var $74f863cf9791434a$export$52e50651d87300e3 = "markAsSent"; // Count: 6
var $74f863cf9791434a$export$13da1b5a005ef035 = "clearSent"; // Count: 5
var $74f863cf9791434a$export$4637bcb72c509e60 = "bufferOverride"; // Count: 3
var $74f863cf9791434a$export$63ab2dad6d8a60ed = "BUFFER_KEY"; // Count: 5
var $74f863cf9791434a$export$d03f333763905c89 = "SENT_BUFFER_KEY"; // Count: 7
var $74f863cf9791434a$export$20d3a25105cda3b1 = "MAX_BUFFER_SIZE"; // Count: 5
var $74f863cf9791434a$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 6
var $74f863cf9791434a$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 3
var $74f863cf9791434a$export$df21ab0de9057cc4 = "triggerSend"; // Count: 6
var $74f863cf9791434a$export$c7ff2c36e5c78421 = "diagLog"; // Count: 15
var $74f863cf9791434a$export$6b8e1dc9b77f253c = "onunloadDisableBeacon"; // Count: 2
var $74f863cf9791434a$export$f5629284a6f7ec3d = "isBeaconApiDisabled"; // Count: 3
var $74f863cf9791434a$export$e5390b88ba6f1b04 = "_sender"; // Count: 5
var $74f863cf9791434a$export$82b4fc64eafa0acf = "_senderConfig"; // Count: 4
var $74f863cf9791434a$export$782dd40ba58c3597 = "enableSessionStorageBuffer"; // Count: 2
var $74f863cf9791434a$export$3f8a6394c5f7e7be = "_buffer"; // Count: 9
var $74f863cf9791434a$export$51ccd61d31b31ade = "samplingPercentage"; // Count: 2
var $74f863cf9791434a$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 4
var $74f863cf9791434a$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 8
var $74f863cf9791434a$export$dbe59923e879fdc5 = "customHeaders"; // Count: 4
var $74f863cf9791434a$export$85f018eb7798fb52 = "disableXhr"; // Count: 5
var $74f863cf9791434a$export$d1f891e9714d3108 = "onunloadDisableFetch"; // Count: 2
var $74f863cf9791434a$export$99a824310ffb055 = "disableTelemetry"; // Count: 2
var $74f863cf9791434a$export$aa558e99f83347cf = "baseType"; // Count: 4
var $74f863cf9791434a$export$c2afe23fa18f9dff = "sampleRate"; // Count: 4
var $74f863cf9791434a$export$12df46deb7379c67 = "convertUndefined"; // Count: 2
var $74f863cf9791434a$export$9b55da9813cf231b = "_xhrReadyStateChange"; // Count: 2
var $74f863cf9791434a$export$fd0c91d4da43d71b = "_onError"; // Count: 11
var $74f863cf9791434a$export$689c49d56ac33585 = "_onPartialSuccess"; // Count: 3
var $74f863cf9791434a$export$82a109ffee49e423 = "_onSuccess"; // Count: 6
var $74f863cf9791434a$export$fb8523c8667e286a = "itemsAccepted"; // Count: 5
var $74f863cf9791434a$export$746df81af2cb9d94 = "itemsReceived"; // Count: 6
var $74f863cf9791434a$export$daf21ca1b4199d89 = "isRetryDisabled"; // Count: 5
var $74f863cf9791434a$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $74f863cf9791434a$export$983774f06380e463 = "maxBatchInterval"; // Count: 2
var $74f863cf9791434a$export$298b8388870fcfe9 = "eventsSendRequest"; // Count: 2
var $74f863cf9791434a$export$87cff5e4f8bac22c = "disableInstrumentationKeyValidation"; // Count: 2
var $74f863cf9791434a$export$2c3af30a5c45aa6e = "getSamplingScore"; // Count: 2
var $74f863cf9791434a$export$d676f8c50f371355 = "getHashCodeScore"; // Count: 4

});


parcelRegister("6Mo87", function(module, exports) {

$parcel$export(module.exports, "createOfflineListener", function () { return $4ef9f17eec476db1$export$798b7fe42d5e3d06; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $5GGqM = parcelRequire("5GGqM");
var $lhl6R = parcelRequire("lhl6R");
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");

var $a2D3N = parcelRequire("a2D3N");
function $4ef9f17eec476db1$var$_disableEvents(target, evtNamespace) {
    (0, $lhl6R.eventOff)(target, null, null, evtNamespace);
}
function $4ef9f17eec476db1$export$798b7fe42d5e3d06(parentEvtNamespace) {
    var _a;
    var _document = (0, $bU24K.getDocument)();
    var _navigator = (0, $bU24K.getNavigator)(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var _onlineStatus = true;
    var _evtNamespace = (0, $lhl6R.mergeEvtNamespace)((0, $5GGqM.createUniqueNamespace)("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents((0, $bU24K.getWindow)())) _isListening = true;
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) _isListening = true;
            }
        }
        if (_isListening) // We are listening to events so lets set the current status rather than assuming we are online #1538
        {
            if (_navigator && !(0, $hGXAo.isNullOrUndefined)(_navigator[0, $a2D3N._DYN_ON_LINE /* @min:%2eonLine */ ])) _onlineStatus = _navigator[0, $a2D3N._DYN_ON_LINE /* @min:%2eonLine */ ];
        }
    } catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = (0, $lhl6R.eventOn)(target, "online", _setOnline, _evtNamespace);
            if (enabled) (0, $lhl6R.eventOn)(target, "offline", _setOffline, _evtNamespace);
        }
        return enabled;
    }
    function _setOnline() {
        _onlineStatus = true;
    }
    function _setOffline() {
        _onlineStatus = false;
    }
    function _isOnline() {
        var result = true;
        if (_isListening) result = _onlineStatus;
        else if (_navigator && !(0, $hGXAo.isNullOrUndefined)(_navigator[0, $a2D3N._DYN_ON_LINE /* @min:%2eonLine */ ])) result = _navigator[0, $a2D3N._DYN_ON_LINE /* @min:%2eonLine */ ];
        return result;
    }
    function _unload() {
        var win = (0, $bU24K.getWindow)();
        if (win && _isListening) {
            $4ef9f17eec476db1$var$_disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!(0, $hGXAo.isUndefined)(target.ononline)) $4ef9f17eec476db1$var$_disableEvents(target, _evtNamespace);
            }
            _isListening = false;
        }
    }
    return _a = {}, _a[0, $a2D3N._DYN_IS_ONLINE /* @min:isOnline */ ] = _isOnline, _a.isListening = function() {
        return _isListening;
    }, _a.unload = _unload, _a;
}

});

parcelRegister("lGJIn", function(module, exports) {

$parcel$export(module.exports, "ArraySendBuffer", function () { return $fca0fb36f379acc4$export$d706e5fd60d36d56; });
$parcel$export(module.exports, "SessionStorageSendBuffer", function () { return $fca0fb36f379acc4$export$dcb776947c16915f; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $h1GMI = parcelRequire("h1GMI");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $bU24K = parcelRequire("bU24K");

var $a2D3N = parcelRequire("a2D3N");
var $fca0fb36f379acc4$var$BaseSendBuffer = /** @class */ function() {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this._get = function() {
            return _buffer;
        };
        this._set = function(buffer) {
            _buffer = buffer;
            return _buffer;
        };
        (0, $bO3cR.default)(BaseSendBuffer, this, function(_self) {
            _self[0, $a2D3N._DYN_ENQUEUE /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $a2D3N._DYN_COUNT /* @min:%2ecount */ ]() >= config[0, $a2D3N._DYN_EVENTS_LIMIT_IN_MEM /* @min:%2eeventsLimitInMem */ ]()) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 105 /* _eInternalMessageId.InMemoryStorageBufferFull */ , "Maximum in-memory buffer size reached: " + _self[0, $a2D3N._DYN_COUNT /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[0, $a2D3N._DYN_PUSH /* @min:%2epush */ ](payload);
            };
            _self[0, $a2D3N._DYN_COUNT /* @min:%2ecount */ ] = function() {
                return _buffer[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ];
            };
            _self.size = function() {
                var size = _buffer[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ];
                for(var lp = 0; lp < _buffer[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]; lp++)size += _buffer[lp][0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ];
                if (!config[0, $a2D3N._DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */ ]()) size += 2;
                return size;
            };
            _self[0, $a2D3N._DYN_CLEAR /* @min:%2eclear */ ] = function() {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function() {
                return _buffer.slice(0);
            };
            _self[0, $a2D3N._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ] = function(payload) {
                if (payload && payload[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    var batch = config[0, $a2D3N._DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */ ]() ? payload.join("\n") : "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
        });
    }
    // Removed Stub for BaseSendBuffer.prototype.enqueue.
    // Removed Stub for BaseSendBuffer.prototype.count.
    // Removed Stub for BaseSendBuffer.prototype.size.
    // Removed Stub for BaseSendBuffer.prototype.clear.
    // Removed Stub for BaseSendBuffer.prototype.getItems.
    // Removed Stub for BaseSendBuffer.prototype.batchPayloads.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseSendBuffer.__ieDyn = 1;
    return BaseSendBuffer;
}();
/*
 * An array based send buffer.
 */ var $fca0fb36f379acc4$export$d706e5fd60d36d56 = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        (0, $bO3cR.default)(ArraySendBuffer, _this, function(_self, _base) {
            _self[0, $a2D3N._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ] = function(payload) {
                _base[0, $a2D3N._DYN_CLEAR /* @min:%2eclear */ ]();
            };
            _self[0, $a2D3N._DYN_CLEAR_SENT /* @min:%2eclearSent */ ] = function(payload) {
            // not supported
            };
        });
        return _this;
    }
    // Removed Stub for ArraySendBuffer.prototype.markAsSent.
    // Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ArraySendBuffer.__ieDyn = 1;
    return ArraySendBuffer;
}($fca0fb36f379acc4$var$BaseSendBuffer);
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */ var $fca0fb36f379acc4$export$dcb776947c16915f = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        var _a = config[0, $a2D3N._DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */ ]() || {
            getItem: (0, $h1GMI.utlGetSessionStorage),
            setItem: (0, $h1GMI.utlSetSessionStorage)
        }, getItem = _a.getItem, setItem = _a.setItem;
        (0, $bO3cR.default)(SessionStorageSendBuffer, _this, function(_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $a2D3N._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ]) buffer[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $a2D3N._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ];
            _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], []);
            _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], buffer);
            _self[0, $a2D3N._DYN_ENQUEUE /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $a2D3N._DYN_COUNT /* @min:%2ecount */ ]() >= SessionStorageSendBuffer[0, $a2D3N._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Maximum buffer size reached: " + _self[0, $a2D3N._DYN_COUNT /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[0, $a2D3N._DYN_ENQUEUE /* @min:%2eenqueue */ ](payload);
                _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], _self._get());
            };
            _self[0, $a2D3N._DYN_CLEAR /* @min:%2eclear */ ] = function() {
                _base[0, $a2D3N._DYN_CLEAR /* @min:%2eclear */ ]();
                _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], _self._get());
                _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], []);
                _bufferFullMessageSent = false;
            };
            _self[0, $a2D3N._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ] = function(payload) {
                _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $a2D3N._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Sent buffer reached its maximum size: " + sentElements[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ], true);
                        sentElements[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $a2D3N._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ];
                    }
                    _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
                }
            };
            _self[0, $a2D3N._DYN_CLEAR_SENT /* @min:%2eclearSent */ ] = function(payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[0, $a2D3N._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                (0, $hGXAo.arrForEach)(buffer, function(value) {
                    if (!(0, $hGXAo.isFunction)(value) && (0, $hGXAo.arrIndexOf)(payloads, value) === -1) remaining[0, $a2D3N._DYN_PUSH /* @min:%2epush */ ](value);
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = config[0, $a2D3N._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && config[0, $a2D3N._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? config[0, $a2D3N._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = (0, $bU24K.getJSON)().parse(bufferJson);
                        if ((0, $hGXAo.isString)(buffer_1)) // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                        buffer_1 = (0, $bU24K.getJSON)().parse(buffer_1);
                        if (buffer_1 && (0, $hGXAo.isArray)(buffer_1)) return buffer_1;
                    }
                } catch (e) {
                    (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = config[0, $a2D3N._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && config[0, $a2D3N._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? config[0, $a2D3N._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[0, $a2D3N._DYN_STRINGIFY /* @min:%2estringify */ ](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                } catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[0, $a2D3N._DYN_STRINGIFY /* @min:%2estringify */ ]([]));
                    (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $hGXAo.getExceptionName)(e) + ". Buffer cleared", {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            }
        });
        return _this;
    }
    // Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
    // Removed Stub for SessionStorageSendBuffer.prototype.clear.
    // Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}($fca0fb36f379acc4$var$BaseSendBuffer);

});

parcelRegister("ffWC0", function(module, exports) {

$parcel$export(module.exports, "Serializer", function () { return $b1b5b8d89b2636d0$export$ef852775387a0be7; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $i86yL = parcelRequire("i86yL");
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");

var $a2D3N = parcelRequire("a2D3N");
var $b1b5b8d89b2636d0$export$ef852775387a0be7 = /** @class */ function() {
    function Serializer(logger) {
        (0, $bO3cR.default)(Serializer, this, function(_self) {
            /**
             * Serializes the current object to a JSON string.
             */ _self.serialize = function(input) {
                var output = _serializeObject(input, "root");
                try {
                    return (0, $bU24K.getJSON)()[0, $a2D3N._DYN_STRINGIFY /* @min:%2estringify */ ](output);
                } catch (e) {
                    // if serialization fails return an empty string
                    (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $hGXAo.isFunction)(e[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]) ? e[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , "cannot serialize object because it is null or undefined", {
                        name: name
                    }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 50 /* _eInternalMessageId.CircularReferenceDetected */ , "Circular reference detected while serializing object", {
                        name: name
                    }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") output = _serializeStringMap(source, "number", name);
                    else if (name === "properties") output = _serializeStringMap(source, "string", name);
                    else if (name === "tags") output = _serializeStringMap(source, "string", name);
                    else if ((0, $hGXAo.isArray)(source)) output = _serializeArray(source, name);
                    else {
                        (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "Attempting to serialize an object which does not implement ISerializable", {
                            name: name
                        }, true);
                        try {
                            // verify that the object can be stringified
                            (0, $bU24K.getJSON)()[0, $a2D3N._DYN_STRINGIFY /* @min:%2estringify */ ](source);
                            output = source;
                        } catch (e) {
                            // if serialization fails return an empty string
                            (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $hGXAo.isFunction)(e[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]) ? e[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                (0, $hGXAo.objForEachKey)(source.aiDataContract, function(field, contract) {
                    var isRequired = (0, $hGXAo.isFunction)(contract) ? contract() & 1 /* FieldType.Required */  : contract & 1 /* FieldType.Required */ ;
                    var isHidden = (0, $hGXAo.isFunction)(contract) ? contract() & 4 /* FieldType.Hidden */  : contract & 4 /* FieldType.Hidden */ ;
                    var isArray = contract & 2 /* FieldType.Array */ ;
                    var isPresent = source[field] !== undefined;
                    var isObj = (0, $hGXAo.isObject)(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */ , "Missing required field specification. The field is required but not present on source", {
                        field: field,
                        name: name
                    });
                    else if (!isHidden) {
                        var value = void 0;
                        if (isObj) {
                            if (isArray) // special case; recurse on each object in the source array
                            value = _serializeArray(source[field], field);
                            else // recurse on the source object in this field
                            value = _serializeObject(source[field], field);
                        } else // assign the source field to the output even if undefined or required
                        value = source[field];
                        // only emit this field if the value is defined
                        if (value !== undefined) output[field] = value;
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!(0, $hGXAo.isArray)(sources)) (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 54 /* _eInternalMessageId.ItemNotInArray */ , "This field was specified as an array in the contract but the item is not an array.\r\n", {
                        name: name
                    }, true);
                    else {
                        output = [];
                        for(var i = 0; i < sources[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]; i++){
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[0, $a2D3N._DYN_PUSH /* @min:%2epush */ ](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    (0, $hGXAo.objForEachKey)(map, function(field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else if (!value[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]) output[field] = "invalid field: toString() is not defined.";
                            else output[field] = value[0, $a2D3N._DYN_TO_STRING /* @min:%2etoString */ ]();
                        } else if (expectedType === "number") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else {
                                var num = parseFloat(value);
                                if (isNaN(num)) output[field] = "NaN";
                                else output[field] = num;
                            }
                        } else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            (0, $i86yL._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
    // Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    Serializer.__ieDyn = 1;
    return Serializer;
}();

});

parcelRegister("gfcch", function(module, exports) {

$parcel$export(module.exports, "Sample", function () { return $bd3782212e4a1ffa$export$21a3eccb8a1780eb; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $jMj33 = parcelRequire("jMj33");

var $i86yL = parcelRequire("i86yL");

var $a2D3N = parcelRequire("a2D3N");

var $1AKR8 = parcelRequire("1AKR8");
var $bd3782212e4a1ffa$export$21a3eccb8a1780eb = /** @class */ function() {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || (0, $i86yL.safeGetLogger)(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */ , 58 /* _eInternalMessageId.SampleRateOutOfRange */ , "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", {
                samplingRate: sampleRate
            }, true);
            sampleRate = 100;
        }
        this[0, $a2D3N._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ] = sampleRate;
        this.samplingScoreGenerator = new (0, $1AKR8.SamplingScoreGenerator)();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */ Sample.prototype.isSampledIn = function(envelope) {
        var samplingPercentage = this[0, $a2D3N._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) return true;
        else if (envelope.baseType === (0, $jMj33.Metric)[0, $a2D3N._DYN_DATA_TYPE /* @min:%2edataType */ ]) // exclude MetricData telemetry from sampling
        return true;
        isSampledIn = this.samplingScoreGenerator[0, $a2D3N._DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */ ](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}();

});
parcelRegister("1AKR8", function(module, exports) {

$parcel$export(module.exports, "SamplingScoreGenerator", function () { return $128d7fdf7805787a$export$4526db980ad5b8a1; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $llS2C = parcelRequire("llS2C");

var $a2D3N = parcelRequire("a2D3N");

var $elMQn = parcelRequire("elMQn");
var $128d7fdf7805787a$export$4526db980ad5b8a1 = /** @class */ function() {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new (0, $elMQn.HashCodeScoreGenerator)();
        var keys = new (0, $llS2C.ContextTagKeys)();
        _self[0, $a2D3N._DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */ ] = function(item) {
            var score = 0;
            if (item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] && item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][keys.userId]) score = hashCodeGenerator.getHashCodeScore(item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][keys.userId]);
            else if (item.ext && item.ext.user && item.ext.user.id) score = hashCodeGenerator[0, $a2D3N._DYN_GET_HASH_CODE_SCORE /* @min:%2egetHashCodeScore */ ](item.ext.user.id);
            else if (item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ] && item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][keys.operationId]) score = hashCodeGenerator.getHashCodeScore(item[0, $a2D3N._DYN_TAGS /* @min:%2etags */ ][keys.operationId]);
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[0, $a2D3N._DYN_TRACE_ID /* @min:%2etraceID */ ]) score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[0, $a2D3N._DYN_TRACE_ID /* @min:%2etraceID */ ]);
            else // tslint:disable-next-line:insecure-random
            score = Math.random() * 100;
            return score;
        };
    }
    return SamplingScoreGenerator;
}();

});
parcelRegister("elMQn", function(module, exports) {

$parcel$export(module.exports, "HashCodeScoreGenerator", function () { return $a728ea320b364756$export$e2bdf7ff70742e42; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $a2D3N = parcelRequire("a2D3N");
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var $a728ea320b364756$var$MIN_INPUT_LENGTH = 8;
var $a728ea320b364756$export$e2bdf7ff70742e42 = /** @class */ function() {
    function HashCodeScoreGenerator() {}
    HashCodeScoreGenerator.prototype.getHashCodeScore = function(key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function(input) {
        if (input === "") return 0;
        while(input[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ] < $a728ea320b364756$var$MIN_INPUT_LENGTH)input = input.concat(input);
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for(var i = 0; i < input[0, $a2D3N._DYN_LENGTH /* @min:%2elength */ ]; ++i){
            hash = (hash << 5) + hash + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}();

});




parcelRegister("aOa6H", function(module, exports) {

$parcel$export(module.exports, "AppInsightsCore", function () { return $7de669f397e97ac7$export$e7ac25a6828d23bf; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $dYOpt = parcelRequire("dYOpt");

var $i86yL = parcelRequire("i86yL");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $jsIWo = parcelRequire("jsIWo");

var $4LGgU = parcelRequire("4LGgU");
var $7de669f397e97ac7$export$e7ac25a6828d23bf = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        (0, $bO3cR.default)(AppInsightsCore, _this, function(_self, _base) {
            _self[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                _base[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ](config, extensions, logger || new (0, $i86yL.DiagnosticLogger)(config), notificationManager || new (0, $jsIWo.NotificationManager)(config));
            };
            _self.track = function(telemetryItem) {
                (0, $4LGgU.doPerf)(_self[0, $59IxV.STR_GET_PERF_MGR /* @min:%2egetPerfMgr */ ](), function() {
                    return "AppInsightsCore:track";
                }, function() {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        (0, $hGXAo.throwError)("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function() {
                    return {
                        item: telemetryItem
                    };
                }, !telemetryItem.sync);
            };
            function _validateTelemetryItem(telemetryItem) {
                if ((0, $hGXAo.isNullOrUndefined)(telemetryItem[0, $j5TD0._DYN_NAME /* @min:%2ename */ ])) {
                    _notifyInvalidEvent(telemetryItem);
                    (0, $hGXAo.throwError)("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[0, $j5TD0._DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */ ]();
                if (manager) manager[0, $59IxV.STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */ ]([
                    telemetryItem
                ], 2 /* eEventsDiscardedReason.InvalidEvent */ );
            }
        });
        return _this;
    }
    // Removed Stub for AppInsightsCore.prototype.initialize.
    // Removed Stub for AppInsightsCore.prototype.track.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    AppInsightsCore.__ieDyn = 1;
    return AppInsightsCore;
}((0, $dYOpt.BaseCore));

});
parcelRegister("dYOpt", function(module, exports) {

$parcel$export(module.exports, "BaseCore", function () { return $a2d7fb4a1b935431$export$21d040fe824fa2f5; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");
var $91dsF = parcelRequire("91dsF");

var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $a6QGM = parcelRequire("a6QGM");

var $hB9U1 = parcelRequire("hB9U1");

var $5GGqM = parcelRequire("5GGqM");

var $39sw1 = parcelRequire("39sw1");

var $i86yL = parcelRequire("i86yL");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $4LGgU = parcelRequire("4LGgU");

var $jx9Ci = parcelRequire("jx9Ci");

var $8ZAtX = parcelRequire("8ZAtX");

var $bKLC0 = parcelRequire("bKLC0");

var $eOe4Z = parcelRequire("eOe4Z");
"use strict";
var $a2d7fb4a1b935431$var$strValidationError = "Plugins must provide initialize method";
var $a2d7fb4a1b935431$var$strNotificationManager = "_notificationManager";
var $a2d7fb4a1b935431$var$strSdkUnloadingError = "SDK is still unloading...";
var $a2d7fb4a1b935431$var$strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
var $a2d7fb4a1b935431$var$defaultInitConfig = {
    // Have the Diagnostic Logger default to log critical errors to the console
    loggingLevelConsole: 1 /* eLoggingSeverity.CRITICAL */ 
};
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */ function $a2d7fb4a1b935431$var$_createPerfManager(core, notificationMgr) {
    return new (0, $4LGgU.PerfManager)(notificationMgr);
}
function $a2d7fb4a1b935431$var$_validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    (0, $hGXAo.arrForEach)(allExtensions, function(ext) {
        // Check for ext.initialize
        if ((0, $hGXAo.isNullOrUndefined)(ext) || (0, $hGXAo.isNullOrUndefined)(ext[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ])) (0, $hGXAo.throwError)($a2d7fb4a1b935431$var$strValidationError);
        var extPriority = ext[0, $59IxV.STR_PRIORITY /* @min:%2epriority */ ];
        var identifier = ext[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ];
        if (ext && extPriority) {
            if (!(0, $hGXAo.isNullOrUndefined)(extPriorities[extPriority])) (0, $i86yL._warnToConsole)(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            else // set a value
            extPriorities[extPriority] = identifier;
        }
        // Split extensions to core and channelController
        if (!extPriority || extPriority < channelPriority) // Add to core extension that will be managed by BaseCore
        coreExtensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](ext);
    });
    return _a = {
        all: allExtensions
    }, _a[0, $59IxV.STR_CORE /* @min:core */ ] = coreExtensions, _a;
}
function $a2d7fb4a1b935431$var$_isPluginPresent(thePlugin, plugins) {
    var exists = false;
    (0, $hGXAo.arrForEach)(plugins, function(plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function $a2d7fb4a1b935431$var$_createDummyNotificationManager() {
    var _a;
    return (0, $91dsF.objCreateFn)((_a = {}, _a[0, $j5TD0._DYN_ADD_NOTIFICATION_LIS1 /* @min:addNotificationListener */ ] = function(listener) {}, _a[0, $j5TD0._DYN_REMOVE_NOTIFICATION_2 /* @min:removeNotificationListener */ ] = function(listener) {}, _a[0, $59IxV.STR_EVENTS_SENT /* @min:eventsSent */ ] = function(events) {}, _a[0, $59IxV.STR_EVENTS_DISCARDED /* @min:eventsDiscarded */ ] = function(events, reason) {}, _a[0, $59IxV.STR_EVENTS_SEND_REQUEST /* @min:eventsSendRequest */ ] = function(sendReason, isAsync) {}, _a));
}
var $a2d7fb4a1b935431$export$21d040fe824fa2f5 = /** @class */ function() {
    function BaseCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _config;
        var _isInitialized;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _coreExtensions;
        var _channelControl;
        var _channelConfig;
        var _channelQueue;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _debugListener;
        var _traceCtx;
        /**
         * Internal log poller
         */ var _internalLogPoller = 0;
        var _forceStopInternalLogPoller = false;
        (0, $bO3cR.default)(BaseCore, this, function(_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            _self[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = function() {
                return _isInitialized;
            };
            // Creating the self.initialize = ()
            _self[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                if (_isUnloading) (0, $hGXAo.throwError)($a2d7fb4a1b935431$var$strSdkUnloadingError);
                // Make sure core is only initialized once
                if (_self[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ]()) (0, $hGXAo.throwError)("Core should not be initialized more than once");
                _config = config || {};
                _self[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ] = _config;
                if ((0, $hGXAo.isNullOrUndefined)(config[0, $j5TD0._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ])) (0, $hGXAo.throwError)("Please provide instrumentation key");
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[$a2d7fb4a1b935431$var$strNotificationManager] = notificationManager;
                _initDebugListener();
                _initPerfManager();
                // add notification to the extensions in the config so other plugins can access it
                _initExtConfig();
                if (logger) _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ] = logger;
                var cfgExtensions = (0, $hGXAo.getSetValue)(_config, (0, $59IxV.STR_EXTENSIONS), []);
                // Extension validation
                _configExtensions = [];
                _configExtensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ].apply(_configExtensions, (0, $8AlFX.__spreadArrayFn)((0, $8AlFX.__spreadArrayFn)([], extensions, false), cfgExtensions, false));
                _channelConfig = (0, $hGXAo.getSetValue)(_config, (0, $59IxV.STR_CHANNELS), []);
                _initPluginChain(null);
                if (!_channelQueue || _channelQueue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] === 0) (0, $hGXAo.throwError)("No " + (0, $59IxV.STR_CHANNELS) + " available");
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function() {
                var controls = [];
                if (_channelQueue) (0, $hGXAo.arrForEach)(_channelQueue, function(channels) {
                    controls[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](channels.queue);
                });
                return (0, $hGXAo.objFreeze)(controls);
            };
            _self.track = function(telemetryItem) {
                // setup default iKey if not passed in
                telemetryItem.iKey = telemetryItem.iKey || _config[0, $j5TD0._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ];
                // add default timestamp if not passed in
                telemetryItem[0, $j5TD0._DYN_TIME /* @min:%2etime */ ] = telemetryItem[0, $j5TD0._DYN_TIME /* @min:%2etime */ ] || (0, $hGXAo.toISOString)(new Date());
                // Common Schema 4.0
                telemetryItem.ver = telemetryItem.ver || "4.0";
                if (!_isUnloading && _self[0, $j5TD0._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ]()) // Process the telemetry plugin chain
                _createTelCtx()[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](telemetryItem);
                else // Queue events until all extensions are initialized
                _eventQueue[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](telemetryItem);
            };
            _self[0, $j5TD0._DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */ ] = _createTelCtx;
            _self[0, $j5TD0._DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */ ] = function() {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = $a2d7fb4a1b935431$var$_createDummyNotificationManager();
                    // For backward compatibility only
                    _self[$a2d7fb4a1b935431$var$strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */ _self[0, $j5TD0._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $j5TD0._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */ _self[0, $j5TD0._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $j5TD0._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ](listener);
            };
            _self.getCookieMgr = function() {
                if (!_cookieManager) _cookieManager = (0, $hB9U1.createCookieMgr)(_config, _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ]);
                return _cookieManager;
            };
            _self.setCookieMgr = function(cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self[0, $59IxV.STR_GET_PERF_MGR /* @min:%2egetPerfMgr */ ] = function() {
                if (!_perfManager && !_cfgPerfManager) {
                    if ((0, $hGXAo.getCfgValue)(_config.enablePerfMgr)) {
                        var createPerfMgr = (0, $hGXAo.getCfgValue)(_config[0, $59IxV.STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */ ]);
                        if ((0, $hGXAo.isFunction)(createPerfMgr)) _cfgPerfManager = createPerfMgr(_self, _self[0, $j5TD0._DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */ ]());
                    }
                }
                return _perfManager || _cfgPerfManager || (0, $4LGgU.getGblPerfMgr)();
            };
            _self.setPerfMgr = function(perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function() {
                return _eventQueue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
            };
            _self.releaseQueue = function() {
                if (_isInitialized && _eventQueue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    (0, $hGXAo.arrForEach)(eventQueue, function(event) {
                        _createTelCtx()[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](event);
                    });
                }
            };
            _self.pollInternalLogs = function(eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                if (_internalLogPoller) {
                    clearInterval(_internalLogPoller);
                    _internalLogPoller = null;
                }
                return _startInternalLogTimer(true);
            };
            function _startInternalLogTimer(alwaysStart) {
                if (!_internalLogPoller && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ] && _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ].queue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0;
                    if (shouldStart) {
                        var interval = (0, $hGXAo.getCfgValue)(_config.diagnosticLogInterval);
                        if (!interval || !(interval > 0)) interval = 10000;
                        // Keeping as an interval timer for backward compatibility as it returns the result
                        _internalLogPoller = setInterval(function() {
                            clearInterval(_internalLogPoller);
                            _internalLogPoller = 0;
                            _flushInternalLogs();
                        }, interval);
                    }
                }
                return _internalLogPoller;
            }
            _self[0, $j5TD0._DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */ ] = function() {
                _forceStopInternalLogPoller = true;
                if (_internalLogPoller) {
                    clearInterval(_internalLogPoller);
                    _internalLogPoller = 0;
                    _flushInternalLogs();
                }
            };
            // Add addTelemetryInitializer
            (0, $hGXAo.proxyFunctions)(_self, function() {
                return _telemetryInitializerPlugin;
            }, [
                "addTelemetryInitializer"
            ]);
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) isAsync = true;
                if (!_isInitialized) // The SDK is not initialized
                (0, $hGXAo.throwError)($a2d7fb4a1b935431$var$strSdkNotInitialized);
                // Check if the SDK still unloading so throw
                if (_isUnloading) // The SDK is already unloading
                (0, $hGXAo.throwError)($a2d7fb4a1b935431$var$strSdkUnloadingError);
                var unloadState = (_a = {
                    reason: 50 /* TelemetryUnloadReason.SdkUnload */ 
                }, _a[0, $j5TD0._DYN_IS_ASYNC /* @min:isAsync */ ] = isAsync, _a.flushComplete = false, _a);
                var processUnloadCtx = (0, $jx9Ci.createProcessTelemetryUnloadContext)(_getPluginChain(), _self);
                processUnloadCtx[0, $j5TD0._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](function() {
                    _initDefaults();
                    unloadComplete && unloadComplete(unloadState);
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[0, $j5TD0._DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */ ]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */ , cbTimeout)) _doUnload(false);
            };
            _self[0, $j5TD0._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ] = _getPlugin;
            _self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError($a2d7fb4a1b935431$var$strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */ 
                };
                function _addPlugin(removed) {
                    _configExtensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](plugin);
                    updateState.added = [
                        plugin
                    ];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [
                        existingPlugin.plugin
                    ];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */ ,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function(removed) {
                        if (!removed) // Previous plugin was successfully removed or was not installed
                        addCb && addCb(false);
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */ ;
                            _addPlugin(true);
                        }
                    });
                } else _addPlugin(false);
            };
            _self.evtNamespace = function() {
                return _evtNamespace;
            };
            _self[0, $j5TD0._DYN_FLUSH /* @min:%2eflush */ ] = _flushChannels;
            _self.getTraceCtx = function(createNew) {
                if (!_traceCtx) _traceCtx = (0, $8ZAtX.createDistributedTraceContext)();
                return _traceCtx;
            };
            _self.setTraceCtx = function(traceCtx) {
                _traceCtx = traceCtx || null;
            };
            // Create the addUnloadCb
            (0, $hGXAo.proxyFunctionAs)(_self, "addUnloadCb", function() {
                return _unloadHandlers;
            }, "add");
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _config = (0, $hGXAo.objExtend)(true, {}, $a2d7fb4a1b935431$var$defaultInitConfig);
                _self[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ] = _config;
                _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ] = new (0, $i86yL.DiagnosticLogger)(_config);
                _self[0, $j5TD0._DYN__EXTENSIONS /* @min:%2e_extensions */ ] = [];
                _telemetryInitializerPlugin = new (0, $bKLC0.TelemetryInitializerPlugin)();
                _eventQueue = [];
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                _cookieManager = null;
                _pluginChain = null;
                _coreExtensions = null;
                _configExtensions = [];
                _channelControl = null;
                _channelConfig = null;
                _channelQueue = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = (0, $5GGqM.createUniqueNamespace)("AIBaseCore", true);
                _unloadHandlers = (0, $eOe4Z.createUnloadHandlerContainer)();
                _traceCtx = null;
            }
            function _createTelCtx() {
                var theCtx = (0, $jx9Ci.createProcessTelemetryContext)(_getPluginChain(), _config, _self);
                theCtx[0, $j5TD0._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](_startInternalLogTimer);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = $a2d7fb4a1b935431$var$_validateExtensions(_self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ], (0, $a6QGM.ChannelControllerPriority), _configExtensions);
                _coreExtensions = theExtensions[0, $59IxV.STR_CORE /* @min:%2ecore */ ];
                _pluginChain = null;
                // Sort the complete set of extensions by priority
                var allExtensions = theExtensions.all;
                // Initialize the Channel Queues and the channel plugins first
                _channelQueue = (0, $hGXAo.objFreeze)((0, $a6QGM.createChannelQueues)(_channelConfig, allExtensions, _self));
                if (_channelControl) {
                    // During add / remove of a plugin this may get called again, so don't re-add if already present
                    // But we also want the controller as the last, so remove if already present
                    // And reusing the existing instance, just in case an installed plugin has a reference and
                    // is using it.
                    var idx = (0, $hGXAo.arrIndexOf)(allExtensions, _channelControl);
                    if (idx !== -1) allExtensions[0, $j5TD0._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                    idx = (0, $hGXAo.arrIndexOf)(_coreExtensions, _channelControl);
                    if (idx !== -1) _coreExtensions[0, $j5TD0._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                    _channelControl._setQueue(_channelQueue);
                } else _channelControl = (0, $a6QGM.createChannelControllerPlugin)(_channelQueue, _self);
                // Add on "channelController" as the last "plugin"
                allExtensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](_channelControl);
                _coreExtensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](_channelControl);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _self[0, $j5TD0._DYN__EXTENSIONS /* @min:%2e_extensions */ ] = (0, $8ZAtX.sortPlugins)(allExtensions);
                // Initialize the controls
                _channelControl[0, $j5TD0._DYN_INITIALIZE /* @min:%2einitialize */ ](_config, _self, allExtensions);
                var initCtx = _createTelCtx();
                (0, $8ZAtX.initializePlugins)(initCtx, allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self[0, $j5TD0._DYN__EXTENSIONS /* @min:%2e_extensions */ ] = (0, $hGXAo.objFreeze)((0, $8ZAtX.sortPlugins)(_coreExtensions || [])).slice();
                if (updateState) _doUpdate(updateState);
            }
            function _getPlugin(pluginIdentifier) {
                var _a;
                var theExt = null;
                var thePlugin = null;
                (0, $hGXAo.arrForEach)(_self[0, $j5TD0._DYN__EXTENSIONS /* @min:%2e_extensions */ ], function(ext) {
                    if (ext[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ] === pluginIdentifier && ext !== _channelControl && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                });
                if (!thePlugin && _channelControl) // Check the channel Controller
                thePlugin = _channelControl.getChannel(pluginIdentifier);
                if (thePlugin) theExt = (_a = {
                    plugin: thePlugin
                }, _a[0, $j5TD0._DYN_SET_ENABLED /* @min:setEnabled */ ] = function(enabled) {
                    (0, $8ZAtX._getPluginState)(thePlugin)[0, $59IxV.STR_DISABLED] = !enabled;
                }, _a.isEnabled = function() {
                    var pluginState = (0, $8ZAtX._getPluginState)(thePlugin);
                    return !pluginState[0, $j5TD0._DYN_TEARDOWN /* @min:%2eteardown */ ] && !pluginState[0, $59IxV.STR_DISABLED];
                }, _a.remove = function(isAsync, removeCb) {
                    var _a;
                    if (isAsync === void 0) isAsync = true;
                    var pluginsToRemove = [
                        thePlugin
                    ];
                    var unloadState = (_a = {
                        reason: 1 /* TelemetryUnloadReason.PluginUnload */ 
                    }, _a[0, $j5TD0._DYN_IS_ASYNC /* @min:isAsync */ ] = isAsync, _a);
                    _removePlugins(pluginsToRemove, unloadState, function(removed) {
                        if (removed) // Re-Initialize the plugin chain
                        _initPluginChain({
                            reason: 32 /* TelemetryUpdateReason.PluginRemoved */ ,
                            removed: pluginsToRemove
                        });
                        removeCb && removeCb(removed);
                    });
                }, _a);
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_coreExtensions || []).slice();
                    // During add / remove this may get called again, so don't readd if already present
                    if ((0, $hGXAo.arrIndexOf)(extensions, _telemetryInitializerPlugin) === -1) extensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](_telemetryInitializerPlugin);
                    _pluginChain = (0, $jx9Ci.createTelemetryProxyChain)((0, $8ZAtX.sortPlugins)(extensions), _config, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    var unloadChain = (0, $jx9Ci.createTelemetryProxyChain)(thePlugins, _config, _self);
                    var unloadCtx = (0, $jx9Ci.createProcessTelemetryUnloadContext)(unloadChain, _self);
                    unloadCtx[0, $j5TD0._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](function() {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        (0, $hGXAo.arrForEach)(_configExtensions, function(plugin, idx) {
                            if (!$a2d7fb4a1b935431$var$_isPluginPresent(plugin, thePlugins)) newConfigExtensions[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](plugin);
                            else removed = true;
                        });
                        _configExtensions = newConfigExtensions;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            (0, $hGXAo.arrForEach)(_channelConfig, function(queue, idx) {
                                var newQueue = [];
                                (0, $hGXAo.arrForEach)(queue, function(channel) {
                                    if (!$a2d7fb4a1b935431$var$_isPluginPresent(channel, thePlugins)) newQueue[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](channel);
                                    else removed = true;
                                });
                                newChannelConfig[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startInternalLogTimer();
                    });
                    unloadCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](unloadState);
                } else removeComplete(false);
            }
            function _flushInternalLogs() {
                if (_self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ] && _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ].queue) {
                    var queue = _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ].queue.slice(0);
                    _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ].queue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] = 0;
                    (0, $hGXAo.arrForEach)(queue, function(logMessage) {
                        var _a;
                        var item = (_a = {}, _a[0, $j5TD0._DYN_NAME /* @min:name */ ] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[0, $j5TD0._DYN_MESSAGE_ID /* @min:%2emessageId */ ], _a.iKey = (0, $hGXAo.getCfgValue)(_config[0, $j5TD0._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]), _a.time = (0, $hGXAo.toISOString)(new Date()), _a.baseType = (0, $i86yL._InternalLogMessage).dataType, _a.baseData = {
                            message: logMessage[0, $j5TD0._DYN_MESSAGE /* @min:%2emessage */ ]
                        }, _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                if (_channelControl) return _channelControl[0, $j5TD0._DYN_FLUSH /* @min:%2eflush */ ](isAsync, callBack, sendReason || 6 /* SendRequestReason.SdkUnload */ , cbTimeout);
                callBack && callBack(false);
                return true;
            }
            function _initDebugListener() {
                var disableDbgExt = (0, $hGXAo.getCfgValue)(_config.disableDbgExt);
                if (disableDbgExt === true && _debugListener) {
                    // Remove any previously loaded debug listener
                    _notificationManager[0, $j5TD0._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ](_debugListener);
                    _debugListener = null;
                }
                if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                    _debugListener = (0, $39sw1.getDebugListener)(_config);
                    _notificationManager[0, $j5TD0._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ](_debugListener);
                }
            }
            function _initPerfManager() {
                var enablePerfMgr = (0, $hGXAo.getCfgValue)(_config.enablePerfMgr);
                if (!enablePerfMgr && _cfgPerfManager) // Remove any existing config based performance manager
                _cfgPerfManager = null;
                if (enablePerfMgr) // Set the performance manager creation function if not defined
                (0, $hGXAo.getSetValue)(_config, (0, $59IxV.STR_CREATE_PERF_MGR), $a2d7fb4a1b935431$var$_createPerfManager);
            }
            function _initExtConfig() {
                var extConfig = (0, $hGXAo.getSetValue)(_config, (0, $59IxV.STR_EXTENSION_CONFIG), {});
                extConfig.NotificationManager = _notificationManager;
            }
            function _doUpdate(updateState) {
                var updateCtx = (0, $jx9Ci.createProcessTelemetryUpdateContext)(_getPluginChain(), _self);
                updateCtx[0, $j5TD0._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](_startInternalLogTimer);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](updateState);
            }
            function _logOrThrowError(message) {
                var logger = _self[0, $j5TD0._DYN_LOGGER /* @min:%2elogger */ ];
                if (logger) {
                    // there should always be a logger
                    (0, $i86yL._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , message);
                    _startInternalLogTimer();
                } else (0, $hGXAo.throwError)(message);
            }
        });
    }
    // Removed Stub for BaseCore.prototype.initialize.
    // Removed Stub for BaseCore.prototype.getTransmissionControls.
    // Removed Stub for BaseCore.prototype.track.
    // Removed Stub for BaseCore.prototype.getProcessTelContext.
    // Removed Stub for BaseCore.prototype.getNotifyMgr.
    // Removed Stub for BaseCore.prototype.addNotificationListener.
    // Removed Stub for BaseCore.prototype.removeNotificationListener.
    // Removed Stub for BaseCore.prototype.getCookieMgr.
    // Removed Stub for BaseCore.prototype.setCookieMgr.
    // Removed Stub for BaseCore.prototype.getPerfMgr.
    // Removed Stub for BaseCore.prototype.setPerfMgr.
    // Removed Stub for BaseCore.prototype.eventCnt.
    // Removed Stub for BaseCore.prototype.pollInternalLogs.
    // Removed Stub for BaseCore.prototype.stopPollingInternalLogs.
    // Removed Stub for BaseCore.prototype.addTelemetryInitializer.
    // Removed Stub for BaseCore.prototype.unload.
    // Removed Stub for BaseCore.prototype.getPlugin.
    // Removed Stub for BaseCore.prototype.addPlugin.
    // Removed Stub for BaseCore.prototype.evtNamespace.
    // Removed Stub for BaseCore.prototype.addUnloadCb.
    // Removed Stub for BaseCore.prototype.flush.
    // Removed Stub for BaseCore.prototype.getTraceCtx.
    // Removed Stub for BaseCore.prototype.setTraceCtx.
    // Removed Stub for BaseCore.prototype.releaseQueue.
    // Removed Stub for BaseCore.prototype._updateHook.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseCore.__ieDyn = 1;
    return BaseCore;
}();

});
parcelRegister("a6QGM", function(module, exports) {

$parcel$export(module.exports, "ChannelControllerPriority", function () { return $75c355d57b878291$export$a1373ad9f192f374; });
$parcel$export(module.exports, "createChannelControllerPlugin", function () { return $75c355d57b878291$export$7d61c45afab4719d; });
$parcel$export(module.exports, "createChannelQueues", function () { return $75c355d57b878291$export$9baa95a4af0f2d3; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 

var $j5TD0 = parcelRequire("j5TD0");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");

var $jx9Ci = parcelRequire("jx9Ci");

var $8ZAtX = parcelRequire("8ZAtX");
var $75c355d57b878291$export$a1373ad9f192f374 = 500;
var $75c355d57b878291$var$ChannelValidationMessage = "Channel has invalid priority - ";
function $75c355d57b878291$var$_addChannelQueue(channelQueue, queue, core) {
    if (queue && (0, $hGXAo.isArray)(queue) && queue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        queue = queue.sort(function(a, b) {
            return a[0, $59IxV.STR_PRIORITY /* @min:%2epriority */ ] - b[0, $59IxV.STR_PRIORITY /* @min:%2epriority */ ];
        });
        (0, $hGXAo.arrForEach)(queue, function(queueItem) {
            if (queueItem[0, $59IxV.STR_PRIORITY /* @min:%2epriority */ ] < $75c355d57b878291$export$a1373ad9f192f374) (0, $hGXAo.throwError)($75c355d57b878291$var$ChannelValidationMessage + queueItem[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ]);
        });
        channelQueue[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ]({
            queue: (0, $hGXAo.objFreeze)(queue),
            chain: (0, $jx9Ci.createTelemetryProxyChain)(queue, core[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ], core)
        });
    }
}
function $75c355d57b878291$export$7d61c45afab4719d(channelQueue, core) {
    function _getTelCtx() {
        return (0, $jx9Ci.createProcessTelemetryContext)(null, core[0, $j5TD0._DYN_CONFIG /* @min:%2econfig */ ], core, null);
    }
    function _processChannelQueue(theChannels, itemCtx, processFn, onComplete) {
        var waiting = theChannels ? theChannels[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] + 1 : 1;
        function _runChainOnComplete() {
            waiting--;
            if (waiting === 0) {
                onComplete && onComplete();
                onComplete = null;
            }
        }
        if (waiting > 0) (0, $hGXAo.arrForEach)(theChannels, function(channels) {
            // pass on to first item in queue
            if (channels && channels.queue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                var channelChain = channels.chain;
                var chainCtx = itemCtx[0, $j5TD0._DYN_CREATE_NEW /* @min:%2ecreateNew */ ](channelChain);
                chainCtx[0, $j5TD0._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](_runChainOnComplete);
                // Cause this chain to start processing
                processFn(chainCtx);
            } else waiting--;
        });
        _runChainOnComplete();
    }
    function _doUpdate(updateCtx, updateState) {
        var theUpdateState = updateState || {
            reason: 0 /* TelemetryUpdateReason.Unknown */ 
        };
        _processChannelQueue(channelQueue, updateCtx, function(chainCtx) {
            chainCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUpdateState);
        }, function() {
            updateCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUpdateState);
        });
        return true;
    }
    function _doTeardown(unloadCtx, unloadState) {
        var theUnloadState = unloadState || {
            reason: 0 /* TelemetryUnloadReason.ManualTeardown */ ,
            isAsync: false
        };
        _processChannelQueue(channelQueue, unloadCtx, function(chainCtx) {
            chainCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUnloadState);
        }, function() {
            unloadCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUnloadState);
            isInitialized = false;
        });
        return true;
    }
    function _getChannel(pluginIdentifier) {
        var thePlugin = null;
        if (channelQueue && channelQueue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $hGXAo.arrForEach)(channelQueue, function(channels) {
            // pass on to first item in queue
            if (channels && channels.queue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                (0, $hGXAo.arrForEach)(channels.queue, function(ext) {
                    if (ext[0, $j5TD0._DYN_IDENTIFIER /* @min:%2eidentifier */ ] === pluginIdentifier) {
                        thePlugin = ext;
                        // Cause arrForEach to stop iterating
                        return -1;
                    }
                });
                if (thePlugin) // Cause arrForEach to stop iterating
                return -1;
            }
        });
        return thePlugin;
    }
    var isInitialized = false;
    var channelController = {
        identifier: "ChannelControllerPlugin",
        priority: $75c355d57b878291$export$a1373ad9f192f374,
        initialize: function(config, core, extensions, pluginChain) {
            isInitialized = true;
            (0, $hGXAo.arrForEach)(channelQueue, function(channels) {
                if (channels && channels.queue[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $8ZAtX.initializePlugins)((0, $jx9Ci.createProcessTelemetryContext)(channels.chain, config, core), extensions);
            });
        },
        isInitialized: function() {
            return isInitialized;
        },
        processTelemetry: function(item, itemCtx) {
            _processChannelQueue(channelQueue, itemCtx || _getTelCtx(), function(chainCtx) {
                chainCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](item);
            }, function() {
                itemCtx[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](item);
            });
        },
        update: _doUpdate,
        pause: function() {
            _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
                chainCtx.iterate(function(plugin) {
                    plugin.pause && plugin.pause();
                });
            }, null);
        },
        resume: function() {
            _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
                chainCtx.iterate(function(plugin) {
                    plugin.resume && plugin.resume();
                });
            }, null);
        },
        teardown: _doTeardown,
        getChannel: _getChannel,
        flush: function(isAsync, callBack, sendReason, cbTimeout) {
            // Setting waiting to one so that we don't call the callBack until we finish iterating
            var waiting = 1;
            var doneIterating = false;
            var cbTimer = null;
            cbTimeout = cbTimeout || 5000;
            function doCallback() {
                waiting--;
                if (doneIterating && waiting === 0) {
                    if (cbTimer) {
                        clearTimeout(cbTimer);
                        cbTimer = null;
                    }
                    callBack && callBack(doneIterating);
                    callBack = null;
                }
            }
            _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
                chainCtx.iterate(function(plugin) {
                    if (plugin[0, $j5TD0._DYN_FLUSH /* @min:%2eflush */ ]) {
                        waiting++;
                        var handled_1 = false;
                        // Not all channels will call this callback for every scenario
                        if (!plugin[0, $j5TD0._DYN_FLUSH /* @min:%2eflush */ ](isAsync, function() {
                            handled_1 = true;
                            doCallback();
                        }, sendReason)) {
                            if (!handled_1) {
                                // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                // followup function (such as unloading)
                                if (isAsync && cbTimer == null) cbTimer = setTimeout(function() {
                                    cbTimer = null;
                                    doCallback();
                                }, cbTimeout);
                                else doCallback();
                            }
                        }
                    }
                });
            }, function() {
                doneIterating = true;
                doCallback();
            });
            return true;
        },
        _setQueue: function(queue) {
            channelQueue = queue;
        }
    };
    return channelController;
}
function $75c355d57b878291$export$9baa95a4af0f2d3(channels, extensions, core) {
    var channelQueue = [];
    if (channels) // Add and sort the configuration channel queues
    (0, $hGXAo.arrForEach)(channels, function(queue) {
        return $75c355d57b878291$var$_addChannelQueue(channelQueue, queue, core);
    });
    if (extensions) {
        // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
        var extensionQueue_1 = [];
        (0, $hGXAo.arrForEach)(extensions, function(plugin) {
            if (plugin[0, $59IxV.STR_PRIORITY /* @min:%2epriority */ ] > $75c355d57b878291$export$a1373ad9f192f374) extensionQueue_1[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](plugin);
        });
        $75c355d57b878291$var$_addChannelQueue(channelQueue, extensionQueue_1, core);
    }
    return channelQueue;
}

});

parcelRegister("bKLC0", function(module, exports) {

$parcel$export(module.exports, "TelemetryInitializerPlugin", function () { return $88e8ec5753d189d1$export$5da7f32cc3b89dc1; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 
// 

var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $dtXLi = parcelRequire("dtXLi");

var $i86yL = parcelRequire("i86yL");

var $bU24K = parcelRequire("bU24K");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
var $88e8ec5753d189d1$export$5da7f32cc3b89dc1 = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        (0, $bO3cR.default)(TelemetryInitializerPlugin, _this, function(_self, _base) {
            _self.addTelemetryInitializer = function(telemetryInitializer) {
                var theInitializer = {
                    id: _id++,
                    fn: telemetryInitializer
                };
                _initializers[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](theInitializer);
                var handler = {
                    remove: function() {
                        (0, $hGXAo.arrForEach)(_initializers, function(initializer, idx) {
                            if (initializer.id === theInitializer.id) {
                                _initializers[0, $j5TD0._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                                return -1;
                            }
                        });
                    }
                };
                return handler;
            };
            _self[0, $59IxV.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ] = function(item, itemCtx) {
                var doNotSendItem = false;
                var telemetryInitializersCount = _initializers[0, $j5TD0._DYN_LENGTH /* @min:%2elength */ ];
                for(var i = 0; i < telemetryInitializersCount; ++i){
                    var telemetryInitializer = _initializers[i];
                    if (telemetryInitializer) try {
                        if (telemetryInitializer.fn[0, $j5TD0._DYN_APPLY /* @min:%2eapply */ ](null, [
                            item
                        ]) === false) {
                            doNotSendItem = true;
                            break;
                        }
                    } catch (e) {
                        // log error but dont stop executing rest of the telemetry initializers
                        // doNotSendItem = true;
                        (0, $i86yL._throwInternal)(itemCtx[0, $j5TD0._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $hGXAo.getExceptionName)(e), {
                            exception: (0, $bU24K.dumpObj)(e)
                        }, true);
                    }
                }
                if (!doNotSendItem) _self[0, $j5TD0._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](item, itemCtx);
            };
            _self[0, $j5TD0._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ] = function() {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
    // Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    TelemetryInitializerPlugin.__ieDyn = 1;
    return TelemetryInitializerPlugin;
}((0, $dtXLi.BaseTelemetryPlugin));

});


parcelRegister("jsIWo", function(module, exports) {

$parcel$export(module.exports, "NotificationManager", function () { return $e2b37e24ff0b16f4$export$dfa1f14b6290f8c5; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $j5TD0 = parcelRequire("j5TD0");

var $hGXAo = parcelRequire("hGXAo");

var $59IxV = parcelRequire("59IxV");
function $e2b37e24ff0b16f4$var$_runListeners(listeners, name, isAsync, callback) {
    (0, $hGXAo.arrForEach)(listeners, function(listener) {
        if (listener && listener[name]) {
            if (isAsync) setTimeout(function() {
                return callback(listener);
            }, 0);
            else try {
                callback(listener);
            } catch (e) {
            // Catch errors to ensure we don't block sending the requests
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */ var $e2b37e24ff0b16f4$export$dfa1f14b6290f8c5 = /** @class */ function() {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        (0, $bO3cR.default)(NotificationManager, this, function(_self) {
            _self[0, $j5TD0._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _self.listeners[0, $j5TD0._DYN_PUSH /* @min:%2epush */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */ _self[0, $j5TD0._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                var index = (0, $hGXAo.arrIndexOf)(_self[0, $j5TD0._DYN_LISTENERS /* @min:%2elisteners */ ], listener);
                while(index > -1){
                    _self.listeners[0, $j5TD0._DYN_SPLICE /* @min:%2esplice */ ](index, 1);
                    index = (0, $hGXAo.arrIndexOf)(_self[0, $j5TD0._DYN_LISTENERS /* @min:%2elisteners */ ], listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */ _self[0, $59IxV.STR_EVENTS_SENT /* @min:%2eeventsSent */ ] = function(events) {
                $e2b37e24ff0b16f4$var$_runListeners(_self[0, $j5TD0._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $59IxV.STR_EVENTS_SENT), true, function(listener) {
                    listener[0, $59IxV.STR_EVENTS_SENT /* @min:%2eeventsSent */ ](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */ _self[0, $59IxV.STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */ ] = function(events, reason) {
                $e2b37e24ff0b16f4$var$_runListeners(_self[0, $j5TD0._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $59IxV.STR_EVENTS_DISCARDED), true, function(listener) {
                    listener[0, $59IxV.STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */ ](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */ _self[0, $59IxV.STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ] = function(sendReason, isAsync) {
                $e2b37e24ff0b16f4$var$_runListeners(_self[0, $j5TD0._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $59IxV.STR_EVENTS_SEND_REQUEST), isAsync, function(listener) {
                    listener[0, $59IxV.STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ](sendReason, isAsync);
                });
            };
            _self[0, $59IxV.STR_PERF_EVENT /* @min:%2eperfEvent */ ] = function(perfEvent) {
                if (perfEvent) // Send all events or only parent events
                {
                    if (perfEvtsSendAll || !perfEvent[0, $j5TD0._DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */ ]()) $e2b37e24ff0b16f4$var$_runListeners(_self[0, $j5TD0._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $59IxV.STR_PERF_EVENT), false, function(listener) {
                        if (perfEvent[0, $j5TD0._DYN_IS_ASYNC /* @min:%2eisAsync */ ]) setTimeout(function() {
                            return listener[0, $59IxV.STR_PERF_EVENT /* @min:%2eperfEvent */ ](perfEvent);
                        }, 0);
                        else listener[0, $59IxV.STR_PERF_EVENT /* @min:%2eperfEvent */ ](perfEvent);
                    });
                }
            };
        });
    }
    // Removed Stub for NotificationManager.prototype.addNotificationListener.
    // Removed Stub for NotificationManager.prototype.removeNotificationListener.
    // Removed Stub for NotificationManager.prototype.eventsSent.
    // Removed Stub for NotificationManager.prototype.eventsDiscarded.
    // Removed Stub for NotificationManager.prototype.eventsSendRequest.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    NotificationManager.__ieDyn = 1;
    return NotificationManager;
}();

});


parcelRegister("8S0st", function(module, exports) {

$parcel$export(module.exports, "AjaxMonitor", function () { return $6753b8e5805e0a52$export$d9a50c4d1eb2475f; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $rOoAk = parcelRequire("rOoAk");
var $55exP = parcelRequire("55exP");
var $cseB2 = parcelRequire("cseB2");
var $cVsUj = parcelRequire("cVsUj");
var $HME9b = parcelRequire("HME9b");
var $cXuOT = parcelRequire("cXuOT");
var $ddqo3 = parcelRequire("ddqo3");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $dtXLi = parcelRequire("dtXLi");
var $jx9Ci = parcelRequire("jx9Ci");
var $5GGqM = parcelRequire("5GGqM");
var $bU24K = parcelRequire("bU24K");
var $lhl6R = parcelRequire("lhl6R");
var $k0iSW = parcelRequire("k0iSW");
var $91dsF = parcelRequire("91dsF");
var $77mRF = parcelRequire("77mRF");
var $82FQ4 = parcelRequire("82FQ4");

var $eJNsa = parcelRequire("eJNsa");

var $ioYfq = parcelRequire("ioYfq");

var $6YNdy = parcelRequire("6YNdy");
var $6753b8e5805e0a52$var$AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var $6753b8e5805e0a52$var$strDiagLog = "diagLog";
var $6753b8e5805e0a52$var$AJAX_DATA_CONTAINER = "_ajaxData";
var $6753b8e5805e0a52$var$STR_FETCH = "fetch";
var $6753b8e5805e0a52$var$ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var $6753b8e5805e0a52$var$ERROR_PREFIX = ", monitoring data for this ajax call ";
var $6753b8e5805e0a52$var$ERROR_POSTFIX = $6753b8e5805e0a52$var$ERROR_PREFIX + "may be incorrect.";
var $6753b8e5805e0a52$var$ERROR_NOT_SENT = $6753b8e5805e0a52$var$ERROR_PREFIX + "won't be sent.";
var $6753b8e5805e0a52$var$CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var $6753b8e5805e0a52$var$CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var $6753b8e5805e0a52$var$FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var $6753b8e5805e0a52$var$_markCount = 0;
/** @Ignore */ function $6753b8e5805e0a52$var$_supportsFetch() {
    var _global = (0, $91dsF.getGlobal)();
    if (!_global || (0, $hGXAo.isNullOrUndefined)(_global.Request) || (0, $hGXAo.isNullOrUndefined)(_global.Request[0, $82FQ4.strShimPrototype]) || (0, $hGXAo.isNullOrUndefined)(_global[$6753b8e5805e0a52$var$STR_FETCH])) return null;
    return _global[$6753b8e5805e0a52$var$STR_FETCH];
}
var $6753b8e5805e0a52$var$_isWebWorker = null;
function $6753b8e5805e0a52$var$isWebWorker() {
    if ($6753b8e5805e0a52$var$_isWebWorker == null) try {
        $6753b8e5805e0a52$var$_isWebWorker = !!(self && self instanceof WorkerGlobalScope);
    } catch (e) {
        $6753b8e5805e0a52$var$_isWebWorker = false;
    }
    return $6753b8e5805e0a52$var$_isWebWorker;
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */ function $6753b8e5805e0a52$var$_supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a;
    var result = false;
    if ((0, $bU24K.isXhrSupported)()) {
        var proto = XMLHttpRequest[0, $82FQ4.strShimPrototype];
        result = !(0, $hGXAo.isNullOrUndefined)(proto) && !(0, $hGXAo.isNullOrUndefined)(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
        !(0, $hGXAo.isNullOrUndefined)(proto.send) && !(0, $hGXAo.isNullOrUndefined)(proto.abort);
    }
    var ieVer = (0, $bU24K.getIEVersion)();
    if (ieVer && ieVer < 9) result = false;
    if (result) // Disable if the XmlHttpRequest can't be extended or hooked
    try {
        var xhr = new XMLHttpRequest();
        var xhrData = {
            xh: [],
            i: (_a = {}, _a[ajaxDataId] = {}, _a)
        };
        xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER] = xhrData;
        // Check that we can update the prototype
        var theOpen = XMLHttpRequest[0, $82FQ4.strShimPrototype].open;
        XMLHttpRequest[0, $82FQ4.strShimPrototype].open = theOpen;
    } catch (e) {
        // We can't decorate the xhr object so disable monitoring
        result = false;
        $6753b8e5805e0a52$var$_throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
            exception: (0, $bU24K.dumpObj)(e)
        });
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */ var $6753b8e5805e0a52$var$_getAjaxData = function(xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER]) return (xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */ var $6753b8e5805e0a52$var$_addSharedXhrHeaders = function(xhr, name, value) {
    if (xhr) {
        var headers = (xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) headers.push({
            n: name,
            v: value
        });
    }
};
var $6753b8e5805e0a52$var$_isHeaderSet = function(xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) (0, $hGXAo.arrForEach)(headers, function(header) {
            if (header.n === name) {
                isPresent = true;
                return -1;
            }
        });
    }
    return isPresent;
};
/** @Ignore */ function $6753b8e5805e0a52$var$_getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = $6753b8e5805e0a52$var$_getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ]) result += "(url: '" + ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] + "')";
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */ function $6753b8e5805e0a52$var$_throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $i86yL._throwInternal)(ajaxMonitorInstance[$6753b8e5805e0a52$var$strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */ , msgId, message, properties, isUserAct);
}
/** @ignore */ function $6753b8e5805e0a52$var$_throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $i86yL._throwInternal)(ajaxMonitorInstance[$6753b8e5805e0a52$var$strDiagLog](), 2 /* eLoggingSeverity.WARNING */ , msgId, message, properties, isUserAct);
}
/** @Ignore */ function $6753b8e5805e0a52$var$_createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function(callDetails) {
        $6753b8e5805e0a52$var$_throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
            ajaxDiagnosticsMessage: $6753b8e5805e0a52$var$_getFailedAjaxDiagnosticsMessage(callDetails[0, $ioYfq._DYN_INST /* @min:%2einst */ ], ajaxMonitorInstance._ajaxDataId),
            exception: (0, $bU24K.dumpObj)(callDetails.err)
        });
    };
}
function $6753b8e5805e0a52$var$_indexOf(value, match) {
    if (value && match) return value.indexOf(match);
    return -1;
}
function $6753b8e5805e0a52$var$_addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function() {
            (0, $hGXAo.arrForEach)(container, function(initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function $6753b8e5805e0a52$var$_processDependencyContainer(core, container, details, message) {
    var result = true;
    (0, $hGXAo.arrForEach)(container, function(theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) result = false;
        } catch (e) {
            (0, $i86yL._throwInternal)(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Dependency " + message + " [#" + idx + "] failed: " + (0, $hGXAo.getExceptionName)(e), {
                exception: (0, $bU24K.dumpObj)(e)
            }, true);
        }
    });
    return result;
}
function $6753b8e5805e0a52$var$_processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var initializersCount = listeners[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ];
    if (initializersCount > 0) {
        var details = {
            core: core,
            xhr: xhr,
            input: input,
            init: init,
            traceId: ajaxData[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ],
            spanId: ajaxData[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ],
            traceFlags: ajaxData[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ],
            context: ajaxData[0, $ioYfq._DYN_CONTEXT /* @min:%2econtext */ ] || {},
            aborted: !!ajaxData[0, $ioYfq._DYN_ABORTED /* @min:%2eaborted */ ]
        };
        $6753b8e5805e0a52$var$_processDependencyContainer(core, listeners, details, "listener");
        ajaxData[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ] = details[0, $ioYfq._DYN_TRACE_ID0 /* @min:%2etraceId */ ];
        ajaxData[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ] = details[0, $ioYfq._DYN_SPAN_ID1 /* @min:%2espanId */ ];
        ajaxData[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = details[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
        ajaxData[0, $ioYfq._DYN_CONTEXT /* @min:%2econtext */ ] = details[0, $ioYfq._DYN_CONTEXT /* @min:%2econtext */ ];
    }
}
var $6753b8e5805e0a52$var$BLOB_CORE = "*.blob.core.";
var $6753b8e5805e0a52$export$ae1f7dcb3278b8bb = (0, $hGXAo.deepFreeze)([
    $6753b8e5805e0a52$var$BLOB_CORE + "windows.net",
    $6753b8e5805e0a52$var$BLOB_CORE + "chinacloudapi.cn",
    $6753b8e5805e0a52$var$BLOB_CORE + "cloudapi.de",
    $6753b8e5805e0a52$var$BLOB_CORE + "usgovcloudapi.net"
]);
var $6753b8e5805e0a52$var$_internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
function $6753b8e5805e0a52$var$_getDefaultConfig() {
    var config = {
        maxAjaxCallsPerView: 500,
        disableAjaxTracking: false,
        disableFetchTracking: false,
        excludeRequestFromAutoTrackingPatterns: undefined,
        disableCorrelationHeaders: false,
        distributedTracingMode: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
        correlationHeaderExcludedDomains: $6753b8e5805e0a52$export$ae1f7dcb3278b8bb,
        correlationHeaderDomains: undefined,
        correlationHeaderExcludePatterns: undefined,
        appId: undefined,
        enableCorsCorrelation: false,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false,
        enableAjaxErrorStatusText: false,
        enableAjaxPerfTracking: false,
        maxAjaxPerfLookupAttempts: 3,
        ajaxPerfLookupDelay: 25,
        ignoreHeaders: [
            "Authorization",
            "X-API-Key",
            "WWW-Authenticate"
        ],
        addRequestContext: undefined,
        addIntEndpoints: true
    };
    return config;
}
function $6753b8e5805e0a52$var$_getEmptyConfig() {
    var emptyConfig = $6753b8e5805e0a52$var$_getDefaultConfig();
    (0, $hGXAo.objForEachKey)(emptyConfig, function(value) {
        emptyConfig[value] = undefined;
    });
    return emptyConfig;
}
var $6753b8e5805e0a52$export$d9a50c4d1eb2475f = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _config;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        (0, $bO3cR.default)(AjaxMonitor, _this, function(_self, _base) {
            var _addHook = _base._addHook;
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = (0, $lhl6R.mergeEvtNamespace)((0, $5GGqM.createUniqueNamespace)("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function() {
                _initDefaults();
            };
            _self.trackDependencyData = function(dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ], null, dependency, properties);
            };
            _self[0, $ioYfq._DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */ ] = function(ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                $6753b8e5805e0a52$var$_processDependencyListeners(_dependencyListeners, _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ], ajaxData, xhr, input, init);
                if (input || input === "") {
                    if ((0, $rOoAk.CorrelationIdHelper)[0, $ioYfq._DYN_CAN_INCLUDE_CORRELAT3 /* @min:%2ecanIncludeCorrelationHeader */ ](_config, ajaxData[0, $ioYfq._DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (!init) init = {};
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ] || (input instanceof Request ? input[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ] || {} : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ] + "." + ajaxData[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ];
                            headers.set((0, $ddqo3.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                            if (_enableRequestHeaderTracking) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $ddqo3.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                        }
                        var appId = _config[0, $ioYfq._DYN_APP_ID /* @min:%2eappId */ ] || _context && _context[0, $ioYfq._DYN_APP_ID /* @min:%2eappId */ ]();
                        if (appId) {
                            headers.set((0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $ddqo3.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                            if (_enableRequestHeaderTracking) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $ddqo3.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
                            if ((0, $hGXAo.isNullOrUndefined)(traceFlags)) traceFlags = 0x01;
                            var traceParent = (0, $cseB2.formatTraceParent)((0, $cseB2.createTraceParent)(ajaxData[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ], ajaxData[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ], traceFlags));
                            headers.set((0, $ddqo3.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                            if (_enableRequestHeaderTracking) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $ddqo3.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                        }
                        init[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ] = headers;
                    }
                    return init;
                } else if (xhr) {
                    if ((0, $rOoAk.CorrelationIdHelper)[0, $ioYfq._DYN_CAN_INCLUDE_CORRELAT3 /* @min:%2ecanIncludeCorrelationHeader */ ](_config, ajaxData[0, $ioYfq._DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            if (!$6753b8e5805e0a52$var$_isHeaderSet(xhr, (0, $ddqo3.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ])) {
                                var id = "|" + ajaxData[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ] + "." + ajaxData[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ];
                                xhr[0, $ioYfq._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $ddqo3.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                                if (_enableRequestHeaderTracking) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $ddqo3.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                            } else $6753b8e5805e0a52$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $ddqo3.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ] + "] as it has already been set by another instance");
                        }
                        var appId = _config[0, $ioYfq._DYN_APP_ID /* @min:%2eappId */ ] || _context && _context[0, $ioYfq._DYN_APP_ID /* @min:%2eappId */ ]();
                        if (appId) {
                            if (!$6753b8e5805e0a52$var$_isHeaderSet(xhr, (0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ])) {
                                xhr[0, $ioYfq._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $ddqo3.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                                if (_enableRequestHeaderTracking) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $ddqo3.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                            } else $6753b8e5805e0a52$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ] + "] as it has already been set by another instance");
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
                            if ((0, $hGXAo.isNullOrUndefined)(traceFlags)) traceFlags = 0x01;
                            if (!$6753b8e5805e0a52$var$_isHeaderSet(xhr, (0, $ddqo3.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ])) {
                                var traceParent = (0, $cseB2.formatTraceParent)((0, $cseB2.createTraceParent)(ajaxData[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ], ajaxData[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ], traceFlags));
                                xhr[0, $ioYfq._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $ddqo3.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                                if (_enableRequestHeaderTracking) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $ddqo3.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                            } else $6753b8e5805e0a52$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $ddqo3.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ] + "] as it has already been set by another instance");
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[0, $ioYfq._DYN_TRACK_DEPENDENCY_DAT4 /* @min:%2etrackDependencyDataInternal */ ] = function(dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_config[0, $ioYfq._DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */ ] === 2 /* eDistributedTracingModes.W3C */  || _config[0, $ioYfq._DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */ ] === 1 /* eDistributedTracingModes.AI_AND_W3C */ ) && typeof dependency.id === "string" && dependency.id[dependency.id[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] - 1] !== ".") dependency.id += ".";
                    if ((0, $hGXAo.isNullOrUndefined)(dependency[0, $ioYfq._DYN_START_TIME /* @min:%2estartTime */ ])) dependency[0, $ioYfq._DYN_START_TIME /* @min:%2estartTime */ ] = new Date();
                    var item = (0, $55exP.createTelemetryItem)(dependency, (0, $cXuOT.RemoteDependencyData).dataType, (0, $cXuOT.RemoteDependencyData).envelopeType, _self[$6753b8e5805e0a52$var$strDiagLog](), properties, systemProperties);
                    _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ].track(item);
                } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) $6753b8e5805e0a52$var$_throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */ , "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function(dependencyListener) {
                return $6753b8e5805e0a52$var$_addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function(dependencyInitializer) {
                return $6753b8e5805e0a52$var$_addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = (0, $bU24K.getLocation)();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _currentWindowHost = location && location.host && location.host[0, $ioYfq._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
                _config = AjaxMonitor.getEmptyConfig();
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = (0, $5GGqM.createUniqueNamespace)("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
            }
            function _populateDefaults(config) {
                var ctx = (0, $jx9Ci.createProcessTelemetryContext)(null, config, _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ]);
                // Reset to the empty config
                _config = $6753b8e5805e0a52$var$_getEmptyConfig();
                var defaultConfig = $6753b8e5805e0a52$var$_getDefaultConfig();
                (0, $hGXAo.objForEachKey)(defaultConfig, function(field, value) {
                    _config[field] = ctx.getConfig(AjaxMonitor.identifier, field, value);
                });
                var distributedTracingMode = _config[0, $ioYfq._DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */ ];
                _enableRequestHeaderTracking = _config[0, $ioYfq._DYN_ENABLE_REQUEST_HEADE6 /* @min:%2eenableRequestHeaderTracking */ ];
                _enableAjaxErrorStatusText = _config[0, $ioYfq._DYN_ENABLE_AJAX_ERROR_ST7 /* @min:%2eenableAjaxErrorStatusText */ ];
                _enableAjaxPerfTracking = _config[0, $ioYfq._DYN_ENABLE_AJAX_PERF_TRA8 /* @min:%2eenableAjaxPerfTracking */ ];
                _maxAjaxCallsPerView = _config[0, $ioYfq._DYN_MAX_AJAX_CALLS_PER_V9 /* @min:%2emaxAjaxCallsPerView */ ];
                _enableResponseHeaderTracking = _config[0, $ioYfq._DYN_ENABLE_RESPONSE_HEAD10 /* @min:%2eenableResponseHeaderTracking */ ];
                _excludeRequestFromAutoTrackingPatterns = [].concat(_config[0, $ioYfq._DYN_EXCLUDE_REQUEST_FROM11 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */ ] || [], _config.addIntEndpoints !== false ? $6753b8e5805e0a52$var$_internalExcludeEndpoints : []);
                _addRequestContext = _config[0, $ioYfq._DYN_ADD_REQUEST_CONTEXT /* @min:%2eaddRequestContext */ ];
                _isUsingAIHeaders = distributedTracingMode === 0 /* eDistributedTracingModes.AI */  || distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                _isUsingW3CHeaders = distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */  || distributedTracingMode === 2 /* eDistributedTracingModes.W3C */ ;
                if (_enableAjaxPerfTracking) {
                    var iKey = config.instrumentationKey || "unkwn";
                    if (iKey[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] > 5) _markPrefix = $6753b8e5805e0a52$var$AJAX_MONITOR_PREFIX + iKey.substring(iKey[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] - 5) + ".";
                    else _markPrefix = $6753b8e5805e0a52$var$AJAX_MONITOR_PREFIX + iKey + ".";
                }
                _disableAjaxTracking = !!_config[0, $ioYfq._DYN_DISABLE_AJAX_TRACKIN12 /* @min:%2edisableAjaxTracking */ ];
                _disableFetchTracking = !!_config[0, $ioYfq._DYN_DISABLE_FETCH_TRACKI13 /* @min:%2edisableFetchTracking */ ];
            }
            function _populateContext() {
                var propExt = _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ].getPlugin((0, $HME9b.PropertiesPluginIdentifier));
                if (propExt) _context = propExt.plugin[0, $ioYfq._DYN_CONTEXT /* @min:%2econtext */ ]; // we could move IPropertiesPlugin to common as well
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _config.ignoreHeaders) (0, $hGXAo.arrForEach)(_config.ignoreHeaders, function(key) {
                    if (key[0, $ioYfq._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() === header[0, $ioYfq._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]()) {
                        rlt = false;
                        return -1;
                    }
                });
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = $6753b8e5805e0a52$var$_supportsFetch();
                if (!fetch) return;
                var global = (0, $91dsF.getGlobal)();
                var isPolyfill = fetch.polyfill;
                if (!_disableFetchTracking && !_fetchInitialized) {
                    _addHook((0, $77mRF.InstrumentFunc)(global, $6753b8e5805e0a52$var$STR_FETCH, {
                        ns: _evtNamespace,
                        // Add request hook
                        req: function(callDetails, input, init) {
                            var fetchData;
                            if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                            !(isPolyfill && _xhrInitialized)) {
                                var ctx = callDetails.ctx();
                                fetchData = _createFetchRecord(input, init);
                                var newInit = _self[0, $ioYfq._DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */ ](fetchData, input, init);
                                if (newInit !== init) callDetails.set(1, newInit);
                                ctx.data = fetchData;
                            }
                        },
                        rsp: function(callDetails, input) {
                            if (!_disableFetchTracking) {
                                var fetchData_1 = callDetails.ctx().data;
                                if (fetchData_1) // Replace the result with the new promise from this code
                                callDetails.rslt = callDetails.rslt.then(function(response) {
                                    _reportFetchMetrics(callDetails, (response || {})[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ], input, response, fetchData_1, function() {
                                        var ajaxResponse = {
                                            statusText: (response || {})[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ],
                                            headerMap: null,
                                            correlationContext: _getFetchCorrelationContext(response)
                                        };
                                        if (_enableResponseHeaderTracking && response) {
                                            var responseHeaderMap_1 = {};
                                            response.headers.forEach(function(value, name) {
                                                if (_canIncludeHeaders(name)) responseHeaderMap_1[name] = value;
                                            });
                                            ajaxResponse[0, $ioYfq._DYN_HEADER_MAP /* @min:%2eheaderMap */ ] = responseHeaderMap_1;
                                        }
                                        return ajaxResponse;
                                    });
                                    return response;
                                })["catch"](function(reason) {
                                    _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, {
                                        error: reason.message || (0, $bU24K.dumpObj)(reason)
                                    });
                                    throw reason;
                                });
                            }
                        },
                        // Create an error callback to report any hook errors
                        hkErr: $6753b8e5805e0a52$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to monitor Window.fetch" + $6753b8e5805e0a52$var$ERROR_POSTFIX)
                    }, true, $6753b8e5805e0a52$var$isWebWorker()));
                    _fetchInitialized = true;
                } else if (isPolyfill) // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                // of reporting ourselves, for example React Native uses a polyfill for fetch
                // Note: Polyfill implementations that don't support the "poyyfill" tag are not supported
                // the workaround is to add a polyfill property to your fetch implementation before initializing
                // App Insights
                _addHook((0, $77mRF.InstrumentFunc)(global, $6753b8e5805e0a52$var$STR_FETCH, {
                    ns: _evtNamespace,
                    req: function(callDetails, input, init) {
                        // Just call so that we record any disabled URL
                        _isDisabledRequest(null, input, init);
                    }
                }));
                if (isPolyfill) // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                // But also supports multiple App Insights usages
                global[$6753b8e5805e0a52$var$STR_FETCH].polyfill = isPolyfill;
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook((0, $77mRF.InstrumentProto)(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if ($6753b8e5805e0a52$var$_supportsAjaxMonitoring(_self, _ajaxDataId) && !_disableAjaxTracking && !_xhrInitialized) {
                    // Instrument open
                    _hookProto(XMLHttpRequest, "open", {
                        ns: _evtNamespace,
                        req: function(callDetails, method, url, async) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $ioYfq._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $6753b8e5805e0a52$var$_getAjaxData(xhr, _ajaxDataId);
                                if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                    if (!ajaxData || !ajaxData.xhrMonitoringState[0, $ioYfq._DYN_OPEN_DONE /* @min:%2eopenDone */ ]) // Only create a single ajaxData (even when multiple AI instances are running)
                                    ajaxData = _openHandler(xhr, method, url, async);
                                    // always attach to the on ready state change (required for handling multiple instances)
                                    _attachToOnReadyStateChange(xhr, ajaxData);
                                }
                            }
                        },
                        hkErr: $6753b8e5805e0a52$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , $6753b8e5805e0a52$var$ERROR_HEADER + ".open" + $6753b8e5805e0a52$var$ERROR_POSTFIX)
                    });
                    // Instrument send
                    _hookProto(XMLHttpRequest, "send", {
                        ns: _evtNamespace,
                        req: function(callDetails, context) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $ioYfq._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $6753b8e5805e0a52$var$_getAjaxData(xhr, _ajaxDataId);
                                if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[0, $ioYfq._DYN_SEND_DONE /* @min:%2esendDone */ ]) {
                                    _createMarkId("xhr", ajaxData);
                                    ajaxData[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ] = (0, $rOoAk.dateTimeUtilsNow)();
                                    _self[0, $ioYfq._DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */ ](ajaxData, undefined, undefined, xhr);
                                    ajaxData.xhrMonitoringState[0, $ioYfq._DYN_SEND_DONE /* @min:%2esendDone */ ] = true;
                                }
                            }
                        },
                        hkErr: $6753b8e5805e0a52$var$_createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */ , $6753b8e5805e0a52$var$ERROR_HEADER + $6753b8e5805e0a52$var$ERROR_POSTFIX)
                    });
                    // Instrument abort
                    _hookProto(XMLHttpRequest, "abort", {
                        ns: _evtNamespace,
                        req: function(callDetails) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $ioYfq._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $6753b8e5805e0a52$var$_getAjaxData(xhr, _ajaxDataId);
                                if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[0, $ioYfq._DYN_ABORT_DONE /* @min:%2eabortDone */ ]) {
                                    ajaxData[0, $ioYfq._DYN_ABORTED /* @min:%2eaborted */ ] = 1;
                                    ajaxData.xhrMonitoringState[0, $ioYfq._DYN_ABORT_DONE /* @min:%2eabortDone */ ] = true;
                                }
                            }
                        },
                        hkErr: $6753b8e5805e0a52$var$_createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */ , $6753b8e5805e0a52$var$ERROR_HEADER + ".abort" + $6753b8e5805e0a52$var$ERROR_POSTFIX)
                    });
                    // Instrument setRequestHeader
                    _hookProto(XMLHttpRequest, "setRequestHeader", {
                        ns: _evtNamespace,
                        req: function(callDetails, header, value) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $ioYfq._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $6753b8e5805e0a52$var$_getAjaxData(xhr, _ajaxDataId);
                                if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                    $6753b8e5805e0a52$var$_addSharedXhrHeaders(xhr, header, value);
                                    if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                        if (ajaxData) ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][header] = value;
                                    }
                                }
                            }
                        },
                        hkErr: $6753b8e5805e0a52$var$_createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , $6753b8e5805e0a52$var$ERROR_HEADER + ".setRequestHeader" + $6753b8e5805e0a52$var$ERROR_POSTFIX)
                    });
                    _xhrInitialized = true;
                }
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!(0, $hGXAo.isString)(request) ? (request || {}).url || "" : request) || "")[0, $ioYfq._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                (0, $hGXAo.arrForEach)(_excludeRequestFromAutoTrackingPatterns, function(regex) {
                    var theRegex = regex;
                    if ((0, $hGXAo.isString)(regex)) theRegex = new RegExp(regex);
                    if (!isDisabled) isDisabled = theRegex.test(theUrl);
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) return isDisabled;
                var idx = $6753b8e5805e0a52$var$_indexOf(theUrl, "?");
                var idx2 = $6753b8e5805e0a52$var$_indexOf(theUrl, "#");
                if (idx === -1 || idx2 !== -1 && idx2 < idx) idx = idx2;
                if (idx !== -1) // Strip off any Query string
                theUrl = theUrl.substring(0, idx);
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!(0, $hGXAo.isNullOrUndefined)(xhr)) // Look on the XMLHttpRequest of the URL string value
                isDisabled = xhr[0, $cVsUj.DisabledPropertyName] === true || theUrl[0, $cVsUj.DisabledPropertyName] === true;
                else if (!(0, $hGXAo.isNullOrUndefined)(request)) // Look for DisabledPropertyName in either Request or RequestInit
                isDisabled = (typeof request === "object" ? request[0, $cVsUj.DisabledPropertyName] === true : false) || (init ? init[0, $cVsUj.DisabledPropertyName] === true : false);
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && (0, $rOoAk.isInternalApplicationInsightsEndpoint)(theUrl)) isDisabled = true;
                if (isDisabled) // Add the disabled url if not present
                {
                    if (!_disabledUrls[theUrl]) _disabledUrls[theUrl] = 1;
                } else // Check to see if the url is listed as disabled
                if (_disabledUrls[theUrl]) isDisabled = true;
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!(0, $hGXAo.isNullOrUndefined)(xhr)) ajaxValidation = excludeAjaxDataValidation === true || !(0, $hGXAo.isNullOrUndefined)(ajaxData);
                // checking to see that all interested functions on xhr were instrumented
                return initialized && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ] && _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ].getTraceCtx(false);
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) distributedTraceCtx = (0, $rOoAk.createDistributedTraceContextFromTrace)(_context.telemetryTrace);
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $ioYfq._DYN_GET_TRACE_ID /* @min:%2egetTraceId */ ]() || (0, $k0iSW.generateW3CId)();
                var spanID = (0, $k0iSW.generateW3CId)().substr(0, 16);
                var xhrRequestData = xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER] = xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER] || {
                    xh: [],
                    i: {}
                };
                var ajaxDataCntr = xhrRequestData.i = xhrRequestData.i || {};
                var ajaxData = ajaxDataCntr[_ajaxDataId] = ajaxDataCntr[_ajaxDataId] || new (0, $6YNdy.ajaxRecord)(traceID, spanID, _self[$6753b8e5805e0a52$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $ioYfq._DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ] = method;
                ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = url;
                ajaxData.xhrMonitoringState[0, $ioYfq._DYN_OPEN_DONE /* @min:%2eopenDone */ ] = true;
                ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = {};
                ajaxData.async = async;
                ajaxData[0, $ioYfq._DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[0, $ioYfq._DYN_STATE_CHANGE_ATTACHE14 /* @min:%2estateChangeAttached */ ] = (0, $lhl6R.eventOn)(xhr, "readystatechange", function() {
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) _onAjaxComplete(xhr);
                    } catch (e) {
                        var exceptionText = (0, $bU24K.dumpObj)(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || $6753b8e5805e0a52$var$_indexOf(exceptionText[0, $ioYfq._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](), "c00c023f") === -1) $6753b8e5805e0a52$var$_throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */ , $6753b8e5805e0a52$var$ERROR_HEADER + " 'readystatechange' event handler" + $6753b8e5805e0a52$var$ERROR_POSTFIX, {
                            ajaxDiagnosticsMessage: $6753b8e5805e0a52$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                            exception: exceptionText
                        });
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") // As per the specification responseText is only valid if the type is an empty string or "text"
                    return xhr[0, $ioYfq._DYN_RESPONSE_TEXT /* @min:%2eresponseText */ ];
                } catch (e) {
                // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = $6753b8e5805e0a52$var$_getAjaxData(xhr, _ajaxDataId);
                ajaxData[0, $ioYfq._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ] = (0, $rOoAk.dateTimeUtilsNow)();
                ajaxData[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] = xhr[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = $6753b8e5805e0a52$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) errorProps["exception"] = (0, $bU24K.dumpObj)(e);
                    $6753b8e5805e0a52$var$_throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , $6753b8e5805e0a52$var$FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + $6753b8e5805e0a52$var$ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
                    try {
                        var dependency = ajaxData[0, $ioYfq._DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */ ]("Ajax", _enableRequestHeaderTracking, function() {
                            var ajaxResponse = {
                                statusText: xhr[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ],
                                headerMap: null,
                                correlationContext: _getAjaxCorrelationContext(xhr),
                                type: xhr.responseType,
                                responseText: _getResponseText(xhr),
                                response: xhr[0, $ioYfq._DYN_RESPONSE /* @min:%2eresponse */ ]
                            };
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[0, $ioYfq._DYN_GET_ALL_RESPONSE_HEA16 /* @min:%2egetAllResponseHeaders */ ]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = (0, $hGXAo.strTrim)(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    (0, $hGXAo.arrForEach)(arr, function(line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) responseHeaderMap_2[header] = value;
                                    });
                                    ajaxResponse[0, $ioYfq._DYN_HEADER_MAP /* @min:%2eheaderMap */ ] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) properties = _addRequestContext({
                                status: xhr[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ],
                                xhr: xhr
                            });
                        } catch (e) {
                            $6753b8e5805e0a52$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $6753b8e5805e0a52$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) dependency[0, $eJNsa.STR_PROPERTIES /* @min:%2eproperties */ ] = (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, dependency.properties), properties);
                            var sysProperties = ajaxData[0, $ioYfq._DYN_GET_PART_APROPS /* @min:%2egetPartAProps */ ]();
                            _reportDependencyInternal(_dependencyInitializers, _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                        } else _reportXhrError(null, {
                            requestSentTime: ajaxData[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ],
                            responseFinishedTime: ajaxData[0, $ioYfq._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ]
                        });
                    } finally{
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = xhr[$6753b8e5805e0a52$var$AJAX_DATA_CONTAINER] || {
                                i: {}
                            };
                            var ajaxDataCntr = xhrRequestData.i || {};
                            if (ajaxDataCntr[_ajaxDataId]) ajaxDataCntr[_ajaxDataId] = null;
                        } catch (e) {
                        // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function(e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                try {
                    var responseHeadersString = xhr[0, $ioYfq._DYN_GET_ALL_RESPONSE_HEA16 /* @min:%2egetAllResponseHeaders */ ]();
                    if (responseHeadersString !== null) {
                        var index = $6753b8e5805e0a52$var$_indexOf(responseHeadersString[0, $ioYfq._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](), (0, $ddqo3.RequestHeaders)[8 /* eRequestHeaders.requestContextHeaderLowerCase */ ]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader((0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]);
                            return (0, $rOoAk.CorrelationIdHelper)[0, $ioYfq._DYN_GET_CORRELATION_CONT17 /* @min:%2egetCorrelationContext */ ](responseHeader);
                        }
                    }
                } catch (e) {
                    $6753b8e5805e0a52$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $6753b8e5805e0a52$var$CORRELATION_HEADER_ERROR, {
                        ajaxDiagnosticsMessage: $6753b8e5805e0a52$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = (0, $bU24K.getPerformance)();
                    if (performance_1 && (0, $hGXAo.isFunction)(performance_1.mark)) {
                        $6753b8e5805e0a52$var$_markCount++;
                        var markId = _markPrefix + type + "#" + $6753b8e5805e0a52$var$_markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] === 1) ajaxData[0, $ioYfq._DYN_PERF_MARK /* @min:%2eperfMark */ ] = entries[0];
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[0, $ioYfq._DYN_PERF_MARK /* @min:%2eperfMark */ ];
                var performance = (0, $bU24K.getPerformance)();
                var maxAttempts = _config.maxAjaxPerfLookupAttempts;
                var retryDelay = _config[0, $ioYfq._DYN_AJAX_PERF_LOOKUP_DEL18 /* @min:%2eajaxPerfLookupDelay */ ];
                var requestUrl = ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for(var lp = entries[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] - 1; lp >= 0; lp--){
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType && ($6753b8e5805e0a52$var$_indexOf(entry[0, $ioYfq._DYN_NAME /* @min:%2ename */ ], requestUrl) !== -1 || $6753b8e5805e0a52$var$_indexOf(requestUrl, entry[0, $ioYfq._DYN_NAME /* @min:%2ename */ ]) !== -1)) perfTiming = entry;
                                    } else if (entry.entryType === "mark" && entry[0, $ioYfq._DYN_NAME /* @min:%2ename */ ] === perfMark[0, $ioYfq._DYN_NAME /* @min:%2ename */ ]) {
                                        // We hit the start event
                                        ajaxData[0, $ioYfq._DYN_PERF_TIMING /* @min:%2eperfTiming */ ] = perfTiming;
                                        break;
                                    }
                                    if (entry[0, $ioYfq._DYN_START_TIME /* @min:%2estartTime */ ] < perfMark[0, $ioYfq._DYN_START_TIME /* @min:%2estartTime */ ] - 1000) break;
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                        ajaxData[0, $ioYfq._DYN_PERF_TIMING /* @min:%2eperfTiming */ ] || // - we have not found the perf entry or
                        attempt >= maxAttempts || // - we have tried too many attempts or
                        ajaxData.async === false) {
                            if (perfMark && (0, $hGXAo.isFunction)(performance.clearMarks)) // Remove the mark so we don't fill up the performance resources too much
                            performance.clearMarks(perfMark[0, $ioYfq._DYN_NAME /* @min:%2ename */ ]);
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        } else // We need to wait for the browser to populate the window.performance entry
                        // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                        // this is a scheduling issue for the browser implementation
                        setTimeout(locateResourceTiming, retryDelay);
                    } catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $ioYfq._DYN_GET_TRACE_ID /* @min:%2egetTraceId */ ]() || (0, $k0iSW.generateW3CId)();
                var spanID = (0, $k0iSW.generateW3CId)().substr(0, 16);
                var ajaxData = new (0, $6YNdy.ajaxRecord)(traceID, spanID, _self[$6753b8e5805e0a52$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $ioYfq._DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ] = (0, $rOoAk.dateTimeUtilsNow)();
                ajaxData[0, $ioYfq._DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                if (input instanceof Request) ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = input ? input.url : "";
                else ajaxData[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = input;
                var method = "GET";
                if (init && init[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ]) method = init[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ];
                else if (input && input instanceof Request) method = input[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ];
                ajaxData[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ] : 0) || (input instanceof Request ? input[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ] || {} : {}));
                    headers.forEach(function(value, key) {
                        if (_canIncludeHeaders(key)) requestHeaders[key] = value;
                    });
                }
                ajaxData[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = requestHeaders;
                _createMarkId($6753b8e5805e0a52$var$STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!(0, $hGXAo.isNullOrUndefined)(input)) {
                        if ((0, $hGXAo.isString)(input)) result += "(url: '".concat(input, "')");
                        else result += "(url: '".concat(input.url, "')");
                    }
                } catch (e) {
                    $6753b8e5805e0a52$var$_throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to grab failed fetch diagnostics message", {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) return;
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) errorProps["exception"] = (0, $bU24K.dumpObj)(e);
                    $6753b8e5805e0a52$var$_throwInternalWarning(_self, msgId, $6753b8e5805e0a52$var$FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + $6753b8e5805e0a52$var$ERROR_NOT_SENT, errorProps);
                }
                ajaxData[0, $ioYfq._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ] = (0, $rOoAk.dateTimeUtilsNow)();
                ajaxData[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] = status;
                _findPerfResourceEntry($6753b8e5805e0a52$var$STR_FETCH, ajaxData, function() {
                    var dependency = ajaxData[0, $ioYfq._DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */ ]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) properties = _addRequestContext({
                            status: status,
                            request: input,
                            response: response
                        });
                    } catch (e) {
                        $6753b8e5805e0a52$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $6753b8e5805e0a52$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) dependency[0, $eJNsa.STR_PROPERTIES /* @min:%2eproperties */ ] = (0, $8AlFX.__assignFn)((0, $8AlFX.__assignFn)({}, dependency.properties), properties);
                        var sysProperties = ajaxData[0, $ioYfq._DYN_GET_PART_APROPS /* @min:%2egetPartAProps */ ]();
                        _reportDependencyInternal(_dependencyInitializers, _self[0, $ioYfq._DYN_CORE /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                    } else _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , null, {
                        requestSentTime: ajaxData[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ],
                        responseFinishedTime: ajaxData[0, $ioYfq._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ]
                    });
                }, function(e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                if (response && response[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ]) try {
                    var responseHeader = response[0, $ioYfq._DYN_HEADERS /* @min:%2eheaders */ ].get((0, $ddqo3.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]);
                    return (0, $rOoAk.CorrelationIdHelper)[0, $ioYfq._DYN_GET_CORRELATION_CONT17 /* @min:%2egetCorrelationContext */ ](responseHeader);
                } catch (e) {
                    $6753b8e5805e0a52$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $6753b8e5805e0a52$var$CORRELATION_HEADER_ERROR, {
                        fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var result = true;
                var initializersCount = initializers[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ];
                if (initializersCount > 0) {
                    var details = {
                        item: dependency,
                        properties: properties,
                        sysProperties: systemProperties,
                        context: ajaxData ? ajaxData[0, $ioYfq._DYN_CONTEXT /* @min:%2econtext */ ] : null,
                        aborted: ajaxData ? !!ajaxData[0, $ioYfq._DYN_ABORTED /* @min:%2eaborted */ ] : false
                    };
                    result = $6753b8e5805e0a52$var$_processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) _self[0, $ioYfq._DYN_TRACK_DEPENDENCY_DAT4 /* @min:%2etrackDependencyDataInternal */ ](dependency, properties, systemProperties);
            }
        });
        return _this;
    }
    // Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function(item, itemCtx) {
        this.processNext(item, itemCtx);
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyData.
    // Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
    // Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AjaxMonitor.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    AjaxMonitor.getDefaultConfig = $6753b8e5805e0a52$var$_getDefaultConfig;
    AjaxMonitor.getEmptyConfig = $6753b8e5805e0a52$var$_getEmptyConfig;
    return AjaxMonitor;
}((0, $dtXLi.BaseTelemetryPlugin));

});
parcelRegister("eJNsa", function(module, exports) {

$parcel$export(module.exports, "STR_DURATION", function () { return $ababa10eed1aecbb$export$be41298b7716c698; });
$parcel$export(module.exports, "STR_PROPERTIES", function () { return $ababa10eed1aecbb$export$400e70f2a2ecb5aa; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $ababa10eed1aecbb$export$be41298b7716c698 = "duration";
var $ababa10eed1aecbb$export$400e70f2a2ecb5aa = "properties";

});

parcelRegister("ioYfq", function(module, exports) {

$parcel$export(module.exports, "_DYN_REQUEST_URL", function () { return $d65933dc8bb106cc$export$8ff033ecd75b66c3; });
$parcel$export(module.exports, "_DYN_INST", function () { return $d65933dc8bb106cc$export$25a34734290022f3; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $d65933dc8bb106cc$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_TRACE_ID", function () { return $d65933dc8bb106cc$export$a5eb52c53bba8560; });
$parcel$export(module.exports, "_DYN_SPAN_ID", function () { return $d65933dc8bb106cc$export$c105b94efa183847; });
$parcel$export(module.exports, "_DYN_TRACE_FLAGS", function () { return $d65933dc8bb106cc$export$4e92e4b92b41ba2d; });
$parcel$export(module.exports, "_DYN_CONTEXT", function () { return $d65933dc8bb106cc$export$fdcd48959e13aba7; });
$parcel$export(module.exports, "_DYN_ABORTED", function () { return $d65933dc8bb106cc$export$fcf18cee9ee41961; });
$parcel$export(module.exports, "_DYN_TRACE_ID0", function () { return $d65933dc8bb106cc$export$f8d9e07631527156; });
$parcel$export(module.exports, "_DYN_SPAN_ID1", function () { return $d65933dc8bb106cc$export$e39be82dc519c4ae; });
$parcel$export(module.exports, "_DYN_CORE", function () { return $d65933dc8bb106cc$export$f9ae8d0acf86503e; });
$parcel$export(module.exports, "_DYN_INCLUDE_CORRELATION_2", function () { return $d65933dc8bb106cc$export$ec2c4b7da1ef8dd0; });
$parcel$export(module.exports, "_DYN_CAN_INCLUDE_CORRELAT3", function () { return $d65933dc8bb106cc$export$ae427c8b4e4f202a; });
$parcel$export(module.exports, "_DYN_GET_ABSOLUTE_URL", function () { return $d65933dc8bb106cc$export$de5be3709039b9b0; });
$parcel$export(module.exports, "_DYN_HEADERS", function () { return $d65933dc8bb106cc$export$829ed22a43b4aada; });
$parcel$export(module.exports, "_DYN_REQUEST_HEADERS", function () { return $d65933dc8bb106cc$export$b58618e731cdb301; });
$parcel$export(module.exports, "_DYN_APP_ID", function () { return $d65933dc8bb106cc$export$3d3b09d87c20a6d6; });
$parcel$export(module.exports, "_DYN_SET_REQUEST_HEADER", function () { return $d65933dc8bb106cc$export$84ecd29f369f5b1d; });
$parcel$export(module.exports, "_DYN_TRACK_DEPENDENCY_DAT4", function () { return $d65933dc8bb106cc$export$bc1ce1356cea67a; });
$parcel$export(module.exports, "_DYN_DISTRIBUTED_TRACING_5", function () { return $d65933dc8bb106cc$export$cc97618f4c74340f; });
$parcel$export(module.exports, "_DYN_START_TIME", function () { return $d65933dc8bb106cc$export$69cac26425c8ea23; });
$parcel$export(module.exports, "_DYN_TO_LOWER_CASE", function () { return $d65933dc8bb106cc$export$e4eaee9e01d9baaa; });
$parcel$export(module.exports, "_DYN_ENABLE_REQUEST_HEADE6", function () { return $d65933dc8bb106cc$export$574c5c1d5bb17955; });
$parcel$export(module.exports, "_DYN_ENABLE_AJAX_ERROR_ST7", function () { return $d65933dc8bb106cc$export$c9cd806c1fef7192; });
$parcel$export(module.exports, "_DYN_ENABLE_AJAX_PERF_TRA8", function () { return $d65933dc8bb106cc$export$7c0a9d78ce383de9; });
$parcel$export(module.exports, "_DYN_MAX_AJAX_CALLS_PER_V9", function () { return $d65933dc8bb106cc$export$7f047061a0f4113a; });
$parcel$export(module.exports, "_DYN_ENABLE_RESPONSE_HEAD10", function () { return $d65933dc8bb106cc$export$650df8a93357784d; });
$parcel$export(module.exports, "_DYN_EXCLUDE_REQUEST_FROM11", function () { return $d65933dc8bb106cc$export$16e1c69e14a7249e; });
$parcel$export(module.exports, "_DYN_ADD_REQUEST_CONTEXT", function () { return $d65933dc8bb106cc$export$e9d1b90025f35753; });
$parcel$export(module.exports, "_DYN_DISABLE_AJAX_TRACKIN12", function () { return $d65933dc8bb106cc$export$966ff5e4f4a47843; });
$parcel$export(module.exports, "_DYN_DISABLE_FETCH_TRACKI13", function () { return $d65933dc8bb106cc$export$674680799cc6c04c; });
$parcel$export(module.exports, "_DYN_STATUS", function () { return $d65933dc8bb106cc$export$f8d169088a01f6f2; });
$parcel$export(module.exports, "_DYN_STATUS_TEXT", function () { return $d65933dc8bb106cc$export$e44f43b238a0c7f0; });
$parcel$export(module.exports, "_DYN_HEADER_MAP", function () { return $d65933dc8bb106cc$export$422ea83a60e3414b; });
$parcel$export(module.exports, "_DYN_OPEN_DONE", function () { return $d65933dc8bb106cc$export$9984940f44bb6769; });
$parcel$export(module.exports, "_DYN_SEND_DONE", function () { return $d65933dc8bb106cc$export$ebd7b63f645a373e; });
$parcel$export(module.exports, "_DYN_REQUEST_SENT_TIME", function () { return $d65933dc8bb106cc$export$b3507d39ae3f3e22; });
$parcel$export(module.exports, "_DYN_ABORT_DONE", function () { return $d65933dc8bb106cc$export$dda6370f5a5c9f36; });
$parcel$export(module.exports, "_DYN_GET_TRACE_ID", function () { return $d65933dc8bb106cc$export$90dab0fe9b2b7158; });
$parcel$export(module.exports, "_DYN_GET_TRACE_FLAGS", function () { return $d65933dc8bb106cc$export$1fd22cf8d803736f; });
$parcel$export(module.exports, "_DYN_METHOD", function () { return $d65933dc8bb106cc$export$47d30bd816d62bdc; });
$parcel$export(module.exports, "_DYN_ERROR_STATUS_TEXT", function () { return $d65933dc8bb106cc$export$cce28811c9041832; });
$parcel$export(module.exports, "_DYN_STATE_CHANGE_ATTACHE14", function () { return $d65933dc8bb106cc$export$292775acf8df8831; });
$parcel$export(module.exports, "_DYN_RESPONSE_TEXT", function () { return $d65933dc8bb106cc$export$d9f76b3afffa4e88; });
$parcel$export(module.exports, "_DYN_RESPONSE_FINISHED_TI15", function () { return $d65933dc8bb106cc$export$182d7e789a77d304; });
$parcel$export(module.exports, "_DYN__CREATE_TRACK_ITEM", function () { return $d65933dc8bb106cc$export$e31aceb60e1b3a1a; });
$parcel$export(module.exports, "_DYN_RESPONSE", function () { return $d65933dc8bb106cc$export$71a9f4a2e496846d; });
$parcel$export(module.exports, "_DYN_GET_ALL_RESPONSE_HEA16", function () { return $d65933dc8bb106cc$export$6bf05f118580ffa; });
$parcel$export(module.exports, "_DYN_GET_PART_APROPS", function () { return $d65933dc8bb106cc$export$e2e640c31408a88f; });
$parcel$export(module.exports, "_DYN_GET_CORRELATION_CONT17", function () { return $d65933dc8bb106cc$export$c69633899eccb4a7; });
$parcel$export(module.exports, "_DYN_PERF_MARK", function () { return $d65933dc8bb106cc$export$9e85e7b326182790; });
$parcel$export(module.exports, "_DYN_AJAX_PERF_LOOKUP_DEL18", function () { return $d65933dc8bb106cc$export$1ee8a32f080b146; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $d65933dc8bb106cc$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_PERF_TIMING", function () { return $d65933dc8bb106cc$export$6bec4987b5d3526c; });
$parcel$export(module.exports, "_DYN_CORRELATION_CONTEXT", function () { return $d65933dc8bb106cc$export$c4a9b5c39c7409f7; });
$parcel$export(module.exports, "_DYN_AJAX_TOTAL_DURATION", function () { return $d65933dc8bb106cc$export$7820e90f0eaab413; });
$parcel$export(module.exports, "_DYN_EVENT_TRACE_CTX", function () { return $d65933dc8bb106cc$export$c050ff25390a2bce; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $d65933dc8bb106cc$export$8ff033ecd75b66c3 = "requestUrl"; // Count: 12
var $d65933dc8bb106cc$export$25a34734290022f3 = "inst"; // Count: 5
var $d65933dc8bb106cc$export$6eae51590aaea43 = "length"; // Count: 10
var $d65933dc8bb106cc$export$a5eb52c53bba8560 = "traceID"; // Count: 9
var $d65933dc8bb106cc$export$c105b94efa183847 = "spanID"; // Count: 8
var $d65933dc8bb106cc$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 13
var $d65933dc8bb106cc$export$fdcd48959e13aba7 = "context"; // Count: 7
var $d65933dc8bb106cc$export$fcf18cee9ee41961 = "aborted"; // Count: 7
var $d65933dc8bb106cc$export$f8d9e07631527156 = "traceId"; // Count: 5
var $d65933dc8bb106cc$export$e39be82dc519c4ae = "spanId"; // Count: 5
var $d65933dc8bb106cc$export$f9ae8d0acf86503e = "core"; // Count: 8
var $d65933dc8bb106cc$export$ec2c4b7da1ef8dd0 = "includeCorrelationHeaders"; // Count: 4
var $d65933dc8bb106cc$export$ae427c8b4e4f202a = "canIncludeCorrelationHeader"; // Count: 2
var $d65933dc8bb106cc$export$de5be3709039b9b0 = "getAbsoluteUrl"; // Count: 3
var $d65933dc8bb106cc$export$829ed22a43b4aada = "headers"; // Count: 6
var $d65933dc8bb106cc$export$b58618e731cdb301 = "requestHeaders"; // Count: 13
var $d65933dc8bb106cc$export$3d3b09d87c20a6d6 = "appId"; // Count: 5
var $d65933dc8bb106cc$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $d65933dc8bb106cc$export$bc1ce1356cea67a = "trackDependencyDataInternal"; // Count: 2
var $d65933dc8bb106cc$export$cc97618f4c74340f = "distributedTracingMode"; // Count: 3
var $d65933dc8bb106cc$export$69cac26425c8ea23 = "startTime"; // Count: 6
var $d65933dc8bb106cc$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $d65933dc8bb106cc$export$574c5c1d5bb17955 = "enableRequestHeaderTracking"; // Count: 2
var $d65933dc8bb106cc$export$c9cd806c1fef7192 = "enableAjaxErrorStatusText"; // Count: 2
var $d65933dc8bb106cc$export$7c0a9d78ce383de9 = "enableAjaxPerfTracking"; // Count: 2
var $d65933dc8bb106cc$export$7f047061a0f4113a = "maxAjaxCallsPerView"; // Count: 2
var $d65933dc8bb106cc$export$650df8a93357784d = "enableResponseHeaderTracking"; // Count: 2
var $d65933dc8bb106cc$export$16e1c69e14a7249e = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var $d65933dc8bb106cc$export$e9d1b90025f35753 = "addRequestContext"; // Count: 2
var $d65933dc8bb106cc$export$966ff5e4f4a47843 = "disableAjaxTracking"; // Count: 2
var $d65933dc8bb106cc$export$674680799cc6c04c = "disableFetchTracking"; // Count: 2
var $d65933dc8bb106cc$export$f8d169088a01f6f2 = "status"; // Count: 11
var $d65933dc8bb106cc$export$e44f43b238a0c7f0 = "statusText"; // Count: 9
var $d65933dc8bb106cc$export$422ea83a60e3414b = "headerMap"; // Count: 8
var $d65933dc8bb106cc$export$9984940f44bb6769 = "openDone"; // Count: 3
var $d65933dc8bb106cc$export$ebd7b63f645a373e = "sendDone"; // Count: 3
var $d65933dc8bb106cc$export$b3507d39ae3f3e22 = "requestSentTime"; // Count: 9
var $d65933dc8bb106cc$export$dda6370f5a5c9f36 = "abortDone"; // Count: 3
var $d65933dc8bb106cc$export$90dab0fe9b2b7158 = "getTraceId"; // Count: 3
var $d65933dc8bb106cc$export$1fd22cf8d803736f = "getTraceFlags"; // Count: 3
var $d65933dc8bb106cc$export$47d30bd816d62bdc = "method"; // Count: 8
var $d65933dc8bb106cc$export$cce28811c9041832 = "errorStatusText"; // Count: 3
var $d65933dc8bb106cc$export$292775acf8df8831 = "stateChangeAttached"; // Count: 2
var $d65933dc8bb106cc$export$d9f76b3afffa4e88 = "responseText"; // Count: 6
var $d65933dc8bb106cc$export$182d7e789a77d304 = "responseFinishedTime"; // Count: 7
var $d65933dc8bb106cc$export$e31aceb60e1b3a1a = "CreateTrackItem"; // Count: 3
var $d65933dc8bb106cc$export$71a9f4a2e496846d = "response"; // Count: 4
var $d65933dc8bb106cc$export$6bf05f118580ffa = "getAllResponseHeaders"; // Count: 2
var $d65933dc8bb106cc$export$e2e640c31408a88f = "getPartAProps"; // Count: 3
var $d65933dc8bb106cc$export$c69633899eccb4a7 = "getCorrelationContext"; // Count: 2
var $d65933dc8bb106cc$export$9e85e7b326182790 = "perfMark"; // Count: 4
var $d65933dc8bb106cc$export$1ee8a32f080b146 = "ajaxPerfLookupDelay"; // Count: 2
var $d65933dc8bb106cc$export$9734b0a24bf02e93 = "name"; // Count: 6
var $d65933dc8bb106cc$export$6bec4987b5d3526c = "perfTiming"; // Count: 3
var $d65933dc8bb106cc$export$ae4e4f44752daa55 = "ajaxDiagnosticsMessage"; // Count: 3
var $d65933dc8bb106cc$export$c4a9b5c39c7409f7 = "correlationContext"; // Count: 3
var $d65933dc8bb106cc$export$7820e90f0eaab413 = "ajaxTotalDuration"; // Count: 3
var $d65933dc8bb106cc$export$c050ff25390a2bce = "eventTraceCtx"; // Count: 3

});

parcelRegister("6YNdy", function(module, exports) {

$parcel$export(module.exports, "ajaxRecord", function () { return $514e8649a7f96751$export$3391d178758cbbb1; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $i2MiW = parcelRequire("i2MiW");
var $rOoAk = parcelRequire("rOoAk");
var $cWQSw = parcelRequire("cWQSw");
var $6bipl = parcelRequire("6bipl");
var $3uBtC = parcelRequire("3uBtC");

var $hGXAo = parcelRequire("hGXAo");

var $eJNsa = parcelRequire("eJNsa");

var $ioYfq = parcelRequire("ioYfq");
/** @ignore */ function $514e8649a7f96751$var$_calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) result = (0, $rOoAk.dateTimeUtilsDuration)(from, to);
    return result;
}
/** @ignore */ function $514e8649a7f96751$var$_setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = $514e8649a7f96751$var$_calcPerfDuration(resourceEntry, start, end);
    if (value) result = $514e8649a7f96751$var$_setPerfValue(props, name, (0, $6bipl.msToTimeSpan)(value));
    return result;
}
/** @ignore */ function $514e8649a7f96751$var$_setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = props[strPerf] || {};
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */ function $514e8649a7f96751$var$_populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */ var resourceEntry = ajaxData[0, $ioYfq._DYN_PERF_TIMING /* @min:%2eperfTiming */ ];
    var props = dependency[0, $eJNsa.STR_PROPERTIES /* @min:%2eproperties */ ] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= $514e8649a7f96751$var$_setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[0, $eJNsa.STR_DURATION /* @min:%2eduration */ ];
        if (!duration) duration = $514e8649a7f96751$var$_calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        propsSet |= $514e8649a7f96751$var$_setPerfValue(props, (0, $eJNsa.STR_DURATION), duration);
        propsSet |= $514e8649a7f96751$var$_setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            (0, $hGXAo.arrForEach)(serverTiming, function(value, idx) {
                var name = (0, $hGXAo.normalizeJsName)(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                (0, $hGXAo.objForEachKey)(value, function(key, val) {
                    if (key !== strName && (0, $hGXAo.isString)(val) || (0, $hGXAo.isNumber)(val)) {
                        if (newValue[key]) val = newValue[key] + ";" + val;
                        if (val || !(0, $hGXAo.isString)(val)) // Only set the value if it has a value and it's not an empty string
                        newValue[key] = val;
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= $514e8649a7f96751$var$_setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= $514e8649a7f96751$var$_setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= $514e8649a7f96751$var$_setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= $514e8649a7f96751$var$_setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    } else if (ajaxData[0, $ioYfq._DYN_PERF_MARK /* @min:%2eperfMark */ ]) propsSet |= $514e8649a7f96751$var$_setPerfValue(props, "missing", ajaxData.perfAttempts);
    if (propsSet) dependency[0, $eJNsa.STR_PROPERTIES /* @min:%2eproperties */ ] = props;
}
var $514e8649a7f96751$export$79f098456caec6e7 = /** @class */ function() {
    function XHRMonitoringState() {
        var self = this;
        self[0, $ioYfq._DYN_OPEN_DONE /* @min:%2eopenDone */ ] = false;
        self.setRequestHeaderDone = false;
        self[0, $ioYfq._DYN_SEND_DONE /* @min:%2esendDone */ ] = false;
        self[0, $ioYfq._DYN_ABORT_DONE /* @min:%2eabortDone */ ] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[0, $ioYfq._DYN_STATE_CHANGE_ATTACHE14 /* @min:%2estateChangeAttached */ ] = false;
    }
    return XHRMonitoringState;
}();
var $514e8649a7f96751$export$3391d178758cbbb1 = /** @class */ function() {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[0, $ioYfq._DYN_PERF_MARK /* @min:%2eperfMark */ ] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[0, $ioYfq._DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */ ] = null;
        self[0, $ioYfq._DYN_ABORTED /* @min:%2eaborted */ ] = 0;
        self.pageUrl = null;
        self[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = null;
        self.requestSize = 0;
        self[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ] = null;
        self[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] = null;
        self[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ] = null;
        self.responseStartedTime = null;
        self[0, $ioYfq._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new $514e8649a7f96751$export$79f098456caec6e7();
        self.clientFailure = 0;
        self[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ] = traceId;
        self[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ] = spanId;
        self[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) self[0, $ioYfq._DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */ ] = (_a = {}, _a[0, $ioYfq._DYN_TRACE_ID0 /* @min:traceId */ ] = traceCtx[0, $ioYfq._DYN_GET_TRACE_ID /* @min:%2egetTraceId */ ](), _a[0, $ioYfq._DYN_SPAN_ID1 /* @min:spanId */ ] = traceCtx.getSpanId(), _a[0, $ioYfq._DYN_TRACE_FLAGS /* @min:traceFlags */ ] = traceCtx[0, $ioYfq._DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */ ](), _a);
        else self[0, $ioYfq._DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */ ] = null;
        (0, $bO3cR.default)(ajaxRecord, self, function(self) {
            self.getAbsoluteUrl = function() {
                return self[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] ? (0, $3uBtC.urlGetAbsoluteUrl)(self[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ]) : null;
            };
            self.getPathName = function() {
                return self[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] ? (0, $i2MiW.dataSanitizeUrl)(_logger, (0, $3uBtC.urlGetCompleteUrl)(self[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ], self[0, $ioYfq._DYN_REQUEST_URL /* @min:%2erequestUrl */ ])) : null;
            };
            self[0, $ioYfq._DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */ ] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round((0, $rOoAk.dateTimeUtilsDuration)(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[0, $ioYfq._DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */ ] < 0) return null;
                var dependency = (_a = {
                    id: "|" + self[0, $ioYfq._DYN_TRACE_ID /* @min:%2etraceID */ ] + "." + self[0, $ioYfq._DYN_SPAN_ID /* @min:%2espanID */ ],
                    target: self[0, $ioYfq._DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */ ]()
                }, _a[0, $ioYfq._DYN_NAME /* @min:name */ ] = self.getPathName(), _a.type = ajaxType, _a[0, $ioYfq._DYN_START_TIME /* @min:startTime */ ] = null, _a.duration = self[0, $ioYfq._DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */ ], _a.success = +self[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] >= 200 && +self[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] < 400, _a.responseCode = +self[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ], _a[0, $eJNsa.STR_PROPERTIES] = {
                    HttpMethod: self[0, $ioYfq._DYN_METHOD /* @min:%2emethod */ ]
                }, _a);
                var props = dependency[0, $eJNsa.STR_PROPERTIES];
                if (self[0, $ioYfq._DYN_ABORTED /* @min:%2eaborted */ ]) props[0, $ioYfq._DYN_ABORTED /* @min:%2eaborted */ ] = true;
                if (self[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ]) {
                    // Set the correct dependency start time
                    dependency[0, $ioYfq._DYN_START_TIME /* @min:%2estartTime */ ] = new Date();
                    dependency[0, $ioYfq._DYN_START_TIME /* @min:%2estartTime */ ].setTime(self[0, $ioYfq._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ]);
                }
                // Add Ajax perf details if available
                $514e8649a7f96751$var$_populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if ((0, $hGXAo.objKeys)(self.requestHeaders)[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] > 0) props[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = self[0, $ioYfq._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ];
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[0, $ioYfq._DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */ ];
                        if (correlationContext) dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        if (response[0, $ioYfq._DYN_HEADER_MAP /* @min:%2eheaderMap */ ]) {
                            if ((0, $hGXAo.objKeys)(response.headerMap)[0, $ioYfq._DYN_LENGTH /* @min:%2elength */ ] > 0) props.responseHeaders = response[0, $ioYfq._DYN_HEADER_MAP /* @min:%2eheaderMap */ ];
                        }
                        if (self[0, $ioYfq._DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */ ]) {
                            if (self[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") props.responseText = response.responseText ? response[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ] + " - " + response[strResponseText] : response[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ];
                                if (responseType === "json") props.responseText = response.response ? response[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ] + " - " + JSON.stringify(response[0, $ioYfq._DYN_RESPONSE /* @min:%2eresponse */ ]) : response[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ];
                            } else if (self[0, $ioYfq._DYN_STATUS /* @min:%2estatus */ ] === 0) props.responseText = response[0, $ioYfq._DYN_STATUS_TEXT /* @min:%2estatusText */ ] || "";
                        }
                    }
                }
                return dependency;
            };
            self[0, $ioYfq._DYN_GET_PART_APROPS /* @min:%2egetPartAProps */ ] = function() {
                var _a;
                var partA = null;
                var traceCtx = self[0, $ioYfq._DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */ ];
                if (traceCtx && (traceCtx[0, $ioYfq._DYN_TRACE_ID0 /* @min:%2etraceId */ ] || traceCtx[0, $ioYfq._DYN_SPAN_ID1 /* @min:%2espanId */ ])) {
                    partA = {};
                    var traceExt = partA[(0, $cWQSw.Extensions).TraceExt] = (_a = {}, _a[0, $ioYfq._DYN_TRACE_ID /* @min:traceID */ ] = traceCtx[0, $ioYfq._DYN_TRACE_ID0 /* @min:%2etraceId */ ], _a.parentID = traceCtx[0, $ioYfq._DYN_SPAN_ID1 /* @min:%2espanId */ ], _a);
                    if (!(0, $hGXAo.isNullOrUndefined)(traceCtx[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ])) traceExt[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = traceCtx[0, $ioYfq._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
                }
                return partA;
            };
        });
    }
    // Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
    // Removed Stub for ajaxRecord.prototype.getPathName.
    // Removed Stub for ajaxRecord.prototype.CreateTrackItem.
    // Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ajaxRecord.__ieDyn = 1;
    return ajaxRecord;
}();

});


parcelRegister("iri4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6c8c413a82636f7$export$2e2bcd8739ae039; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/ 
var $8AlFX = parcelRequire("8AlFX");

var $bO3cR = parcelRequire("bO3cR");

var $HME9b = parcelRequire("HME9b");
var $rOoAk = parcelRequire("rOoAk");
var $czkZK = parcelRequire("czkZK");
var $h1GMI = parcelRequire("h1GMI");

var $i86yL = parcelRequire("i86yL");
var $dtXLi = parcelRequire("dtXLi");
var $jx9Ci = parcelRequire("jx9Ci");
var $bU24K = parcelRequire("bU24K");
var $hGXAo = parcelRequire("hGXAo");

var $itgFs = parcelRequire("itgFs");

var $bcXLZ = parcelRequire("bcXLZ");
var $d6c8c413a82636f7$var$PropertiesPlugin = /** @class */ function(_super) {
    (0, $8AlFX.__extendsFn)(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = (0, $HME9b.PropertiesPluginIdentifier);
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        (0, $bO3cR.default)(PropertiesPlugin, _this, function(_self, _base) {
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event The event that needs to be processed
             */ _self.processTelemetry = function(event, itemCtx) {
                if ((0, $hGXAo.isNullOrUndefined)(event)) ;
                else {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === (0, $czkZK.PageView).envelopeType) itemCtx.diagLog().resetInternalMessageCount();
                    var theContext = _self.context || {};
                    if (theContext.session) // If customer did not provide custom session id update the session manager
                    {
                        if (typeof _self.context.session.id !== "string" && theContext[0, $bcXLZ._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ]) theContext[0, $bcXLZ._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ][0, $bcXLZ._DYN_UPDATE /* @min:%2eupdate */ ]();
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[0, $bcXLZ._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ]) userCtx[0, $bcXLZ._DYN_UPDATE /* @min:%2eupdate */ ](theContext.user.id);
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[0, $bcXLZ._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ]) {
                        userCtx[0, $bcXLZ._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ] = false;
                        var message = new (0, $i86yL._InternalLogMessage)(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */ , ((0, $bU24K.getNavigator)() || {}).userAgent || "");
                        (0, $i86yL._logInternalMessage)(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */ , message);
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[0, $bcXLZ._DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */ ]) {
                    var traceCtx = core[0, $bcXLZ._DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */ ](false);
                    if (traceCtx === _distributedTraceCtx) core.setTraceCtx(_previousTraceCtx);
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                var ctx = (0, $jx9Ci.createProcessTelemetryContext)(null, config, core);
                var defaultConfig = PropertiesPlugin.getDefaultConfig();
                _extensionConfig = _extensionConfig || {};
                (0, $hGXAo.objForEachKey)(defaultConfig, function(field, value) {
                    _extensionConfig[field] = function() {
                        return ctx.getConfig(identifier, field, value());
                    };
                });
                if (config.storagePrefix) (0, $h1GMI.utlSetStoragePrefix)(config.storagePrefix);
                _previousTraceCtx = core[0, $bcXLZ._DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */ ](false);
                _self.context = new (0, $itgFs.TelemetryContext)(core, _extensionConfig, _previousTraceCtx);
                _distributedTraceCtx = (0, $rOoAk.createDistributedTraceContextFromTrace)(_self.context[0, $bcXLZ._DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */ ], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function() {
                    var breezeChannel = core.getPlugin((0, $HME9b.BreezeChannelIdentifier));
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
                // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                _self["_extConfig"] = _extensionConfig;
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                (0, $hGXAo.getSetValue)(evt, "tags", []);
                (0, $hGXAo.getSetValue)(evt, "ext", {});
                var ctx = _self.context;
                ctx[0, $bcXLZ._DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */ ](evt, itemCtx);
                ctx[0, $bcXLZ._DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */ ](evt, itemCtx);
                ctx[0, $bcXLZ._DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */ ](evt, itemCtx);
                ctx[0, $bcXLZ._DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */ ](evt, itemCtx);
                ctx[0, $bcXLZ._DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */ ](evt, itemCtx);
                ctx[0, $bcXLZ._DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */ ](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[0, $bcXLZ._DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */ ](evt, itemCtx); // legacy tags
                ctx[0, $bcXLZ._DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */ ](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    PropertiesPlugin.getDefaultConfig = function() {
        var _a;
        var defaultValue;
        var nullValue = null;
        var defaultConfig = (_a = {
            instrumentationKey: function() {
                return defaultValue;
            }
        }, _a[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:accountId */ ] = function() {
            return nullValue;
        }, _a.sessionRenewalMs = function() {
            return 1800000;
        }, _a.samplingPercentage = function() {
            return 100;
        }, _a.sessionExpirationMs = function() {
            return 86400000;
        }, _a[0, $bcXLZ._DYN_COOKIE_DOMAIN /* @min:cookieDomain */ ] = function() {
            return nullValue;
        }, _a[0, $bcXLZ._DYN_SDK_EXTENSION /* @min:sdkExtension */ ] = function() {
            return nullValue;
        }, _a.isBrowserLinkTrackingEnabled = function() {
            return false;
        }, _a.appId = function() {
            return nullValue;
        }, _a[0, $bcXLZ._DYN_GET_SESSION_ID /* @min:getSessionId */ ] = function() {
            return nullValue;
        }, _a[0, $bcXLZ._DYN_NAME_PREFIX /* @min:namePrefix */ ] = function() {
            return defaultValue;
        }, _a[0, $bcXLZ._DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */ ] = function() {
            return defaultValue;
        }, _a[0, $bcXLZ._DYN_USER_COOKIE_POSTFIX /* @min:userCookiePostfix */ ] = function() {
            return defaultValue;
        }, _a[0, $bcXLZ._DYN_ID_LENGTH /* @min:idLength */ ] = function() {
            return 22;
        }, _a[0, $bcXLZ._DYN_GET_NEW_ID /* @min:getNewId */ ] = function() {
            return nullValue;
        }, _a);
        return defaultConfig;
    };
    // Removed Stub for PropertiesPlugin.prototype.initialize.
    // Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    return PropertiesPlugin;
}((0, $dtXLi.BaseTelemetryPlugin));
var $d6c8c413a82636f7$export$2e2bcd8739ae039 = $d6c8c413a82636f7$var$PropertiesPlugin;

});
parcelRegister("itgFs", function(module, exports) {

$parcel$export(module.exports, "TelemetryContext", function () { return $d727dd4c248cd20e$export$7b6b7bc4acb29126; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/ 
var $bO3cR = parcelRequire("bO3cR");

var $cWQSw = parcelRequire("cWQSw");
var $i2MiW = parcelRequire("i2MiW");
var $czkZK = parcelRequire("czkZK");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $bU24K = parcelRequire("bU24K");

var $5mFvm = parcelRequire("5mFvm");

var $FfpHr = parcelRequire("FfpHr");

var $8i0h9 = parcelRequire("8i0h9");

var $koLGo = parcelRequire("koLGo");

var $c1zZi = parcelRequire("c1zZi");

var $4dOxb = parcelRequire("4dOxb");

var $4vl87 = parcelRequire("4vl87");

var $bcXLZ = parcelRequire("bcXLZ");
var $d727dd4c248cd20e$var$strExt = "ext";
var $d727dd4c248cd20e$var$strTags = "tags";
function $d727dd4c248cd20e$var$_removeEmpty(target, name) {
    if (target && target[name] && (0, $hGXAo.objKeys)(target[name])[0, $bcXLZ._DYN_LENGTH /* @min:%2elength */ ] === 0) delete target[name];
}
var $d727dd4c248cd20e$export$7b6b7bc4acb29126 = /** @class */ function() {
    function TelemetryContext(core, defaultConfig, previousTraceCtx) {
        var _this = this;
        var logger = core.logger;
        this.appId = function() {
            return null;
        };
        this[0, $bcXLZ._DYN_GET_SESSION_ID /* @min:%2egetSessionId */ ] = function() {
            return null;
        };
        (0, $bO3cR.default)(TelemetryContext, this, function(_self) {
            _self.application = new (0, $5mFvm.Application)();
            _self.internal = new (0, $8i0h9.Internal)(defaultConfig);
            if ((0, $bU24K.hasWindow)()) {
                _self[0, $bcXLZ._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ] = new (0, $c1zZi._SessionManager)(defaultConfig, core);
                _self.device = new (0, $FfpHr.Device)();
                _self.location = new (0, $koLGo.Location)();
                _self.user = new (0, $4vl87.User)(defaultConfig, core);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[0, $bcXLZ._DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */ ] = new (0, $4dOxb.TelemetryTrace)(traceId, parentId, name_1, logger);
                _self.session = new (0, $c1zZi.Session)();
            }
            _self[0, $bcXLZ._DYN_GET_SESSION_ID /* @min:%2egetSessionId */ ] = function() {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && (0, $hGXAo.isString)(session.id)) sesId = session.id;
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[0, $bcXLZ._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ] || {})[0, $bcXLZ._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ];
                    sesId = autoSession && (0, $hGXAo.isString)(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[0, $bcXLZ._DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */ ] = function(evt, itemCtx) {
                (0, $hGXAo.setValue)((0, $hGXAo.getSetValue)(evt.ext, (0, $cWQSw.Extensions).AppExt), "sesId", _self[0, $bcXLZ._DYN_GET_SESSION_ID /* @min:%2egetSessionId */ ](), (0, $hGXAo.isString));
            };
            _self[0, $bcXLZ._DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */ ] = function(evt, itemCtx) {
                (0, $hGXAo.setValue)(evt.ext, (0, $cWQSw.Extensions).OSExt, _self.os);
            };
            _self[0, $bcXLZ._DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */ ] = function(evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = (0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strTags);
                    (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).applicationVersion, application.ver, (0, $hGXAo.isString));
                    (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).applicationBuild, application.build, (0, $hGXAo.isString));
                }
            };
            _self[0, $bcXLZ._DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */ ] = function(evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = (0, $hGXAo.getSetValue)((0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strExt), (0, $cWQSw.Extensions).DeviceExt);
                    (0, $hGXAo.setValue)(extDevice, "localId", device.id, (0, $hGXAo.isString));
                    (0, $hGXAo.setValue)(extDevice, "ip", device.ip, (0, $hGXAo.isString));
                    (0, $hGXAo.setValue)(extDevice, "model", device.model, (0, $hGXAo.isString));
                    (0, $hGXAo.setValue)(extDevice, "deviceClass", device.deviceClass, (0, $hGXAo.isString));
                }
            };
            _self[0, $bcXLZ._DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */ ] = function(evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = (0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strTags);
                    (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).internalAgentVersion, internal.agentVersion, (0, $hGXAo.isString)); // not mapped in CS 4.0
                    (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).internalSdkVersion, (0, $i2MiW.dataSanitizeString)(logger, internal.sdkVersion, 64), (0, $hGXAo.isString));
                    if (evt.baseType === (0, $i86yL._InternalLogMessage).dataType || evt.baseType === (0, $czkZK.PageView).dataType) {
                        (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).internalSnippet, internal.snippetVer, (0, $hGXAo.isString));
                        (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).internalSdkSrc, internal.sdkSrc, (0, $hGXAo.isString));
                    }
                }
            };
            _self[0, $bcXLZ._DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */ ] = function(evt, itemCtx) {
                var location = _this.location;
                if (location) (0, $hGXAo.setValue)((0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strTags, []), (0, $cWQSw.CtxTagKeys).locationIp, location.ip, (0, $hGXAo.isString));
            };
            _self[0, $bcXLZ._DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */ ] = function(evt, itemCtx) {
                var telemetryTrace = _self[0, $bcXLZ._DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */ ];
                if (telemetryTrace) {
                    var extTrace = (0, $hGXAo.getSetValue)((0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strExt), (0, $cWQSw.Extensions).TraceExt, {
                        traceID: undefined,
                        parentID: undefined
                    });
                    (0, $hGXAo.setValue)(extTrace, "traceID", telemetryTrace.traceID, (0, $hGXAo.isString), (0, $hGXAo.isNullOrUndefined));
                    (0, $hGXAo.setValue)(extTrace, "name", telemetryTrace.name, (0, $hGXAo.isString), (0, $hGXAo.isNullOrUndefined));
                    (0, $hGXAo.setValue)(extTrace, "parentID", telemetryTrace.parentID, (0, $hGXAo.isString), (0, $hGXAo.isNullOrUndefined));
                }
            };
            _self.applyWebContext = function(evt, itemCtx) {
                var web = _this.web;
                if (web) (0, $hGXAo.setValue)((0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strExt), (0, $cWQSw.Extensions).WebExt, web);
            };
            _self[0, $bcXLZ._DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */ ] = function(evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = (0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strTags, []);
                    // stays in tags
                    (0, $hGXAo.setValue)(tags, (0, $cWQSw.CtxTagKeys).userAccountId, user[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ], (0, $hGXAo.isString));
                    // CS 4.0
                    var extUser = (0, $hGXAo.getSetValue)((0, $hGXAo.getSetValue)(evt, $d727dd4c248cd20e$var$strExt), (0, $cWQSw.Extensions).UserExt);
                    (0, $hGXAo.setValue)(extUser, "id", user.id, (0, $hGXAo.isString));
                    (0, $hGXAo.setValue)(extUser, "authId", user[0, $bcXLZ._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ], (0, $hGXAo.isString));
                }
            };
            _self.cleanUp = function(evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    $d727dd4c248cd20e$var$_removeEmpty(ext, (0, $cWQSw.Extensions).DeviceExt);
                    $d727dd4c248cd20e$var$_removeEmpty(ext, (0, $cWQSw.Extensions).UserExt);
                    $d727dd4c248cd20e$var$_removeEmpty(ext, (0, $cWQSw.Extensions).WebExt);
                    $d727dd4c248cd20e$var$_removeEmpty(ext, (0, $cWQSw.Extensions).OSExt);
                    $d727dd4c248cd20e$var$_removeEmpty(ext, (0, $cWQSw.Extensions).AppExt);
                    $d727dd4c248cd20e$var$_removeEmpty(ext, (0, $cWQSw.Extensions).TraceExt);
                }
            };
        });
    }
    // Removed Stub for TelemetryContext.prototype.applySessionContext.
    // Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
    // Removed Stub for TelemetryContext.prototype.applyApplicationContext.
    // Removed Stub for TelemetryContext.prototype.applyDeviceContext.
    // Removed Stub for TelemetryContext.prototype.applyInternalContext.
    // Removed Stub for TelemetryContext.prototype.applyLocationContext.
    // Removed Stub for TelemetryContext.prototype.applyOperationContext.
    // Removed Stub for TelemetryContext.prototype.applyWebContext.
    // Removed Stub for TelemetryContext.prototype.applyUserContext.
    // Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    TelemetryContext.__ieDyn = 1;
    return TelemetryContext;
}();

});
parcelRegister("5mFvm", function(module, exports) {

$parcel$export(module.exports, "Application", function () { return $3e7f33d088594993$export$16975c34e60e1e61; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $3e7f33d088594993$export$16975c34e60e1e61 = /** @class */ function() {
    function Application() {}
    return Application;
}();

});

parcelRegister("FfpHr", function(module, exports) {

$parcel$export(module.exports, "Device", function () { return $07bfc9408d0ed755$export$8215d14a63d9fb10; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $07bfc9408d0ed755$export$8215d14a63d9fb10 = /** @class */ function() {
    /**
     * Constructs a new instance of the Device class
     */ function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}();

});

parcelRegister("8i0h9", function(module, exports) {

$parcel$export(module.exports, "Internal", function () { return $609037e4c0a26fbe$export$81742925a72ee8f2; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bcXLZ = parcelRequire("bcXLZ");
var $609037e4c0a26fbe$var$Version = "2.8.18";
var $609037e4c0a26fbe$export$81742925a72ee8f2 = /** @class */ function() {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */ function Internal(config) {
        this.sdkVersion = (config[0, $bcXLZ._DYN_SDK_EXTENSION /* @min:%2esdkExtension */ ] && config[0, $bcXLZ._DYN_SDK_EXTENSION /* @min:%2esdkExtension */ ]() ? config[0, $bcXLZ._DYN_SDK_EXTENSION /* @min:%2esdkExtension */ ]() + "_" : "") + "javascript:" + $609037e4c0a26fbe$var$Version;
    }
    return Internal;
}();

});
parcelRegister("bcXLZ", function(module, exports) {

$parcel$export(module.exports, "_DYN_SESSION_MANAGER", function () { return $828f2e5fedbb53f2$export$1c39d669bde62767; });
$parcel$export(module.exports, "_DYN_UPDATE", function () { return $828f2e5fedbb53f2$export$c9f4bebf02f459de; });
$parcel$export(module.exports, "_DYN_IS_USER_COOKIE_SET", function () { return $828f2e5fedbb53f2$export$52b1fe3e70f4c699; });
$parcel$export(module.exports, "_DYN_IS_NEW_USER", function () { return $828f2e5fedbb53f2$export$e8019acdc6dfe227; });
$parcel$export(module.exports, "_DYN_GET_TRACE_CTX", function () { return $828f2e5fedbb53f2$export$2d15b9b0e9d1daaa; });
$parcel$export(module.exports, "_DYN_TELEMETRY_TRACE", function () { return $828f2e5fedbb53f2$export$805965d0d38cc4a5; });
$parcel$export(module.exports, "_DYN_APPLY_SESSION_CONTEX0", function () { return $828f2e5fedbb53f2$export$585a4eb45f8043ec; });
$parcel$export(module.exports, "_DYN_APPLY_APPLICATION_CO1", function () { return $828f2e5fedbb53f2$export$5c833c29ed72a760; });
$parcel$export(module.exports, "_DYN_APPLY_DEVICE_CONTEXT", function () { return $828f2e5fedbb53f2$export$f3448cce94ee4935; });
$parcel$export(module.exports, "_DYN_APPLY_OPERATION_CONT2", function () { return $828f2e5fedbb53f2$export$a6c599a5c1ab6761; });
$parcel$export(module.exports, "_DYN_APPLY_USER_CONTEXT", function () { return $828f2e5fedbb53f2$export$5090ada1085f4557; });
$parcel$export(module.exports, "_DYN_APPLY_OPERATING_SYST3", function () { return $828f2e5fedbb53f2$export$dddc87038d37bcef; });
$parcel$export(module.exports, "_DYN_APPLY_LOCATION_CONTE4", function () { return $828f2e5fedbb53f2$export$4768decfd4f15bcf; });
$parcel$export(module.exports, "_DYN_APPLY_INTERNAL_CONTE5", function () { return $828f2e5fedbb53f2$export$348ac062a116e27c; });
$parcel$export(module.exports, "_DYN_ACCOUNT_ID", function () { return $828f2e5fedbb53f2$export$f251a1587d4aac90; });
$parcel$export(module.exports, "_DYN_SDK_EXTENSION", function () { return $828f2e5fedbb53f2$export$49c19c49385e770b; });
$parcel$export(module.exports, "_DYN_GET_SESSION_ID", function () { return $828f2e5fedbb53f2$export$3af04f76fec134a; });
$parcel$export(module.exports, "_DYN_NAME_PREFIX", function () { return $828f2e5fedbb53f2$export$6d013a7bc2da53c1; });
$parcel$export(module.exports, "_DYN_SESSION_COOKIE_POSTF6", function () { return $828f2e5fedbb53f2$export$d2109757a25c372a; });
$parcel$export(module.exports, "_DYN_USER_COOKIE_POSTFIX", function () { return $828f2e5fedbb53f2$export$f3af58106bbab288; });
$parcel$export(module.exports, "_DYN_ID_LENGTH", function () { return $828f2e5fedbb53f2$export$5c90c36f2382a0ff; });
$parcel$export(module.exports, "_DYN_GET_NEW_ID", function () { return $828f2e5fedbb53f2$export$d4e11a6879dac67b; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $828f2e5fedbb53f2$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_AUTOMATIC_SESSION", function () { return $828f2e5fedbb53f2$export$4d608086992f55c7; });
$parcel$export(module.exports, "_DYN_AUTHENTICATED_ID", function () { return $828f2e5fedbb53f2$export$574ff42e0e7ce0c; });
$parcel$export(module.exports, "_DYN_SESSION_EXPIRATION_M7", function () { return $828f2e5fedbb53f2$export$e56d5c5918c53a30; });
$parcel$export(module.exports, "_DYN_SESSION_RENEWAL_MS", function () { return $828f2e5fedbb53f2$export$e274b4de953959a8; });
$parcel$export(module.exports, "_DYN_CONFIG", function () { return $828f2e5fedbb53f2$export$25fc8bd3fb7f1e5a; });
$parcel$export(module.exports, "_DYN_ACQUISITION_DATE", function () { return $828f2e5fedbb53f2$export$8c9471ee03377604; });
$parcel$export(module.exports, "_DYN_RENEWAL_DATE", function () { return $828f2e5fedbb53f2$export$7254663b30b11264; });
$parcel$export(module.exports, "_DYN_COOKIE_DOMAIN", function () { return $828f2e5fedbb53f2$export$2e1ae641796d707d; });
$parcel$export(module.exports, "_DYN_JOIN", function () { return $828f2e5fedbb53f2$export$9876e756459769d6; });
$parcel$export(module.exports, "_DYN_COOKIE_SEPARATOR", function () { return $828f2e5fedbb53f2$export$57599fb6aa598bd4; });
$parcel$export(module.exports, "_DYN_AUTH_USER_COOKIE_NAM8", function () { return $828f2e5fedbb53f2$export$b362f54ec0f6467; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $828f2e5fedbb53f2$export$1c39d669bde62767 = "sessionManager"; // Count: 3
var $828f2e5fedbb53f2$export$c9f4bebf02f459de = "update"; // Count: 4
var $828f2e5fedbb53f2$export$52b1fe3e70f4c699 = "isUserCookieSet"; // Count: 4
var $828f2e5fedbb53f2$export$e8019acdc6dfe227 = "isNewUser"; // Count: 4
var $828f2e5fedbb53f2$export$2d15b9b0e9d1daaa = "getTraceCtx"; // Count: 3
var $828f2e5fedbb53f2$export$805965d0d38cc4a5 = "telemetryTrace"; // Count: 3
var $828f2e5fedbb53f2$export$585a4eb45f8043ec = "applySessionContext"; // Count: 2
var $828f2e5fedbb53f2$export$5c833c29ed72a760 = "applyApplicationContext"; // Count: 2
var $828f2e5fedbb53f2$export$f3448cce94ee4935 = "applyDeviceContext"; // Count: 2
var $828f2e5fedbb53f2$export$a6c599a5c1ab6761 = "applyOperationContext"; // Count: 2
var $828f2e5fedbb53f2$export$5090ada1085f4557 = "applyUserContext"; // Count: 2
var $828f2e5fedbb53f2$export$dddc87038d37bcef = "applyOperatingSystemContxt"; // Count: 2
var $828f2e5fedbb53f2$export$4768decfd4f15bcf = "applyLocationContext"; // Count: 2
var $828f2e5fedbb53f2$export$348ac062a116e27c = "applyInternalContext"; // Count: 2
var $828f2e5fedbb53f2$export$f251a1587d4aac90 = "accountId"; // Count: 8
var $828f2e5fedbb53f2$export$49c19c49385e770b = "sdkExtension"; // Count: 4
var $828f2e5fedbb53f2$export$3af04f76fec134a = "getSessionId"; // Count: 4
var $828f2e5fedbb53f2$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 7
var $828f2e5fedbb53f2$export$d2109757a25c372a = "sessionCookiePostfix"; // Count: 4
var $828f2e5fedbb53f2$export$f3af58106bbab288 = "userCookiePostfix"; // Count: 4
var $828f2e5fedbb53f2$export$5c90c36f2382a0ff = "idLength"; // Count: 5
var $828f2e5fedbb53f2$export$d4e11a6879dac67b = "getNewId"; // Count: 6
var $828f2e5fedbb53f2$export$6eae51590aaea43 = "length"; // Count: 4
var $828f2e5fedbb53f2$export$4d608086992f55c7 = "automaticSession"; // Count: 5
var $828f2e5fedbb53f2$export$574ff42e0e7ce0c = "authenticatedId"; // Count: 6
var $828f2e5fedbb53f2$export$e56d5c5918c53a30 = "sessionExpirationMs"; // Count: 5
var $828f2e5fedbb53f2$export$e274b4de953959a8 = "sessionRenewalMs"; // Count: 4
var $828f2e5fedbb53f2$export$25fc8bd3fb7f1e5a = "config"; // Count: 4
var $828f2e5fedbb53f2$export$8c9471ee03377604 = "acquisitionDate"; // Count: 5
var $828f2e5fedbb53f2$export$7254663b30b11264 = "renewalDate"; // Count: 4
var $828f2e5fedbb53f2$export$2e1ae641796d707d = "cookieDomain"; // Count: 3
var $828f2e5fedbb53f2$export$9876e756459769d6 = "join"; // Count: 5
var $828f2e5fedbb53f2$export$57599fb6aa598bd4 = "cookieSeparator"; // Count: 5
var $828f2e5fedbb53f2$export$b362f54ec0f6467 = "authUserCookieName"; // Count: 3

});


parcelRegister("koLGo", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $03d514cba8990919$export$18a2be9195644f38; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $03d514cba8990919$export$18a2be9195644f38 = /** @class */ function() {
    function Location() {}
    return Location;
}();

});

parcelRegister("c1zZi", function(module, exports) {

$parcel$export(module.exports, "Session", function () { return $8c117e73b68cbd7a$export$1fb4852a55678982; });
$parcel$export(module.exports, "_SessionManager", function () { return $8c117e73b68cbd7a$export$9a3efd42578d1f11; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $h1GMI = parcelRequire("h1GMI");

var $i86yL = parcelRequire("i86yL");
var $hGXAo = parcelRequire("hGXAo");
var $bU24K = parcelRequire("bU24K");
var $1iY3X = parcelRequire("1iY3X");
var $hB9U1 = parcelRequire("hB9U1");

var $bcXLZ = parcelRequire("bcXLZ");
var $8c117e73b68cbd7a$var$cookieNameConst = "ai_session";
var $8c117e73b68cbd7a$export$1fb4852a55678982 = /** @class */ function() {
    function Session() {}
    return Session;
}();
var $8c117e73b68cbd7a$export$9a3efd42578d1f11 = /** @class */ function() {
    function _SessionManager(config, core) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = (0, $i86yL.safeGetLogger)(core);
        var _cookieManager = (0, $hB9U1.safeGetCookieMgr)(core);
        (0, $bO3cR.default)(_SessionManager, self, function(_self) {
            if (!config) config = {};
            if (!(0, $hGXAo.isFunction)(config[0, $bcXLZ._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ])) config[0, $bcXLZ._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ] = function() {
                return _SessionManager.acquisitionSpan;
            };
            if (!(0, $hGXAo.isFunction)(config[0, $bcXLZ._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ])) config[0, $bcXLZ._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ] = function() {
                return _SessionManager.renewalSpan;
            };
            _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ] = config;
            // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
            var sessionCookiePostfix = _self.config[0, $bcXLZ._DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */ ] && _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ][0, $bcXLZ._DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */ ]() ? _self.config[0, $bcXLZ._DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */ ]() : _self.config[0, $bcXLZ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ][0, $bcXLZ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ][0, $bcXLZ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() : "";
            _storageNamePrefix = function() {
                return $8c117e73b68cbd7a$var$cookieNameConst + sessionCookiePostfix;
            };
            _self[0, $bcXLZ._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ] = new $8c117e73b68cbd7a$export$1fb4852a55678982();
            _self[0, $bcXLZ._DYN_UPDATE /* @min:%2eupdate */ ] = function() {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = (0, $hGXAo.dateNow)();
                var isExpired = false;
                var session = _self[0, $bcXLZ._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ];
                if (!session.id) isExpired = !_initializeAutomaticSession(session, nowMs);
                var sessionExpirationMs = _self.config[0, $bcXLZ._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ]();
                if (!isExpired && sessionExpirationMs > 0) {
                    var sessionRenewalMs = _self.config[0, $bcXLZ._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ]();
                    var timeSinceAcqMs = nowMs - session[0, $bcXLZ._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ];
                    var timeSinceRenewalMs = nowMs - session[0, $bcXLZ._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) // update automaticSession so session state has correct id
                _renew(nowMs);
                else // do not update the cookie more often than cookieUpdateInterval
                if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) _setCookie(session, nowMs);
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */ _self.backup = function() {
                var session = _self[0, $bcXLZ._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ];
                _setStorage(session.id, session[0, $bcXLZ._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ], session[0, $bcXLZ._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix());
                if (cookieValue && (0, $hGXAo.isFunction)(cookieValue.split)) isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = (0, $h1GMI.utlGetLocalStorage)(_logger, _storageNamePrefix());
                    if (storageValue) isValid = _initializeAutomaticSessionWithData(session, storageValue);
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param {string} sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[0, $bcXLZ._DYN_LENGTH /* @min:%2elength */ ] >= 2) try {
                    var acqMs = +tokens[1] || 0;
                    var renewalMs = +tokens[2] || 0;
                    if (isNaN(acqMs) || acqMs <= 0) (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session acquisition date is 0" + sessionReset);
                    else if (isNaN(renewalMs) || renewalMs <= 0) (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session renewal date is 0" + sessionReset);
                    else if (tokens[0]) {
                        // Everything looks valid so set the values
                        session.id = tokens[0];
                        session[0, $bcXLZ._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ] = acqMs;
                        session[0, $bcXLZ._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ] = renewalMs;
                        isValid = true;
                    }
                } catch (e) {
                    (0, $i86yL._throwInternal)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */ , "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + (0, $hGXAo.getExceptionName)(e), {
                        exception: (0, $bU24K.dumpObj)(e)
                    });
                }
                return isValid;
            }
            function _renew(nowMs) {
                var theConfig = _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ] || {};
                var getNewId = (theConfig[0, $bcXLZ._DYN_GET_NEW_ID /* @min:%2egetNewId */ ] ? theConfig[0, $bcXLZ._DYN_GET_NEW_ID /* @min:%2egetNewId */ ]() : null) || (0, $1iY3X.newId);
                _self.automaticSession.id = getNewId(theConfig[0, $bcXLZ._DYN_ID_LENGTH /* @min:%2eidLength */ ] ? theConfig[0, $bcXLZ._DYN_ID_LENGTH /* @min:%2eidLength */ ]() : 22);
                _self[0, $bcXLZ._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ][0, $bcXLZ._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ] = nowMs;
                _setCookie(_self[0, $bcXLZ._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!(0, $h1GMI.utlCanUseLocalStorage)()) (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */ , "Browser does not support local storage. Session durations will be inaccurate.");
            }
            function _setCookie(session, nowMs) {
                var acq = session[0, $bcXLZ._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ];
                session[0, $bcXLZ._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ] = nowMs;
                var config = _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ];
                var renewalPeriodMs = config[0, $bcXLZ._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ]();
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = acq + config[0, $bcXLZ._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ]() - nowMs;
                var cookie = [
                    session.id,
                    acq,
                    nowMs
                ];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) maxAgeSec = acqTimeLeftMs / 1000;
                else maxAgeSec = renewalPeriodMs / 1000;
                var cookieDomain = config[0, $bcXLZ._DYN_COOKIE_DOMAIN /* @min:%2ecookieDomain */ ] ? config[0, $bcXLZ._DYN_COOKIE_DOMAIN /* @min:%2ecookieDomain */ ]() : null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix(), cookie.join("|"), config[0, $bcXLZ._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ]() > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                (0, $h1GMI.utlSetLocalStorage)(_logger, _storageNamePrefix(), [
                    guid,
                    acq,
                    renewal
                ][0, $bcXLZ._DYN_JOIN /* @min:%2ejoin */ ]("|"));
            }
        });
    }
    // Removed Stub for _SessionManager.prototype.update.
    // Removed Stub for _SessionManager.prototype.backup.
    _SessionManager.acquisitionSpan = 86400000; // 24 hours in ms
    _SessionManager.renewalSpan = 1800000; // 30 minutes in ms
    _SessionManager.cookieUpdateInterval = 60000; // 1 minute in ms
    return _SessionManager;
}();

});

parcelRegister("4dOxb", function(module, exports) {

$parcel$export(module.exports, "TelemetryTrace", function () { return $312f935b8abb5389$export$d65492b1f626b9ec; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $i2MiW = parcelRequire("i2MiW");

var $k0iSW = parcelRequire("k0iSW");
var $bU24K = parcelRequire("bU24K");
var $312f935b8abb5389$export$d65492b1f626b9ec = /** @class */ function() {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || (0, $k0iSW.generateW3CId)();
        _self.parentID = parentId;
        var location = (0, $bU24K.getLocation)();
        if (!name && location && location.pathname) name = location.pathname;
        _self.name = (0, $i2MiW.dataSanitizeString)(logger, name);
    }
    return TelemetryTrace;
}();

});

parcelRegister("4vl87", function(module, exports) {

$parcel$export(module.exports, "User", function () { return $347a72a224f76779$export$1f44aaf2ec115b54; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $bO3cR = parcelRequire("bO3cR");

var $h1GMI = parcelRequire("h1GMI");

var $i86yL = parcelRequire("i86yL");
var $1iY3X = parcelRequire("1iY3X");
var $hB9U1 = parcelRequire("hB9U1");
var $hGXAo = parcelRequire("hGXAo");

var $bcXLZ = parcelRequire("bcXLZ");
function $347a72a224f76779$var$_validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) return false;
    return true;
}
var $347a72a224f76779$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(config, core) {
        /**
         * A flag indicating whether this represents a new user
         */ this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */ this.isUserCookieSet = false;
        var _logger = (0, $i86yL.safeGetLogger)(core);
        var _cookieManager = (0, $hB9U1.safeGetCookieMgr)(core);
        var _storageNamePrefix;
        (0, $bO3cR.default)(User, this, function(_self) {
            _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ] = config;
            var userCookiePostfix = _self.config[0, $bcXLZ._DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */ ] && _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ][0, $bcXLZ._DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */ ]() ? _self[0, $bcXLZ._DYN_CONFIG /* @min:%2econfig */ ][0, $bcXLZ._DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */ ]() : "";
            _storageNamePrefix = function() {
                return User.userCookieName + userCookiePostfix;
            };
            // get userId or create new one if none exists
            var cookie = _cookieManager.get(_storageNamePrefix());
            if (cookie) {
                _self[0, $bcXLZ._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ] = false;
                var params = cookie.split(User[0, $bcXLZ._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]);
                if (params[0, $bcXLZ._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    _self.id = params[0];
                    // we already have a cookie
                    _self[0, $bcXLZ._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ] = !!_self.id;
                }
            }
            function _generateNewId() {
                var theConfig = config || {};
                var getNewId = (theConfig[0, $bcXLZ._DYN_GET_NEW_ID /* @min:%2egetNewId */ ] ? theConfig[0, $bcXLZ._DYN_GET_NEW_ID /* @min:%2egetNewId */ ]() : null) || (0, $1iY3X.newId);
                var id = getNewId(theConfig[0, $bcXLZ._DYN_ID_LENGTH /* @min:%2eidLength */ ] ? config[0, $bcXLZ._DYN_ID_LENGTH /* @min:%2eidLength */ ]() : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = (0, $hGXAo.toISOString)(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[0, $bcXLZ._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ] = true;
                var newCookie = [
                    userId,
                    acqStr
                ];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[0, $bcXLZ._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ] = _cookieManager.set(_storageNamePrefix(), cookie, oneYear);
            }
            if (!_self.id) {
                _self.id = _generateNewId();
                var newCookie = _generateNewCookie(_self.id);
                _setUserCookie(newCookie[0, $bcXLZ._DYN_JOIN /* @min:%2ejoin */ ](User[0, $bcXLZ._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]));
                // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                // We should respect their wishes and clear ourselves from local storage
                var name_1 = config[0, $bcXLZ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && config[0, $bcXLZ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? config[0, $bcXLZ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() + "ai_session" : "ai_session";
                (0, $h1GMI.utlRemoveStorage)(_logger, name_1);
            }
            // We still take the account id from the ctor param for backward compatibility.
            // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
            _self[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = config[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] ? config[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ]() : undefined;
            // Get the auth user id and account id from the cookie if exists
            // Cookie is in the pattern: <authenticatedId>|<accountId>
            var authCookie = _cookieManager.get(User[0, $bcXLZ._DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */ ]);
            if (authCookie) {
                authCookie = decodeURI(authCookie);
                var authCookieString = authCookie.split(User[0, $bcXLZ._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]);
                if (authCookieString[0]) _self[0, $bcXLZ._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ] = authCookieString[0];
                if (authCookieString[0, $bcXLZ._DYN_LENGTH /* @min:%2elength */ ] > 1 && authCookieString[1]) _self[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = authCookieString[1];
            }
            _self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) storeInCookie = false;
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !$347a72a224f76779$var$_validateUserInput(authenticatedUserId) || accountId && !$347a72a224f76779$var$_validateUserInput(accountId);
                if (isInvalidInput) {
                    (0, $i86yL._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */ , "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[0, $bcXLZ._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ] = authenticatedUserId;
                var authCookie = _self[0, $bcXLZ._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ];
                if (accountId) {
                    _self[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = accountId;
                    authCookie = [
                        _self[0, $bcXLZ._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ],
                        _self.accountId
                    ][0, $bcXLZ._DYN_JOIN /* @min:%2ejoin */ ](User[0, $bcXLZ._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]);
                }
                if (storeInCookie) // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                // Encoding the cookie to handle unexpected unicode characters.
                _cookieManager.set(User[0, $bcXLZ._DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */ ], encodeURI(authCookie));
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */ _self.clearAuthenticatedUserContext = function() {
                _self[0, $bcXLZ._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ] = null;
                _self[0, $bcXLZ._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = null;
                _cookieManager.del(User[0, $bcXLZ._DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */ ]);
            };
            _self[0, $bcXLZ._DYN_UPDATE /* @min:%2eupdate */ ] = function(userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[0, $bcXLZ._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[0, $bcXLZ._DYN_JOIN /* @min:%2ejoin */ ](User[0, $bcXLZ._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]));
                }
            };
        });
    }
    // Removed Stub for User.prototype.setAuthenticatedUserContext.
    // Removed Stub for User.prototype.clearAuthenticatedUserContext.
    // Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}();

});



parcelRegister("kzp4v", function(module, exports) {

$parcel$export(module.exports, "STR_SNIPPET", function () { return $ef9a8639d280d3b3$export$c40a95bd1f19a04a; });
$parcel$export(module.exports, "STR_GET_COOKIE_MGR", function () { return $ef9a8639d280d3b3$export$da4182b670dc48ff; });
$parcel$export(module.exports, "STR_START_TRACK_PAGE", function () { return $ef9a8639d280d3b3$export$4dff843ac2d49cae; });
$parcel$export(module.exports, "STR_STOP_TRACK_PAGE", function () { return $ef9a8639d280d3b3$export$83ac403ed0121674; });
$parcel$export(module.exports, "STR_FLUSH", function () { return $ef9a8639d280d3b3$export$36b97ab40aae74fe; });
$parcel$export(module.exports, "STR_START_TRACK_EVENT", function () { return $ef9a8639d280d3b3$export$5ac4d387b85102; });
$parcel$export(module.exports, "STR_STOP_TRACK_EVENT", function () { return $ef9a8639d280d3b3$export$7895813056375cb; });
$parcel$export(module.exports, "STR_ADD_TELEMETRY_INITIALIZER", function () { return $ef9a8639d280d3b3$export$40f0bd7f5212655f; });
$parcel$export(module.exports, "STR_POLL_INTERNAL_LOGS", function () { return $ef9a8639d280d3b3$export$6030ed320bde556b; });
$parcel$export(module.exports, "STR_GET_PLUGIN", function () { return $ef9a8639d280d3b3$export$59cf80c2878d98fc; });
$parcel$export(module.exports, "STR_EVT_NAMESPACE", function () { return $ef9a8639d280d3b3$export$657de6e6c53d3d4b; });
$parcel$export(module.exports, "STR_TRACK_EVENT", function () { return $ef9a8639d280d3b3$export$2a937c908483aaba; });
$parcel$export(module.exports, "STR_TRACK_TRACE", function () { return $ef9a8639d280d3b3$export$6a76308d410f3214; });
$parcel$export(module.exports, "STR_TRACK_METRIC", function () { return $ef9a8639d280d3b3$export$f73efacb9b6b9a35; });
$parcel$export(module.exports, "STR_TRACK_PAGE_VIEW", function () { return $ef9a8639d280d3b3$export$96dcb75b34c1a4; });
$parcel$export(module.exports, "STR_TRACK_EXCEPTION", function () { return $ef9a8639d280d3b3$export$5a8b50b634878942; });
$parcel$export(module.exports, "STR_TRACK_DEPENDENCY_DATA", function () { return $ef9a8639d280d3b3$export$ab9c6dcf6c4e2bbc; });
$parcel$export(module.exports, "STR_SET_AUTHENTICATED_USER_CONTEXT", function () { return $ef9a8639d280d3b3$export$94666ce386bd4f64; });
$parcel$export(module.exports, "STR_CLEAR_AUTHENTICATED_USER_CONTEXT", function () { return $ef9a8639d280d3b3$export$f920535c288b298f; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $ef9a8639d280d3b3$var$_AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var $ef9a8639d280d3b3$var$_TRACK = "track";
var $ef9a8639d280d3b3$export$5e8607ab26634759 = "";
var $ef9a8639d280d3b3$export$c40a95bd1f19a04a = "snippet";
var $ef9a8639d280d3b3$export$da4182b670dc48ff = "getCookieMgr";
var $ef9a8639d280d3b3$export$4dff843ac2d49cae = "startTrackPage";
var $ef9a8639d280d3b3$export$83ac403ed0121674 = "stopTrackPage";
var $ef9a8639d280d3b3$export$36b97ab40aae74fe = "flush";
var $ef9a8639d280d3b3$export$5ac4d387b85102 = "startTrackEvent";
var $ef9a8639d280d3b3$export$7895813056375cb = "stopTrackEvent";
var $ef9a8639d280d3b3$export$40f0bd7f5212655f = "addTelemetryInitializer";
var $ef9a8639d280d3b3$export$98706f009830c697 = $ef9a8639d280d3b3$export$40f0bd7f5212655f + "s";
var $ef9a8639d280d3b3$export$6030ed320bde556b = "pollInternalLogs";
var $ef9a8639d280d3b3$export$59cf80c2878d98fc = "getPlugin";
var $ef9a8639d280d3b3$export$657de6e6c53d3d4b = "evtNamespace";
var $ef9a8639d280d3b3$export$2a937c908483aaba = $ef9a8639d280d3b3$var$_TRACK + "Event";
var $ef9a8639d280d3b3$export$6a76308d410f3214 = $ef9a8639d280d3b3$var$_TRACK + "Trace";
var $ef9a8639d280d3b3$export$f73efacb9b6b9a35 = $ef9a8639d280d3b3$var$_TRACK + "Metric";
var $ef9a8639d280d3b3$export$96dcb75b34c1a4 = $ef9a8639d280d3b3$var$_TRACK + "PageView";
var $ef9a8639d280d3b3$export$5a8b50b634878942 = $ef9a8639d280d3b3$var$_TRACK + "Exception";
var $ef9a8639d280d3b3$export$ab9c6dcf6c4e2bbc = $ef9a8639d280d3b3$var$_TRACK + "DependencyData";
var $ef9a8639d280d3b3$export$94666ce386bd4f64 = "set" + $ef9a8639d280d3b3$var$_AUTHENTICATED_USER_CONTEXT;
var $ef9a8639d280d3b3$export$f920535c288b298f = "clear" + $ef9a8639d280d3b3$var$_AUTHENTICATED_USER_CONTEXT;

});

parcelRegister("9gNlH", function(module, exports) {

$parcel$export(module.exports, "_DYN_UPDATE_SNIPPET_DEFIN0", function () { return $6bfbe3568890cd22$export$56d11d1ffdb728a7; });
$parcel$export(module.exports, "_DYN_LOAD_APP_INSIGHTS", function () { return $6bfbe3568890cd22$export$e434ab7388d06df0; });
$parcel$export(module.exports, "_DYN_ENDPOINT_URL", function () { return $6bfbe3568890cd22$export$bfa1c9e5dcf1e78; });
$parcel$export(module.exports, "_DYN_DIAGNOSTIC_LOG_INTER4", function () { return $6bfbe3568890cd22$export$4631c661dc34d47f; });
$parcel$export(module.exports, "_DYN_DISABLE_FLUSH_ON_BEF11", function () { return $6bfbe3568890cd22$export$a07bbe540f52b458; });
$parcel$export(module.exports, "_DYN_DISABLE_FLUSH_ON_UNL12", function () { return $6bfbe3568890cd22$export$2a30c6d97fdf0018; });
$parcel$export(module.exports, "_DYN_CONFIG", function () { return $6bfbe3568890cd22$export$25fc8bd3fb7f1e5a; });
$parcel$export(module.exports, "_DYN_CONTEXT", function () { return $6bfbe3568890cd22$export$fdcd48959e13aba7; });
$parcel$export(module.exports, "_DYN_PUSH", function () { return $6bfbe3568890cd22$export$a0a330e7fa1e278c; });
$parcel$export(module.exports, "_DYN_VERSION", function () { return $6bfbe3568890cd22$export$568c4302d11f2b22; });
$parcel$export(module.exports, "_DYN_QUEUE", function () { return $6bfbe3568890cd22$export$a1c208448cc1b3be; });
$parcel$export(module.exports, "_DYN_CONNECTION_STRING", function () { return $6bfbe3568890cd22$export$1160203e21ea532; });
$parcel$export(module.exports, "_DYN_INSTRUMENTATION_KEY", function () { return $6bfbe3568890cd22$export$81cfd43387c8dbcc; });
$parcel$export(module.exports, "_DYN_APP_INSIGHTS", function () { return $6bfbe3568890cd22$export$d8af525758d25fb5; });
$parcel$export(module.exports, "_DYN_DISABLE_IKEY_DEPRECA18", function () { return $6bfbe3568890cd22$export$2ca03919edead886; });
$parcel$export(module.exports, "_DYN_GET_TRANSMISSION_CON19", function () { return $6bfbe3568890cd22$export$b3539c8da0ecc607; });
$parcel$export(module.exports, "_DYN_ONUNLOAD_FLUSH", function () { return $6bfbe3568890cd22$export$f30bfb116278d530; });
$parcel$export(module.exports, "_DYN_ADD_HOUSEKEEPING_BEF20", function () { return $6bfbe3568890cd22$export$b3ed0e59f38a8fcc; });
$parcel$export(module.exports, "_DYN_INDEX_OF", function () { return $6bfbe3568890cd22$export$a3d3f936db372b4b; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $6bfbe3568890cd22$export$56d11d1ffdb728a7 = "updateSnippetDefinitions"; // Count: 4
var $6bfbe3568890cd22$export$e434ab7388d06df0 = "loadAppInsights"; // Count: 4
var $6bfbe3568890cd22$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 4
var $6bfbe3568890cd22$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 3
var $6bfbe3568890cd22$export$983774f06380e463 = "maxBatchInterval"; // Count: 3
var $6bfbe3568890cd22$export$2c73dfb33d25230b = "disableExceptionTracking"; // Count: 2
var $6bfbe3568890cd22$export$99a824310ffb055 = "disableTelemetry"; // Count: 2
var $6bfbe3568890cd22$export$82b14b88cf436ea1 = "emitLineDelimitedJson"; // Count: 2
var $6bfbe3568890cd22$export$4631c661dc34d47f = "diagnosticLogInterval"; // Count: 6
var $6bfbe3568890cd22$export$e17c3d9a2369a284 = "autoTrackPageVisitTime"; // Count: 2
var $6bfbe3568890cd22$export$51ccd61d31b31ade = "samplingPercentage"; // Count: 4
var $6bfbe3568890cd22$export$f7da12a644be5862 = "disableAjaxTracking"; // Count: 2
var $6bfbe3568890cd22$export$8e8c994d518b7819 = "maxAjaxCallsPerView"; // Count: 3
var $6bfbe3568890cd22$export$9e0ab1d9fac8a26c = "isBeaconApiDisabled"; // Count: 2
var $6bfbe3568890cd22$export$77fb4d57addb69c1 = "disableCorrelationHeaders"; // Count: 2
var $6bfbe3568890cd22$export$403128f8b49883c6 = "correlationHeaderExcludedDomains"; // Count: 2
var $6bfbe3568890cd22$export$a07bbe540f52b458 = "disableFlushOnBeforeUnload"; // Count: 4
var $6bfbe3568890cd22$export$2a30c6d97fdf0018 = "disableFlushOnUnload"; // Count: 3
var $6bfbe3568890cd22$export$53c294bc3a6a47ff = "enableSessionStorageBuffer"; // Count: 2
var $6bfbe3568890cd22$export$6cac25abb8c67dca = "isCookieUseDisabled"; // Count: 2
var $6bfbe3568890cd22$export$8e5935a499744308 = "isStorageUseDisabled"; // Count: 2
var $6bfbe3568890cd22$export$64926320c15e80f9 = "isBrowserLinkTrackingEnabled"; // Count: 2
var $6bfbe3568890cd22$export$fe04ab9b23fe7639 = "enableCorsCorrelation"; // Count: 2
var $6bfbe3568890cd22$export$25fc8bd3fb7f1e5a = "config"; // Count: 6
var $6bfbe3568890cd22$export$fdcd48959e13aba7 = "context"; // Count: 8
var $6bfbe3568890cd22$export$a0a330e7fa1e278c = "push"; // Count: 5
var $6bfbe3568890cd22$export$568c4302d11f2b22 = "version"; // Count: 6
var $6bfbe3568890cd22$export$a1c208448cc1b3be = "queue"; // Count: 6
var $6bfbe3568890cd22$export$1160203e21ea532 = "connectionString"; // Count: 3
var $6bfbe3568890cd22$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 2
var $6bfbe3568890cd22$export$d8af525758d25fb5 = "appInsights"; // Count: 3
var $6bfbe3568890cd22$export$2ca03919edead886 = "disableIkeyDeprecationMessage"; // Count: 2
var $6bfbe3568890cd22$export$b3539c8da0ecc607 = "getTransmissionControls"; // Count: 2
var $6bfbe3568890cd22$export$f30bfb116278d530 = "onunloadFlush"; // Count: 6
var $6bfbe3568890cd22$export$b3ed0e59f38a8fcc = "addHousekeepingBeforeUnload"; // Count: 2
var $6bfbe3568890cd22$export$a3d3f936db372b4b = "indexOf"; // Count: 4

});



parcelRegister("gDDh0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c51d471764a905d$export$2e2bcd8739ae039; });
const $5c51d471764a905d$var$styles = [
    "font-weight: bold; color: red",
    "color: orange",
    "font-weight: bold; color: red"
];
const $5c51d471764a905d$var$printFunctionCall = (name, args)=>console.log(`\u{279C} %c${name}(%c${args ? args.map((value)=>JSON.stringify(value)).join(", ") : ""}%c)`, ...$5c51d471764a905d$var$styles);
var $5c51d471764a905d$export$2e2bcd8739ae039 = $5c51d471764a905d$var$printFunctionCall;

});



parcelRegister("1iE9F", function(module, exports) {
$parcel$export(module.exports, "RFIDTagsPage", function () { return (parcelRequire("eRU9J")).RFIDTagsPage; });
parcelRequire("eRU9J");

});
parcelRegister("eRU9J", function(module, exports) {

$parcel$export(module.exports, "RFIDTagsPage", function () { return $437823f6d4b73aff$export$57aa6992c23c34e2; });

var $6uMv9 = parcelRequire("6uMv9");

var $96Lrx = parcelRequire("96Lrx");

var $52Dbq = parcelRequire("52Dbq");
parcelRequire("8HFyP");
var $1rxFa = parcelRequire("1rxFa");

var $89oi3 = parcelRequire("89oi3");

var $aL1Vp = parcelRequire("aL1Vp");

var $2akJT = parcelRequire("2akJT");
const $437823f6d4b73aff$export$57aa6992c23c34e2 = ()=>{
    const text = (0, $aL1Vp.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2akJT.LazyTabView), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $96Lrx.TabPanel), {
        header: text("lblRFIDWidget"),
        leftIcon: "pi pi-tags mr-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1rxFa.RFIDTagsWidget), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $96Lrx.TabPanel), {
        header: text("lblRejectedRFIDTags"),
        leftIcon: "pi pi-plus mr-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $89oi3.RegisterRfidTagWidget), null))));
};

});
parcelRegister("8HFyP", function(module, exports) {
$parcel$export(module.exports, "RFIDTagsWidget", function () { return (parcelRequire("1rxFa")).RFIDTagsWidget; });
parcelRequire("1rxFa");

});
parcelRegister("1rxFa", function(module, exports) {

$parcel$export(module.exports, "RFIDTagsWidget", function () { return $21f35c8144ddf663$export$e98a44e1c16336a1; });

var $6uMv9 = parcelRequire("6uMv9");

var $dpspD = parcelRequire("dpspD");

var $4vH3e = parcelRequire("4vH3e");

var $aIcGc = parcelRequire("aIcGc");

var $iQS7O = parcelRequire("iQS7O");

var $cFTyZ = parcelRequire("cFTyZ");

var $983fr = parcelRequire("983fr");

var $8RYO3 = parcelRequire("8RYO3");

var $fvmYM = parcelRequire("fvmYM");

var $2LNSS = parcelRequire("2LNSS");

var $i4kGB = parcelRequire("i4kGB");

var $8Gccq = parcelRequire("8Gccq");

var $8LupL = parcelRequire("8LupL");

var $1oBYI = parcelRequire("1oBYI");
parcelRequire("1f9LI");
var $fGDdf = parcelRequire("fGDdf");

var $lJyWk = parcelRequire("lJyWk");

var $aL1Vp = parcelRequire("aL1Vp");

var $3jZfA = parcelRequire("3jZfA");
const $21f35c8144ddf663$export$e98a44e1c16336a1 = ()=>{
    const text = (0, $aL1Vp.default)();
    const { partnerId: partnerId, selectedCompanyId: selectedCompanyId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const { data: rfidTags = [], isLoading: isLoadingRfidTags } = (0, $8Gccq.useRFIDTagsQuery)(partnerId, selectedCompanyId);
    const [deleteTag] = (0, $fvmYM.useNfcTagDeleteMutation)();
    const [globalFilter, setGlobalFilter] = (0, $6uMv9.useState)("");
    const menuRef = (0, $6uMv9.useRef)(null);
    const toast = (0, $3jZfA.useToast)();
    const [rfidTag, setRfidTag] = (0, $6uMv9.useState)(undefined);
    const [rfidTagModalVisible, setRfidTagModalVisible] = (0, $6uMv9.useState)(false);
    const [poolsModalIsVisible, setPoolsModalIsVisible] = (0, $6uMv9.useState)(false);
    const [chargepointsModalIsVisible, setChargepointsModalIsVisible] = (0, $6uMv9.useState)(false);
    const editAdmin = (rfidTag)=>{
        setRfidTag(rfidTag);
        setRfidTagModalVisible(true);
    };
    const closeRfidTagModal = ()=>{
        setRfidTagModalVisible(false);
        setRfidTag(undefined);
    };
    const confirmDelete = (rfidTag)=>{
        (0, $iQS7O.confirmDialog)({
            header: text("lblDeleteRFID"),
            message: text("msgDoYouWantToDeleteRFID", {
                id: rfidTag.id
            }),
            icon: "pi pi-info-circle",
            position: "bottom",
            accept: async ()=>{
                deleteTag({
                    nfcTagId: rfidTag.id
                }).unwrap().then(()=>{
                    toast.notifySuccess(text("msgRFIDDeleted"));
                }).catch(()=>{
                    toast.notifyError(text("msgRFIDNotDeleted"));
                });
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex align-items-center justify-content-end mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
        icon: "pi pi-plus",
        onClick: ()=>setRfidTagModalVisible(true),
        size: "small",
        className: "mr-2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "rfid-search-input",
        type: "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $983fr.Menu), {
        model: [
            {
                label: text("lblRFIDAccessToPools"),
                command: ()=>setPoolsModalIsVisible(true),
                disabled: !rfidTag?.companyId
            },
            {
                label: text("lblRFIDAccessToChargers"),
                command: ()=>setChargepointsModalIsVisible(true),
                disabled: !rfidTag?.companyId
            }
        ],
        ref: menuRef,
        popup: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: rfidTags,
        globalFilter: globalFilter,
        globalFilterFields: [
            "id",
            "companyName",
            "fullName",
            "externalId",
            "comment"
        ],
        removableSort: true,
        loading: isLoadingRfidTags,
        dataKey: "id",
        paginator: true,
        rows: 10,
        emptyMessage: text("msgNoRfidTagsFound"),
        "data-testid": "rfid-tags"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "id",
        header: text("lblId"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (rowData)=>(0, $2LNSS.default)(rowData.id),
        header: text("lblRfidDex")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (rowData)=>(0, $2LNSS.default)(rowData.id, true),
        header: text("lblRfidReverse")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "companyName",
        header: text("lblOrganisationNameField"),
        sortable: true,
        hidden: (0, $8LupL.isAdminDomain)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "fullName",
        header: text("lblUserOrOwner"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "externalId",
        header: text("lblExternalId"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "comment",
        header: text("lblComment"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (rowData)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "flex gap-3"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                icon: "pi pi-pencil",
                rounded: true,
                outlined: true,
                severity: "info",
                onClick: ()=>editAdmin(rowData)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                icon: "pi pi-cog",
                rounded: true,
                outlined: true,
                onClick: (event)=>{
                    setRfidTag(rowData);
                    menuRef.current?.toggle(event);
                },
                disabled: !rowData.companyId,
                tooltip: rowData?.companyId ? undefined : text("lblRFIDSettingsRestrictionTooltip"),
                tooltipOptions: {
                    position: "left",
                    showOnDisabled: true
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                icon: "pi pi-trash",
                rounded: true,
                outlined: true,
                severity: "danger",
                onClick: ()=>confirmDelete(rowData)
            }));
        }
    })), rfidTagModalVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $i4kGB.RfidTagModal), {
        rfidTag: rfidTag,
        onClose: closeRfidTagModal
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fGDdf.RfidTagPoolsModal), {
        visible: poolsModalIsVisible,
        onHide: ()=>setPoolsModalIsVisible(false),
        rfidTag: rfidTag
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lJyWk.RfidTagChargepointsModal), {
        visible: chargepointsModalIsVisible,
        onHide: ()=>setChargepointsModalIsVisible(false),
        rfidTag: rfidTag
    }));
};

});
parcelRegister("1f9LI", function(module, exports) {
$parcel$export(module.exports, "RfidTagPoolsModal", function () { return (parcelRequire("fGDdf")).RfidTagPoolsModal; });
parcelRequire("fGDdf");

});
parcelRegister("fGDdf", function(module, exports) {

$parcel$export(module.exports, "RfidTagPoolsModal", function () { return $e2730195d7b20a2d$export$90554b92efd53398; });

var $05aLh = parcelRequire("05aLh");

var $6uMv9 = parcelRequire("6uMv9");

var $dpspD = parcelRequire("dpspD");

var $cFTyZ = parcelRequire("cFTyZ");

var $fvmYM = parcelRequire("fvmYM");

var $8RYO3 = parcelRequire("8RYO3");

var $aL1Vp = parcelRequire("aL1Vp");

var $1oBYI = parcelRequire("1oBYI");
parcelRequire("522SL");
var $3zgWN = parcelRequire("3zgWN");
const $e2730195d7b20a2d$export$90554b92efd53398 = ({ visible: visible, onHide: onHide, rfidTag: rfidTag })=>{
    const text = (0, $aL1Vp.default)();
    const { data: pools, isLoading: poolsIsLoading } = (0, $fvmYM.useCompanyGetPoolsWithNfcInfoForTagQuery)({
        companyId: rfidTag?.companyId || "",
        nfcTagId: rfidTag?.id || ""
    }, {
        skip: !rfidTag?.companyId || !rfidTag?.id,
        refetchOnMountOrArgChange: true
    });
    const [loadingStates, setLoadingStates] = (0, $6uMv9.useState)({});
    const [updatePool] = (0, $fvmYM.useCompanySetPoolsNfcInfoForTagMutation)();
    const setNfcAccess = async (hasNfcAccess, pool)=>{
        setLoadingStates((prev)=>({
                ...prev,
                [`${pool.id}`]: true
            }));
        try {
            if (rfidTag) await updatePool({
                body: [
                    {
                        companyId: rfidTag.companyId,
                        id: pool.id,
                        hasNfcAccess: hasNfcAccess
                    }
                ],
                companyId: rfidTag.companyId,
                nfcTagId: rfidTag.id
            }).unwrap();
        } catch (err) {
        // ignore
        } finally{
            setLoadingStates((prev)=>({
                    ...prev,
                    [`${pool.id}`]: false
                }));
        }
    };
    const [globalFilter, setGlobalFilter] = (0, $6uMv9.useState)("");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $05aLh.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("lblRFIDAccessToPools")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-wrap align-items-center justify-content-end mb-3 pt-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "pools-search-input",
        value: globalFilter,
        type: "search",
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: pools,
        loading: poolsIsLoading,
        paginator: true,
        rows: 10,
        globalFilter: globalFilter,
        emptyMessage: text("msgNoPoolsFound")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3zgWN.Switch), {
                checked: !!pool.hasNfcAccess,
                onChange: (event)=>{
                    setNfcAccess(event.value, pool);
                },
                loading: loadingStates[`${pool.id}`],
                inputId: `switch-nfc-access-${pool.id}`,
                pt: {
                    input: {
                        "data-testid": `switch-nfc-access-${pool.id}`
                    }
                }
            }),
        header: text("lblRFIDAccess")
    })));
};

});
parcelRegister("522SL", function(module, exports) {
$parcel$export(module.exports, "Switch", function () { return (parcelRequire("3zgWN")).Switch; });
parcelRequire("3zgWN");

});
parcelRegister("3zgWN", function(module, exports) {

$parcel$export(module.exports, "Switch", function () { return $d79669703366d67a$export$b5d5cf8927ab7262; });

var $luiwW = parcelRequire("luiwW");

var $6uMv9 = parcelRequire("6uMv9");
const $d79669703366d67a$export$b5d5cf8927ab7262 = ({ checked: checked, onChange: onChange, disabled: disabled, loading: loading, label: label, inputId: inputId, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $luiwW.InputSwitch), {
        checked: checked,
        onChange: onChange,
        disabled: loading || disabled,
        inputId: inputId,
        ...props
    }), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("i", {
        className: "pi pi-spin pi-spinner text-lg"
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "m-0",
        htmlFor: inputId
    }, label));
};

});




parcelRegister("lJyWk", function(module, exports) {

$parcel$export(module.exports, "RfidTagChargepointsModal", function () { return $1f78147c8fdb2fce$export$86b444f64437c5ff; });

var $05aLh = parcelRequire("05aLh");

var $6uMv9 = parcelRequire("6uMv9");

var $cFTyZ = parcelRequire("cFTyZ");

var $dpspD = parcelRequire("dpspD");

var $fvmYM = parcelRequire("fvmYM");

var $1oBYI = parcelRequire("1oBYI");

var $aL1Vp = parcelRequire("aL1Vp");

var $8RYO3 = parcelRequire("8RYO3");

var $cLivy = parcelRequire("cLivy");
parcelRequire("522SL");
var $3zgWN = parcelRequire("3zgWN");
const $1f78147c8fdb2fce$export$86b444f64437c5ff = ({ visible: visible, onHide: onHide, rfidTag: rfidTag })=>{
    const text = (0, $aL1Vp.default)();
    const { data: chargePoints, isLoading: chargePointsIsLoading } = (0, $fvmYM.useCompanyGetChargePointsWithNfcInfoForTagQuery)({
        companyId: rfidTag?.companyId || "",
        nfcTagId: rfidTag?.id || ""
    }, {
        skip: !rfidTag?.companyId || !rfidTag?.id
    });
    const adaptConnectorNaming = (0, $cLivy.useAdaptConnectorNaming)();
    const [updateChargepointsNfcAccess] = (0, $fvmYM.useCompanySetChargePointsNfcInfoForTagMutation)();
    const [loadingStates, setLoadingStates] = (0, $6uMv9.useState)({});
    const updateNfcAccess = async (chargePointId, connectorId, hasNfcAccess)=>{
        setLoadingStates((prev)=>({
                ...prev,
                [`${chargePointId}_${connectorId}`]: true
            }));
        try {
            if (rfidTag) await updateChargepointsNfcAccess({
                body: [
                    {
                        chargePointId: chargePointId,
                        connectorId: connectorId,
                        hasNfcAccess: hasNfcAccess
                    }
                ],
                companyId: rfidTag.companyId,
                nfcTagId: rfidTag.id
            }).unwrap();
        } catch (err) {
        // ignore
        } finally{
            setLoadingStates((prev)=>({
                    ...prev,
                    [`${chargePointId}_${connectorId}`]: false
                }));
        }
    };
    const [globalFilter, setGlobalFilter] = (0, $6uMv9.useState)("");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $05aLh.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("lblRFIDAccessToChargers")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-wrap align-items-center justify-content-end mb-3 pt-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "pools-search-input",
        value: globalFilter,
        type: "search",
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: chargePoints,
        loading: chargePointsIsLoading,
        paginator: true,
        rows: 10,
        globalFilter: globalFilter,
        emptyMessage: text("msgNoChargePointsFound")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "id",
        header: text("lblId")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        className: "w-4",
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "flex flex-column gap-2"
            }, chargePoint.connectors?.map((connector)=>{
                if (connector.connectorFunctionType === "Charger") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3zgWN.Switch), {
                    key: connector.connectorId,
                    checked: !!connector.hasNfcAccess,
                    onChange: ()=>updateNfcAccess(chargePoint.id, connector.connectorId, !connector.hasNfcAccess),
                    loading: loadingStates[`${chargePoint.id}_${connector.connectorId}`],
                    label: adaptConnectorNaming(connector.name),
                    inputId: `switch-${chargePoint.id}-${connector.connectorId}`,
                    pt: {
                        input: {
                            "data-testid": `switch-${chargePoint.id}-${connector.connectorId}`
                        }
                    }
                });
            })),
        header: text("lblRFIDAccess")
    })));
};

});



parcelRegister("89oi3", function(module, exports) {

$parcel$export(module.exports, "RegisterRfidTagWidget", function () { return $6108c92b297617c6$export$bdb2c33964b673f7; });

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $dpspD = parcelRequire("dpspD");

var $cFTyZ = parcelRequire("cFTyZ");

var $aIcGc = parcelRequire("aIcGc");

var $g2ttc = parcelRequire("g2ttc");

var $iQS7O = parcelRequire("iQS7O");

var $7N8Pf = parcelRequire("7N8Pf");

var $hTRiE = parcelRequire("hTRiE");

var $7Aqef = parcelRequire("7Aqef");

var $lTw4g = parcelRequire("lTw4g");

var $6AVKx = parcelRequire("6AVKx");

var $8RYO3 = parcelRequire("8RYO3");

var $aL1Vp = parcelRequire("aL1Vp");

var $fvmYM = parcelRequire("fvmYM");

var $8N7S6 = parcelRequire("8N7S6");

var $1oBYI = parcelRequire("1oBYI");
parcelRequire("kDPMb");
var $31uqV = parcelRequire("31uqV");

var $8LupL = parcelRequire("8LupL");

var $3Epa9 = parcelRequire("3Epa9");

var $kvJbm = parcelRequire("kvJbm");

var $bbKZs = parcelRequire("bbKZs");

var $6Wbwp = parcelRequire("6Wbwp");

var $8Gccq = parcelRequire("8Gccq");

var $iXXep = parcelRequire("iXXep");

var $3jZfA = parcelRequire("3jZfA");
const $6108c92b297617c6$export$bdb2c33964b673f7 = ()=>{
    const text = (0, $aL1Vp.default)();
    const { partnerId: partnerId, selectedCompanyId: selectedCompanyId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const [createRfidTag] = (0, $fvmYM.useNfcTagCreateMutation)();
    const toast = (0, $3jZfA.useToast)();
    const [addRfidTagIsOpened, setAddRfidTagIsOpened] = (0, $6uMv9.useState)(false);
    const [selectedTags, setSelectedTags] = (0, $6uMv9.useState)([]);
    const [globalFilter, setGlobalFilter] = (0, $6uMv9.useState)("");
    const onAddRfidTag = ()=>{
        if (0, $8LupL.isAdminDomain) handleAddSelected(selectedCompanyId);
        else if (0, $8LupL.isPartnerDomain) setAddRfidTagIsOpened(true);
    };
    const handleAddSelected = (organisationId)=>{
        setAddRfidTagIsOpened(false);
        const tags = selectedTags.map((item)=>({
                nfcTag: {
                    id: item.nfcTagId,
                    partnerId: partnerId,
                    companyId: organisationId,
                    active: true
                }
            }));
        Promise.all(tags.map((tag)=>createRfidTag(tag).unwrap())).then(()=>{
            toast.notifySuccess(text("msgRFIDTagAdded"));
            setSelectedTags([]);
        }).catch(()=>toast.notifyError(text("msgRFIDTagCouldNotBeAdded")));
    };
    const op = (0, $6uMv9.useRef)(null);
    const { data: chargePoints, isLoading: isLoadingChargePoints } = (0, $8Gccq.useChargePointsQuery)({
        partnerId: partnerId,
        companyId: selectedCompanyId,
        expand: (0, $6Wbwp.default).OcppConfig
    });
    const { data: organisations, isLoading: isLoadingOrganisations } = (0, $fvmYM.usePartnerGetCompaniesByPartnerIdQuery)({
        partnerId: partnerId
    }, {
        skip: !partnerId
    });
    const [filters, setFilters] = (0, $6uMv9.useState)({
        noOfItems: 10,
        page: 0,
        partnerId: (0, $8LupL.isPartnerDomain) ? partnerId : undefined,
        chargePointId: undefined,
        companyId: (0, $8LupL.isAdminDomain) ? selectedCompanyId : undefined,
        from: (0, $hTRiE.default)(new Date(), 1).toISOString(),
        to: undefined
    });
    const { data: rejectedTags, isLoading: rejectedTagsAreLoading } = (0, $fvmYM.useNfcTagGetRejectedTagsQuery)(filters, {
        refetchOnMountOrArgChange: true
    });
    const [deleteRejectedTag] = (0, $fvmYM.useChargePointDeleteRejectedTagMutation)();
    const confirmDelete = (rfidTag)=>{
        (0, $iQS7O.confirmDialog)({
            header: text("lblDeleteRejectedRFID"),
            message: text("msgDoYouWantToDeleteRejectedRFID", {
                id: rfidTag.nfcTagId
            }),
            icon: "pi pi-info-circle",
            position: "bottom",
            accept: ()=>{
                deleteRejectedTag({
                    chargePointId: rfidTag.chargePointId,
                    nfcTagId: rfidTag.nfcTagId
                }).unwrap().then(()=>{
                    toast.notifySuccess(text("msgRejectedRFIDDeleted"));
                }).catch(()=>{
                    toast.notifyError(text("msgRejectedRFIDNotDeleted"));
                });
            }
        });
    };
    const applyFilter = (filter)=>{
        setFilters((prev)=>({
                ...prev,
                ...filter,
                page: 0
            }));
    };
    const filteredData = (rejectedTags?.items || []).filter((item)=>{
        if (!globalFilter) return true;
        const search = globalFilter.toLowerCase();
        return item.nfcTagId?.toLowerCase()?.includes(search) || item.chargePointId?.toLowerCase()?.includes(search);
    });
    const selectedCharger = chargePoints?.items?.find((item)=>item.id === filters.chargePointId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-wrap gap-2 justify-content-end align-items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex gap-2 align-items-center justify-content-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
        disabled: selectedTags.length === 0,
        onClick: onAddRfidTag,
        label: text("btnAddSelected"),
        "data-testid": "add-selected-tags-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "organisation-search-input",
        type: "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH,
        "data-testid": "search-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
        icon: "pi pi-filter",
        rounded: true,
        text: true,
        onClick: (e)=>op.current?.toggle(e),
        "data-testid": "filter-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $g2ttc.OverlayPanel), {
        ref: op,
        closeOnEscape: true,
        className: "px-2 max-w-25rem",
        "data-testid": "filter-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iXXep.Dropdown), {
        label: text("lblChargePointId"),
        value: filters.chargePointId,
        options: chargePoints?.items?.map(({ id: id })=>({
                value: id,
                label: id
            })),
        onChange: (e)=>applyFilter({
                chargePointId: e.value
            }),
        checkmark: true,
        highlightOnSelect: false,
        filter: true,
        id: "charge-point-select",
        className: "w-full",
        showClear: true,
        loading: isLoadingChargePoints,
        "data-testid": "charge-point-select"
    }), selectedCharger && ((0, $3Epa9.default)(selectedCharger) || (0, $kvJbm.default)(selectedCharger)) && !(0, $bbKZs.default)(selectedCharger, selectedCharger.connectors?.at(0)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("small", {
        className: "p-text-secondary block mt-2"
    }, text("msgTurnOnNfcForReader")) : null), (0, $8LupL.isPartnerDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iXXep.Dropdown), {
        label: text("lblOrganisation"),
        value: filters.companyId,
        options: organisations?.map(({ id: id, name: name })=>({
                value: id,
                label: name
            })),
        onChange: (e)=>applyFilter({
                companyId: e.value
            }),
        checkmark: true,
        highlightOnSelect: false,
        filter: true,
        id: "organisation-select",
        className: "w-full",
        showClear: true,
        loading: isLoadingOrganisations,
        "data-testid": "organisation-select"
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "p-label",
        htmlFor: "charge-point-select"
    }, text("lblDateFrom")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7N8Pf.Calendar), {
        className: "w-full",
        id: "from",
        value: filters.from ? new Date(filters.from) : undefined,
        onChange: (e)=>applyFilter({
                from: e.value ? (0, $lTw4g.default)(e.value).toISOString() : undefined
            }),
        minDate: (0, $7Aqef.default)(new Date(), 1),
        maxDate: filters.to ? new Date(filters.to) : new Date(),
        showButtonBar: true,
        "data-testid": "date-from-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "p-label",
        htmlFor: "charge-point-select"
    }, text("lblDateTo")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7N8Pf.Calendar), {
        className: "w-full",
        id: "to",
        value: filters.to ? new Date(filters.to) : undefined,
        onChange: (e)=>applyFilter({
                to: e.value ? (0, $6AVKx.default)(e.value).toISOString() : undefined
            }),
        minDate: filters.from ? new Date(filters.from) : (0, $7Aqef.default)(new Date(), 1),
        maxDate: new Date(),
        showButtonBar: true,
        "data-testid": "date-to-input"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: filteredData,
        removableSort: true,
        loading: rejectedTagsAreLoading,
        lazy: true,
        paginator: true,
        rows: filters.noOfItems ?? 10,
        emptyMessage: text("msgNoRfidTagsFound"),
        selectionMode: "checkbox",
        selection: selectedTags,
        onSelectionChange: (e)=>setSelectedTags(e.value),
        first: (filters.page ?? 0) * (filters.noOfItems ?? 10),
        totalRecords: rejectedTags?.totalCount ?? 0,
        "data-testid": "rejected-rfid-tags",
        onPage: (e)=>{
            setFilters((prev)=>({
                    ...prev,
                    page: e.page
                }));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        selectionMode: "multiple",
        headerClassName: "w-3rem"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "nfcTagId",
        header: text("lblId")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "chargePointId",
        header: text("lblChargePointId")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "timeStamp",
        header: text("lblRejectedAt"),
        body: (tagData)=>(0, $8N7S6.dateLocalize)(tagData.timeStamp)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (rowData)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                icon: "pi pi-trash",
                rounded: true,
                outlined: true,
                severity: "danger",
                onClick: ()=>confirmDelete(rowData)
            });
        }
    })), addRfidTagIsOpened && partnerId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $31uqV.AddRFIDModal), {
        partnerId: partnerId,
        onSubmit: handleAddSelected,
        onClose: ()=>setAddRfidTagIsOpened(false)
    }) : null);
};

});
parcelRegister("7N8Pf", function(module, exports) {

$parcel$export(module.exports, "Calendar", function () { return $5ac3f498be1136b1$export$e1aef45b828286de; });

var $6uMv9 = parcelRequire("6uMv9");

var $cFTyZ = parcelRequire("cFTyZ");

var $aIcGc = parcelRequire("aIcGc");

var $cb4tE = parcelRequire("cb4tE");

var $8Mqhq = parcelRequire("8Mqhq");

var $cItft = parcelRequire("cItft");

var $74zy6 = parcelRequire("74zy6");

var $7Vzgo = parcelRequire("7Vzgo");

var $jeibK = parcelRequire("jeibK");

var $cITD2 = parcelRequire("cITD2");

var $gEdFY = parcelRequire("gEdFY");

var $9PD3x = parcelRequire("9PD3x");

var $8VKpw = parcelRequire("8VKpw");

var $15euW = parcelRequire("15euW");

var $eR8nv = parcelRequire("eR8nv");

var $2Z6lH = parcelRequire("2Z6lH");
"use client";
function $5ac3f498be1136b1$var$_extends() {
    $5ac3f498be1136b1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ac3f498be1136b1$var$_extends.apply(this, arguments);
}
function $5ac3f498be1136b1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5ac3f498be1136b1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ac3f498be1136b1$var$_typeof(o);
}
function $5ac3f498be1136b1$var$_toPrimitive(input, hint) {
    if ($5ac3f498be1136b1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5ac3f498be1136b1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5ac3f498be1136b1$var$_toPropertyKey(arg) {
    var key = $5ac3f498be1136b1$var$_toPrimitive(arg, "string");
    return $5ac3f498be1136b1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5ac3f498be1136b1$var$_defineProperty(obj, key, value) {
    key = $5ac3f498be1136b1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ac3f498be1136b1$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5ac3f498be1136b1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5ac3f498be1136b1$var$_arrayLikeToArray$1(arr);
}
function $5ac3f498be1136b1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5ac3f498be1136b1$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5ac3f498be1136b1$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5ac3f498be1136b1$var$_arrayLikeToArray$1(o, minLen);
}
function $5ac3f498be1136b1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5ac3f498be1136b1$var$_toConsumableArray(arr) {
    return $5ac3f498be1136b1$var$_arrayWithoutHoles(arr) || $5ac3f498be1136b1$var$_iterableToArray(arr) || $5ac3f498be1136b1$var$_unsupportedIterableToArray$1(arr) || $5ac3f498be1136b1$var$_nonIterableSpread();
}
function $5ac3f498be1136b1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5ac3f498be1136b1$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5ac3f498be1136b1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5ac3f498be1136b1$var$_slicedToArray(arr, i) {
    return $5ac3f498be1136b1$var$_arrayWithHoles(arr) || $5ac3f498be1136b1$var$_iterableToArrayLimit(arr, i) || $5ac3f498be1136b1$var$_unsupportedIterableToArray$1(arr, i) || $5ac3f498be1136b1$var$_nonIterableRest();
}
var $5ac3f498be1136b1$var$styles = "\n@layer primereact {\n    .p-calendar {\n        position: relative;\n        display: inline-flex;\n        max-width: 100%;\n    }\n\n    .p-calendar .p-inputtext {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n\n    .p-calendar-w-btn-right .p-inputtext {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    .p-calendar-w-btn-right .p-datepicker-trigger {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-inputtext {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-datepicker-trigger {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    /* Fluid */\n    .p-fluid .p-calendar {\n        display: flex;\n    }\n\n    .p-fluid .p-calendar .p-inputtext {\n        width: 1%;\n    }\n\n    /* Datepicker */\n    .p-calendar .p-datepicker {\n        min-width: 100%;\n    }\n\n    .p-datepicker {\n        width: auto;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-datepicker-inline {\n        display: inline-block;\n        position: static;\n        overflow-x: auto;\n    }\n\n    /* Header */\n    .p-datepicker-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-datepicker-header .p-datepicker-title {\n        margin: 0 auto;\n    }\n\n    .p-datepicker-prev,\n    .p-datepicker-next {\n        cursor: pointer;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    .p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {\n        flex: 1 1 auto;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    /* DatePicker Table */\n    .p-datepicker table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .p-datepicker td > span {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        margin: 0 auto;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Month Picker */\n    .p-monthpicker-month {\n        width: 33.3%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /*  Button Bar */\n    .p-datepicker-buttonbar {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    /* Time Picker */\n    .p-timepicker {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .p-timepicker button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-timepicker > div {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    /* Touch UI */\n    .p-datepicker-touch-ui,\n    .p-calendar .p-datepicker-touch-ui {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        min-width: 80vw;\n        transform: translate(-50%, -50%);\n    }\n\n    /* Year Picker */\n    .p-yearpicker-year {\n        width: 50%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n}\n";
var $5ac3f498be1136b1$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, isFilled = _ref.isFilled, panelVisible = _ref.panelVisible;
        return (0, $15euW.classNames)("p-calendar p-component p-inputwrapper", $5ac3f498be1136b1$var$_defineProperty($5ac3f498be1136b1$var$_defineProperty($5ac3f498be1136b1$var$_defineProperty($5ac3f498be1136b1$var$_defineProperty($5ac3f498be1136b1$var$_defineProperty($5ac3f498be1136b1$var$_defineProperty($5ac3f498be1136b1$var$_defineProperty({}, "p-calendar-w-btn p-calendar-w-btn-".concat(props.iconPos), props.showIcon), "p-calendar-disabled", props.disabled), "p-invalid", props.invalid), "p-calendar-timeonly", props.timeOnly), "p-inputwrapper-filled", props.value || isFilled), "p-inputwrapper-focus", focusedState), "p-focus", focusedState || panelVisible));
    },
    input: function input(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $15euW.classNames)("p-inputtext p-component", {
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    dropdownButton: "p-datepicker-trigger",
    buttonbar: "p-datepicker-buttonbar",
    todayButton: "p-button-text",
    clearButton: "p-button-text",
    footer: "p-datepicker-footer",
    yearPicker: "p-yearpicker",
    year: function year(_ref3) {
        var isYearSelected = _ref3.isYearSelected, y = _ref3.y, isMonthYearDisabled = _ref3.isMonthYearDisabled;
        return (0, $15euW.classNames)("p-yearpicker-year", {
            "p-highlight": isYearSelected(y),
            "p-disabled": isMonthYearDisabled(-1, y)
        });
    },
    monthPicker: "p-monthpicker",
    month: function month(_ref4) {
        var isMonthSelected = _ref4.isMonthSelected, isMonthYearDisabled = _ref4.isMonthYearDisabled, i = _ref4.i, currentYear = _ref4.currentYear;
        return (0, $15euW.classNames)("p-monthpicker-month", {
            "p-highlight": isMonthSelected(i),
            "p-disabled": isMonthYearDisabled(i, currentYear)
        });
    },
    hourPicker: "p-hour-picker",
    secondPicker: "p-second-picker",
    minutePicker: "p-minute-picker",
    millisecondPicker: "p-millisecond-picker",
    ampmPicker: "p-ampm-picker",
    separatorContainer: "p-separator",
    dayLabel: function dayLabel(_ref5) {
        var className = _ref5.className;
        return className;
    },
    day: function day(_ref6) {
        var date = _ref6.date;
        return (0, $15euW.classNames)({
            "p-datepicker-other-month": date.otherMonth,
            "p-datepicker-today": date.today
        });
    },
    panel: function panel(_ref7) {
        var panelClassName = _ref7.panelClassName;
        return panelClassName;
    },
    previousIcon: "p-datepicker-prev-icon",
    previousButton: "p-datepicker-prev",
    nextIcon: "p-datepicker-next-icon",
    nextButton: "p-datepicker-next",
    incrementButton: "p-link",
    decrementButton: "p-link",
    title: "p-datepicker-title",
    timePicker: "p-timepicker",
    monthTitle: "p-datepicker-month p-link",
    yearTitle: "p-datepicker-year p-link",
    decadeTitle: "p-datepicker-decade",
    header: "p-datepicker-header",
    groupContainer: "p-datepicker-group-container",
    group: "p-datepicker-group",
    select: function select(_ref8) {
        var props = _ref8.props;
        return props.monthNavigator && props.view !== "month" ? "p-datepicker-month" : props.yearNavigator ? "p-datepicker-year" : undefined;
    },
    weekHeader: "p-datepicker-weekheader p-disabled",
    weekNumber: "p-datepicker-weeknumber",
    weekLabelContainer: "p-disabled",
    container: "p-datepicker-calendar-container",
    table: "p-datepicker-calendar",
    transition: "p-connected-overlay"
};
var $5ac3f498be1136b1$var$CalendarBase = (0, $cb4tE.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Calendar",
        appendTo: null,
        ariaLabelledBy: null,
        ariaLabel: null,
        autoZIndex: true,
        autoFocus: false,
        baseZIndex: 0,
        className: null,
        clearButtonClassName: "p-button-secondary",
        dateFormat: null,
        dateTemplate: null,
        decadeTemplate: null,
        decrementIcon: null,
        disabled: false,
        disabledDates: null,
        disabledDays: null,
        enabledDates: null,
        footerTemplate: null,
        formatDateTime: null,
        headerTemplate: null,
        hideOnDateTimeSelect: false,
        hideOnRangeSelection: false,
        hourFormat: "24",
        icon: null,
        iconPos: "right",
        id: null,
        incrementIcon: null,
        inline: false,
        inputClassName: null,
        inputId: null,
        inputMode: "none",
        inputRef: null,
        inputStyle: null,
        variant: null,
        invalid: false,
        keepInvalid: false,
        locale: null,
        mask: null,
        maskSlotChar: "_",
        maxDate: null,
        maxDateCount: null,
        minDate: null,
        monthNavigator: false,
        monthNavigatorTemplate: null,
        name: null,
        nextIcon: null,
        numberOfMonths: 1,
        onBlur: null,
        onChange: null,
        onClearButtonClick: null,
        onFocus: null,
        onHide: null,
        onInput: null,
        onMonthChange: null,
        onSelect: null,
        onShow: null,
        onTodayButtonClick: null,
        onViewDateChange: null,
        onVisibleChange: null,
        panelClassName: null,
        panelStyle: null,
        parseDateTime: null,
        placeholder: null,
        prevIcon: null,
        readOnlyInput: false,
        required: false,
        selectOtherMonths: false,
        selectionMode: "single",
        shortYearCutoff: "+10",
        showButtonBar: false,
        showIcon: false,
        showMillisec: false,
        showMinMaxRange: false,
        showOnFocus: true,
        showOtherMonths: true,
        showSeconds: false,
        showTime: false,
        showWeek: false,
        stepHour: 1,
        stepMillisec: 1,
        stepMinute: 1,
        stepSecond: 1,
        style: null,
        tabIndex: null,
        timeOnly: false,
        todayButtonClassName: "p-button-secondary",
        tooltip: null,
        tooltipOptions: null,
        touchUI: false,
        transitionOptions: null,
        value: null,
        view: "date",
        viewDate: null,
        visible: false,
        yearNavigator: false,
        yearNavigatorTemplate: null,
        yearRange: null,
        children: undefined
    },
    css: {
        classes: $5ac3f498be1136b1$var$classes,
        styles: $5ac3f498be1136b1$var$styles
    }
});
var $5ac3f498be1136b1$var$CalendarPanel = /*#__PURE__*/ $6uMv9.forwardRef(function(props, ref) {
    var cx = props.cx;
    var mergeProps = (0, $8Mqhq.useMergeProps)();
    var createElement = function createElement() {
        var panelProps = mergeProps({
            className: cx("panel", {
                panelClassName: props.className
            }),
            style: props.style,
            role: props.inline ? null : "dialog",
            id: props.id,
            "aria-label": (0, $cFTyZ.localeOption)("chooseDate", props.locale),
            "aria-modal": props.inline ? null : "true",
            onClick: props.onClick,
            onMouseUp: props.onMouseUp
        }, props.ptm("panel", {
            hostName: props.hostName
        }));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, props.ptm("transition", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $6uMv9.createElement((0, $eR8nv.CSSTransition), $5ac3f498be1136b1$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $6uMv9.createElement("div", $5ac3f498be1136b1$var$_extends({
            ref: ref
        }, panelProps), props.children));
    };
    var element = createElement();
    return props.inline ? element : /*#__PURE__*/ $6uMv9.createElement((0, $2Z6lH.Portal), {
        element: element,
        appendTo: props.appendTo
    });
});
$5ac3f498be1136b1$var$CalendarPanel.displayName = "CalendarPanel";
function $5ac3f498be1136b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ac3f498be1136b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ac3f498be1136b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5ac3f498be1136b1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ac3f498be1136b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5ac3f498be1136b1$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $5ac3f498be1136b1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $5ac3f498be1136b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5ac3f498be1136b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5ac3f498be1136b1$var$_arrayLikeToArray(o, minLen);
}
function $5ac3f498be1136b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5ac3f498be1136b1$export$e1aef45b828286de = /*#__PURE__*/ $6uMv9.memo(/*#__PURE__*/ $6uMv9.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $8Mqhq.useMergeProps)();
    var context = $6uMv9.useContext((0, $cFTyZ.PrimeReactContext));
    var props = $5ac3f498be1136b1$var$CalendarBase.getProps(inProps, context);
    var _React$useState = $6uMv9.useState(false), _React$useState2 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _React$useState3 = $6uMv9.useState(false), _React$useState4 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState3, 2), overlayVisibleState = _React$useState4[0], setOverlayVisibleState = _React$useState4[1];
    var _React$useState5 = $6uMv9.useState(null), _React$useState6 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState5, 2), viewDateState = _React$useState6[0], setViewDateState = _React$useState6[1];
    var _React$useState7 = $6uMv9.useState(props.id), _React$useState8 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState7, 2), idState = _React$useState8[0], setIdState = _React$useState8[1];
    var isTypingRef = $6uMv9.useRef(false);
    var metaData = {
        props: props,
        state: {
            focused: focusedState,
            overlayVisible: overlayVisibleState,
            viewDate: viewDateState
        }
    };
    var _CalendarBase$setMeta = $5ac3f498be1136b1$var$CalendarBase.setMetaData(metaData), ptm = _CalendarBase$setMeta.ptm, cx = _CalendarBase$setMeta.cx, isUnstyled = _CalendarBase$setMeta.isUnstyled;
    (0, $cb4tE.useHandleStyle)($5ac3f498be1136b1$var$CalendarBase.css.styles, isUnstyled, {
        name: "calendar"
    });
    var elementRef = $6uMv9.useRef(null);
    var overlayRef = $6uMv9.useRef(null);
    var inputRef = $6uMv9.useRef(props.inputRef);
    var navigation = $6uMv9.useRef(null);
    var ignoreFocusFunctionality = $6uMv9.useRef(false);
    var timePickerTimer = $6uMv9.useRef(null);
    var viewStateChanged = $6uMv9.useRef(false);
    var touchUIMask = $6uMv9.useRef(null);
    var overlayEventListener = $6uMv9.useRef(null);
    var touchUIMaskClickListener = $6uMv9.useRef(null);
    var isOverlayClicked = $6uMv9.useRef(false);
    var previousButton = $6uMv9.useRef(false);
    var nextButton = $6uMv9.useRef(false);
    var viewChangedWithKeyDown = $6uMv9.useRef(false);
    var onChangeRef = $6uMv9.useRef(null);
    var isClearClicked = $6uMv9.useRef(false);
    var _React$useState9 = $6uMv9.useState("date"), _React$useState10 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState9, 2), currentView = _React$useState10[0], setCurrentView = _React$useState10[1];
    var _React$useState11 = $6uMv9.useState(null), _React$useState12 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState11, 2), currentMonth = _React$useState12[0], setCurrentMonth = _React$useState12[1];
    var _React$useState13 = $6uMv9.useState(null), _React$useState14 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState13, 2), currentYear = _React$useState14[0], setCurrentYear = _React$useState14[1];
    var _React$useState15 = $6uMv9.useState([]), _React$useState16 = $5ac3f498be1136b1$var$_slicedToArray(_React$useState15, 2), yearOptions = _React$useState16[0], setYearOptions = _React$useState16[1];
    var previousValue = (0, $8Mqhq.usePrevious)(props.value);
    var visible = props.inline || (props.onVisibleChange ? props.visible : overlayVisibleState);
    var attributeSelector = (0, $15euW.UniqueComponentId)();
    var panelId = idState + "_panel";
    var _useOverlayListener = (0, $8Mqhq.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === "outside" ? !isOverlayClicked.current && !isNavIconClicked(event.target) && hide("outside") : hide();
            isOverlayClicked.current = false;
        },
        when: !(props.touchUI || props.inline) && visible,
        type: "mousedown"
    }), _useOverlayListener2 = $5ac3f498be1136b1$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var getDateFormat = function getDateFormat() {
        return props.dateFormat || (0, $cFTyZ.localeOption)("dateFormat", props.locale);
    };
    var onInputFocus = function onInputFocus(event) {
        if (ignoreFocusFunctionality.current) {
            setFocusedState(true);
            ignoreFocusFunctionality.current = false;
        } else {
            if (props.showOnFocus && !visible) show();
            setFocusedState(true);
            props.onFocus && props.onFocus(event);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        updateInputfield(props.value);
        props.onBlur && props.onBlur(event);
        setFocusedState(false);
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                if (!overlayVisibleState) show();
                else {
                    focusToFirstCell();
                    event.preventDefault();
                }
                break;
            case "Escape":
                hide();
                props.touchUI && disableModality();
                break;
            case "Tab":
                if (overlayRef && overlayRef.current) {
                    (0, $15euW.DomHandler).getFocusableElements(overlayRef.current).forEach(function(el) {
                        return el.tabIndex = "-1";
                    });
                    hide();
                    props.touchUI && disableModality();
                }
                break;
        }
    };
    var onUserInput = function onUserInput(event) {
        updateValueOnInput(event, event.target.value);
        props.onInput && props.onInput(event);
    };
    var updateValueOnInput = function updateValueOnInput(event, rawValue, invalidCallback) {
        try {
            var value = parseValueFromString(props.timeOnly ? rawValue.replace("_", "") : rawValue);
            if (isValidSelection(value)) {
                isTypingRef.current = true;
                updateModel(event, value);
                updateViewDate(event, value.length ? value[0] : value);
            }
        } catch (err) {
            //invalid date
            if (invalidCallback) invalidCallback();
            else {
                var _value = props.keepInvalid ? rawValue : null;
                updateModel(event, _value);
            }
        }
    };
    var reFocusInputField = function reFocusInputField() {
        if (!props.inline && inputRef.current) {
            ignoreFocusFunctionality.current = true;
            (0, $15euW.DomHandler).focus(inputRef.current);
        }
    };
    var isValidSelection = function isValidSelection(value) {
        var isValid = true;
        if (isSingleSelection()) {
            if (!(isSelectable(value.getDate(), value.getMonth(), value.getFullYear(), false) && isSelectableTime(value))) isValid = false;
        } else if (value.every(function(v) {
            return isSelectable(v.getDate(), v.getMonth(), v.getFullYear(), false) && isSelectableTime(v);
        })) {
            if (isRangeSelection()) isValid = value.length > 1 && value[1] > value[0] ? true : false;
        }
        return isValid;
    };
    var onButtonClick = function onButtonClick() {
        visible ? hide() : show();
    };
    var onPrevButtonClick = function onPrevButtonClick(event) {
        navigation.current = {
            backward: true,
            button: true
        };
        navBackward(event);
    };
    var onNextButtonClick = function onNextButtonClick(event) {
        navigation.current = {
            backward: false,
            button: true
        };
        navForward(event);
    };
    var onContainerButtonKeydown = function onContainerButtonKeydown(event) {
        switch(event.code){
            case "Tab":
                !props.inline && trapFocus(event);
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
        }
    };
    var onPickerKeyDown = function onPickerKeyDown(event, type, direction) {
        if (event.key === "Enter" || event.key === "Space") {
            onTimePickerElementMouseDown(event, type, direction);
            event.preventDefault();
            return;
        }
        onContainerButtonKeydown(event);
    };
    var onPickerKeyUp = function onPickerKeyUp(event) {
        if (event.key === "Enter" || event.key === "Space") {
            onTimePickerElementMouseUp();
            event.preventDefault();
            return;
        }
    };
    var trapFocus = function trapFocus(event) {
        event === null || event === void 0 || event.preventDefault();
        var focusableElements = (0, $15euW.DomHandler).getFocusableElements(overlayRef.current);
        if (focusableElements && focusableElements.length > 0) {
            if (!document.activeElement) focusableElements[0].focus();
            else {
                var focusedIndex = focusableElements.indexOf(document.activeElement);
                if (event !== null && event !== void 0 && event.shiftKey) {
                    if (focusedIndex === -1 || focusedIndex === 0) focusableElements[focusableElements.length - 1].focus();
                    else focusableElements[focusedIndex - 1].focus();
                } else if (focusedIndex === -1 || focusedIndex === focusableElements.length - 1) focusableElements[0].focus();
                else focusableElements[focusedIndex + 1].focus();
            }
        }
    };
    var updateFocus = function updateFocus() {
        if (navigation.current) {
            if (navigation.current.button) {
                initFocusableCell();
                if (navigation.current.backward) previousButton.current.focus();
                else nextButton.current.focus();
            } else {
                var cell;
                if (navigation.current.backward) {
                    var cells = (0, $15euW.DomHandler).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                    cell = cells[cells.length - 1];
                } else cell = (0, $15euW.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                if (cell) {
                    cell.tabIndex = "0";
                    cell.focus();
                }
            }
            navigation.current = null;
        } else initFocusableCell();
    };
    var initFocusableCell = function initFocusableCell() {
        var cell;
        if (currentView === "month") {
            var cells = (0, $15euW.DomHandler).find(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"]');
            var selectedCell = (0, $15euW.DomHandler).findSingle(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"][data-p-highlight="true"]');
            cells.forEach(function(cell) {
                return cell.tabIndex = -1;
            });
            cell = selectedCell || cells[0];
        } else {
            cell = (0, $15euW.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
            if (!cell) {
                var todayCell = (0, $15euW.DomHandler).findSingle(overlayRef.current, "td.p-datepicker-today span:not(.p-disabled)");
                cell = todayCell || (0, $15euW.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
            }
        }
        if (cell) cell.tabIndex = "0";
    };
    var focusToFirstCell = function focusToFirstCell() {
        if (currentView) {
            var cell;
            if (currentView === "date") {
                cell = (0, $15euW.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) {
                    var todayCell = (0, $15euW.DomHandler).findSingle(overlayRef.current, "td.p-datepicker-today span:not(.p-disabled)");
                    cell = todayCell || (0, $15euW.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                }
            } else if (currentView === "month" || currentView === "year") {
                cell = (0, $15euW.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) cell = (0, $15euW.DomHandler).findSingle(overlayRef.current, '[data-pc-section="'.concat(currentView, 'picker"] [data-pc-section="').concat(currentView, '"]:not([data-p-disabled="true"])'));
            }
            if (cell) {
                cell.tabIndex = "0";
                cell && cell.focus();
            }
        }
    };
    var navBackward = function navBackward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === "date") {
            if (newViewDate.getMonth() === 0) {
                newViewDate.setMonth(11);
                newViewDate.setFullYear(decrementYear());
                setCurrentMonth(11);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() - 1);
                setCurrentMonth(function(prevState) {
                    return prevState - 1;
                });
            }
        } else if (currentView === "month") {
            var newYear = newViewDate.getFullYear() - 1;
            if (props.yearNavigator) {
                var minYear = parseInt(props.yearRange.split(":")[0], 10);
                if (newYear < minYear) newYear = minYear;
            }
            newViewDate.setFullYear(newYear);
        }
        if (currentView === "month") newViewDate.setFullYear(decrementYear());
        else if (currentView === "year") newViewDate.setFullYear(decrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var navForward = function navForward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === "date") {
            if (newViewDate.getMonth() === 11) {
                newViewDate.setMonth(0);
                newViewDate.setFullYear(incrementYear());
                setCurrentMonth(0);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() + 1);
                setCurrentMonth(function(prevState) {
                    return prevState + 1;
                });
            }
        } else if (currentView === "month") {
            var newYear = newViewDate.getFullYear() + 1;
            if (props.yearNavigator) {
                var maxYear = parseInt(props.yearRange.split(":")[1], 10);
                if (newYear > maxYear) newYear = maxYear;
            }
            newViewDate.setFullYear(newYear);
        }
        if (currentView === "month") newViewDate.setFullYear(incrementYear());
        else if (currentView === "year") newViewDate.setFullYear(incrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var populateYearOptions = function populateYearOptions(start, end) {
        var _yearOptions = [];
        for(var i = start; i <= end; i++)yearOptions.push(i);
        setYearOptions(_yearOptions);
    };
    var decrementYear = function decrementYear() {
        var _currentYear = currentYear - 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear < yearOptions[0]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] - difference, yearOptions[yearOptions.length - 1] - difference);
        }
        return _currentYear;
    };
    var incrementYear = function incrementYear() {
        var _currentYear = currentYear + 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear.current > yearOptions[yearOptions.length - 1]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] + difference, yearOptions[yearOptions.length - 1] + difference);
        }
        return _currentYear;
    };
    var onMonthDropdownChange = function onMonthDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setMonth(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onYearDropdownChange = function onYearDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setFullYear(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onTodayButtonClick = function onTodayButtonClick(event) {
        var today = new Date();
        var dateMeta = {
            day: today.getDate(),
            month: today.getMonth(),
            year: today.getFullYear(),
            today: true,
            selectable: true
        };
        var timeMeta = {
            hours: today.getHours(),
            minutes: today.getMinutes(),
            seconds: today.getSeconds(),
            milliseconds: today.getMilliseconds()
        };
        updateViewDate(event, today);
        onDateSelect(event, dateMeta, timeMeta);
        props.onTodayButtonClick && props.onTodayButtonClick(event);
    };
    var onClearButtonClick = function onClearButtonClick(event) {
        isClearClicked.current = true;
        updateModel(event, null);
        updateInputfield(null);
        hide();
        props.onClearButtonClick && props.onClearButtonClick(event);
    };
    var onPanelClick = function onPanelClick(event) {
        if (!props.inline) (0, $9PD3x.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onPanelMouseUp = function onPanelMouseUp(event) {
        onPanelClick(event);
    };
    var onTimePickerElementMouseDown = function onTimePickerElementMouseDown(event, type, direction) {
        if (!props.disabled) {
            repeat(event, null, type, direction);
            event.preventDefault();
        }
    };
    var onTimePickerElementMouseUp = function onTimePickerElementMouseUp() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var onTimePickerElementMouseLeave = function onTimePickerElementMouseLeave() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var repeat = function repeat(event, interval, type, direction) {
        clearTimePickerTimer();
        timePickerTimer.current = setTimeout(function() {
            repeat(event, 100, type, direction);
        }, interval || 500);
        switch(type){
            case 0:
                if (direction === 1) incrementHour(event);
                else decrementHour(event);
                break;
            case 1:
                if (direction === 1) incrementMinute(event);
                else decrementMinute(event);
                break;
            case 2:
                if (direction === 1) incrementSecond(event);
                else decrementSecond(event);
                break;
            case 3:
                if (direction === 1) incrementMilliSecond(event);
                else decrementMilliSecond(event);
                break;
        }
    };
    var clearTimePickerTimer = function clearTimePickerTimer() {
        if (timePickerTimer.current) clearTimeout(timePickerTimer.current);
    };
    var roundMinutesToStep = function roundMinutesToStep(minutes) {
        if (props.stepMinute) return Math.round(minutes / props.stepMinute) * props.stepMinute;
        return minutes;
    };
    var incrementHour = function incrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour + props.stepHour;
        newHour = newHour >= 24 ? newHour - 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getHours() === newHour) {
                if (props.maxDate.getMinutes() < currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.maxDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementHour = function decrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour - props.stepHour;
        newHour = newHour < 0 ? newHour + 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getHours() === newHour) {
                if (props.minDate.getMinutes() > currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.minDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var doStepMinute = function doStepMinute(currentMinute, step) {
        if (props.stepMinute <= 1) return step ? currentMinute + step : currentMinute;
        if (!step) {
            step = props.stepMinute;
            if (currentMinute % step === 0) return currentMinute;
        }
        return Math.floor((currentMinute + step) / step) * step;
    };
    var incrementMinute = function incrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, props.stepMinute);
        newMinute = newMinute > 59 ? newMinute - 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getMinutes() === newMinute) {
                if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                    if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementMinute = function decrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, -props.stepMinute);
        newMinute = newMinute < 0 ? newMinute + 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getMinutes() === newMinute) {
                if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                    if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), props.minDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementSecond = function incrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond + props.stepSecond;
        newSecond = newSecond > 59 ? newSecond - 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getSeconds() === newSecond) {
                if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.maxDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementSecond = function decrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond - props.stepSecond;
        newSecond = newSecond < 0 ? newSecond + 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getSeconds() === newSecond) {
                if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.minDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementMilliSecond = function incrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond + props.stepMillisec;
        newMillisecond = newMillisecond > 999 ? newMillisecond - 1000 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var decrementMilliSecond = function decrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond - props.stepMillisec;
        newMillisecond = newMillisecond < 0 ? newMillisecond + 999 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var toggleAmPm = function toggleAmPm(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour >= 12 ? currentHour - 12 : currentHour + 12;
        if (validateHour(convertTo24Hour(newHour, currentHour > 11), currentTime)) updateTime(event, newHour, currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
        event.preventDefault();
    };
    var getViewDate = function getViewDate(date) {
        var propValue = props.value;
        var viewDate = date || (props.onViewDateChange ? props.viewDate : viewDateState);
        if (Array.isArray(propValue)) propValue = propValue[0];
        return viewDate && isValidDate(viewDate) ? viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
    };
    var getCurrentDateTime = function getCurrentDateTime() {
        if (isSingleSelection()) return props.value && props.value instanceof Date ? cloneDate(props.value) : getViewDate();
        else if (isMultipleSelection()) {
            if (props.value && props.value.length) return cloneDate(props.value[props.value.length - 1]);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = cloneDate(props.value[0]);
                var endDate = cloneDate(props.value[1]);
                return endDate || startDate;
            }
        }
        return new Date();
    };
    var cloneDate = function cloneDate(date) {
        return isValidDate(date) ? new Date(date.valueOf()) : date;
    };
    var isValidDate = function isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    };
    var convertTo24Hour = function convertTo24Hour(hour, pm) {
        if (props.hourFormat === "12") return hour === 12 ? pm ? 12 : 0 : pm ? hour + 12 : hour;
        return hour;
    };
    var validateHour = function validateHour(hour, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (props.minDate.getHours() > hour) valid = false;
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (props.maxDate.getHours() < hour) valid = false;
        }
        return valid;
    };
    var validateMinute = function validateMinute(minute, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours()) {
                if (props.minDate.getMinutes() > minute) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours()) {
                if (props.maxDate.getMinutes() < minute) valid = false;
            }
        }
        return valid;
    };
    var validateSecond = function validateSecond(second, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getSeconds() > second) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getSeconds() < second) valid = false;
            }
        }
        return valid;
    };
    var validateMillisecond = function validateMillisecond(millisecond, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getSeconds() === props.minDate.getSeconds() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getMilliseconds() > millisecond) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getSeconds() === props.maxDate.getSeconds() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getMilliseconds() < millisecond) valid = false;
            }
        }
        return valid;
    };
    var validateDate = function validateDate(value) {
        if (props.yearNavigator) {
            var viewYear = value.getFullYear();
            var minRangeYear = props.yearRange ? parseInt(props.yearRange.split(":")[0], 10) : null;
            var maxRangeYear = props.yearRange ? parseInt(props.yearRange.split(":")[1], 10) : null;
            var minYear = props.minDate && minRangeYear != null ? Math.max(props.minDate.getFullYear(), minRangeYear) : props.minDate || minRangeYear;
            var maxYear = props.maxDate && maxRangeYear != null ? Math.min(props.maxDate.getFullYear(), maxRangeYear) : props.maxDate || maxRangeYear;
            if (minYear && minYear > viewYear) viewYear = minYear;
            if (maxYear && maxYear < viewYear) viewYear = maxYear;
            value.setFullYear(viewYear);
        }
        if (renderMonthsNavigator(0)) {
            var viewMonth = value.getMonth();
            var viewMonthWithMinMax = parseInt(isInMinYear(value) && Math.max(props.minDate.getMonth(), viewMonth).toString() || isInMaxYear(value) && Math.min(props.maxDate.getMonth(), viewMonth).toString() || viewMonth);
            value.setMonth(viewMonthWithMinMax);
        }
    };
    var updateTime = function updateTime(event, hour, minute, second, millisecond) {
        var newDateTime = getCurrentDateTime();
        newDateTime.setHours(hour);
        newDateTime.setMinutes(minute);
        newDateTime.setSeconds(second);
        newDateTime.setMilliseconds(millisecond);
        if (isMultipleSelection()) {
            if (props.value && props.value.length) {
                var value = $5ac3f498be1136b1$var$_toConsumableArray(props.value);
                value[value.length - 1] = newDateTime;
                newDateTime = value;
            } else newDateTime = [
                newDateTime
            ];
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                newDateTime = endDate ? [
                    startDate,
                    newDateTime
                ] : [
                    newDateTime,
                    null
                ];
            } else newDateTime = [
                newDateTime,
                null
            ];
        }
        updateModel(event, newDateTime);
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: newDateTime
        });
        updateInputfield(newDateTime);
    };
    var updateViewDate = function updateViewDate(event, value) {
        validateDate(value);
        if (props.onViewDateChange && event) props.onViewDateChange({
            originalEvent: event,
            value: value
        });
        else {
            viewStateChanged.current = true;
            setViewDateState(value);
        }
        if (!value) onClearButtonClick(event);
        if (value && props.onSelect) {
            var day = value.getDate();
            var month = value.getMonth();
            var year = value.getFullYear();
            onDateSelect(event, {
                day: day,
                month: month,
                year: year,
                selectable: isSelectable(day, month, year)
            });
        }
    };
    var setNavigationState = function setNavigationState(newViewDate) {
        if (!newViewDate || !props.showMinMaxRange || props.view !== "date" || !overlayRef.current) return;
        var navPrev = (0, $15euW.DomHandler).findSingle(overlayRef.current, '[data-pc-section="previousbutton"]');
        var navNext = (0, $15euW.DomHandler).findSingle(overlayRef.current, '[data-pc-section="nextbutton"]');
        if (props.disabled) {
            !isUnstyled() && (0, $15euW.DomHandler).addClass(navPrev, "p-disabled");
            navPrev.setAttribute("data-p-disabled", true);
            !isUnstyled() && (0, $15euW.DomHandler).addClass(navNext, "p-disabled");
            navNext.setAttribute("data-p-disabled", true);
            return;
        }
        // previous (check first day of month at 00:00:00)
        if (props.minDate) {
            var firstDayOfMonth = cloneDate(newViewDate);
            if (firstDayOfMonth.getMonth() === 0) {
                firstDayOfMonth.setMonth(11, 1);
                firstDayOfMonth.setFullYear(firstDayOfMonth.getFullYear() - 1);
            } else firstDayOfMonth.setMonth(firstDayOfMonth.getMonth(), 1);
            firstDayOfMonth.setHours(0);
            firstDayOfMonth.setMinutes(0);
            firstDayOfMonth.setSeconds(0);
            if (props.minDate > firstDayOfMonth) (0, $15euW.DomHandler).addClass(navPrev, "p-disabled");
            else (0, $15euW.DomHandler).removeClass(navPrev, "p-disabled");
        }
        // next (check last day of month at 11:59:59)
        if (props.maxDate) {
            var lastDayOfMonth = cloneDate(newViewDate);
            if (lastDayOfMonth.getMonth() === 11) {
                lastDayOfMonth.setMonth(0, 1);
                lastDayOfMonth.setFullYear(lastDayOfMonth.getFullYear() + 1);
            } else lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1, 1);
            lastDayOfMonth.setHours(0);
            lastDayOfMonth.setMinutes(0);
            lastDayOfMonth.setSeconds(0);
            lastDayOfMonth.setSeconds(-1);
            if (props.maxDate < lastDayOfMonth) (0, $15euW.DomHandler).addClass(navNext, "p-disabled");
            else (0, $15euW.DomHandler).removeClass(navNext, "p-disabled");
        }
    };
    var onDateCellKeydown = function onDateCellKeydown(event, date, groupIndex) {
        var cellContent = event.currentTarget;
        var cell = cellContent.parentElement;
        var cellIndex = (0, $15euW.DomHandler).index(cell);
        switch(event.code){
            case "ArrowDown":
                cellContent.tabIndex = "-1";
                var nextRow = cell.parentElement.nextElementSibling;
                if (nextRow) {
                    var tableRowIndex = (0, $15euW.DomHandler).index(cell.parentElement);
                    var tableRows = Array.from(cell.parentElement.parentElement.children);
                    var nextTableRows = tableRows.slice(tableRowIndex + 1);
                    var hasNextFocusableDate = nextTableRows.find(function(el) {
                        var focusCell = el.children[cellIndex].children[0];
                        return !(0, $15euW.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (hasNextFocusableDate) {
                        var focusCell = hasNextFocusableDate.children[cellIndex].children[0];
                        focusCell.tabIndex = "0";
                        focusCell.focus();
                    } else {
                        navigation.current = {
                            backward: false
                        };
                        navForward(event);
                    }
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "ArrowUp":
                cellContent.tabIndex = "-1";
                if (event.altKey) hide(null, reFocusInputField);
                else {
                    var prevRow = cell.parentElement.previousElementSibling;
                    if (prevRow) {
                        var _tableRowIndex = (0, $15euW.DomHandler).index(cell.parentElement);
                        var _tableRows = Array.from(cell.parentElement.parentElement.children);
                        var prevTableRows = _tableRows.slice(0, _tableRowIndex).reverse();
                        var _hasNextFocusableDate = prevTableRows.find(function(el) {
                            var focusCell = el.children[cellIndex].children[0];
                            return !(0, $15euW.DomHandler).getAttribute(focusCell, "data-p-disabled");
                        });
                        if (_hasNextFocusableDate) {
                            var _focusCell = _hasNextFocusableDate.children[cellIndex].children[0];
                            _focusCell.tabIndex = "0";
                            _focusCell.focus();
                        } else {
                            navigation.current = {
                                backward: true
                            };
                            navBackward(event);
                        }
                    } else {
                        navigation.current = {
                            backward: true
                        };
                        navBackward(event);
                    }
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cellContent.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    var cells = Array.from(cell.parentElement.children);
                    var prevCells = cells.slice(0, cellIndex).reverse();
                    var _hasNextFocusableDate2 = prevCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $15euW.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (_hasNextFocusableDate2) {
                        var _focusCell2 = _hasNextFocusableDate2.children[0];
                        _focusCell2.tabIndex = "0";
                        _focusCell2.focus();
                    } else navigateToMonth(true, groupIndex, event);
                } else navigateToMonth(true, groupIndex, event);
                event.preventDefault();
                break;
            case "ArrowRight":
                cellContent.tabIndex = "-1";
                var nextCell = cell.nextElementSibling;
                if (nextCell) {
                    var _cells = Array.from(cell.parentElement.children);
                    var nextCells = _cells.slice(cellIndex + 1);
                    var _hasNextFocusableDate3 = nextCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $15euW.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (_hasNextFocusableDate3) {
                        var _focusCell3 = _hasNextFocusableDate3.children[0];
                        _focusCell3.tabIndex = "0";
                        _focusCell3.focus();
                    } else navigateToMonth(false, groupIndex, event);
                } else navigateToMonth(false, groupIndex, event);
                event.preventDefault();
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                onDateSelect(event, date);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                if (!props.inline) trapFocus(event);
                break;
            case "Home":
                cellContent.tabIndex = "-1";
                var currentRow = cell.parentElement;
                var _focusCell4 = currentRow.children[0].children[0];
                if ((0, $15euW.DomHandler).getAttribute(_focusCell4, "data-p-disabled")) navigateToMonth(groupIndex, true, event);
                else {
                    _focusCell4.tabIndex = "0";
                    _focusCell4.focus();
                }
                event.preventDefault();
                break;
            case "End":
                cellContent.tabIndex = "-1";
                var _currentRow = cell.parentElement;
                var _focusCell5 = _currentRow.children[_currentRow.children.length - 1].children[0];
                if ((0, $15euW.DomHandler).getAttribute(_focusCell5, "data-p-disabled")) navigateToMonth(groupIndex, false, event);
                else {
                    _focusCell5.tabIndex = "0";
                    _focusCell5.focus();
                }
                event.preventDefault();
                break;
            case "PageUp":
                cellContent.tabIndex = "-1";
                if (event.shiftKey) {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                } else navigateToMonth(groupIndex, true, event);
                event.preventDefault();
                break;
            case "PageDown":
                cellContent.tabIndex = "-1";
                if (event.shiftKey) {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                } else navigateToMonth(groupIndex, false, event);
                event.preventDefault();
                break;
        }
    };
    var navigateToMonth = function navigateToMonth(prev, groupIndex, event) {
        if (prev) {
            if (props.numberOfMonths === 1 || groupIndex === 0) {
                navigation.current = {
                    backward: true
                };
                navBackward(event);
            } else {
                var prevMonthContainer = overlayRef.current.children[groupIndex - 1];
                var cells = (0, $15euW.DomHandler).find(prevMonthContainer, 'table td span:not([data-p-disabled="true"])');
                var focusCell = cells[cells.length - 1];
                focusCell.tabIndex = "0";
                focusCell.focus();
            }
        } else if (props.numberOfMonths === 1 || groupIndex === props.numberOfMonths - 1) {
            navigation.current = {
                backward: false
            };
            navForward(event);
        } else {
            var nextMonthContainer = overlayRef.current.children[groupIndex + 1];
            var _focusCell6 = (0, $15euW.DomHandler).findSingle(nextMonthContainer, 'table td span:not([data-p-disabled="true"])');
            _focusCell6.tabIndex = "0";
            _focusCell6.focus();
        }
    };
    var onMonthCellKeydown = function onMonthCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case "ArrowUp":
            case "ArrowDown":
                cell.tabIndex = "-1";
                var cells = cell.parentElement.children;
                var cellIndex = (0, $15euW.DomHandler).index(cell);
                var nextCell = cells[event.which === 40 ? cellIndex + 3 : cellIndex - 3];
                if (nextCell) {
                    nextCell.tabIndex = "0";
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cell.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = "0";
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case "ArrowRight":
                cell.tabIndex = "-1";
                var _nextCell = cell.nextElementSibling;
                if (_nextCell) {
                    _nextCell.tabIndex = "0";
                    _nextCell.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "PageUp":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case "PageDown":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                if (props.view !== "month") viewChangedWithKeyDown.current = true;
                onMonthSelect(event, index);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                trapFocus(event);
                break;
        }
    };
    var onYearCellKeydown = function onYearCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case "ArrowUp":
            case "ArrowDown":
                cell.tabIndex = "-1";
                var cells = cell.parentElement.children;
                var cellIndex = (0, $15euW.DomHandler).index(cell);
                var nextCell = cells[event.code === "ArrowDown" ? cellIndex + 2 : cellIndex - 2];
                if (nextCell) {
                    nextCell.tabIndex = "0";
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cell.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = "0";
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case "ArrowRight":
                cell.tabIndex = "-1";
                var _nextCell2 = cell.nextElementSibling;
                if (_nextCell2) {
                    _nextCell2.tabIndex = "0";
                    _nextCell2.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "PageUp":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case "PageDown":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                if (props.view !== "year") viewChangedWithKeyDown.current = true;
                onYearSelect(event, index);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                trapFocus(event);
                break;
        }
    };
    var onDateSelect = function onDateSelect(event, dateMeta, timeMeta) {
        if (props.disabled || !dateMeta.selectable) {
            event.preventDefault();
            return;
        }
        (0, $15euW.DomHandler).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])').forEach(function(cell) {
            return cell.tabIndex = -1;
        });
        event.currentTarget.focus();
        if (isMultipleSelection()) {
            if (isSelected(dateMeta)) {
                var value = props.value.filter(function(date) {
                    return !isDateEquals(date, dateMeta);
                });
                updateModel(event, value);
                updateInputfield(value);
            } else if (!props.maxDateCount || !props.value || props.maxDateCount > props.value.length) selectDate(event, dateMeta, timeMeta);
        } else selectDate(event, dateMeta, timeMeta);
        if (!props.inline && isSingleSelection() && (!props.showTime || props.hideOnDateTimeSelect)) {
            setTimeout(function() {
                hide("dateselect");
            }, 100);
            if (touchUIMask.current) disableModality();
        }
        event.preventDefault();
    };
    var selectTime = function selectTime(date, timeMeta) {
        if (props.showTime) {
            var hours;
            var minutes;
            var seconds;
            var milliseconds;
            if (timeMeta) {
                hours = timeMeta.hours;
                minutes = timeMeta.minutes;
                seconds = timeMeta.seconds;
                milliseconds = timeMeta.milliseconds;
            } else {
                var time = getCurrentDateTime();
                var _ref2 = [
                    time.getHours(),
                    time.getMinutes(),
                    time.getSeconds(),
                    time.getMilliseconds()
                ];
                hours = _ref2[0];
                minutes = _ref2[1];
                seconds = _ref2[2];
                milliseconds = _ref2[3];
            }
            date.setHours(hours);
            date.setMinutes(doStepMinute(minutes));
            date.setSeconds(seconds);
            date.setMilliseconds(milliseconds);
        }
    };
    var selectDate = function selectDate(event, dateMeta, timeMeta) {
        var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
        selectTime(date, timeMeta);
        if (props.minDate && props.minDate > date) date = props.minDate;
        if (props.maxDate && props.maxDate < date) date = props.maxDate;
        var selectedValues = date;
        if (isSingleSelection()) updateModel(event, date);
        else if (isMultipleSelection()) {
            selectedValues = props.value ? [].concat($5ac3f498be1136b1$var$_toConsumableArray(props.value), [
                date
            ]) : [
                date
            ];
            updateModel(event, selectedValues);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                if (!endDate) {
                    if (date.getTime() >= startDate.getTime()) endDate = date;
                    else {
                        endDate = startDate;
                        startDate = date;
                    }
                } else {
                    startDate = date;
                    endDate = null;
                }
                selectedValues = [
                    startDate,
                    endDate
                ];
                updateModel(event, selectedValues);
                if (props.hideOnRangeSelection && endDate !== null) setTimeout(function() {
                    setOverlayVisibleState(false);
                }, 150);
            } else {
                selectedValues = [
                    date,
                    null
                ];
                updateModel(event, selectedValues);
            }
        }
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: date
        });
        updateInputfield(selectedValues);
    };
    var decrementDecade = function decrementDecade() {
        var _currentYear = currentYear - 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var incrementDecade = function incrementDecade() {
        var _currentYear = currentYear + 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var switchToMonthView = function switchToMonthView(event) {
        if (event && event.code && (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space")) viewChangedWithKeyDown.current = true;
        setCurrentView("month");
        event.preventDefault();
    };
    var switchToYearView = function switchToYearView(event) {
        if (event && event.code && (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space")) viewChangedWithKeyDown.current = true;
        setCurrentView("year");
        event.preventDefault();
    };
    var onMonthSelect = function onMonthSelect(event, month) {
        if (props.view === "month") {
            onDateSelect(event, {
                year: currentYear,
                month: month,
                day: 1,
                selectable: true
            });
            event.preventDefault();
        } else {
            setCurrentMonth(month);
            createMonthsMeta(month, currentYear);
            var currentDate = cloneDate(getCurrentDateTime());
            currentDate.setDate(1); // #2948 always set to 1st of month
            currentDate.setMonth(month);
            currentDate.setYear(currentYear);
            setViewDateState(currentDate);
            setCurrentView("date");
            props.onMonthChange && props.onMonthChange({
                month: month + 1,
                year: currentYear
            });
            updateViewDate(event, currentDate);
        }
    };
    var onYearSelect = function onYearSelect(event, year) {
        if (props.view === "year") onDateSelect(event, {
            year: year,
            month: 0,
            day: 1,
            selectable: true
        });
        else {
            setCurrentYear(year);
            setCurrentView("month");
            props.onMonthChange && props.onMonthChange({
                month: currentMonth + 1,
                year: year
            });
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) {
            var newValue = cloneDate(value);
            viewStateChanged.current = true;
            onChangeRef.current({
                originalEvent: event,
                value: newValue,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: newValue
                }
            });
        }
    };
    var show = function show(type) {
        if (props.onVisibleChange) props.onVisibleChange({
            visible: true,
            type: type
        });
        else {
            setOverlayVisibleState(true);
            overlayEventListener.current = function(e) {
                if (!isOutsideClicked(e)) isOverlayClicked.current = true;
            };
            (0, $9PD3x.OverlayService).on("overlay-click", overlayEventListener.current);
        }
    };
    var hide = function hide(type, callback) {
        var _hideCallback = function _hideCallback() {
            viewStateChanged.current = false;
            ignoreFocusFunctionality.current = false;
            isOverlayClicked.current = false;
            callback && callback();
            (0, $9PD3x.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        };
        props.touchUI && disableModality();
        if (props.onVisibleChange) props.onVisibleChange({
            visible: type !== "dateselect",
            // false only if selecting a value to close panel
            type: type,
            callback: _hideCallback
        });
        else {
            setOverlayVisibleState(false);
            _hideCallback();
        }
    };
    var onOverlayEnter = function onOverlayEnter() {
        var styles = props.touchUI ? {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        } : !props.inline ? {
            position: "absolute",
            top: "0",
            left: "0"
        } : undefined;
        (0, $15euW.DomHandler).addStyles(overlayRef.current, styles);
        if (props.autoZIndex) {
            var key = props.touchUI ? "modal" : "overlay";
            (0, $15euW.ZIndexUtils).set(key, overlayRef.current, context && context.autoZIndex || (0, $cFTyZ.default).autoZIndex, props.baseZIndex || context && context.zIndex[key] || (0, $cFTyZ.default).zIndex[key]);
        }
        if (!props.touchUI && overlayRef && overlayRef.current && inputRef && inputRef.current && !appendDisabled()) {
            var inputWidth = (0, $15euW.DomHandler).getOuterWidth(inputRef.current);
            // #5435 must have reasonable width if input is too small
            if (inputWidth < 220) inputWidth = 220;
            if (props.view === "date") overlayRef.current.style.width = (0, $15euW.DomHandler).getOuterWidth(overlayRef.current) + "px";
            else overlayRef.current.style.width = inputWidth + "px";
            // #5830 Tailwind does not need a min width it breaks the styling
            if (!isUnstyled()) overlayRef.current.style.minWidth = inputWidth + "px";
        }
        alignOverlay();
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
        setFocusedState(false);
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $15euW.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var appendDisabled = function appendDisabled() {
        var appendTo = props.appendTo || context && context.appendTo || (0, $cFTyZ.default).appendTo;
        return appendTo === "self" || props.inline;
    };
    var alignOverlay = function alignOverlay() {
        if (props.touchUI) enableModality();
        else if (overlayRef && overlayRef.current && inputRef && inputRef.current) {
            (0, $15euW.DomHandler).alignOverlay(overlayRef.current, inputRef.current, props.appendTo || context && context.appendTo || (0, $cFTyZ.default).appendTo);
            if (appendDisabled()) (0, $15euW.DomHandler).relativePosition(overlayRef.current, inputRef.current);
            else (0, $15euW.DomHandler).absolutePosition(overlayRef.current, inputRef.current);
        }
    };
    var enableModality = function enableModality() {
        if (!touchUIMask.current) {
            touchUIMask.current = document.createElement("div");
            touchUIMask.current.style.zIndex = String((0, $15euW.ZIndexUtils).get(overlayRef.current) - 1);
            !isUnstyled() && (0, $15euW.DomHandler).addMultipleClasses(touchUIMask.current, "p-component-overlay p-datepicker-mask p-datepicker-mask-scrollblocker p-component-overlay-enter");
            touchUIMaskClickListener.current = function() {
                disableModality();
                hide();
            };
            touchUIMask.current.addEventListener("click", touchUIMaskClickListener.current);
            document.body.appendChild(touchUIMask.current);
            (0, $15euW.DomHandler).blockBodyScroll();
        }
    };
    var disableModality = function disableModality() {
        if (touchUIMask.current) {
            if (isUnstyled) destroyMask();
            else {
                !isUnstyled() && (0, $15euW.DomHandler).addClass(touchUIMask.current, "p-component-overlay-leave");
                if ((0, $15euW.DomHandler).hasCSSAnimation(touchUIMask.current) > 0) touchUIMask.current.addEventListener("animationend", function() {
                    destroyMask();
                });
                else destroyMask();
            }
        }
    };
    var destroyMask = function destroyMask() {
        if (touchUIMask.current) {
            touchUIMask.current.removeEventListener("click", touchUIMaskClickListener.current);
            touchUIMaskClickListener.current = null;
            document.body.removeChild(touchUIMask.current);
            touchUIMask.current = null;
        }
        var bodyChildren = document.body.children;
        var hasBlockerMasks;
        for(var i = 0; i < bodyChildren.length; i++){
            var bodyChild = bodyChildren[i];
            if ((0, $15euW.DomHandler).hasClass(bodyChild, "p-datepicker-mask-scrollblocker")) {
                hasBlockerMasks = true;
                break;
            }
        }
        if (!hasBlockerMasks) (0, $15euW.DomHandler).unblockBodyScroll();
    };
    var isOutsideClicked = function isOutsideClicked(event) {
        return elementRef.current && !(elementRef.current.isSameNode(event.target) || isNavIconClicked(event.target) || elementRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var isNavIconClicked = function isNavIconClicked(target) {
        return previousButton.current && (previousButton.current.isSameNode(target) || previousButton.current.contains(target)) || nextButton.current && (nextButton.current.isSameNode(target) || nextButton.current.contains(target));
    };
    var getFirstDayOfMonthIndex = function getFirstDayOfMonthIndex(month, year) {
        var day = new Date();
        day.setDate(1);
        day.setMonth(month);
        day.setFullYear(year);
        var dayIndex = day.getDay() + getSundayIndex();
        return dayIndex >= 7 ? dayIndex - 7 : dayIndex;
    };
    var getDaysCountInMonth = function getDaysCountInMonth(month, year) {
        return 32 - daylightSavingAdjust(new Date(year, month, 32)).getDate();
    };
    var getDaysCountInPrevMonth = function getDaysCountInPrevMonth(month, year) {
        var prev = getPreviousMonthAndYear(month, year);
        return getDaysCountInMonth(prev.month, prev.year);
    };
    var daylightSavingAdjust = function daylightSavingAdjust(date) {
        if (!date) return null;
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
    };
    var getPreviousMonthAndYear = function getPreviousMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 0) {
            m = 11;
            y = year - 1;
        } else {
            m = month - 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getNextMonthAndYear = function getNextMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 11) {
            m = 0;
            y = year + 1;
        } else {
            m = month + 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getSundayIndex = function getSundayIndex() {
        var firstDayOfWeek = (0, $cFTyZ.localeOption)("firstDayOfWeek", props.locale);
        return firstDayOfWeek > 0 ? 7 - firstDayOfWeek : 0;
    };
    var createWeekDaysMeta = function createWeekDaysMeta() {
        var weekDays = [];
        var _localeOptions = (0, $cFTyZ.localeOptions)(props.locale), dayIndex = _localeOptions.firstDayOfWeek, dayNamesMin = _localeOptions.dayNamesMin;
        for(var i = 0; i < 7; i++){
            weekDays.push(dayNamesMin[dayIndex]);
            dayIndex = dayIndex === 6 ? 0 : ++dayIndex;
        }
        return weekDays;
    };
    var createMonthsMeta = function createMonthsMeta(month, year) {
        var months = [];
        for(var i = 0; i < props.numberOfMonths; i++){
            var m = month + i;
            var y = year;
            if (m > 11) {
                m = m % 11 - 1;
                y = year + 1;
            }
            months.push(createMonthMeta(m, y));
        }
        return months;
    };
    var createMonthMeta = function createMonthMeta(month, year) {
        var dates = [];
        var firstDay = getFirstDayOfMonthIndex(month, year);
        var daysLength = getDaysCountInMonth(month, year);
        var prevMonthDaysLength = getDaysCountInPrevMonth(month, year);
        var dayNo = 1;
        var today = new Date();
        var weekNumbers = [];
        var monthRows = Math.ceil((daysLength + firstDay) / 7);
        for(var i = 0; i < monthRows; i++){
            var week = [];
            if (i === 0) {
                for(var j = prevMonthDaysLength - firstDay + 1; j <= prevMonthDaysLength; j++){
                    var prev = getPreviousMonthAndYear(month, year);
                    week.push({
                        day: j,
                        month: prev.month,
                        year: prev.year,
                        otherMonth: true,
                        today: isToday(today, j, prev.month, prev.year),
                        selectable: isSelectable(j, prev.month, prev.year, true)
                    });
                }
                var remainingDaysLength = 7 - week.length;
                for(var _j = 0; _j < remainingDaysLength; _j++){
                    week.push({
                        day: dayNo,
                        month: month,
                        year: year,
                        today: isToday(today, dayNo, month, year),
                        selectable: isSelectable(dayNo, month, year, false)
                    });
                    dayNo++;
                }
            } else for(var _j2 = 0; _j2 < 7; _j2++){
                if (dayNo > daysLength) {
                    var next = getNextMonthAndYear(month, year);
                    week.push({
                        day: dayNo - daysLength,
                        month: next.month,
                        year: next.year,
                        otherMonth: true,
                        today: isToday(today, dayNo - daysLength, next.month, next.year),
                        selectable: isSelectable(dayNo - daysLength, next.month, next.year, true)
                    });
                } else week.push({
                    day: dayNo,
                    month: month,
                    year: year,
                    today: isToday(today, dayNo, month, year),
                    selectable: isSelectable(dayNo, month, year, false)
                });
                dayNo++;
            }
            if (props.showWeek) weekNumbers.push(getWeekNumber(new Date(week[0].year, week[0].month, week[0].day)));
            dates.push(week);
        }
        return {
            month: month,
            year: year,
            dates: dates,
            weekNumbers: weekNumbers
        };
    };
    var getWeekNumber = function getWeekNumber(date) {
        var checkDate = cloneDate(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
        var time = checkDate.getTime();
        checkDate.setMonth(0);
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
    };
    var isSelectable = function isSelectable(day, month, year, otherMonth) {
        var validMin = true;
        var validMax = true;
        var validDate = true;
        var validDay = true;
        var validMonth = true;
        if (props.minDate) {
            if (props.minDate.getFullYear() > year) validMin = false;
            else if (props.minDate.getFullYear() === year) {
                if (month > -1 && props.minDate.getMonth() > month) validMin = false;
                else if (month > -1 && props.minDate.getMonth() === month) {
                    if (day > 0 && props.minDate.getDate() > day) validMin = false;
                }
            }
        }
        if (props.maxDate) {
            if (props.maxDate.getFullYear() < year) validMax = false;
            else if (props.maxDate.getFullYear() === year) {
                if (month > -1 && props.maxDate.getMonth() < month) validMax = false;
                else if (month > -1 && props.maxDate.getMonth() === month) {
                    if (day > 0 && props.maxDate.getDate() < day) validMax = false;
                }
            }
        }
        if (props.disabledDates || props.enabledDates || props.disabledDays) validDay = !isDayDisabled(day, month, year);
        if (props.selectOtherMonths === false && otherMonth) validMonth = false;
        return validMin && validMax && validDate && validDay && validMonth;
    };
    var isSelectableTime = function isSelectableTime(value) {
        var validMin = true;
        var validMax = true;
        if (props.minDate && props.minDate.toDateString() === value.toDateString()) {
            if (props.minDate.getHours() > value.getHours()) validMin = false;
            else if (props.minDate.getHours() === value.getHours()) {
                if (props.minDate.getMinutes() > value.getMinutes()) validMin = false;
                else if (props.minDate.getMinutes() === value.getMinutes()) {
                    if (props.minDate.getSeconds() > value.getSeconds()) validMin = false;
                    else if (props.minDate.getSeconds() === value.getSeconds()) {
                        if (props.minDate.getMilliseconds() > value.getMilliseconds()) validMin = false;
                    }
                }
            }
        }
        if (props.maxDate && props.maxDate.toDateString() === value.toDateString()) {
            if (props.maxDate.getHours() < value.getHours()) validMax = false;
            else if (props.maxDate.getHours() === value.getHours()) {
                if (props.maxDate.getMinutes() < value.getMinutes()) validMax = false;
                else if (props.maxDate.getMinutes() === value.getMinutes()) {
                    if (props.maxDate.getSeconds() < value.getSeconds()) validMax = false;
                    else if (props.maxDate.getSeconds() === value.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < value.getMilliseconds()) validMax = false;
                    }
                }
            }
        }
        return validMin && validMax;
    };
    var isSelected = function isSelected(dateMeta) {
        if (props.value) {
            if (isSingleSelection()) return isDateEquals(props.value, dateMeta);
            else if (isMultipleSelection()) {
                var selected = false;
                var _iterator = $5ac3f498be1136b1$var$_createForOfIteratorHelper(props.value), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var date = _step.value;
                        selected = isDateEquals(date, dateMeta);
                        if (selected) break;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return selected;
            } else if (isRangeSelection()) {
                if (props.value[1]) return isDateEquals(props.value[0], dateMeta) || isDateEquals(props.value[1], dateMeta) || isDateBetween(props.value[0], props.value[1], dateMeta);
                return isDateEquals(props.value[0], dateMeta);
            }
        } else return false;
    };
    var isComparable = function isComparable() {
        return props.value != null && typeof props.value !== "string";
    };
    var isMonthSelected = function isMonthSelected(month) {
        if (isComparable()) {
            var value = isRangeSelection() ? props.value[0] : props.value;
            if (isMultipleSelection()) return value.some(function(currentValue) {
                return currentValue.getMonth() === month && currentValue.getFullYear() === currentYear;
            });
            return value.getMonth() === month && value.getFullYear() === currentYear;
        }
        return false;
    };
    var isYearSelected = function isYearSelected(year) {
        if (isComparable()) {
            var value = isRangeSelection() ? props.value[0] : props.value;
            if (isMultipleSelection()) return value.some(function(currentValue) {
                return currentValue.getFullYear() === year;
            });
            return value.getFullYear() === year;
        }
        return false;
    };
    var switchViewButtonDisabled = function switchViewButtonDisabled() {
        return props.numberOfMonths > 1 || props.disabled;
    };
    var isDateEquals = function isDateEquals(value, dateMeta) {
        if (value && value instanceof Date) return value.getDate() === dateMeta.day && value.getMonth() === dateMeta.month && value.getFullYear() === dateMeta.year;
        return false;
    };
    var isDateBetween = function isDateBetween(start, end, dateMeta) {
        var between = false;
        if (start && end) {
            var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
            return start.getTime() <= date.getTime() && end.getTime() >= date.getTime();
        }
        return between;
    };
    var isSingleSelection = function isSingleSelection() {
        return props.selectionMode === "single";
    };
    var isRangeSelection = function isRangeSelection() {
        return props.selectionMode === "range";
    };
    var isMultipleSelection = function isMultipleSelection() {
        return props.selectionMode === "multiple";
    };
    var isToday = function isToday(today, day, month, year) {
        return today.getDate() === day && today.getMonth() === month && today.getFullYear() === year;
    };
    var isDayDisabled = function isDayDisabled(day, month, year) {
        var isDisabled = false;
        // first check for disabled dates
        if (props.disabledDates) {
            if (props.disabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            })) isDisabled = true;
        }
        // next if not disabled then check for disabled days
        if (!isDisabled && props.disabledDays && currentView === "date") {
            var weekday = new Date(year, month, day);
            var weekdayNumber = weekday.getDay();
            if (props.disabledDays.indexOf(weekdayNumber) !== -1) isDisabled = true;
        }
        // last check for enabled dates to force dates enabled
        if (props.enabledDates) {
            var isEnabled = props.enabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            });
            if (isEnabled) isDisabled = false;
            else if (!props.disabledDays && !props.disabledDates) // disable other dates when only enabledDates are present
            isDisabled = true;
        }
        return isDisabled;
    };
    var isMonthYearDisabled = function isMonthYearDisabled(month, year) {
        var daysCountInAllMonth = month === -1 ? new Array(12).fill(0).map(function(_, i) {
            return getDaysCountInMonth(i, year);
        }) : [
            getDaysCountInMonth(month, year)
        ];
        for(var i = 0; i < daysCountInAllMonth.length; i++){
            var monthDays = daysCountInAllMonth[i];
            var _month = month === -1 ? i : month;
            for(var day = 1; day <= monthDays; day++){
                var isDateSelectable = isSelectable(day, _month, year);
                if (isDateSelectable) return false;
            }
        }
        return true;
    };
    var updateInputfield = function updateInputfield(value) {
        if (!inputRef.current) return;
        var formattedValue = "";
        if (value) try {
            if (isSingleSelection()) formattedValue = isValidDate(value) ? formatDateTime(value) : props.keepInvalid ? value : "";
            else if (isMultipleSelection()) for(var i = 0; i < value.length; i++){
                var selectedValue = value[i];
                var dateAsString = isValidDate(selectedValue) ? formatDateTime(selectedValue) : "";
                formattedValue = formattedValue + dateAsString;
                if (i !== value.length - 1) formattedValue = formattedValue + ", ";
            }
            else if (isRangeSelection()) {
                if (value && value.length) {
                    var startDate = value[0];
                    var endDate = value[1];
                    formattedValue = isValidDate(startDate) ? formatDateTime(startDate) : "";
                    if (endDate) formattedValue = formattedValue + (isValidDate(endDate) ? " - " + formatDateTime(endDate) : "");
                }
            }
        } catch (err) {
            formattedValue = value;
        }
        inputRef.current.value = formattedValue;
    };
    var formatDateTime = function formatDateTime(date) {
        if (props.formatDateTime) return props.formatDateTime(date);
        var formattedValue = null;
        if (date) {
            if (props.timeOnly) formattedValue = formatTime(date);
            else {
                formattedValue = formatDate(date, getDateFormat());
                if (props.showTime) formattedValue = formattedValue + (" " + formatTime(date));
            }
        }
        return formattedValue;
    };
    var formatDate = function formatDate(date, format) {
        if (!date) return "";
        var iFormat;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var formatNumber = function formatNumber(match, value, len) {
            var num = "" + value;
            if (lookAhead(match)) while(num.length < len)num = "0" + num;
            return num;
        };
        var formatName = function formatName(match, value, shortNames, longNames) {
            return lookAhead(match) ? longNames[value] : shortNames[value];
        };
        var output = "";
        var literal = false;
        var _localeOptions2 = (0, $cFTyZ.localeOptions)(props.locale), dayNamesShort = _localeOptions2.dayNamesShort, dayNames = _localeOptions2.dayNames, monthNamesShort = _localeOptions2.monthNamesShort, monthNames = _localeOptions2.monthNames;
        if (date) {
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else output = output + format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case "d":
                    output = output + formatNumber("d", date.getDate(), 2);
                    break;
                case "D":
                    output = output + formatName("D", date.getDay(), dayNamesShort, dayNames);
                    break;
                case "o":
                    output = output + formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                    break;
                case "m":
                    output = output + formatNumber("m", date.getMonth() + 1, 2);
                    break;
                case "M":
                    output = output + formatName("M", date.getMonth(), monthNamesShort, monthNames);
                    break;
                case "y":
                    output = output + (lookAhead("y") ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100);
                    break;
                case "@":
                    output = output + date.getTime();
                    break;
                case "!":
                    output = output + (date.getTime() * 10000 + ticksTo1970);
                    break;
                case "'":
                    if (lookAhead("'")) output = output + "'";
                    else literal = true;
                    break;
                default:
                    output = output + format.charAt(iFormat);
            }
        }
        return output;
    };
    var formatTime = function formatTime(date) {
        if (!date) return "";
        var output = "";
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var milliseconds = date.getMilliseconds();
        if (props.hourFormat === "12" && hours > 11 && hours !== 12) hours = hours - 12;
        if (props.hourFormat === "12") output = output + (hours === 0 ? 12 : hours < 10 ? "0" + hours : hours);
        else output = output + (hours < 10 ? "0" + hours : hours);
        output = output + ":";
        output = output + (minutes < 10 ? "0" + minutes : minutes);
        if (props.showSeconds) {
            output = output + ":";
            output = output + (seconds < 10 ? "0" + seconds : seconds);
        }
        if (props.showMillisec) {
            output = output + ".";
            output = output + (milliseconds < 100 ? (milliseconds < 10 ? "00" : "0") + milliseconds : milliseconds);
        }
        if (props.hourFormat === "12") output = output + (date.getHours() > 11 ? " PM" : " AM");
        return output;
    };
    var parseValueFromString = function parseValueFromString(text) {
        if (!text || text.trim().length === 0) return null;
        var value;
        if (isSingleSelection()) value = parseDateTime(text);
        else if (isMultipleSelection()) {
            var tokens = text.split(",");
            value = [];
            var _iterator2 = $5ac3f498be1136b1$var$_createForOfIteratorHelper(tokens), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var token = _step2.value;
                    value.push(parseDateTime(token.trim()));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } else if (isRangeSelection()) {
            var _tokens = text.split(" - ");
            value = [];
            for(var i = 0; i < _tokens.length; i++)value[i] = parseDateTime(_tokens[i].trim());
        }
        return value;
    };
    var parseDateTime = function parseDateTime(text) {
        if (props.parseDateTime) return props.parseDateTime(text);
        var date;
        var parts = text.split(" ");
        if (props.timeOnly) {
            date = new Date();
            populateTime(date, parts[0], parts[1]);
        } else if (props.showTime) {
            date = parseDate(parts[0], getDateFormat());
            populateTime(date, parts[1], parts[2]);
        } else date = parseDate(text, getDateFormat());
        return date;
    };
    var populateTime = function populateTime(value, timeString, ampm) {
        if (props.hourFormat === "12" && ampm !== "PM" && ampm !== "AM") throw new Error("Invalid Time");
        var time = parseTime(timeString, ampm);
        value.setHours(time.hour);
        value.setMinutes(time.minute);
        value.setSeconds(time.second);
        value.setMilliseconds(time.millisecond);
    };
    var parseTime = function parseTime(value, ampm) {
        value = props.showMillisec ? value.replace(".", ":") : value;
        var tokens = value.split(":");
        var validTokenLength = props.showSeconds ? 3 : 2;
        validTokenLength = props.showMillisec ? validTokenLength + 1 : validTokenLength;
        if (tokens.length !== validTokenLength || tokens[0].length !== 2 || tokens[1].length !== 2 || props.showSeconds && tokens[2].length !== 2 || props.showMillisec && tokens[3].length !== 3) throw new Error("Invalid time");
        var h = parseInt(tokens[0], 10);
        var m = parseInt(tokens[1], 10);
        var s = props.showSeconds ? parseInt(tokens[2], 10) : null;
        var ms = props.showMillisec ? parseInt(tokens[3], 10) : null;
        if (isNaN(h) || isNaN(m) || h > 23 || m > 59 || props.hourFormat === "12" && h > 12 || props.showSeconds && (isNaN(s) || s > 59) || props.showMillisec && (isNaN(s) || s > 1000)) throw new Error("Invalid time");
        else {
            if (props.hourFormat === "12") {
                if (h !== 12 && ampm === "PM") h = h + 12;
                if (h === 12 && ampm === "AM") h = h - 12;
            }
            return {
                hour: h,
                minute: m,
                second: s,
                millisecond: ms
            };
        }
    };
    // Ported from jquery-ui datepicker parseDate
    var parseDate = function parseDate(value, format) {
        if (format == null || value == null) throw new Error("Invalid arguments");
        value = $5ac3f498be1136b1$var$_typeof(value) === "object" ? value.toString() : value + "";
        if (value === "") return null;
        var iFormat;
        var dim;
        var extra;
        var iValue = 0;
        var shortYearCutoff = typeof props.shortYearCutoff !== "string" ? props.shortYearCutoff : new Date().getFullYear() % 100 + parseInt(props.shortYearCutoff, 10);
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var literal = false;
        var date;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var getNumber = function getNumber(match) {
            var isDoubled = lookAhead(match);
            var size = match === "@" ? 14 : match === "!" ? 20 : match === "y" && isDoubled ? 4 : match === "o" ? 3 : 2;
            var minSize = match === "y" ? size : 1;
            var digits = new RegExp("^\\d{" + minSize + "," + size + "}");
            var num = value.substring(iValue).match(digits);
            if (!num) throw new Error("Missing number at position " + iValue);
            iValue = iValue + num[0].length;
            return parseInt(num[0], 10);
        };
        var getName = function getName(match, shortNames, longNames) {
            var index = -1;
            var arr = lookAhead(match) ? longNames : shortNames;
            var names = [];
            for(var i = 0; i < arr.length; i++)names.push([
                i,
                arr[i]
            ]);
            names.sort(function(a, b) {
                return -(a[1].length - b[1].length);
            });
            for(var _i = 0; _i < names.length; _i++){
                var name = names[_i][1];
                if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                    index = names[_i][0];
                    iValue = iValue + name.length;
                    break;
                }
            }
            if (index !== -1) return index + 1;
            throw new Error("Unknown name at position " + iValue);
        };
        var checkLiteral = function checkLiteral() {
            if (value.charAt(iValue) !== format.charAt(iFormat)) throw new Error("Unexpected literal at position " + iValue);
            iValue++;
        };
        if (props.view === "month") day = 1;
        if (props.view === "year") {
            day = 1;
            month = 1;
        }
        var _localeOptions3 = (0, $cFTyZ.localeOptions)(props.locale), dayNamesShort = _localeOptions3.dayNamesShort, dayNames = _localeOptions3.dayNames, monthNamesShort = _localeOptions3.monthNamesShort, monthNames = _localeOptions3.monthNames;
        for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
            if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
            else checkLiteral();
        } else switch(format.charAt(iFormat)){
            case "d":
                day = getNumber("d");
                break;
            case "D":
                getName("D", dayNamesShort, dayNames);
                break;
            case "o":
                doy = getNumber("o");
                break;
            case "m":
                month = getNumber("m");
                break;
            case "M":
                month = getName("M", monthNamesShort, monthNames);
                break;
            case "y":
                year = getNumber("y");
                break;
            case "@":
                date = new Date(getNumber("@"));
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "!":
                date = new Date((getNumber("!") - ticksTo1970) / 10000);
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "'":
                if (lookAhead("'")) checkLiteral();
                else literal = true;
                break;
            default:
                checkLiteral();
        }
        if (iValue < value.length) {
            extra = value.substr(iValue);
            if (!/^\s+/.test(extra)) throw new Error("Extra/unparsed characters found in date: " + extra);
        }
        if (year === -1) year = new Date().getFullYear();
        else if (year < 100) year = year + (new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100));
        if (doy > -1) {
            month = 1;
            day = doy;
            do {
                dim = getDaysCountInMonth(year, month - 1);
                if (day <= dim) break;
                month++;
                day = day - dim;
            }while (true);
        }
        date = daylightSavingAdjust(new Date(year, month - 1, day));
        if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) throw new Error("Invalid date"); // E.g. 31/02/00
        return date;
    };
    var isInMinYear = function isInMinYear(viewDate) {
        return props.minDate && props.minDate.getFullYear() === viewDate.getFullYear();
    };
    var isInMaxYear = function isInMaxYear(viewDate) {
        return props.maxDate && props.maxDate.getFullYear() === viewDate.getFullYear();
    };
    $6uMv9.useEffect(function() {
        (0, $15euW.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $8Mqhq.useMountEffect)(function() {
        var viewDate = getViewDate(props.viewDate);
        validateDate(viewDate);
        setViewDateState(viewDate);
        setCurrentMonth(viewDate.getMonth());
        setCurrentYear(viewDate.getFullYear());
        setCurrentView(props.view);
        if (!idState) {
            var uniqueId = (0, $15euW.UniqueComponentId)();
            !idState && setIdState(uniqueId);
        }
        if (props.inline) {
            overlayRef && overlayRef.current.setAttribute(attributeSelector, "");
            if (!props.disabled) {
                initFocusableCell();
                if (props.numberOfMonths === 1) overlayRef.current.style.width = (0, $15euW.DomHandler).getOuterWidth(overlayRef.current) + "px";
            }
        }
        if (props.value) {
            updateInputfield(props.value);
            setValue(props.value);
        }
        if (props.autoFocus) // delay showing until rendered so `alignPanel()` method aligns the popup in the right location
        setTimeout(function() {
            return (0, $15euW.DomHandler).focus(inputRef.current, props.autoFocus);
        }, 200);
    });
    $6uMv9.useEffect(function() {
        // see https://github.com/primefaces/primereact/issues/4030
        onChangeRef.current = props.onChange;
    }, [
        props.onChange
    ]);
    $6uMv9.useEffect(function() {
        var unbindMaskEvents = null;
        if (props.mask) unbindMaskEvents = (0, $15euW.mask)(inputRef.current, {
            mask: props.mask,
            slotChar: props.maskSlotChar,
            readOnly: props.readOnlyInput || props.disabled,
            onChange: function onChange(e) {
                updateValueOnInput(e.originalEvent, e.value, function() {
                    return false;
                });
            },
            onBlur: function onBlur(e) {
                updateValueOnInput(e, e.target.value);
            }
        }).unbindEvents;
        return function() {
            props.mask && unbindMaskEvents && unbindMaskEvents();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.disabled,
        props.mask,
        props.readOnlyInput
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        if (viewChangedWithKeyDown.current) setCurrentView(props.view);
        viewChangedWithKeyDown.current = false;
    }, [
        props.view
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        focusToFirstCell();
    }, [
        currentView
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        if (!props.onViewDateChange && !viewStateChanged.current) setValue(props.value);
        if (props.viewDate) updateViewDate(null, getViewDate(props.viewDate));
    }, [
        props.onViewDateChange,
        props.value,
        props.viewDate
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        if (overlayVisibleState || props.visible) // Github #5529
        setTimeout(function() {
            alignOverlay();
        });
    }, [
        currentView,
        overlayVisibleState,
        props.visible
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        var newDate = props.value;
        if (previousValue !== newDate) {
            if (!isTypingRef.current) updateInputfield(newDate);
            isTypingRef.current = false;
            // #3516 view date not updated when value set programatically
            if (!visible && newDate) {
                var viewDate = newDate;
                if (isMultipleSelection()) {
                    if (newDate.length) viewDate = newDate[newDate.length - 1];
                } else if (isRangeSelection()) {
                    if (newDate.length) {
                        var startDate = newDate[0];
                        var endDate = newDate[1];
                        viewDate = endDate || startDate;
                    }
                }
                if (viewDate instanceof Date) {
                    validateDate(viewDate);
                    setViewDateState(viewDate);
                    setCurrentMonth(viewDate.getMonth());
                    setCurrentYear(viewDate.getFullYear());
                }
            }
        }
    }, [
        props.value,
        visible
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        updateInputfield(props.value);
    }, [
        props.dateFormat,
        props.hourFormat,
        props.timeOnly,
        props.showSeconds,
        props.showMillisec,
        props.showTime,
        props.locale
    ]);
    (0, $8Mqhq.useUpdateEffect)(function() {
        if (overlayRef.current) {
            setNavigationState(viewDateState);
            updateFocus();
        }
    });
    (0, $8Mqhq.useUnmountEffect)(function() {
        if (touchUIMask.current) {
            disableModality();
            touchUIMask.current = null;
        }
        (0, $15euW.ZIndexUtils).clear(overlayRef.current);
    });
    $6uMv9.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getCurrentDateTime: getCurrentDateTime,
            getViewDate: getViewDate,
            updateViewDate: updateViewDate,
            focus: function focus() {
                return (0, $15euW.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    var setValue = function setValue(propValue) {
        if (Array.isArray(propValue)) propValue = propValue[0];
        var prevPropValue = previousValue;
        if (Array.isArray(prevPropValue)) prevPropValue = prevPropValue[0];
        var viewDate = props.viewDate && isValidDate(props.viewDate) ? props.viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
        if (isClearClicked.current && props.showTime) {
            viewDate.setHours(0, 0, 0);
            isClearClicked.current = false;
        }
        if (!prevPropValue && propValue || propValue && propValue instanceof Date && propValue.getTime() !== prevPropValue.getTime()) validateDate(viewDate);
        setViewDateState(viewDate);
        viewStateChanged.current = true;
    };
    var createBackwardNavigator = function createBackwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onPrevButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: "hidden"
            }
        };
        var previousIconProps = mergeProps({
            className: cx("previousIcon")
        }, ptm("previousIcon"));
        var icon = props.prevIcon || /*#__PURE__*/ $6uMv9.createElement((0, $7Vzgo.ChevronLeftIcon), previousIconProps);
        var backwardNavigatorIcon = (0, $15euW.IconUtils).getJSXIcon(icon, $5ac3f498be1136b1$var$_objectSpread({}, previousIconProps), {
            props: props
        });
        var _localeOptions4 = (0, $cFTyZ.localeOptions)(props.locale), prevDecade = _localeOptions4.prevDecade, prevYear = _localeOptions4.prevYear, prevMonth = _localeOptions4.prevMonth;
        var previousButtonLabel = currentView === "year" ? prevDecade : currentView === "month" ? prevYear : prevMonth;
        var previousButtonProps = mergeProps($5ac3f498be1136b1$var$_objectSpread({
            type: "button",
            className: cx("previousButton"),
            "aria-label": previousButtonLabel
        }, navigatorProps), ptm("previousButton"));
        return /*#__PURE__*/ $6uMv9.createElement("button", $5ac3f498be1136b1$var$_extends({
            ref: previousButton
        }, previousButtonProps), backwardNavigatorIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null));
    };
    var createForwardNavigator = function createForwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onNextButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: "hidden"
            }
        };
        var nextIconProps = mergeProps({
            className: cx("nextIcon")
        }, ptm("nextIcon"));
        var icon = props.nextIcon || /*#__PURE__*/ $6uMv9.createElement((0, $jeibK.ChevronRightIcon), nextIconProps);
        var forwardNavigatorIcon = (0, $15euW.IconUtils).getJSXIcon(icon, $5ac3f498be1136b1$var$_objectSpread({}, nextIconProps), {
            props: props
        });
        var _localeOptions5 = (0, $cFTyZ.localeOptions)(props.locale), nextDecade = _localeOptions5.nextDecade, nextYear = _localeOptions5.nextYear, nextMonth = _localeOptions5.nextMonth;
        var nextButtonLabel = currentView === "year" ? nextDecade : currentView === "month" ? nextYear : nextMonth;
        var nextButtonProps = mergeProps($5ac3f498be1136b1$var$_objectSpread({
            type: "button",
            className: cx("nextButton"),
            "aria-label": nextButtonLabel
        }, navigatorProps), ptm("nextButton"));
        return /*#__PURE__*/ $6uMv9.createElement("button", $5ac3f498be1136b1$var$_extends({
            ref: nextButton
        }, nextButtonProps), forwardNavigatorIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null));
    };
    var renderMonthsNavigator = function renderMonthsNavigator(index) {
        return props.monthNavigator && props.view !== "month" && (props.numberOfMonths === 1 || index === 0);
    };
    var createTitleMonthElement = function createTitleMonthElement(month, monthIndex) {
        var monthNames = (0, $cFTyZ.localeOption)("monthNames", props.locale);
        if (renderMonthsNavigator(monthIndex)) {
            var viewDate = getViewDate();
            var viewMonth = viewDate.getMonth();
            var displayedMonthOptions = monthNames.map(function(month, index) {
                return (!isInMinYear(viewDate) || index >= props.minDate.getMonth()) && (!isInMaxYear(viewDate) || index <= props.maxDate.getMonth()) ? {
                    label: month,
                    value: index,
                    index: index
                } : null;
            }).filter(function(option) {
                return !!option;
            });
            var displayedMonthNames = displayedMonthOptions.map(function(option) {
                return option.label;
            });
            var selectProps = mergeProps({
                className: cx("select"),
                onChange: function onChange(e) {
                    return onMonthDropdownChange(e, e.target.value);
                },
                value: viewMonth
            }, ptm("select"));
            var _content = /*#__PURE__*/ $6uMv9.createElement("select", selectProps, displayedMonthOptions.map(function(option) {
                var optionProps = mergeProps({
                    value: option.value
                }, ptm("option"));
                return /*#__PURE__*/ $6uMv9.createElement("option", $5ac3f498be1136b1$var$_extends({}, optionProps, {
                    key: option.label
                }), option.label);
            }));
            if (props.monthNavigatorTemplate) {
                var defaultContentOptions = {
                    onChange: onMonthDropdownChange,
                    className: "p-datepicker-month",
                    value: viewMonth,
                    names: displayedMonthNames,
                    options: displayedMonthOptions,
                    element: _content,
                    props: props
                };
                return (0, $15euW.ObjectUtils).getJSXElement(props.monthNavigatorTemplate, defaultContentOptions);
            }
            return _content;
        }
        var monthTitleProps = mergeProps({
            className: cx("monthTitle"),
            onKeyDown: onContainerButtonKeydown,
            "aria-label": (0, $cFTyZ.localeOption)("chooseMonth", props.locale),
            onClick: switchToMonthView,
            disabled: switchViewButtonDisabled()
        }, ptm("monthTitle"));
        return currentView === "date" && /*#__PURE__*/ $6uMv9.createElement("button", monthTitleProps, monthNames[month]);
    };
    var createTitleYearElement = function createTitleYearElement(metaYear) {
        var viewDate = getViewDate();
        var viewYear = viewDate.getFullYear();
        var displayYear = props.numberOfMonths > 1 ? metaYear : currentYear;
        if (props.yearNavigator) {
            var _yearOptions2 = [];
            if (props.yearRange) {
                var years = props.yearRange.split(":");
                var yearStart = parseInt(years[0], 10);
                var yearEnd = parseInt(years[1], 10);
                for(var i = yearStart; i <= yearEnd; i++)_yearOptions2.push(i);
            } else {
                var base = viewYear - viewYear % 10;
                for(var _i2 = 0; _i2 < 10; _i2++)_yearOptions2.push(base + _i2);
            }
            var displayedYearNames = _yearOptions2.filter(function(year) {
                return !(props.minDate && props.minDate.getFullYear() > year) && !(props.maxDate && props.maxDate.getFullYear() < year);
            });
            var selectProps = mergeProps({
                className: cx("select"),
                onChange: function onChange(e) {
                    return onYearDropdownChange(e, e.target.value);
                },
                value: displayYear
            }, ptm("select"));
            var _content2 = /*#__PURE__*/ $6uMv9.createElement("select", selectProps, displayedYearNames.map(function(year) {
                var optionProps = mergeProps({
                    value: year
                }, ptm("option"));
                return /*#__PURE__*/ $6uMv9.createElement("option", $5ac3f498be1136b1$var$_extends({}, optionProps, {
                    key: year
                }), year);
            }));
            if (props.yearNavigatorTemplate) {
                var options = displayedYearNames.map(function(name, i) {
                    return {
                        label: name,
                        value: name,
                        index: i
                    };
                });
                var defaultContentOptions = {
                    onChange: onYearDropdownChange,
                    className: "p-datepicker-year",
                    value: viewYear,
                    names: displayedYearNames,
                    options: options,
                    element: _content2,
                    props: props
                };
                return (0, $15euW.ObjectUtils).getJSXElement(props.yearNavigatorTemplate, defaultContentOptions);
            }
            return _content2;
        }
        var yearTitleProps = mergeProps({
            className: cx("yearTitle"),
            "aria-label": (0, $cFTyZ.localeOption)("chooseYear", props.locale),
            onClick: function onClick(e) {
                return switchToYearView(e);
            },
            disabled: switchViewButtonDisabled()
        }, ptm("yearTitle"));
        return currentView !== "year" && /*#__PURE__*/ $6uMv9.createElement("button", yearTitleProps, displayYear);
    };
    var createTitleDecadeElement = function createTitleDecadeElement() {
        var years = yearPickerValues();
        var decadeTitleProps = mergeProps({
            className: cx("decadeTitle")
        }, ptm("decadeTitle"));
        if (currentView === "year") {
            var decadeTitleTextProps = mergeProps(ptm("decadeTitleText"));
            return /*#__PURE__*/ $6uMv9.createElement("span", decadeTitleProps, props.decadeTemplate ? props.decadeTemplate(years) : /*#__PURE__*/ $6uMv9.createElement("span", decadeTitleTextProps, "".concat(yearPickerValues()[0], " - ").concat(yearPickerValues()[yearPickerValues().length - 1])));
        }
        return null;
    };
    var createTitle = function createTitle(monthMetaData, index) {
        var month = createTitleMonthElement(monthMetaData.month, index);
        var year = createTitleYearElement(monthMetaData.year);
        var decade = createTitleDecadeElement();
        var titleProps = mergeProps({
            className: cx("title")
        }, ptm("title"));
        var showMonthAfterYear = (0, $cFTyZ.localeOption)("showMonthAfterYear", props.locale);
        return /*#__PURE__*/ $6uMv9.createElement("div", titleProps, showMonthAfterYear ? year : month, showMonthAfterYear ? month : year, decade);
    };
    var createDayNames = function createDayNames(weekDays) {
        var weekDayProps = mergeProps(ptm("weekDay"));
        var tableHeaderCellProps = mergeProps({
            scope: "col"
        }, ptm("tableHeaderCell"));
        var dayNames = weekDays.map(function(weekDay, index) {
            return /*#__PURE__*/ $6uMv9.createElement("th", $5ac3f498be1136b1$var$_extends({}, tableHeaderCellProps, {
                key: "".concat(weekDay, "-").concat(index)
            }), /*#__PURE__*/ $6uMv9.createElement("span", weekDayProps, weekDay));
        });
        if (props.showWeek) {
            var weekHeaderProps = mergeProps({
                scope: "col",
                className: cx("weekHeader"),
                "data-p-disabled": props.showWeek
            }, ptm("weekHeader", {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekLabel = mergeProps(ptm("weekLabel"));
            var weekHeader = /*#__PURE__*/ $6uMv9.createElement("th", $5ac3f498be1136b1$var$_extends({}, weekHeaderProps, {
                key: "wn"
            }), /*#__PURE__*/ $6uMv9.createElement("span", weekLabel, (0, $cFTyZ.localeOption)("weekHeader", props.locale)));
            return [
                weekHeader
            ].concat($5ac3f498be1136b1$var$_toConsumableArray(dayNames));
        }
        return dayNames;
    };
    var createDateCellContent = function createDateCellContent(date, className, groupIndex) {
        var content = props.dateTemplate ? props.dateTemplate(date) : date.day;
        var selected = isSelected(date);
        var dayLabelProps = mergeProps({
            className: cx("dayLabel", {
                className: className
            }),
            "aria-selected": selected,
            "aria-disabled": !date.selectable,
            onClick: function onClick(e) {
                return onDateSelect(e, date);
            },
            onKeyDown: function onKeyDown(e) {
                return onDateCellKeydown(e, date, groupIndex);
            },
            "data-p-highlight": selected,
            "data-p-disabled": !date.selectable
        }, ptm("dayLabel", {
            context: {
                selected: selected,
                disabled: !date.selectable
            }
        }));
        return /*#__PURE__*/ $6uMv9.createElement("span", dayLabelProps, content, selected && /*#__PURE__*/ $6uMv9.createElement("div", {
            "aria-live": "polite",
            className: "p-hidden-accessible",
            "data-p-hidden-accessible": true,
            pt: ptm("hiddenSelectedDay")
        }));
    };
    var createWeek = function createWeek(weekDates, weekNumber, groupIndex) {
        var week = weekDates.map(function(date) {
            var selected = isSelected(date);
            var dateClassName = (0, $15euW.classNames)({
                "p-highlight": selected,
                "p-disabled": !date.selectable
            });
            var content = date.otherMonth && !props.showOtherMonths ? null : createDateCellContent(date, dateClassName, groupIndex);
            var dayProps = mergeProps({
                className: cx("day", {
                    date: date
                }),
                "aria-label": date.day,
                "data-p-today": date.today,
                "data-p-other-month": date.otherMonth
            }, ptm("day", {
                context: {
                    date: date,
                    today: date.today,
                    otherMonth: date.otherMonth
                }
            }));
            return /*#__PURE__*/ $6uMv9.createElement("td", $5ac3f498be1136b1$var$_extends({}, dayProps, {
                key: date.day
            }), content);
        });
        if (props.showWeek) {
            var weekNumberProps = mergeProps({
                className: cx("weekNumber")
            }, ptm("weekNumber"));
            var weekLabelContainerProps = mergeProps({
                className: cx("weekLabelContainer"),
                "data-p-disabled": props.showWeek
            }, ptm("weekLabelContainer", {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekNumberCell = /*#__PURE__*/ $6uMv9.createElement("td", $5ac3f498be1136b1$var$_extends({}, weekNumberProps, {
                key: "wn" + weekNumber
            }), /*#__PURE__*/ $6uMv9.createElement("span", weekLabelContainerProps, weekNumber));
            return [
                weekNumberCell
            ].concat($5ac3f498be1136b1$var$_toConsumableArray(week));
        }
        return week;
    };
    var createDates = function createDates(monthMetaData, groupIndex) {
        var tableBodyRowProps = mergeProps(ptm("tableBodyRowProps"));
        return monthMetaData.dates.map(function(weekDates, index) {
            return /*#__PURE__*/ $6uMv9.createElement("tr", $5ac3f498be1136b1$var$_extends({}, tableBodyRowProps, {
                key: index
            }), createWeek(weekDates, monthMetaData.weekNumbers[index], groupIndex));
        });
    };
    var createDateViewGrid = function createDateViewGrid(monthMetaData, weekDays, groupIndex) {
        var dayNames = createDayNames(weekDays);
        var dates = createDates(monthMetaData, groupIndex);
        var containerProps = mergeProps({
            className: cx("container"),
            key: (0, $15euW.UniqueComponentId)("calendar_container_")
        }, ptm("container"));
        var tableProps = mergeProps({
            role: "grid",
            className: cx("table")
        }, ptm("table"));
        var tableHeaderProps = mergeProps(ptm("tableHeader"));
        var tableHeaderRowProps = mergeProps(ptm("tableHeaderRow"));
        var tableBodyProps = mergeProps(ptm("tableBody"));
        return currentView === "date" && /*#__PURE__*/ $6uMv9.createElement("div", containerProps, /*#__PURE__*/ $6uMv9.createElement("table", tableProps, /*#__PURE__*/ $6uMv9.createElement("thead", tableHeaderProps, /*#__PURE__*/ $6uMv9.createElement("tr", tableHeaderRowProps, dayNames)), /*#__PURE__*/ $6uMv9.createElement("tbody", tableBodyProps, dates)));
    };
    var createMonth = function createMonth(monthMetaData, index) {
        var weekDays = createWeekDaysMeta();
        var backwardNavigator = createBackwardNavigator(index === 0);
        var forwardNavigator = createForwardNavigator(props.numberOfMonths === 1 || index === props.numberOfMonths - 1);
        var title = createTitle(monthMetaData, index);
        var dateViewGrid = createDateViewGrid(monthMetaData, weekDays, index);
        var header = props.headerTemplate ? props.headerTemplate() : null;
        var monthKey = monthMetaData.month + "-" + monthMetaData.year;
        var groupProps = mergeProps({
            className: cx("group")
        }, ptm("group"));
        var headerProps = mergeProps({
            className: cx("header"),
            key: index
        }, ptm("header"));
        return /*#__PURE__*/ $6uMv9.createElement("div", $5ac3f498be1136b1$var$_extends({}, groupProps, {
            key: monthKey
        }), /*#__PURE__*/ $6uMv9.createElement("div", headerProps, header, backwardNavigator, title, forwardNavigator), dateViewGrid);
    };
    var createMonths = function createMonths(monthsMetaData) {
        var groups = monthsMetaData.map(createMonth);
        var groupContainerProps = mergeProps({
            className: cx("groupContainer")
        }, ptm("groupContainer"));
        return /*#__PURE__*/ $6uMv9.createElement("div", groupContainerProps, groups);
    };
    var createDateView = function createDateView() {
        var viewDate = getViewDate();
        var monthsMetaData = createMonthsMeta(viewDate.getMonth(), viewDate.getFullYear());
        var months = createMonths(monthsMetaData);
        return months;
    };
    var monthPickerValues = function monthPickerValues() {
        var monthPickerValues = [];
        var monthNamesShort = (0, $cFTyZ.localeOption)("monthNamesShort", props.locale);
        for(var i = 0; i <= 11; i++)monthPickerValues.push(monthNamesShort[i]);
        return monthPickerValues;
    };
    var yearPickerValues = function yearPickerValues() {
        var yearPickerValues = [];
        var base = currentYear - currentYear % 10;
        for(var i = 0; i < 10; i++)yearPickerValues.push(base + i);
        return yearPickerValues;
    };
    var createMonthYearView = function createMonthYearView() {
        var backwardNavigator = createBackwardNavigator(true);
        var forwardNavigator = createForwardNavigator(true);
        var yearElement = createTitleYearElement(getViewDate().getFullYear());
        var decade = createTitleDecadeElement();
        var groupContainerProps = mergeProps({
            className: cx("groupContainer")
        }, ptm("groupContainer"));
        var groupProps = mergeProps({
            className: cx("group")
        }, ptm("group"));
        var headerProps = mergeProps({
            className: cx("header")
        }, ptm("header"));
        var titleProps = mergeProps({
            className: cx("title")
        }, ptm("title"));
        return /*#__PURE__*/ $6uMv9.createElement($6uMv9.Fragment, null, /*#__PURE__*/ $6uMv9.createElement("div", groupContainerProps, /*#__PURE__*/ $6uMv9.createElement("div", groupProps, /*#__PURE__*/ $6uMv9.createElement("div", headerProps, backwardNavigator, /*#__PURE__*/ $6uMv9.createElement("div", titleProps, yearElement, decade), forwardNavigator))));
    };
    var createDatePicker = function createDatePicker() {
        if (!props.timeOnly) {
            if (props.view === "date") return createDateView();
            return createMonthYearView();
        }
        return null;
    };
    var incrementIconProps = mergeProps(ptm("incrementIcon"));
    var decrementIconProps = mergeProps(ptm("decrementIcon"));
    var incrementIcon = (0, $15euW.IconUtils).getJSXIcon(props.incrementIcon || /*#__PURE__*/ $6uMv9.createElement((0, $cITD2.ChevronUpIcon), incrementIconProps), $5ac3f498be1136b1$var$_objectSpread({}, incrementIconProps), {
        props: props
    });
    var decrementIcon = (0, $15euW.IconUtils).getJSXIcon(props.decrementIcon || /*#__PURE__*/ $6uMv9.createElement((0, $74zy6.ChevronDownIcon), decrementIconProps), $5ac3f498be1136b1$var$_objectSpread({}, decrementIconProps), {
        props: props
    });
    var createHourPicker = function createHourPicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        var hour = currentTime.getHours();
        // #3770 account for step minutes rolling to next hour
        hour = minute > 59 ? hour + 1 : hour;
        if (props.hourFormat === "12") {
            if (hour === 0) hour = 12;
            else if (hour > 11 && hour !== 12) hour = hour - 12;
        }
        var hourProps = mergeProps(ptm("hour"));
        var _localeOptions6 = (0, $cFTyZ.localeOptions)(props.locale), nextHour = _localeOptions6.nextHour, prevHour = _localeOptions6.prevHour;
        var hourDisplay = hour < 10 ? "0" + hour : hour;
        var hourPickerProps = mergeProps({
            className: cx("hourPicker")
        }, ptm("hourPicker"));
        var incrementButtonProps = mergeProps({
            type: "button",
            className: cx("incrementButton"),
            "aria-label": nextHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("incrementButton"));
        var decrementButtonProps = mergeProps({
            type: "button",
            className: cx("decrementButton"),
            "aria-label": prevHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $6uMv9.createElement("div", hourPickerProps, /*#__PURE__*/ $6uMv9.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)), /*#__PURE__*/ $6uMv9.createElement("span", hourProps, hourDisplay), /*#__PURE__*/ $6uMv9.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)));
    };
    var createMinutePicker = function createMinutePicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        minute = minute > 59 ? minute - 60 : minute;
        var minuteProps = mergeProps(ptm("minute"));
        var _localeOptions7 = (0, $cFTyZ.localeOptions)(props.locale), nextMinute = _localeOptions7.nextMinute, prevMinute = _localeOptions7.prevMinute;
        var minuteDisplay = minute < 10 ? "0" + minute : minute;
        var minutePickerProps = mergeProps({
            className: cx("minutePicker")
        }, ptm("minutePicker"));
        var incrementButtonProps = mergeProps({
            type: "button",
            className: cx("incrementButton"),
            "aria-label": nextMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("incrementButton"));
        var decrementButtonProps = mergeProps({
            type: "button",
            className: cx("decrementButton"),
            "aria-label": prevMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $6uMv9.createElement("div", minutePickerProps, /*#__PURE__*/ $6uMv9.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)), /*#__PURE__*/ $6uMv9.createElement("span", minuteProps, minuteDisplay), /*#__PURE__*/ $6uMv9.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)));
    };
    var createSecondPicker = function createSecondPicker() {
        if (props.showSeconds) {
            var currentTime = getCurrentDateTime();
            var _localeOptions8 = (0, $cFTyZ.localeOptions)(props.locale), nextSecond = _localeOptions8.nextSecond, prevSecond = _localeOptions8.prevSecond;
            var secondProps = mergeProps(ptm("second"));
            var second = currentTime.getSeconds();
            var secondDisplay = second < 10 ? "0" + second : second;
            var secondPickerProps = mergeProps({
                className: cx("secondPicker")
            }, ptm("secondPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": nextSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": prevSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $6uMv9.createElement("div", secondPickerProps, /*#__PURE__*/ $6uMv9.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)), /*#__PURE__*/ $6uMv9.createElement("span", secondProps, secondDisplay), /*#__PURE__*/ $6uMv9.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)));
        }
        return null;
    };
    var createMiliSecondPicker = function createMiliSecondPicker() {
        if (props.showMillisec) {
            var currentTime = getCurrentDateTime();
            var _localeOptions9 = (0, $cFTyZ.localeOptions)(props.locale), nextMilliSecond = _localeOptions9.nextMilliSecond, prevMilliSecond = _localeOptions9.prevMilliSecond;
            var millisecondProps = mergeProps(ptm("millisecond"));
            var millisecond = currentTime.getMilliseconds();
            var millisecondDisplay = millisecond < 100 ? (millisecond < 10 ? "00" : "0") + millisecond : millisecond;
            var millisecondPickerProps = mergeProps({
                className: cx("millisecondPicker")
            }, ptm("millisecondPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": nextMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": prevMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $6uMv9.createElement("div", millisecondPickerProps, /*#__PURE__*/ $6uMv9.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)), /*#__PURE__*/ $6uMv9.createElement("span", millisecondProps, millisecondDisplay), /*#__PURE__*/ $6uMv9.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)));
        }
        return null;
    };
    var createAmPmPicker = function createAmPmPicker() {
        if (props.hourFormat === "12") {
            var currentTime = getCurrentDateTime();
            var _localeOptions10 = (0, $cFTyZ.localeOptions)(props.locale), am = _localeOptions10.am, pm = _localeOptions10.pm;
            var hour = currentTime.getHours();
            var display = hour > 11 ? "PM" : "AM";
            var ampmProps = mergeProps(ptm("ampm"));
            var ampmPickerProps = mergeProps({
                className: cx("ampmPicker")
            }, ptm("ampmPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": am,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": pm,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $6uMv9.createElement("div", ampmPickerProps, /*#__PURE__*/ $6uMv9.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)), /*#__PURE__*/ $6uMv9.createElement("span", ampmProps, display), /*#__PURE__*/ $6uMv9.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null)));
        }
        return null;
    };
    var createSeparator = function createSeparator(separator) {
        var separatorContainerProps = mergeProps({
            className: cx("separatorContainer")
        }, ptm("separatorContainer"));
        var separatorProps = mergeProps(ptm("separator"));
        return /*#__PURE__*/ $6uMv9.createElement("div", separatorContainerProps, /*#__PURE__*/ $6uMv9.createElement("span", separatorProps, separator));
    };
    var createTimePicker = function createTimePicker() {
        if ((props.showTime || props.timeOnly) && currentView === "date") {
            var timePickerProps = mergeProps({
                className: cx("timePicker")
            }, ptm("timePicker"));
            return /*#__PURE__*/ $6uMv9.createElement("div", timePickerProps, createHourPicker(), createSeparator(":"), createMinutePicker(), props.showSeconds && createSeparator(":"), createSecondPicker(), props.showMillisec && createSeparator("."), createMiliSecondPicker(), props.hourFormat === "12" && createSeparator(":"), createAmPmPicker());
        }
        return null;
    };
    var createInputElement = function createInputElement() {
        if (!props.inline) return /*#__PURE__*/ $6uMv9.createElement((0, $gEdFY.InputText), {
            ref: inputRef,
            id: props.inputId,
            name: props.name,
            type: "text",
            role: "combobox",
            className: (0, $15euW.classNames)(props.inputClassName, cx("input", {
                context: context
            })),
            style: props.inputStyle,
            readOnly: props.readOnlyInput,
            disabled: props.disabled,
            required: props.required,
            autoComplete: "off",
            placeholder: props.placeholder,
            tabIndex: props.tabIndex,
            onInput: onUserInput,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            "aria-expanded": overlayVisibleState,
            "aria-autocomplete": "none",
            "aria-haspopup": "dialog",
            "aria-controls": panelId,
            "aria-labelledby": props.ariaLabelledBy,
            "aria-label": props.ariaLabel,
            inputMode: props.inputMode,
            tooltip: props.tooltip,
            tooltipOptions: props.tooltipOptions,
            pt: ptm("input"),
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createButton = function createButton() {
        if (props.showIcon) return /*#__PURE__*/ $6uMv9.createElement((0, $aIcGc.Button), {
            type: "button",
            icon: props.icon || /*#__PURE__*/ $6uMv9.createElement((0, $cItft.CalendarIcon), null),
            onClick: onButtonClick,
            tabIndex: "-1",
            disabled: props.disabled,
            "aria-haspopup": "dialog",
            "aria-label": (0, $cFTyZ.localeOption)("chooseDate", props.locale),
            "aria-expanded": overlayVisibleState,
            "aria-controls": panelId,
            className: cx("dropdownButton"),
            pt: ptm("dropdownButton"),
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createContent = function createContent() {
        var input = createInputElement();
        var button = createButton();
        if (props.iconPos === "left") return /*#__PURE__*/ $6uMv9.createElement($6uMv9.Fragment, null, button, input);
        return /*#__PURE__*/ $6uMv9.createElement($6uMv9.Fragment, null, input, button);
    };
    var createButtonBar = function createButtonBar() {
        if (props.showButtonBar) {
            var _localeOptions11 = (0, $cFTyZ.localeOptions)(props.locale), today = _localeOptions11.today, clear = _localeOptions11.clear, now = _localeOptions11.now;
            var nowDate = new Date();
            var isHidden = props.minDate && props.minDate > nowDate || props.maxDate && props.maxDate < nowDate;
            var buttonbarProps = mergeProps({
                className: cx("buttonbar")
            }, ptm("buttonbar"));
            return /*#__PURE__*/ $6uMv9.createElement("div", buttonbarProps, /*#__PURE__*/ $6uMv9.createElement((0, $aIcGc.Button), {
                type: "button",
                label: props.showTime ? now : today,
                onClick: onTodayButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $15euW.classNames)(props.todayButtonClassName, cx("todayButton")),
                pt: ptm("todayButton"),
                style: isHidden ? {
                    visibility: "hidden"
                } : undefined
            }), /*#__PURE__*/ $6uMv9.createElement((0, $aIcGc.Button), {
                type: "button",
                label: clear,
                onClick: onClearButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $15euW.classNames)(props.clearButtonClassName, cx("clearButton")),
                pt: ptm("clearButton")
            }));
        }
        return null;
    };
    var createFooter = function createFooter() {
        if (props.footerTemplate) {
            var _content3 = props.footerTemplate();
            var footerProps = mergeProps({
                className: cx("footer")
            }, ptm("footer"));
            return /*#__PURE__*/ $6uMv9.createElement("div", footerProps, _content3);
        }
        return null;
    };
    var createMonthPicker = function createMonthPicker() {
        if (currentView === "month") {
            var monthPickerProps = mergeProps({
                className: cx("monthPicker")
            }, ptm("monthPicker"));
            return /*#__PURE__*/ $6uMv9.createElement("div", monthPickerProps, monthPickerValues().map(function(m, i) {
                var selected = isMonthSelected(i);
                var monthProps = mergeProps({
                    className: cx("month", {
                        isMonthSelected: isMonthSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        i: i,
                        currentYear: currentYear
                    }),
                    onClick: function onClick(event) {
                        return onMonthSelect(event, i);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onMonthCellKeydown(event, i);
                    },
                    "data-p-disabled": isMonthYearDisabled(i, currentYear),
                    "data-p-highlight": selected
                }, ptm("month", {
                    context: {
                        month: m,
                        monthIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(i, currentYear)
                    }
                }));
                return /*#__PURE__*/ $6uMv9.createElement("span", $5ac3f498be1136b1$var$_extends({}, monthProps, {
                    key: "month".concat(i + 1)
                }), m, selected && /*#__PURE__*/ $6uMv9.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm("hiddenMonth")
                }, m));
            }));
        }
        return null;
    };
    var createYearPicker = function createYearPicker() {
        if (currentView === "year") {
            var yearPickerProps = mergeProps({
                className: cx("yearPicker")
            }, ptm("yearPicker"));
            return /*#__PURE__*/ $6uMv9.createElement("div", yearPickerProps, yearPickerValues().map(function(y, i) {
                var selected = isYearSelected(y);
                var yearProps = mergeProps({
                    className: cx("year", {
                        isYearSelected: isYearSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        y: y
                    }),
                    onClick: function onClick(event) {
                        return onYearSelect(event, y);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onYearCellKeydown(event, y);
                    },
                    "data-p-highlight": isYearSelected(y),
                    "data-p-disabled": isMonthYearDisabled(-1, y)
                }, ptm("year", {
                    context: {
                        year: y,
                        yearIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(-1, y)
                    }
                }));
                return /*#__PURE__*/ $6uMv9.createElement("span", $5ac3f498be1136b1$var$_extends({}, yearProps, {
                    key: "year".concat(i + 1)
                }), y, selected && /*#__PURE__*/ $6uMv9.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm("hiddenYear")
                }, y));
            }));
        }
        return null;
    };
    var panelClassName = (0, $15euW.classNames)("p-datepicker p-component", props.panelClassName, {
        "p-datepicker-inline": props.inline,
        "p-disabled": props.disabled,
        "p-datepicker-timeonly": props.timeOnly,
        "p-datepicker-multiple-month": props.numberOfMonths > 1,
        "p-datepicker-monthpicker": currentView === "month",
        "p-datepicker-touch-ui": props.touchUI,
        "p-input-filled": context && context.inputStyle === "filled" || (0, $cFTyZ.default).inputStyle === "filled",
        "p-ripple-disabled": context && context.ripple === false || (0, $cFTyZ.default).ripple === false
    });
    var content = createContent();
    var datePicker = createDatePicker();
    var timePicker = createTimePicker();
    var buttonBar = createButtonBar();
    var footer = createFooter();
    var monthPicker = createMonthPicker();
    var yearPicker = createYearPicker();
    var isFilled = (0, $15euW.DomHandler).hasClass(inputRef.current, "p-filled") && inputRef.current.value !== "";
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $15euW.classNames)(props.className, cx("root", {
            focusedState: focusedState,
            isFilled: isFilled,
            panelVisible: visible
        })),
        style: props.style
    }, $5ac3f498be1136b1$var$CalendarBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $6uMv9.createElement("span", $5ac3f498be1136b1$var$_extends({
        ref: elementRef
    }, rootProps), content, /*#__PURE__*/ $6uMv9.createElement($5ac3f498be1136b1$var$CalendarPanel, {
        hostName: "Calendar",
        id: panelId,
        locale: props.locale,
        ref: overlayRef,
        className: panelClassName,
        style: props.panelStyle,
        appendTo: props.appendTo,
        inline: props.inline,
        onClick: onPanelClick,
        onMouseUp: onPanelMouseUp,
        "in": visible,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        transitionOptions: props.transitionOptions,
        ptm: ptm,
        cx: cx
    }, datePicker, timePicker, monthPicker, yearPicker, buttonBar, footer));
}));
$5ac3f498be1136b1$export$e1aef45b828286de.displayName = "Calendar";

});
parcelRegister("cItft", function(module, exports) {

$parcel$export(module.exports, "CalendarIcon", function () { return $9420483f76dd9f94$export$5fda1783bb83f57b; });

var $6uMv9 = parcelRequire("6uMv9");

var $7zClp = parcelRequire("7zClp");
"use client";
function $9420483f76dd9f94$var$_extends() {
    $9420483f76dd9f94$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9420483f76dd9f94$var$_extends.apply(this, arguments);
}
var $9420483f76dd9f94$export$5fda1783bb83f57b = /*#__PURE__*/ $6uMv9.memo(/*#__PURE__*/ $6uMv9.forwardRef(function(inProps, ref) {
    var pti = (0, $7zClp.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $6uMv9.createElement("svg", $9420483f76dd9f94$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $6uMv9.createElement("path", {
        d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
        fill: "currentColor"
    }));
}));
$9420483f76dd9f94$export$5fda1783bb83f57b.displayName = "CalendarIcon";

});

parcelRegister("cITD2", function(module, exports) {

$parcel$export(module.exports, "ChevronUpIcon", function () { return $9434becf97337b75$export$7f01a6cbee61a0f2; });

var $6uMv9 = parcelRequire("6uMv9");

var $7zClp = parcelRequire("7zClp");
"use client";
function $9434becf97337b75$var$_extends() {
    $9434becf97337b75$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9434becf97337b75$var$_extends.apply(this, arguments);
}
var $9434becf97337b75$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $6uMv9.memo(/*#__PURE__*/ $6uMv9.forwardRef(function(inProps, ref) {
    var pti = (0, $7zClp.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $6uMv9.createElement("svg", $9434becf97337b75$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $6uMv9.createElement("path", {
        d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
        fill: "currentColor"
    }));
}));
$9434becf97337b75$export$7f01a6cbee61a0f2.displayName = "ChevronUpIcon";

});


parcelRegister("kDPMb", function(module, exports) {
$parcel$export(module.exports, "AddRFIDModal", function () { return (parcelRequire("31uqV")).AddRFIDModal; });
parcelRequire("31uqV");

});
parcelRegister("31uqV", function(module, exports) {

$parcel$export(module.exports, "AddRFIDModal", function () { return $dfbbf4dee10477c0$export$8ebb47e67c421ca8; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $8gLAc = parcelRequire("8gLAc");

var $iIdvQ = parcelRequire("iIdvQ");

var $fvmYM = parcelRequire("fvmYM");

var $aL1Vp = parcelRequire("aL1Vp");
const $dfbbf4dee10477c0$export$8ebb47e67c421ca8 = ({ onClose: onClose, onSubmit: onSubmit, partnerId: partnerId })=>{
    const text = (0, $aL1Vp.default)();
    const { data: organisations = [], isLoading: isLoading } = (0, $fvmYM.usePartnerGetCompaniesByPartnerIdQuery)({
        partnerId: partnerId
    });
    const { handleSubmit: handleSubmit, control: organisationControl, formState: { isDirty: isDirty } } = (0, $cbVaW.useForm)({
        mode: "all"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("lblAddRFIDTagsModal"),
        actions: [
            {
                label: text("btnCancel"),
                callback: onClose,
                btn: "btn-secondary"
            },
            {
                label: text("btnSave"),
                callback: handleSubmit(({ organisationId: organisationId })=>onSubmit(organisationId)),
                disabled: !isDirty,
                loading: isLoading
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "organisationId",
        control: organisationControl,
        render: ({ field: { value: value, onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iIdvQ.Combobox), {
                id: "select-organisation",
                wrapperClassName: "mb-8 mt-4",
                enableDefaultOption: false,
                labelText: `${text("lblOrganisationField")} *`,
                value: value,
                options: organisations?.map((organisation)=>({
                        value: organisation?.id,
                        label: organisation?.name || ""
                    })),
                onChange: (option)=>onChange(option.value),
                ...rest
            })
    }));
};

});





parcelRegister("gVguk", function(module, exports) {
$parcel$export(module.exports, "ChargersListWidget", function () { return (parcelRequire("5EQcn")).ChargersListWidget; });
parcelRequire("5EQcn");

});
parcelRegister("5EQcn", function(module, exports) {

$parcel$export(module.exports, "ChargersListWidget", function () { return $872f5635dbd1a921$export$b3d677a8e253915a; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $lWDz3 = parcelRequire("lWDz3");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");

var $9ekKl = parcelRequire("9ekKl");

var $3YfCm = parcelRequire("3YfCm");

var $8LupL = parcelRequire("8LupL");

var $1xw2Y = parcelRequire("1xw2Y");

var $d6sTr = parcelRequire("d6sTr");

var $dfOhE = parcelRequire("dfOhE");

var $jeXdk = parcelRequire("jeXdk");

var $35vY7 = parcelRequire("35vY7");

var $8rswm = parcelRequire("8rswm");

var $fvmYM = parcelRequire("fvmYM");

var $2naDF = parcelRequire("2naDF");

var $dXUkh = parcelRequire("dXUkh");

var $2460e = parcelRequire("2460e");

var $duQ8A = parcelRequire("duQ8A");

var $cq3ae = parcelRequire("cq3ae");

var $1dgSH = parcelRequire("1dgSH");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");
const $872f5635dbd1a921$var$SIcon = (0, $akcQ4.default)((0, $lWDz3.FontAwesomeIcon))`
    margin-left: 4px;
`;
const $872f5635dbd1a921$var$NoOfItemsWrapper = (0, $akcQ4.default).div`
    display: flex;
    justify-content: flex-end;
`;
const $872f5635dbd1a921$export$b3d677a8e253915a = /*#__PURE__*/ (0, $6uMv9.memo)(function ChargersListWidget({ companyId: companyId, className: className, style: style, poolChargePoints: poolChargePoints, onAddChargerToPool: onAddChargerToPool }) {
    const text = (0, $aL1Vp.default)();
    const [sortFilter, setSortFilter] = (0, $6uMv9.useState)({
        parameter: (0, $9ekKl.SortParameter).ID
    });
    const [paginationData, setPaginationData] = (0, $6uMv9.useState)({});
    const [isConfirmModalOpen, setConfirmModalOpen] = (0, $6uMv9.useState)(false);
    const [selectedChargePointId, setSelectedChargePointId] = (0, $6uMv9.useState)("");
    const [selectedLoadBalancerGroupId, setSelectedLoadBalancerGroupId] = (0, $6uMv9.useState)("");
    const { data: chargePoints, isLoading: isLoadingChargePoints } = (0, $fvmYM.useCompanyGetChargePointsPagedQuery)({
        companyId: companyId,
        noOfItems: paginationData.NoOfItems,
        page: paginationData.Page,
        expand: "additionalInfo,ocppConfig"
    }, {
        refetchOnMountOrArgChange: true,
        skip: !companyId
    });
    const [removeChargePointMutation, { isLoading: isLoadingRemoveChargePoint }] = (0, $fvmYM.useCompanyRemoveChargePointMutation)();
    const removeChargePoint = async (chargePointId)=>{
        try {
            await removeChargePointMutation({
                companyId: companyId,
                chargePointId: chargePointId
            }).unwrap();
            (0, $2460e.notifySuccess)(text("msgChargerRemoved"));
        } catch (error) {
            if (error?.status === 404) (0, $2460e.notifyError)(text("msgChargePointNotFound"));
            else if (error?.status === 409) (0, $2460e.notifyError)(text("msgChargePointNotRemoved", {
                chargePointId: chargePointId,
                lbgId: selectedLoadBalancerGroupId
            }));
            else if (error?.messageCode) (0, $2460e.notifyError)(text(error?.messageCode));
            else (0, $2460e.notifyError)(text("lblSomethingWentWrong"));
        } finally{
            setConfirmModalOpen(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblChargersWidget"),
        headerButtons: [
            (0, $8LupL.isAdminDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                onClick: onAddChargerToPool,
                size: "sm"
            }, text("btnAdd")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("br", null), !(0, $8LupL.isAdminDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($872f5635dbd1a921$var$NoOfItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8rswm.ResultsPerPage), {
        dataTestid: "results-per-page",
        onSelectNumberOfItems: (numberOfItems)=>setPaginationData({
                Page: 0,
                NoOfItems: numberOfItems
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
        onClick: ()=>setSortFilter({
                parameter: (0, $9ekKl.SortParameter).ID,
                reversed: !sortFilter?.reversed
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSerialNumberShort"
    }), sortFilter?.parameter === (0, $9ekKl.SortParameter).ID && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($872f5635dbd1a921$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblStatus"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSettings"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortFilter({
                parameter: (0, $9ekKl.SortParameter).LAST_HEARTBEAT,
                reversed: !sortFilter?.reversed
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblLastSeenTime"
    }), sortFilter?.parameter === (0, $9ekKl.SortParameter).LAST_HEARTBEAT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($872f5635dbd1a921$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortFilter({
                parameter: (0, $9ekKl.SortParameter).WIFI_SIGNAL_STRENGTH,
                reversed: !sortFilter?.reversed
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSignal"
    }), sortFilter?.parameter === (0, $9ekKl.SortParameter).WIFI_SIGNAL_STRENGTH && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($872f5635dbd1a921$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortFilter({
                parameter: (0, $9ekKl.SortParameter).PARTNER_DESCRIPTION,
                reversed: !sortFilter?.reversed
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPartnerInfo"
    }), sortFilter?.parameter === (0, $9ekKl.SortParameter).PARTNER_DESCRIPTION && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($872f5635dbd1a921$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortFilter({
                parameter: (0, $9ekKl.SortParameter).NAME,
                reversed: !sortFilter?.reversed
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    }), sortFilter?.parameter === (0, $9ekKl.SortParameter).NAME && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($872f5635dbd1a921$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), (0, $8LupL.isPartnerDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-chargepointremove-heading"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, !isLoadingChargePoints && !(0, $8LupL.isAdminDomain) && chargePoints?.items.map((chargePoint, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9ekKl.SLink), {
            as: (0, $iZaUM.Link),
            to: `/chargepoints/${chargePoint.id}`
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeXdk.ChargepointStatus), {
            chargePoint: chargePoint
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d6sTr.default), {
            chargePoint: chargePoint
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint.chargePointStatus === "Offline" && (0, $dfOhE.default)(chargePoint?.lastHeartbeat) || "---"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint?.wifiSignalStrength || "---"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint?.additionalInfo?.partnerDescription || "---"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hide-overflow"
        }, chargePoint?.name || "---"), (0, $8LupL.isPartnerDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-userremoveBtn-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.default), {
            className: "ml-auto",
            "data-testid": "dropdown-menu-btn"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: (e)=>{
                setConfirmModalOpen(true);
                setSelectedChargePointId(chargePoint.id);
                setSelectedLoadBalancerGroupId(chargePoint.loadBalancerGroupId);
                e.stopPropagation();
            },
            disabled: !!chargePoint.loadBalancerGroupId,
            disabledReason: chargePoint.loadBalancerGroupId ? text("msgChargePointNotRemoved", {
                chargePointId: chargePoint.id,
                lbgId: chargePoint.loadBalancerGroupId
            }) : undefined,
            text: text("btnRemove"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1dgSH.default), {
                size: 16
            }),
            key: "btnRemoveCharger",
            "data-testid": "btn-remove-charger"
        }))))), (0, $8LupL.isAdminDomain) && poolChargePoints?.map((chargePoint, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9ekKl.SLink), {
            as: (0, $iZaUM.Link),
            to: `/chargepoints/${chargePoint.id}`,
            className: "btn btn-link btn-xs",
            "data-testid": `table-tr-serial-${chargePoint.id}-btn`
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeXdk.ChargepointStatus), {
            chargePoint: chargePoint || ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d6sTr.default), {
            chargePoint: chargePoint || ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint?.chargePointStatus === "Offline" && (0, $dfOhE.default)(chargePoint?.lastHeartbeat || "") || "---"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint?.wifiSignalStrength || ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint?.additionalInfo?.partnerDescription || ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hide-overflow"
        }, chargePoint?.name || ""))))), (isLoadingChargePoints || isLoadingRemoveChargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small"
    }), chargePoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        totalCount: chargePoints?.totalCount,
        pageIndex: chargePoints.pageIndex,
        pageSize: chargePoints.pageSize,
        displayedChargers: chargePoints.items.length,
        setPageIndex: (index)=>{
            setPaginationData({
                ...paginationData,
                Page: index
            });
        }
    })), isConfirmModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cq3ae.default), {
        message: text("msgConfirmChargerRemoval"),
        onClose: ()=>setConfirmModalOpen(false),
        onConfirm: ()=>removeChargePoint(selectedChargePointId)
    }));
});

});


parcelRegister("iCWiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $424b2fec267a8934$export$2e2bcd8739ae039; });
const $424b2fec267a8934$var$canChangePassword = (currentUser, selectedUser)=>{
    if (!selectedUser) return false;
    if (!selectedUser.id) return false;
    if (currentUser.id === selectedUser.id) return true;
    if (currentUser.isSuperAdmin) return true;
    return false;
};
var $424b2fec267a8934$export$2e2bcd8739ae039 = $424b2fec267a8934$var$canChangePassword;

});


//# sourceMappingURL=index.9902a6f7.js.map
